import * as p from "react";
import w, { forwardRef as Je, createElement as vo, createContext as $d, useContext as Ld, useCallback as be, useRef as It, useLayoutEffect as Hi, useState as un, useEffect as pr, useMemo as wt, useReducer as zd, useImperativeHandle as Bd, Fragment as Yd, useId as Hd } from "react";
import * as qi from "react-dom";
import Vi from "react-dom";
function Ui(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var Zn = { exports: {} }, En = {};
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ka;
function qd() {
  if (ka) return En;
  ka = 1;
  var e = Symbol.for("react.transitional.element"), t = Symbol.for("react.fragment");
  function n(r, o, a) {
    var s = null;
    if (a !== void 0 && (s = "" + a), o.key !== void 0 && (s = "" + o.key), "key" in o) {
      a = {};
      for (var i in o)
        i !== "key" && (a[i] = o[i]);
    } else a = o;
    return o = a.ref, {
      $$typeof: e,
      type: r,
      key: s,
      ref: o !== void 0 ? o : null,
      props: a
    };
  }
  return En.Fragment = t, En.jsx = n, En.jsxs = n, En;
}
var Cn = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ea;
function Vd() {
  return Ea || (Ea = 1, process.env.NODE_ENV !== "production" && (function() {
    function e(b) {
      if (b == null) return null;
      if (typeof b == "function")
        return b.$$typeof === Y ? null : b.displayName || b.name || null;
      if (typeof b == "string") return b;
      switch (b) {
        case h:
          return "Fragment";
        case k:
          return "Profiler";
        case g:
          return "StrictMode";
        case v:
          return "Suspense";
        case P:
          return "SuspenseList";
        case L:
          return "Activity";
      }
      if (typeof b == "object")
        switch (typeof b.tag == "number" && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), b.$$typeof) {
          case y:
            return "Portal";
          case E:
            return (b.displayName || "Context") + ".Provider";
          case C:
            return (b._context.displayName || "Context") + ".Consumer";
          case O:
            var S = b.render;
            return b = b.displayName, b || (b = S.displayName || S.name || "", b = b !== "" ? "ForwardRef(" + b + ")" : "ForwardRef"), b;
          case M:
            return S = b.displayName || null, S !== null ? S : e(b.type) || "Memo";
          case D:
            S = b._payload, b = b._init;
            try {
              return e(b(S));
            } catch {
            }
        }
      return null;
    }
    function t(b) {
      return "" + b;
    }
    function n(b) {
      try {
        t(b);
        var S = !1;
      } catch {
        S = !0;
      }
      if (S) {
        S = console;
        var A = S.error, T = typeof Symbol == "function" && Symbol.toStringTag && b[Symbol.toStringTag] || b.constructor.name || "Object";
        return A.call(
          S,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          T
        ), t(b);
      }
    }
    function r(b) {
      if (b === h) return "<>";
      if (typeof b == "object" && b !== null && b.$$typeof === D)
        return "<...>";
      try {
        var S = e(b);
        return S ? "<" + S + ">" : "<...>";
      } catch {
        return "<...>";
      }
    }
    function o() {
      var b = U.A;
      return b === null ? null : b.getOwner();
    }
    function a() {
      return Error("react-stack-top-frame");
    }
    function s(b) {
      if (J.call(b, "key")) {
        var S = Object.getOwnPropertyDescriptor(b, "key").get;
        if (S && S.isReactWarning) return !1;
      }
      return b.key !== void 0;
    }
    function i(b, S) {
      function A() {
        G || (G = !0, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          S
        ));
      }
      A.isReactWarning = !0, Object.defineProperty(b, "key", {
        get: A,
        configurable: !0
      });
    }
    function d() {
      var b = e(this.type);
      return j[b] || (j[b] = !0, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      )), b = this.props.ref, b !== void 0 ? b : null;
    }
    function l(b, S, A, T, N, V, F, W) {
      return A = V.ref, b = {
        $$typeof: m,
        type: b,
        key: S,
        props: V,
        _owner: N
      }, (A !== void 0 ? A : null) !== null ? Object.defineProperty(b, "ref", {
        enumerable: !1,
        get: d
      }) : Object.defineProperty(b, "ref", { enumerable: !1, value: null }), b._store = {}, Object.defineProperty(b._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: 0
      }), Object.defineProperty(b, "_debugInfo", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: null
      }), Object.defineProperty(b, "_debugStack", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: F
      }), Object.defineProperty(b, "_debugTask", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: W
      }), Object.freeze && (Object.freeze(b.props), Object.freeze(b)), b;
    }
    function u(b, S, A, T, N, V, F, W) {
      var z = S.children;
      if (z !== void 0)
        if (T)
          if (ee(z)) {
            for (T = 0; T < z.length; T++)
              c(z[T]);
            Object.freeze && Object.freeze(z);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else c(z);
      if (J.call(S, "key")) {
        z = e(b);
        var H = Object.keys(S).filter(function(se) {
          return se !== "key";
        });
        T = 0 < H.length ? "{key: someKey, " + H.join(": ..., ") + ": ...}" : "{key: someKey}", R[z + T] || (H = 0 < H.length ? "{" + H.join(": ..., ") + ": ...}" : "{}", console.error(
          `A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`,
          T,
          z,
          H,
          z
        ), R[z + T] = !0);
      }
      if (z = null, A !== void 0 && (n(A), z = "" + A), s(S) && (n(S.key), z = "" + S.key), "key" in S) {
        A = {};
        for (var Q in S)
          Q !== "key" && (A[Q] = S[Q]);
      } else A = S;
      return z && i(
        A,
        typeof b == "function" ? b.displayName || b.name || "Unknown" : b
      ), l(
        b,
        z,
        V,
        N,
        o(),
        A,
        F,
        W
      );
    }
    function c(b) {
      typeof b == "object" && b !== null && b.$$typeof === m && b._store && (b._store.validated = 1);
    }
    var f = w, m = Symbol.for("react.transitional.element"), y = Symbol.for("react.portal"), h = Symbol.for("react.fragment"), g = Symbol.for("react.strict_mode"), k = Symbol.for("react.profiler"), C = Symbol.for("react.consumer"), E = Symbol.for("react.context"), O = Symbol.for("react.forward_ref"), v = Symbol.for("react.suspense"), P = Symbol.for("react.suspense_list"), M = Symbol.for("react.memo"), D = Symbol.for("react.lazy"), L = Symbol.for("react.activity"), Y = Symbol.for("react.client.reference"), U = f.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, J = Object.prototype.hasOwnProperty, ee = Array.isArray, q = console.createTask ? console.createTask : function() {
      return null;
    };
    f = {
      "react-stack-bottom-frame": function(b) {
        return b();
      }
    };
    var G, j = {}, K = f["react-stack-bottom-frame"].bind(
      f,
      a
    )(), _ = q(r(a)), R = {};
    Cn.Fragment = h, Cn.jsx = function(b, S, A, T, N) {
      var V = 1e4 > U.recentlyCreatedOwnerStacks++;
      return u(
        b,
        S,
        A,
        !1,
        T,
        N,
        V ? Error("react-stack-top-frame") : K,
        V ? q(r(b)) : _
      );
    }, Cn.jsxs = function(b, S, A, T, N) {
      var V = 1e4 > U.recentlyCreatedOwnerStacks++;
      return u(
        b,
        S,
        A,
        !0,
        T,
        N,
        V ? Error("react-stack-top-frame") : K,
        V ? q(r(b)) : _
      );
    };
  })()), Cn;
}
var Ca;
function Ud() {
  return Ca || (Ca = 1, process.env.NODE_ENV === "production" ? Zn.exports = qd() : Zn.exports = Vd()), Zn.exports;
}
var x = Ud();
const Gi = 6048e5, Gd = 864e5, Oa = Symbol.for("constructDateFrom");
function Pe(e, t) {
  return typeof e == "function" ? e(t) : e && typeof e == "object" && Oa in e ? e[Oa](t) : e instanceof Date ? new e.constructor(t) : new Date(t);
}
function pe(e, t) {
  return Pe(t || e, e);
}
function Wo(e, t, n) {
  const r = pe(e, n == null ? void 0 : n.in);
  return isNaN(t) ? Pe(e, NaN) : (t && r.setDate(r.getDate() + t), r);
}
function Ki(e, t, n) {
  const r = pe(e, n == null ? void 0 : n.in);
  if (isNaN(t)) return Pe(e, NaN);
  if (!t)
    return r;
  const o = r.getDate(), a = Pe(e, r.getTime());
  a.setMonth(r.getMonth() + t + 1, 0);
  const s = a.getDate();
  return o >= s ? a : (r.setFullYear(
    a.getFullYear(),
    a.getMonth(),
    o
  ), r);
}
let Kd = {};
function $n() {
  return Kd;
}
function fn(e, t) {
  var i, d, l, u;
  const n = $n(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = pe(e, t == null ? void 0 : t.in), a = o.getDay(), s = (a < r ? 7 : 0) + a - r;
  return o.setDate(o.getDate() - s), o.setHours(0, 0, 0, 0), o;
}
function Rn(e, t) {
  return fn(e, { ...t, weekStartsOn: 1 });
}
function Xi(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = Pe(n, 0);
  o.setFullYear(r + 1, 0, 4), o.setHours(0, 0, 0, 0);
  const a = Rn(o), s = Pe(n, 0);
  s.setFullYear(r, 0, 4), s.setHours(0, 0, 0, 0);
  const i = Rn(s);
  return n.getTime() >= a.getTime() ? r + 1 : n.getTime() >= i.getTime() ? r : r - 1;
}
function Sa(e) {
  const t = pe(e), n = new Date(
    Date.UTC(
      t.getFullYear(),
      t.getMonth(),
      t.getDate(),
      t.getHours(),
      t.getMinutes(),
      t.getSeconds(),
      t.getMilliseconds()
    )
  );
  return n.setUTCFullYear(t.getFullYear()), +e - +n;
}
function vn(e, ...t) {
  const n = Pe.bind(
    null,
    t.find((r) => typeof r == "object")
  );
  return t.map(n);
}
function Ft(e, t) {
  const n = pe(e, t == null ? void 0 : t.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Zi(e, t, n) {
  const [r, o] = vn(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = Ft(r), s = Ft(o), i = +a - Sa(a), d = +s - Sa(s);
  return Math.round((i - d) / Gd);
}
function Xd(e, t) {
  const n = Xi(e, t), r = Pe(e, 0);
  return r.setFullYear(n, 0, 4), r.setHours(0, 0, 0, 0), Rn(r);
}
function Zd(e, t, n) {
  return Wo(e, t * 7, n);
}
function Qd(e, t, n) {
  return Ki(e, t * 12, n);
}
function Jd(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Pe.bind(null, o));
    const a = pe(o, r);
    (!n || n < a || isNaN(+a)) && (n = a);
  }), Pe(r, n || NaN);
}
function eu(e, t) {
  let n, r = t == null ? void 0 : t.in;
  return e.forEach((o) => {
    !r && typeof o == "object" && (r = Pe.bind(null, o));
    const a = pe(o, r);
    (!n || n > a || isNaN(+a)) && (n = a);
  }), Pe(r, n || NaN);
}
function tu(e, t, n) {
  const [r, o] = vn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return +Ft(r) == +Ft(o);
}
function Qi(e) {
  return e instanceof Date || typeof e == "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function nu(e) {
  return !(!Qi(e) && typeof e != "number" || isNaN(+pe(e)));
}
function ru(e, t, n) {
  const [r, o] = vn(
    n == null ? void 0 : n.in,
    e,
    t
  ), a = r.getFullYear() - o.getFullYear(), s = r.getMonth() - o.getMonth();
  return a * 12 + s;
}
function Qn(e, t) {
  const n = pe(e, t == null ? void 0 : t.in);
  return n.setHours(23, 59, 59, 999), n;
}
function go(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = n.getMonth();
  return n.setFullYear(n.getFullYear(), r + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function ou(e, t) {
  const [n, r] = vn(e, t.start, t.end);
  return { start: n, end: r };
}
function au(e, t) {
  const { start: n, end: r } = ou(t == null ? void 0 : t.in, e);
  let o = +n > +r;
  const a = o ? +n : +r, s = o ? r : n;
  s.setHours(0, 0, 0, 0), s.setDate(1);
  let i = 1;
  const d = [];
  for (; +s <= a; )
    d.push(Pe(n, s)), s.setMonth(s.getMonth() + i);
  return o ? d.reverse() : d;
}
function mr(e, t) {
  const n = pe(e, t == null ? void 0 : t.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function iu(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = n.getFullYear();
  return n.setFullYear(r + 1, 0, 0), n.setHours(23, 59, 59, 999), n;
}
function $o(e, t) {
  const n = pe(e, t == null ? void 0 : t.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function Ji(e, t) {
  var i, d, l, u;
  const n = $n(), r = (t == null ? void 0 : t.weekStartsOn) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.weekStartsOn) ?? n.weekStartsOn ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.weekStartsOn) ?? 0, o = pe(e, t == null ? void 0 : t.in), a = o.getDay(), s = (a < r ? -7 : 0) + 6 - (a - r);
  return o.setDate(o.getDate() + s), o.setHours(23, 59, 59, 999), o;
}
function su(e, t) {
  return Ji(e, { ...t, weekStartsOn: 1 });
}
const cu = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, lu = (e, t, n) => {
  let r;
  const o = cu[e];
  return typeof o == "string" ? r = o : t === 1 ? r = o.one : r = o.other.replace("{{count}}", t.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + r : r + " ago" : r;
};
function Br(e) {
  return (t = {}) => {
    const n = t.width ? String(t.width) : e.defaultWidth;
    return e.formats[n] || e.formats[e.defaultWidth];
  };
}
const du = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, uu = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, fu = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, pu = {
  date: Br({
    formats: du,
    defaultWidth: "full"
  }),
  time: Br({
    formats: uu,
    defaultWidth: "full"
  }),
  dateTime: Br({
    formats: fu,
    defaultWidth: "full"
  })
}, mu = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, hu = (e, t, n, r) => mu[e];
function On(e) {
  return (t, n) => {
    const r = n != null && n.context ? String(n.context) : "standalone";
    let o;
    if (r === "formatting" && e.formattingValues) {
      const s = e.defaultFormattingWidth || e.defaultWidth, i = n != null && n.width ? String(n.width) : s;
      o = e.formattingValues[i] || e.formattingValues[s];
    } else {
      const s = e.defaultWidth, i = n != null && n.width ? String(n.width) : e.defaultWidth;
      o = e.values[i] || e.values[s];
    }
    const a = e.argumentCallback ? e.argumentCallback(t) : t;
    return o[a];
  };
}
const vu = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, gu = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, xu = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, yu = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, bu = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, wu = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, ku = (e, t) => {
  const n = Number(e), r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Eu = {
  ordinalNumber: ku,
  era: On({
    values: vu,
    defaultWidth: "wide"
  }),
  quarter: On({
    values: gu,
    defaultWidth: "wide",
    argumentCallback: (e) => e - 1
  }),
  month: On({
    values: xu,
    defaultWidth: "wide"
  }),
  day: On({
    values: yu,
    defaultWidth: "wide"
  }),
  dayPeriod: On({
    values: bu,
    defaultWidth: "wide",
    formattingValues: wu,
    defaultFormattingWidth: "wide"
  })
};
function Sn(e) {
  return (t, n = {}) => {
    const r = n.width, o = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], a = t.match(o);
    if (!a)
      return null;
    const s = a[0], i = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], d = Array.isArray(i) ? Ou(i, (c) => c.test(s)) : (
      // [TODO] -- I challenge you to fix the type
      Cu(i, (c) => c.test(s))
    );
    let l;
    l = e.valueCallback ? e.valueCallback(d) : d, l = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(l)
    ) : l;
    const u = t.slice(s.length);
    return { value: l, rest: u };
  };
}
function Cu(e, t) {
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && t(e[n]))
      return n;
}
function Ou(e, t) {
  for (let n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function Su(e) {
  return (t, n = {}) => {
    const r = t.match(e.matchPattern);
    if (!r) return null;
    const o = r[0], a = t.match(e.parsePattern);
    if (!a) return null;
    let s = e.valueCallback ? e.valueCallback(a[0]) : a[0];
    s = n.valueCallback ? n.valueCallback(s) : s;
    const i = t.slice(o.length);
    return { value: s, rest: i };
  };
}
const Mu = /^(\d+)(th|st|nd|rd)?/i, Du = /\d+/i, Pu = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, _u = {
  any: [/^b/i, /^(a|c)/i]
}, Tu = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, Au = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ru = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Nu = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, ju = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Iu = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Fu = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Wu = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, $u = {
  ordinalNumber: Su({
    matchPattern: Mu,
    parsePattern: Du,
    valueCallback: (e) => parseInt(e, 10)
  }),
  era: Sn({
    matchPatterns: Pu,
    defaultMatchWidth: "wide",
    parsePatterns: _u,
    defaultParseWidth: "any"
  }),
  quarter: Sn({
    matchPatterns: Tu,
    defaultMatchWidth: "wide",
    parsePatterns: Au,
    defaultParseWidth: "any",
    valueCallback: (e) => e + 1
  }),
  month: Sn({
    matchPatterns: Ru,
    defaultMatchWidth: "wide",
    parsePatterns: Nu,
    defaultParseWidth: "any"
  }),
  day: Sn({
    matchPatterns: ju,
    defaultMatchWidth: "wide",
    parsePatterns: Iu,
    defaultParseWidth: "any"
  }),
  dayPeriod: Sn({
    matchPatterns: Fu,
    defaultMatchWidth: "any",
    parsePatterns: Wu,
    defaultParseWidth: "any"
  })
}, Lo = {
  code: "en-US",
  formatDistance: lu,
  formatLong: pu,
  formatRelative: hu,
  localize: Eu,
  match: $u,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function Lu(e, t) {
  const n = pe(e, t == null ? void 0 : t.in);
  return Zi(n, $o(n)) + 1;
}
function es(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = +Rn(n) - +Xd(n);
  return Math.round(r / Gi) + 1;
}
function ts(e, t) {
  var u, c, f, m;
  const n = pe(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = $n(), a = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((c = (u = t == null ? void 0 : t.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? o.firstWeekContainsDate ?? ((m = (f = o.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = Pe((t == null ? void 0 : t.in) || e, 0);
  s.setFullYear(r + 1, 0, a), s.setHours(0, 0, 0, 0);
  const i = fn(s, t), d = Pe((t == null ? void 0 : t.in) || e, 0);
  d.setFullYear(r, 0, a), d.setHours(0, 0, 0, 0);
  const l = fn(d, t);
  return +n >= +i ? r + 1 : +n >= +l ? r : r - 1;
}
function zu(e, t) {
  var i, d, l, u;
  const n = $n(), r = (t == null ? void 0 : t.firstWeekContainsDate) ?? ((d = (i = t == null ? void 0 : t.locale) == null ? void 0 : i.options) == null ? void 0 : d.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (l = n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, o = ts(e, t), a = Pe((t == null ? void 0 : t.in) || e, 0);
  return a.setFullYear(o, 0, r), a.setHours(0, 0, 0, 0), fn(a, t);
}
function ns(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = +fn(n, t) - +zu(n, t);
  return Math.round(r / Gi) + 1;
}
function fe(e, t) {
  const n = e < 0 ? "-" : "", r = Math.abs(e).toString().padStart(t, "0");
  return n + r;
}
const Rt = {
  // Year
  y(e, t) {
    const n = e.getFullYear(), r = n > 0 ? n : 1 - n;
    return fe(t === "yy" ? r % 100 : r, t.length);
  },
  // Month
  M(e, t) {
    const n = e.getMonth();
    return t === "M" ? String(n + 1) : fe(n + 1, 2);
  },
  // Day of the month
  d(e, t) {
    return fe(e.getDate(), t.length);
  },
  // AM or PM
  a(e, t) {
    const n = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(e, t) {
    return fe(e.getHours() % 12 || 12, t.length);
  },
  // Hour [0-23]
  H(e, t) {
    return fe(e.getHours(), t.length);
  },
  // Minute
  m(e, t) {
    return fe(e.getMinutes(), t.length);
  },
  // Second
  s(e, t) {
    return fe(e.getSeconds(), t.length);
  },
  // Fraction of second
  S(e, t) {
    const n = t.length, r = e.getMilliseconds(), o = Math.trunc(
      r * Math.pow(10, n - 3)
    );
    return fe(o, t.length);
  }
}, rn = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Ma = {
  // Era
  G: function(e, t, n) {
    const r = e.getFullYear() > 0 ? 1 : 0;
    switch (t) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(r, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(r, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(r, { width: "wide" });
    }
  },
  // Year
  y: function(e, t, n) {
    if (t === "yo") {
      const r = e.getFullYear(), o = r > 0 ? r : 1 - r;
      return n.ordinalNumber(o, { unit: "year" });
    }
    return Rt.y(e, t);
  },
  // Local week-numbering year
  Y: function(e, t, n, r) {
    const o = ts(e, r), a = o > 0 ? o : 1 - o;
    if (t === "YY") {
      const s = a % 100;
      return fe(s, 2);
    }
    return t === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : fe(a, t.length);
  },
  // ISO week-numbering year
  R: function(e, t) {
    const n = Xi(e);
    return fe(n, t.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(e, t) {
    const n = e.getFullYear();
    return fe(n, t.length);
  },
  // Quarter
  Q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "Q":
        return String(r);
      // 01, 02, 03, 04
      case "QQ":
        return fe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(r, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(e, t, n) {
    const r = Math.ceil((e.getMonth() + 1) / 3);
    switch (t) {
      // 1, 2, 3, 4
      case "q":
        return String(r);
      // 01, 02, 03, 04
      case "qq":
        return fe(r, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(r, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(r, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      case "M":
      case "MM":
        return Rt.M(e, t);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(r, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(r, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(e, t, n) {
    const r = e.getMonth();
    switch (t) {
      // 1, 2, ..., 12
      case "L":
        return String(r + 1);
      // 01, 02, ..., 12
      case "LL":
        return fe(r + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(r + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(r, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(r, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(e, t, n, r) {
    const o = ns(e, r);
    return t === "wo" ? n.ordinalNumber(o, { unit: "week" }) : fe(o, t.length);
  },
  // ISO week of year
  I: function(e, t, n) {
    const r = es(e);
    return t === "Io" ? n.ordinalNumber(r, { unit: "week" }) : fe(r, t.length);
  },
  // Day of the month
  d: function(e, t, n) {
    return t === "do" ? n.ordinalNumber(e.getDate(), { unit: "date" }) : Rt.d(e, t);
  },
  // Day of year
  D: function(e, t, n) {
    const r = Lu(e);
    return t === "Do" ? n.ordinalNumber(r, { unit: "dayOfYear" }) : fe(r, t.length);
  },
  // Day of week
  E: function(e, t, n) {
    const r = e.getDay();
    switch (t) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return fe(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(o, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(o, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(e, t, n, r) {
    const o = e.getDay(), a = (o - r.weekStartsOn + 8) % 7 || 7;
    switch (t) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return fe(a, t.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(o, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(o, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(e, t, n) {
    const r = e.getDay(), o = r === 0 ? 7 : r;
    switch (t) {
      // 2
      case "i":
        return String(o);
      // 02
      case "ii":
        return fe(o, t.length);
      // 2nd
      case "io":
        return n.ordinalNumber(o, { unit: "day" });
      // Tue
      case "iii":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(e, t, n) {
    const o = e.getHours() / 12 >= 1 ? "pm" : "am";
    switch (t) {
      case "a":
      case "aa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r === 12 ? o = rn.noon : r === 0 ? o = rn.midnight : o = r / 12 >= 1 ? "pm" : "am", t) {
      case "b":
      case "bb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(e, t, n) {
    const r = e.getHours();
    let o;
    switch (r >= 17 ? o = rn.evening : r >= 12 ? o = rn.afternoon : r >= 4 ? o = rn.morning : o = rn.night, t) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(e, t, n) {
    if (t === "ho") {
      let r = e.getHours() % 12;
      return r === 0 && (r = 12), n.ordinalNumber(r, { unit: "hour" });
    }
    return Rt.h(e, t);
  },
  // Hour [0-23]
  H: function(e, t, n) {
    return t === "Ho" ? n.ordinalNumber(e.getHours(), { unit: "hour" }) : Rt.H(e, t);
  },
  // Hour [0-11]
  K: function(e, t, n) {
    const r = e.getHours() % 12;
    return t === "Ko" ? n.ordinalNumber(r, { unit: "hour" }) : fe(r, t.length);
  },
  // Hour [1-24]
  k: function(e, t, n) {
    let r = e.getHours();
    return r === 0 && (r = 24), t === "ko" ? n.ordinalNumber(r, { unit: "hour" }) : fe(r, t.length);
  },
  // Minute
  m: function(e, t, n) {
    return t === "mo" ? n.ordinalNumber(e.getMinutes(), { unit: "minute" }) : Rt.m(e, t);
  },
  // Second
  s: function(e, t, n) {
    return t === "so" ? n.ordinalNumber(e.getSeconds(), { unit: "second" }) : Rt.s(e, t);
  },
  // Fraction of second
  S: function(e, t) {
    return Rt.S(e, t);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(e, t, n) {
    const r = e.getTimezoneOffset();
    if (r === 0)
      return "Z";
    switch (t) {
      // Hours and optional minutes
      case "X":
        return Pa(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ut(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Ut(r, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Hours and optional minutes
      case "x":
        return Pa(r);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ut(r);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Ut(r, ":");
    }
  },
  // Timezone (GMT)
  O: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Da(r, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Ut(r, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(e, t, n) {
    const r = e.getTimezoneOffset();
    switch (t) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Da(r, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Ut(r, ":");
    }
  },
  // Seconds timestamp
  t: function(e, t, n) {
    const r = Math.trunc(+e / 1e3);
    return fe(r, t.length);
  },
  // Milliseconds timestamp
  T: function(e, t, n) {
    return fe(+e, t.length);
  }
};
function Da(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = Math.trunc(r / 60), a = r % 60;
  return a === 0 ? n + String(o) : n + String(o) + t + fe(a, 2);
}
function Pa(e, t) {
  return e % 60 === 0 ? (e > 0 ? "-" : "+") + fe(Math.abs(e) / 60, 2) : Ut(e, t);
}
function Ut(e, t = "") {
  const n = e > 0 ? "-" : "+", r = Math.abs(e), o = fe(Math.trunc(r / 60), 2), a = fe(r % 60, 2);
  return n + o + t + a;
}
const _a = (e, t) => {
  switch (e) {
    case "P":
      return t.date({ width: "short" });
    case "PP":
      return t.date({ width: "medium" });
    case "PPP":
      return t.date({ width: "long" });
    case "PPPP":
    default:
      return t.date({ width: "full" });
  }
}, rs = (e, t) => {
  switch (e) {
    case "p":
      return t.time({ width: "short" });
    case "pp":
      return t.time({ width: "medium" });
    case "ppp":
      return t.time({ width: "long" });
    case "pppp":
    default:
      return t.time({ width: "full" });
  }
}, Bu = (e, t) => {
  const n = e.match(/(P+)(p+)?/) || [], r = n[1], o = n[2];
  if (!o)
    return _a(e, t);
  let a;
  switch (r) {
    case "P":
      a = t.dateTime({ width: "short" });
      break;
    case "PP":
      a = t.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = t.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = t.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", _a(r, t)).replace("{{time}}", rs(o, t));
}, Yu = {
  p: rs,
  P: Bu
}, Hu = /^D+$/, qu = /^Y+$/, Vu = ["D", "DD", "YY", "YYYY"];
function Uu(e) {
  return Hu.test(e);
}
function Gu(e) {
  return qu.test(e);
}
function Ku(e, t, n) {
  const r = Xu(e, t, n);
  if (console.warn(r), Vu.includes(e)) throw new RangeError(r);
}
function Xu(e, t, n) {
  const r = e[0] === "Y" ? "years" : "days of the month";
  return `Use \`${e.toLowerCase()}\` instead of \`${e}\` (in \`${t}\`) for formatting ${r} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const Zu = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Qu = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Ju = /^'([^]*?)'?$/, ef = /''/g, tf = /[a-zA-Z]/;
function Dn(e, t, n) {
  var u, c, f, m, y, h, g, k;
  const r = $n(), o = (n == null ? void 0 : n.locale) ?? r.locale ?? Lo, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((c = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : c.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((m = (f = r.locale) == null ? void 0 : f.options) == null ? void 0 : m.firstWeekContainsDate) ?? 1, s = (n == null ? void 0 : n.weekStartsOn) ?? ((h = (y = n == null ? void 0 : n.locale) == null ? void 0 : y.options) == null ? void 0 : h.weekStartsOn) ?? r.weekStartsOn ?? ((k = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : k.weekStartsOn) ?? 0, i = pe(e, n == null ? void 0 : n.in);
  if (!nu(i))
    throw new RangeError("Invalid time value");
  let d = t.match(Qu).map((C) => {
    const E = C[0];
    if (E === "p" || E === "P") {
      const O = Yu[E];
      return O(C, o.formatLong);
    }
    return C;
  }).join("").match(Zu).map((C) => {
    if (C === "''")
      return { isToken: !1, value: "'" };
    const E = C[0];
    if (E === "'")
      return { isToken: !1, value: nf(C) };
    if (Ma[E])
      return { isToken: !0, value: C };
    if (E.match(tf))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + E + "`"
      );
    return { isToken: !1, value: C };
  });
  o.localize.preprocessor && (d = o.localize.preprocessor(i, d));
  const l = {
    firstWeekContainsDate: a,
    weekStartsOn: s,
    locale: o
  };
  return d.map((C) => {
    if (!C.isToken) return C.value;
    const E = C.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && Gu(E) || !(n != null && n.useAdditionalDayOfYearTokens) && Uu(E)) && Ku(E, t, String(e));
    const O = Ma[E[0]];
    return O(i, E, o.localize, l);
  }).join("");
}
function nf(e) {
  const t = e.match(Ju);
  return t ? t[1].replace(ef, "'") : e;
}
function rf(e, t) {
  const n = pe(e, t == null ? void 0 : t.in), r = n.getFullYear(), o = n.getMonth(), a = Pe(n, 0);
  return a.setFullYear(r, o + 1, 0), a.setHours(0, 0, 0, 0), a.getDate();
}
function of(e, t) {
  return pe(e, t == null ? void 0 : t.in).getMonth();
}
function af(e, t) {
  return pe(e, t == null ? void 0 : t.in).getFullYear();
}
function sf(e, t) {
  return +pe(e) > +pe(t);
}
function cf(e, t) {
  return +pe(e) < +pe(t);
}
function lf(e, t, n) {
  const [r, o] = vn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear() && r.getMonth() === o.getMonth();
}
function df(e, t, n) {
  const [r, o] = vn(
    n == null ? void 0 : n.in,
    e,
    t
  );
  return r.getFullYear() === o.getFullYear();
}
function Pn(e, t, n) {
  return Wo(e, -t, n);
}
function uf(e, t, n) {
  const r = pe(e, n == null ? void 0 : n.in), o = r.getFullYear(), a = r.getDate(), s = Pe(e, 0);
  s.setFullYear(o, t, 15), s.setHours(0, 0, 0, 0);
  const i = rf(s);
  return r.setMonth(t, Math.min(a, i)), r;
}
function ff(e, t, n) {
  const r = pe(e, n == null ? void 0 : n.in);
  return isNaN(+r) ? Pe(e, NaN) : (r.setFullYear(t), r);
}
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const pf = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), os = (...e) => e.filter((t, n, r) => !!t && t.trim() !== "" && r.indexOf(t) === n).join(" ").trim();
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var mf = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const hf = Je(
  ({
    color: e = "currentColor",
    size: t = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: r,
    className: o = "",
    children: a,
    iconNode: s,
    ...i
  }, d) => vo(
    "svg",
    {
      ref: d,
      ...mf,
      width: t,
      height: t,
      stroke: e,
      strokeWidth: r ? Number(n) * 24 / Number(t) : n,
      className: os("lucide", o),
      ...i
    },
    [
      ...s.map(([l, u]) => vo(l, u)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const en = (e, t) => {
  const n = Je(
    ({ className: r, ...o }, a) => vo(hf, {
      ref: a,
      iconNode: t,
      className: os(`lucide-${pf(e)}`, r),
      ...o
    })
  );
  return n.displayName = `${e}`, n;
};
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const vf = [
  ["path", { d: "M8 2v4", key: "1cmpym" }],
  ["path", { d: "M16 2v4", key: "4m81vk" }],
  ["rect", { width: "18", height: "18", x: "3", y: "4", rx: "2", key: "1hopcy" }],
  ["path", { d: "M3 10h18", key: "8toen8" }]
], gf = en("Calendar", vf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const xf = [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]], yf = en("Check", xf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const bf = [["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]], wf = en("ChevronRight", bf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const kf = [["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]], Ef = en("Circle", kf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Cf = [
  ["path", { d: "M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z", key: "1rqfz7" }],
  ["path", { d: "M14 2v4a2 2 0 0 0 2 2h4", key: "tnqrlb" }],
  ["path", { d: "M10 9H8", key: "b1mrlr" }],
  ["path", { d: "M16 13H8", key: "t4e002" }],
  ["path", { d: "M16 17H8", key: "z1uh3a" }]
], Of = en("FileText", Cf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Sf = [["path", { d: "M21 12a9 9 0 1 1-6.219-8.56", key: "13zald" }]], zo = en("LoaderCircle", Sf);
/**
 * @license lucide-react v0.473.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Mf = [
  ["path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4", key: "ih7n3h" }],
  ["polyline", { points: "17 8 12 3 7 8", key: "t8dd8p" }],
  ["line", { x1: "12", x2: "12", y1: "3", y2: "15", key: "widbto" }]
], as = en("Upload", Mf);
function Df(e, t, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: e,
    timeZoneName: n
  }).format(t).split(/\s/g).slice(2).join(" ");
}
const Yr = {}, _n = {};
function Kt(e, t) {
  try {
    const r = (Yr[e] || (Yr[e] = new Intl.DateTimeFormat("en-US", {
      timeZone: e,
      timeZoneName: "longOffset"
    }).format))(t).split("GMT")[1];
    return r in _n ? _n[r] : Ta(r, r.split(":"));
  } catch {
    if (e in _n) return _n[e];
    const n = e == null ? void 0 : e.match(Pf);
    return n ? Ta(e, n.slice(1)) : NaN;
  }
}
const Pf = /([+-]\d\d):?(\d\d)?/;
function Ta(e, t) {
  const n = +(t[0] || 0), r = +(t[1] || 0), o = +(t[2] || 0) / 60;
  return _n[e] = n * 60 + r > 0 ? n * 60 + r + o : n * 60 - r - o;
}
class pt extends Date {
  //#region static
  constructor(...t) {
    super(), t.length > 1 && typeof t[t.length - 1] == "string" && (this.timeZone = t.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Kt(this.timeZone, this)) ? this.setTime(NaN) : t.length ? typeof t[0] == "number" && (t.length === 1 || t.length === 2 && typeof t[1] != "number") ? this.setTime(t[0]) : typeof t[0] == "string" ? this.setTime(+new Date(t[0])) : t[0] instanceof Date ? this.setTime(+t[0]) : (this.setTime(+new Date(...t)), is(this), xo(this)) : this.setTime(Date.now());
  }
  static tz(t, ...n) {
    return n.length ? new pt(...n, t) : new pt(Date.now(), t);
  }
  //#endregion
  //#region time zone
  withTimeZone(t) {
    return new pt(+this, t);
  }
  getTimezoneOffset() {
    const t = -Kt(this.timeZone, this);
    return t > 0 ? Math.floor(t) : Math.ceil(t);
  }
  //#endregion
  //#region time
  setTime(t) {
    return Date.prototype.setTime.apply(this, arguments), xo(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new pt(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Aa = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((e) => {
  if (!Aa.test(e)) return;
  const t = e.replace(Aa, "$1UTC");
  pt.prototype[t] && (e.startsWith("get") ? pt.prototype[e] = function() {
    return this.internal[t]();
  } : (pt.prototype[e] = function() {
    return Date.prototype[t].apply(this.internal, arguments), _f(this), +this;
  }, pt.prototype[t] = function() {
    return Date.prototype[t].apply(this, arguments), xo(this), +this;
  }));
});
function xo(e) {
  e.internal.setTime(+e), e.internal.setUTCSeconds(e.internal.getUTCSeconds() - Math.round(-Kt(e.timeZone, e) * 60));
}
function _f(e) {
  Date.prototype.setFullYear.call(e, e.internal.getUTCFullYear(), e.internal.getUTCMonth(), e.internal.getUTCDate()), Date.prototype.setHours.call(e, e.internal.getUTCHours(), e.internal.getUTCMinutes(), e.internal.getUTCSeconds(), e.internal.getUTCMilliseconds()), is(e);
}
function is(e) {
  const t = Kt(e.timeZone, e), n = t > 0 ? Math.floor(t) : Math.ceil(t), r = /* @__PURE__ */ new Date(+e);
  r.setUTCHours(r.getUTCHours() - 1);
  const o = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset(), a = -(/* @__PURE__ */ new Date(+r)).getTimezoneOffset(), s = o - a, i = Date.prototype.getHours.apply(e) !== e.internal.getUTCHours();
  s && i && e.internal.setUTCMinutes(e.internal.getUTCMinutes() + s);
  const d = o - n;
  d && Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + d);
  const l = /* @__PURE__ */ new Date(+e);
  l.setUTCSeconds(0);
  const u = o > 0 ? l.getSeconds() : (l.getSeconds() - 60) % 60, c = Math.round(-(Kt(e.timeZone, e) * 60)) % 60;
  (c || u) && (e.internal.setUTCSeconds(e.internal.getUTCSeconds() + c), Date.prototype.setUTCSeconds.call(e, Date.prototype.getUTCSeconds.call(e) + c + u));
  const f = Kt(e.timeZone, e), m = f > 0 ? Math.floor(f) : Math.ceil(f), h = -(/* @__PURE__ */ new Date(+e)).getTimezoneOffset() - m, g = m !== n, k = h - d;
  if (g && k) {
    Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + k);
    const C = Kt(e.timeZone, e), E = C > 0 ? Math.floor(C) : Math.ceil(C), O = m - E;
    O && (e.internal.setUTCMinutes(e.internal.getUTCMinutes() + O), Date.prototype.setUTCMinutes.call(e, Date.prototype.getUTCMinutes.call(e) + O));
  }
}
class Ne extends pt {
  //#region static
  static tz(t, ...n) {
    return n.length ? new Ne(...n, t) : new Ne(Date.now(), t);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [t, n, r] = this.tzComponents(), o = `${t}${n}:${r}`;
    return this.internal.toISOString().slice(0, -1) + o;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [t, n, r, o] = this.internal.toUTCString().split(" ");
    return `${t == null ? void 0 : t.slice(0, -1)} ${r} ${n} ${o}`;
  }
  toTimeString() {
    const t = this.internal.toUTCString().split(" ")[4], [n, r, o] = this.tzComponents();
    return `${t} GMT${n}${r}${o} (${Df(this.timeZone, this)})`;
  }
  toLocaleString(t, n) {
    return Date.prototype.toLocaleString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(t, n) {
    return Date.prototype.toLocaleDateString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(t, n) {
    return Date.prototype.toLocaleTimeString.call(this, t, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const t = this.getTimezoneOffset(), n = t > 0 ? "-" : "+", r = String(Math.floor(Math.abs(t) / 60)).padStart(2, "0"), o = String(Math.abs(t) % 60).padStart(2, "0");
    return [n, r, o];
  }
  //#endregion
  withTimeZone(t) {
    return new Ne(+this, t);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](t) {
    return new Ne(+new Date(t), this.timeZone);
  }
  //#endregion
}
const Ra = 5, Tf = 4;
function Af(e, t) {
  const n = t.startOfMonth(e), r = n.getDay() > 0 ? n.getDay() : 7, o = t.addDays(e, -r + 1), a = t.addDays(o, Ra * 7 - 1);
  return t.getMonth(e) === t.getMonth(a) ? Ra : Tf;
}
function ss(e, t) {
  const n = t.startOfMonth(e), r = n.getDay();
  return r === 1 ? n : r === 0 ? t.addDays(n, -6) : t.addDays(n, -1 * (r - 1));
}
function Rf(e, t) {
  const n = ss(e, t), r = Af(e, t);
  return t.addDays(n, r * 7 - 1);
}
class Mt {
  /**
   * Creates an instance of `DateLib`.
   *
   * @param options Configuration options for the date library.
   * @param overrides Custom overrides for the date library functions.
   */
  constructor(t, n) {
    this.Date = Date, this.today = () => {
      var r;
      return (r = this.overrides) != null && r.today ? this.overrides.today() : this.options.timeZone ? Ne.tz(this.options.timeZone) : new this.Date();
    }, this.newDate = (r, o, a) => {
      var s;
      return (s = this.overrides) != null && s.newDate ? this.overrides.newDate(r, o, a) : this.options.timeZone ? new Ne(r, o, a, this.options.timeZone) : new Date(r, o, a);
    }, this.addDays = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addDays ? this.overrides.addDays(r, o) : Wo(r, o);
    }, this.addMonths = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addMonths ? this.overrides.addMonths(r, o) : Ki(r, o);
    }, this.addWeeks = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addWeeks ? this.overrides.addWeeks(r, o) : Zd(r, o);
    }, this.addYears = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.addYears ? this.overrides.addYears(r, o) : Qd(r, o);
    }, this.differenceInCalendarDays = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarDays ? this.overrides.differenceInCalendarDays(r, o) : Zi(r, o);
    }, this.differenceInCalendarMonths = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.differenceInCalendarMonths ? this.overrides.differenceInCalendarMonths(r, o) : ru(r, o);
    }, this.eachMonthOfInterval = (r) => {
      var o;
      return (o = this.overrides) != null && o.eachMonthOfInterval ? this.overrides.eachMonthOfInterval(r) : au(r);
    }, this.endOfBroadcastWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfBroadcastWeek ? this.overrides.endOfBroadcastWeek(r) : Rf(r, this);
    }, this.endOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfISOWeek ? this.overrides.endOfISOWeek(r) : su(r);
    }, this.endOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfMonth ? this.overrides.endOfMonth(r) : go(r);
    }, this.endOfWeek = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.endOfWeek ? this.overrides.endOfWeek(r, o) : Ji(r, this.options);
    }, this.endOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.endOfYear ? this.overrides.endOfYear(r) : iu(r);
    }, this.format = (r, o, a) => {
      var i;
      const s = (i = this.overrides) != null && i.format ? this.overrides.format(r, o, this.options) : Dn(r, o, this.options);
      return this.options.numerals && this.options.numerals !== "latn" ? this.replaceDigits(s) : s;
    }, this.getISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.getISOWeek ? this.overrides.getISOWeek(r) : es(r);
    }, this.getMonth = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.getMonth ? this.overrides.getMonth(r, this.options) : of(r, this.options);
    }, this.getYear = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.getYear ? this.overrides.getYear(r, this.options) : af(r, this.options);
    }, this.getWeek = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.getWeek ? this.overrides.getWeek(r, this.options) : ns(r, this.options);
    }, this.isAfter = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isAfter ? this.overrides.isAfter(r, o) : sf(r, o);
    }, this.isBefore = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isBefore ? this.overrides.isBefore(r, o) : cf(r, o);
    }, this.isDate = (r) => {
      var o;
      return (o = this.overrides) != null && o.isDate ? this.overrides.isDate(r) : Qi(r);
    }, this.isSameDay = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameDay ? this.overrides.isSameDay(r, o) : tu(r, o);
    }, this.isSameMonth = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameMonth ? this.overrides.isSameMonth(r, o) : lf(r, o);
    }, this.isSameYear = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.isSameYear ? this.overrides.isSameYear(r, o) : df(r, o);
    }, this.max = (r) => {
      var o;
      return (o = this.overrides) != null && o.max ? this.overrides.max(r) : Jd(r);
    }, this.min = (r) => {
      var o;
      return (o = this.overrides) != null && o.min ? this.overrides.min(r) : eu(r);
    }, this.setMonth = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.setMonth ? this.overrides.setMonth(r, o) : uf(r, o);
    }, this.setYear = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.setYear ? this.overrides.setYear(r, o) : ff(r, o);
    }, this.startOfBroadcastWeek = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.startOfBroadcastWeek ? this.overrides.startOfBroadcastWeek(r, this) : ss(r, this);
    }, this.startOfDay = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfDay ? this.overrides.startOfDay(r) : Ft(r);
    }, this.startOfISOWeek = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfISOWeek ? this.overrides.startOfISOWeek(r) : Rn(r);
    }, this.startOfMonth = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfMonth ? this.overrides.startOfMonth(r) : mr(r);
    }, this.startOfWeek = (r, o) => {
      var a;
      return (a = this.overrides) != null && a.startOfWeek ? this.overrides.startOfWeek(r, this.options) : fn(r, this.options);
    }, this.startOfYear = (r) => {
      var o;
      return (o = this.overrides) != null && o.startOfYear ? this.overrides.startOfYear(r) : $o(r);
    }, this.options = { locale: Lo, ...t }, this.overrides = n;
  }
  /**
   * Generates a mapping of Arabic digits (0-9) to the target numbering system
   * digits.
   *
   * @since 9.5.0
   * @returns A record mapping Arabic digits to the target numerals.
   */
  getDigitMap() {
    const { numerals: t = "latn" } = this.options, n = new Intl.NumberFormat("en-US", {
      numberingSystem: t
    }), r = {};
    for (let o = 0; o < 10; o++)
      r[o.toString()] = n.format(o);
    return r;
  }
  /**
   * Replaces Arabic digits in a string with the target numbering system digits.
   *
   * @since 9.5.0
   * @param input The string containing Arabic digits.
   * @returns The string with digits replaced.
   */
  replaceDigits(t) {
    const n = this.getDigitMap();
    return t.replace(/\d/g, (r) => n[r] || r);
  }
  /**
   * Formats a number using the configured numbering system.
   *
   * @since 9.5.0
   * @param value The number to format.
   * @returns The formatted number as a string.
   */
  formatNumber(t) {
    return this.replaceDigits(t.toString());
  }
}
const gt = new Mt();
class cs {
  constructor(t, n, r = gt) {
    this.date = t, this.displayMonth = n, this.outside = !!(n && !r.isSameMonth(t, n)), this.dateLib = r;
  }
  /**
   * Checks if this day is equal to another `CalendarDay`, considering both the
   * date and the displayed month.
   *
   * @param day The `CalendarDay` to compare with.
   * @returns `true` if the days are equal, otherwise `false`.
   */
  isEqualTo(t) {
    return this.dateLib.isSameDay(t.date, this.date) && this.dateLib.isSameMonth(t.displayMonth, this.displayMonth);
  }
}
class Nf {
  constructor(t, n) {
    this.date = t, this.weeks = n;
  }
}
class jf {
  constructor(t, n) {
    this.days = n, this.weekNumber = t;
  }
}
function If(e) {
  return w.createElement("button", { ...e });
}
function Ff(e) {
  return w.createElement("span", { ...e });
}
function Wf(e) {
  const { size: t = 24, orientation: n = "left", className: r } = e;
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: handled by the parent component
    w.createElement(
      "svg",
      { className: r, width: t, height: t, viewBox: "0 0 24 24" },
      n === "up" && w.createElement("polygon", { points: "6.77 17 12.5 11.43 18.24 17 20 15.28 12.5 8 5 15.28" }),
      n === "down" && w.createElement("polygon", { points: "6.77 8 12.5 13.57 18.24 8 20 9.72 12.5 17 5 9.72" }),
      n === "left" && w.createElement("polygon", { points: "16 18.112 9.81111111 12 16 5.87733333 14.0888889 4 6 12 14.0888889 20" }),
      n === "right" && w.createElement("polygon", { points: "8 18.112 14.18888889 12 8 5.87733333 9.91111111 4 18 12 9.91111111 20" })
    )
  );
}
function $f(e) {
  const { day: t, modifiers: n, ...r } = e;
  return w.createElement("td", { ...r });
}
function Lf(e) {
  const { day: t, modifiers: n, ...r } = e, o = w.useRef(null);
  return w.useEffect(() => {
    var a;
    n.focused && ((a = o.current) == null || a.focus());
  }, [n.focused]), w.createElement("button", { ref: o, ...r });
}
var te;
(function(e) {
  e.Root = "root", e.Chevron = "chevron", e.Day = "day", e.DayButton = "day_button", e.CaptionLabel = "caption_label", e.Dropdowns = "dropdowns", e.Dropdown = "dropdown", e.DropdownRoot = "dropdown_root", e.Footer = "footer", e.MonthGrid = "month_grid", e.MonthCaption = "month_caption", e.MonthsDropdown = "months_dropdown", e.Month = "month", e.Months = "months", e.Nav = "nav", e.NextMonthButton = "button_next", e.PreviousMonthButton = "button_previous", e.Week = "week", e.Weeks = "weeks", e.Weekday = "weekday", e.Weekdays = "weekdays", e.WeekNumber = "week_number", e.WeekNumberHeader = "week_number_header", e.YearsDropdown = "years_dropdown";
})(te || (te = {}));
var Ee;
(function(e) {
  e.disabled = "disabled", e.hidden = "hidden", e.outside = "outside", e.focused = "focused", e.today = "today";
})(Ee || (Ee = {}));
var ot;
(function(e) {
  e.range_end = "range_end", e.range_middle = "range_middle", e.range_start = "range_start", e.selected = "selected";
})(ot || (ot = {}));
var Be;
(function(e) {
  e.weeks_before_enter = "weeks_before_enter", e.weeks_before_exit = "weeks_before_exit", e.weeks_after_enter = "weeks_after_enter", e.weeks_after_exit = "weeks_after_exit", e.caption_after_enter = "caption_after_enter", e.caption_after_exit = "caption_after_exit", e.caption_before_enter = "caption_before_enter", e.caption_before_exit = "caption_before_exit";
})(Be || (Be = {}));
function zf(e) {
  const { options: t, className: n, components: r, classNames: o, ...a } = e, s = [o[te.Dropdown], n].join(" "), i = t == null ? void 0 : t.find(({ value: d }) => d === a.value);
  return w.createElement(
    "span",
    { "data-disabled": a.disabled, className: o[te.DropdownRoot] },
    w.createElement(r.Select, { className: s, ...a }, t == null ? void 0 : t.map(({ value: d, label: l, disabled: u }) => w.createElement(r.Option, { key: d, value: d, disabled: u }, l))),
    w.createElement(
      "span",
      { className: o[te.CaptionLabel], "aria-hidden": !0 },
      i == null ? void 0 : i.label,
      w.createElement(r.Chevron, { orientation: "down", size: 18, className: o[te.Chevron] })
    )
  );
}
function Bf(e) {
  return w.createElement("div", { ...e });
}
function Yf(e) {
  return w.createElement("div", { ...e });
}
function Hf(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return w.createElement("div", { ...r }, e.children);
}
function qf(e) {
  const { calendarMonth: t, displayIndex: n, ...r } = e;
  return w.createElement("div", { ...r });
}
function Vf(e) {
  return w.createElement("table", { ...e });
}
function Uf(e) {
  return w.createElement("div", { ...e });
}
const ls = $d(void 0);
function Ln() {
  const e = Ld(ls);
  if (e === void 0)
    throw new Error("useDayPicker() must be used within a custom component.");
  return e;
}
function Gf(e) {
  const { components: t } = Ln();
  return w.createElement(t.Dropdown, { ...e });
}
function Kf(e) {
  const { onPreviousClick: t, onNextClick: n, previousMonth: r, nextMonth: o, ...a } = e, { components: s, classNames: i, labels: { labelPrevious: d, labelNext: l } } = Ln(), u = be((f) => {
    o && (n == null || n(f));
  }, [o, n]), c = be((f) => {
    r && (t == null || t(f));
  }, [r, t]);
  return w.createElement(
    "nav",
    { ...a },
    w.createElement(
      s.PreviousMonthButton,
      { type: "button", className: i[te.PreviousMonthButton], tabIndex: r ? void 0 : -1, "aria-disabled": r ? void 0 : !0, "aria-label": d(r), onClick: c },
      w.createElement(s.Chevron, { disabled: r ? void 0 : !0, className: i[te.Chevron], orientation: "left" })
    ),
    w.createElement(
      s.NextMonthButton,
      { type: "button", className: i[te.NextMonthButton], tabIndex: o ? void 0 : -1, "aria-disabled": o ? void 0 : !0, "aria-label": l(o), onClick: u },
      w.createElement(s.Chevron, { disabled: o ? void 0 : !0, orientation: "right", className: i[te.Chevron] })
    )
  );
}
function Xf(e) {
  const { components: t } = Ln();
  return w.createElement(t.Button, { ...e });
}
function Zf(e) {
  return w.createElement("option", { ...e });
}
function Qf(e) {
  const { components: t } = Ln();
  return w.createElement(t.Button, { ...e });
}
function Jf(e) {
  const { rootRef: t, ...n } = e;
  return w.createElement("div", { ...n, ref: t });
}
function ep(e) {
  return w.createElement("select", { ...e });
}
function tp(e) {
  const { week: t, ...n } = e;
  return w.createElement("tr", { ...n });
}
function np(e) {
  return w.createElement("th", { ...e });
}
function rp(e) {
  return w.createElement(
    "thead",
    { "aria-hidden": !0 },
    w.createElement("tr", { ...e })
  );
}
function op(e) {
  const { week: t, ...n } = e;
  return w.createElement("th", { ...n });
}
function ap(e) {
  return w.createElement("th", { ...e });
}
function ip(e) {
  return w.createElement("tbody", { ...e });
}
function sp(e) {
  const { components: t } = Ln();
  return w.createElement(t.Dropdown, { ...e });
}
const cp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Button: If,
  CaptionLabel: Ff,
  Chevron: Wf,
  Day: $f,
  DayButton: Lf,
  Dropdown: zf,
  DropdownNav: Bf,
  Footer: Yf,
  Month: Hf,
  MonthCaption: qf,
  MonthGrid: Vf,
  Months: Uf,
  MonthsDropdown: Gf,
  Nav: Kf,
  NextMonthButton: Xf,
  Option: Zf,
  PreviousMonthButton: Qf,
  Root: Jf,
  Select: ep,
  Week: tp,
  WeekNumber: op,
  WeekNumberHeader: ap,
  Weekday: np,
  Weekdays: rp,
  Weeks: ip,
  YearsDropdown: sp
}, Symbol.toStringTag, { value: "Module" }));
function kt(e, t, n = !1, r = gt) {
  let { from: o, to: a } = e;
  const { differenceInCalendarDays: s, isSameDay: i } = r;
  return o && a ? (s(a, o) < 0 && ([o, a] = [a, o]), s(t, o) >= (n ? 1 : 0) && s(a, t) >= (n ? 1 : 0)) : !n && a ? i(a, t) : !n && o ? i(o, t) : !1;
}
function ds(e) {
  return !!(e && typeof e == "object" && "before" in e && "after" in e);
}
function Bo(e) {
  return !!(e && typeof e == "object" && "from" in e);
}
function us(e) {
  return !!(e && typeof e == "object" && "after" in e);
}
function fs(e) {
  return !!(e && typeof e == "object" && "before" in e);
}
function ps(e) {
  return !!(e && typeof e == "object" && "dayOfWeek" in e);
}
function ms(e, t) {
  return Array.isArray(e) && e.every(t.isDate);
}
function Et(e, t, n = gt) {
  const r = Array.isArray(t) ? t : [t], { isSameDay: o, differenceInCalendarDays: a, isAfter: s } = n;
  return r.some((i) => {
    if (typeof i == "boolean")
      return i;
    if (n.isDate(i))
      return o(e, i);
    if (ms(i, n))
      return i.includes(e);
    if (Bo(i))
      return kt(i, e, !1, n);
    if (ps(i))
      return Array.isArray(i.dayOfWeek) ? i.dayOfWeek.includes(e.getDay()) : i.dayOfWeek === e.getDay();
    if (ds(i)) {
      const d = a(i.before, e), l = a(i.after, e), u = d > 0, c = l < 0;
      return s(i.before, i.after) ? c && u : u || c;
    }
    return us(i) ? a(e, i.after) > 0 : fs(i) ? a(i.before, e) > 0 : typeof i == "function" ? i(e) : !1;
  });
}
function lp(e, t, n, r, o) {
  const { disabled: a, hidden: s, modifiers: i, showOutsideDays: d, broadcastCalendar: l, today: u } = t, { isSameDay: c, isSameMonth: f, startOfMonth: m, isBefore: y, endOfMonth: h, isAfter: g } = o, k = n && m(n), C = r && h(r), E = {
    [Ee.focused]: [],
    [Ee.outside]: [],
    [Ee.disabled]: [],
    [Ee.hidden]: [],
    [Ee.today]: []
  }, O = {};
  for (const v of e) {
    const { date: P, displayMonth: M } = v, D = !!(M && !f(P, M)), L = !!(k && y(P, k)), Y = !!(C && g(P, C)), U = !!(a && Et(P, a, o)), J = !!(s && Et(P, s, o)) || L || Y || // Broadcast calendar will show outside days as default
    !l && !d && D || l && d === !1 && D, ee = c(P, u ?? o.today());
    D && E.outside.push(v), U && E.disabled.push(v), J && E.hidden.push(v), ee && E.today.push(v), i && Object.keys(i).forEach((q) => {
      const G = i == null ? void 0 : i[q];
      G && Et(P, G, o) && (O[q] ? O[q].push(v) : O[q] = [v]);
    });
  }
  return (v) => {
    const P = {
      [Ee.focused]: !1,
      [Ee.disabled]: !1,
      [Ee.hidden]: !1,
      [Ee.outside]: !1,
      [Ee.today]: !1
    }, M = {};
    for (const D in E) {
      const L = E[D];
      P[D] = L.some((Y) => Y === v);
    }
    for (const D in O)
      M[D] = O[D].some((L) => L === v);
    return {
      ...P,
      // custom modifiers should override all the previous ones
      ...M
    };
  };
}
function dp(e, t, n = {}) {
  return Object.entries(e).filter(([, o]) => o === !0).reduce((o, [a]) => (n[a] ? o.push(n[a]) : t[Ee[a]] ? o.push(t[Ee[a]]) : t[ot[a]] && o.push(t[ot[a]]), o), [t[te.Day]]);
}
function up(e) {
  return {
    ...cp,
    ...e
  };
}
function fp(e) {
  const t = {
    "data-mode": e.mode ?? void 0,
    "data-required": "required" in e ? e.required : void 0,
    "data-multiple-months": e.numberOfMonths && e.numberOfMonths > 1 || void 0,
    "data-week-numbers": e.showWeekNumber || void 0,
    "data-broadcast-calendar": e.broadcastCalendar || void 0,
    "data-nav-layout": e.navLayout || void 0
  };
  return Object.entries(e).forEach(([n, r]) => {
    n.startsWith("data-") && (t[n] = r);
  }), t;
}
function pp() {
  const e = {};
  for (const t in te)
    e[te[t]] = `rdp-${te[t]}`;
  for (const t in Ee)
    e[Ee[t]] = `rdp-${Ee[t]}`;
  for (const t in ot)
    e[ot[t]] = `rdp-${ot[t]}`;
  for (const t in Be)
    e[Be[t]] = `rdp-${Be[t]}`;
  return e;
}
function hs(e, t, n) {
  return (n ?? new Mt(t)).format(e, "LLLL y");
}
const mp = hs;
function hp(e, t, n) {
  return (n ?? new Mt(t)).format(e, "d");
}
function vp(e, t = gt) {
  return t.format(e, "LLLL");
}
function gp(e, t, n) {
  return (n ?? new Mt(t)).format(e, "cccccc");
}
function xp(e, t = gt) {
  return e < 10 ? t.formatNumber(`0${e.toLocaleString()}`) : t.formatNumber(`${e.toLocaleString()}`);
}
function yp() {
  return "";
}
function vs(e, t = gt) {
  return t.format(e, "yyyy");
}
const bp = vs, wp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  formatCaption: hs,
  formatDay: hp,
  formatMonthCaption: mp,
  formatMonthDropdown: vp,
  formatWeekNumber: xp,
  formatWeekNumberHeader: yp,
  formatWeekdayName: gp,
  formatYearCaption: bp,
  formatYearDropdown: vs
}, Symbol.toStringTag, { value: "Module" }));
function kp(e) {
  return e != null && e.formatMonthCaption && !e.formatCaption && (e.formatCaption = e.formatMonthCaption), e != null && e.formatYearCaption && !e.formatYearDropdown && (e.formatYearDropdown = e.formatYearCaption), {
    ...wp,
    ...e
  };
}
function Ep(e, t, n, r, o) {
  const { startOfMonth: a, startOfYear: s, endOfYear: i, eachMonthOfInterval: d, getMonth: l } = o;
  return d({
    start: s(e),
    end: i(e)
  }).map((f) => {
    const m = r.formatMonthDropdown(f, o), y = l(f), h = t && f < a(t) || n && f > a(n) || !1;
    return { value: y, label: m, disabled: h };
  });
}
function Cp(e, t = {}, n = {}) {
  let r = { ...t == null ? void 0 : t[te.Day] };
  return Object.entries(e).filter(([, o]) => o === !0).forEach(([o]) => {
    r = {
      ...r,
      ...n == null ? void 0 : n[o]
    };
  }), r;
}
function Op(e, t, n) {
  const r = e.today(), o = t ? e.startOfISOWeek(r) : e.startOfWeek(r), a = [];
  for (let s = 0; s < 7; s++) {
    const i = e.addDays(o, s);
    a.push(i);
  }
  return a;
}
function Sp(e, t, n, r, o = !1) {
  if (!e || !t)
    return;
  const { startOfYear: a, endOfYear: s, addYears: i, getYear: d, isBefore: l, isSameYear: u } = r, c = a(e), f = s(t), m = [];
  let y = c;
  for (; l(y, f) || u(y, f); )
    m.push(y), y = i(y, 1);
  return o && m.reverse(), m.map((h) => {
    const g = n.formatYearDropdown(h, r);
    return {
      value: d(h),
      label: g,
      disabled: !1
    };
  });
}
function gs(e, t, n, r) {
  let o = (r ?? new Mt(n)).format(e, "PPPP");
  return t.today && (o = `Today, ${o}`), t.selected && (o = `${o}, selected`), o;
}
const Mp = gs;
function xs(e, t, n) {
  return (n ?? new Mt(t)).format(e, "LLLL y");
}
const Dp = xs;
function Pp(e, t, n, r) {
  let o = (r ?? new Mt(n)).format(e, "PPPP");
  return t != null && t.today && (o = `Today, ${o}`), o;
}
function _p(e) {
  return "Choose the Month";
}
function Tp() {
  return "";
}
function Ap(e) {
  return "Go to the Next Month";
}
function Rp(e) {
  return "Go to the Previous Month";
}
function Np(e, t, n) {
  return (n ?? new Mt(t)).format(e, "cccc");
}
function jp(e, t) {
  return `Week ${e}`;
}
function Ip(e) {
  return "Week Number";
}
function Fp(e) {
  return "Choose the Year";
}
const Wp = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  labelCaption: Dp,
  labelDay: Mp,
  labelDayButton: gs,
  labelGrid: xs,
  labelGridcell: Pp,
  labelMonthDropdown: _p,
  labelNav: Tp,
  labelNext: Ap,
  labelPrevious: Rp,
  labelWeekNumber: jp,
  labelWeekNumberHeader: Ip,
  labelWeekday: Np,
  labelYearDropdown: Fp
}, Symbol.toStringTag, { value: "Module" })), zn = (e) => e instanceof HTMLElement ? e : null, Hr = (e) => [
  ...e.querySelectorAll("[data-animated-month]") ?? []
], $p = (e) => zn(e.querySelector("[data-animated-month]")), qr = (e) => zn(e.querySelector("[data-animated-caption]")), Vr = (e) => zn(e.querySelector("[data-animated-weeks]")), Lp = (e) => zn(e.querySelector("[data-animated-nav]")), zp = (e) => zn(e.querySelector("[data-animated-weekdays]"));
function Bp(e, t, { classNames: n, months: r, focused: o, dateLib: a }) {
  const s = It(null), i = It(r), d = It(!1);
  Hi(() => {
    const l = i.current;
    if (i.current = r, !t || !e.current || // safety check because the ref can be set to anything by consumers
    !(e.current instanceof HTMLElement) || // validation required for the animation to work as expected
    r.length === 0 || l.length === 0 || r.length !== l.length)
      return;
    const u = a.isSameMonth(r[0].date, l[0].date), c = a.isAfter(r[0].date, l[0].date), f = c ? n[Be.caption_after_enter] : n[Be.caption_before_enter], m = c ? n[Be.weeks_after_enter] : n[Be.weeks_before_enter], y = s.current, h = e.current.cloneNode(!0);
    if (h instanceof HTMLElement ? (Hr(h).forEach((E) => {
      if (!(E instanceof HTMLElement))
        return;
      const O = $p(E);
      O && E.contains(O) && E.removeChild(O);
      const v = qr(E);
      v && v.classList.remove(f);
      const P = Vr(E);
      P && P.classList.remove(m);
    }), s.current = h) : s.current = null, d.current || u || // skip animation if a day is focused because it can cause issues to the animation and is better for a11y
    o)
      return;
    const g = y instanceof HTMLElement ? Hr(y) : [], k = Hr(e.current);
    if (k != null && k.every((C) => C instanceof HTMLElement) && g && g.every((C) => C instanceof HTMLElement)) {
      d.current = !0, e.current.style.isolation = "isolate";
      const C = Lp(e.current);
      C && (C.style.zIndex = "1"), k.forEach((E, O) => {
        const v = g[O];
        if (!v)
          return;
        E.style.position = "relative", E.style.overflow = "hidden";
        const P = qr(E);
        P && P.classList.add(f);
        const M = Vr(E);
        M && M.classList.add(m);
        const D = () => {
          d.current = !1, e.current && (e.current.style.isolation = ""), C && (C.style.zIndex = ""), P && P.classList.remove(f), M && M.classList.remove(m), E.style.position = "", E.style.overflow = "", E.contains(v) && E.removeChild(v);
        };
        v.style.pointerEvents = "none", v.style.position = "absolute", v.style.overflow = "hidden", v.setAttribute("aria-hidden", "true");
        const L = zp(v);
        L && (L.style.opacity = "0");
        const Y = qr(v);
        Y && (Y.classList.add(c ? n[Be.caption_before_exit] : n[Be.caption_after_exit]), Y.addEventListener("animationend", D));
        const U = Vr(v);
        U && U.classList.add(c ? n[Be.weeks_before_exit] : n[Be.weeks_after_exit]), E.insertBefore(v, E.firstChild);
      });
    }
  });
}
function Yp(e, t, n, r) {
  const o = e[0], a = e[e.length - 1], { ISOWeek: s, fixedWeeks: i, broadcastCalendar: d } = n ?? {}, { addDays: l, differenceInCalendarDays: u, differenceInCalendarMonths: c, endOfBroadcastWeek: f, endOfISOWeek: m, endOfMonth: y, endOfWeek: h, isAfter: g, startOfBroadcastWeek: k, startOfISOWeek: C, startOfWeek: E } = r, O = d ? k(o, r) : s ? C(o) : E(o), v = d ? f(a) : s ? m(y(a)) : h(y(a)), P = u(v, O), M = c(a, o) + 1, D = [];
  for (let U = 0; U <= P; U++) {
    const J = l(O, U);
    if (t && g(J, t))
      break;
    D.push(J);
  }
  const Y = (d ? 35 : 42) * M;
  if (i && D.length < Y) {
    const U = Y - D.length;
    for (let J = 0; J < U; J++) {
      const ee = l(D[D.length - 1], 1);
      D.push(ee);
    }
  }
  return D;
}
function Hp(e) {
  const t = [];
  return e.reduce((n, r) => {
    const o = r.weeks.reduce((a, s) => a.concat(s.days.slice()), t.slice());
    return n.concat(o.slice());
  }, t.slice());
}
function qp(e, t, n, r) {
  const { numberOfMonths: o = 1 } = n, a = [];
  for (let s = 0; s < o; s++) {
    const i = r.addMonths(e, s);
    if (t && i > t)
      break;
    a.push(i);
  }
  return a;
}
function Na(e, t, n, r) {
  const { month: o, defaultMonth: a, today: s = r.today(), numberOfMonths: i = 1 } = e;
  let d = o || a || s;
  const { differenceInCalendarMonths: l, addMonths: u, startOfMonth: c } = r;
  if (n && l(n, d) < i - 1) {
    const f = -1 * (i - 1);
    d = u(n, f);
  }
  return t && l(d, t) < 0 && (d = t), c(d);
}
function Vp(e, t, n, r) {
  const { addDays: o, endOfBroadcastWeek: a, endOfISOWeek: s, endOfMonth: i, endOfWeek: d, getISOWeek: l, getWeek: u, startOfBroadcastWeek: c, startOfISOWeek: f, startOfWeek: m } = r, y = e.reduce((h, g) => {
    const k = n.broadcastCalendar ? c(g, r) : n.ISOWeek ? f(g) : m(g), C = n.broadcastCalendar ? a(g) : n.ISOWeek ? s(i(g)) : d(i(g)), E = t.filter((M) => M >= k && M <= C), O = n.broadcastCalendar ? 35 : 42;
    if (n.fixedWeeks && E.length < O) {
      const M = t.filter((D) => {
        const L = O - E.length;
        return D > C && D <= o(C, L);
      });
      E.push(...M);
    }
    const v = E.reduce((M, D) => {
      const L = n.ISOWeek ? l(D) : u(D), Y = M.find((J) => J.weekNumber === L), U = new cs(D, g, r);
      return Y ? Y.days.push(U) : M.push(new jf(L, [U])), M;
    }, []), P = new Nf(g, v);
    return h.push(P), h;
  }, []);
  return n.reverseMonths ? y.reverse() : y;
}
function Up(e, t) {
  let { startMonth: n, endMonth: r } = e;
  const { startOfYear: o, startOfDay: a, startOfMonth: s, endOfMonth: i, addYears: d, endOfYear: l, newDate: u, today: c } = t, { fromYear: f, toYear: m, fromMonth: y, toMonth: h } = e;
  !n && y && (n = y), !n && f && (n = t.newDate(f, 0, 1)), !r && h && (r = h), !r && m && (r = u(m, 11, 31));
  const g = e.captionLayout === "dropdown" || e.captionLayout === "dropdown-years";
  return n ? n = s(n) : f ? n = u(f, 0, 1) : !n && g && (n = o(d(e.today ?? c(), -100))), r ? r = i(r) : m ? r = u(m, 11, 31) : !r && g && (r = l(e.today ?? c())), [
    n && a(n),
    r && a(r)
  ];
}
function Gp(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a = 1 } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: d } = r, l = o ? a : 1, u = s(e);
  if (!t)
    return i(u, l);
  if (!(d(t, e) < a))
    return i(u, l);
}
function Kp(e, t, n, r) {
  if (n.disableNavigation)
    return;
  const { pagedNavigation: o, numberOfMonths: a } = n, { startOfMonth: s, addMonths: i, differenceInCalendarMonths: d } = r, l = o ? a ?? 1 : 1, u = s(e);
  if (!t)
    return i(u, -l);
  if (!(d(u, t) <= 0))
    return i(u, -l);
}
function Xp(e) {
  const t = [];
  return e.reduce((n, r) => n.concat(r.weeks.slice()), t.slice());
}
function Dr(e, t) {
  const [n, r] = un(e);
  return [t === void 0 ? n : t, r];
}
function Zp(e, t) {
  const [n, r] = Up(e, t), { startOfMonth: o, endOfMonth: a } = t, s = Na(e, n, r, t), [i, d] = Dr(
    s,
    // initialMonth is always computed from props.month if provided
    e.month ? s : void 0
  );
  pr(() => {
    const P = Na(e, n, r, t);
    d(P);
  }, [e.timeZone]);
  const l = qp(i, r, e, t), u = Yp(l, e.endMonth ? a(e.endMonth) : void 0, e, t), c = Vp(l, u, e, t), f = Xp(c), m = Hp(c), y = Kp(i, n, e, t), h = Gp(i, r, e, t), { disableNavigation: g, onMonthChange: k } = e, C = (P) => f.some((M) => M.days.some((D) => D.isEqualTo(P))), E = (P) => {
    if (g)
      return;
    let M = o(P);
    n && M < o(n) && (M = o(n)), r && M > o(r) && (M = o(r)), d(M), k == null || k(M);
  };
  return {
    months: c,
    weeks: f,
    days: m,
    navStart: n,
    navEnd: r,
    previousMonth: y,
    nextMonth: h,
    goToMonth: E,
    goToDay: (P) => {
      C(P) || E(P.date);
    }
  };
}
var ut;
(function(e) {
  e[e.Today = 0] = "Today", e[e.Selected = 1] = "Selected", e[e.LastFocused = 2] = "LastFocused", e[e.FocusedModifier = 3] = "FocusedModifier";
})(ut || (ut = {}));
function ja(e) {
  return !e[Ee.disabled] && !e[Ee.hidden] && !e[Ee.outside];
}
function Qp(e, t, n, r) {
  let o, a = -1;
  for (const s of e) {
    const i = t(s);
    ja(i) && (i[Ee.focused] && a < ut.FocusedModifier ? (o = s, a = ut.FocusedModifier) : r != null && r.isEqualTo(s) && a < ut.LastFocused ? (o = s, a = ut.LastFocused) : n(s.date) && a < ut.Selected ? (o = s, a = ut.Selected) : i[Ee.today] && a < ut.Today && (o = s, a = ut.Today));
  }
  return o || (o = e.find((s) => ja(t(s)))), o;
}
function Jp(e, t, n, r, o, a, s) {
  const { ISOWeek: i, broadcastCalendar: d } = a, { addDays: l, addMonths: u, addWeeks: c, addYears: f, endOfBroadcastWeek: m, endOfISOWeek: y, endOfWeek: h, max: g, min: k, startOfBroadcastWeek: C, startOfISOWeek: E, startOfWeek: O } = s;
  let P = {
    day: l,
    week: c,
    month: u,
    year: f,
    startOfWeek: (M) => d ? C(M, s) : i ? E(M) : O(M),
    endOfWeek: (M) => d ? m(M) : i ? y(M) : h(M)
  }[e](n, t === "after" ? 1 : -1);
  return t === "before" && r ? P = g([r, P]) : t === "after" && o && (P = k([o, P])), P;
}
function ys(e, t, n, r, o, a, s, i = 0) {
  if (i > 365)
    return;
  const d = Jp(e, t, n.date, r, o, a, s), l = !!(a.disabled && Et(d, a.disabled, s)), u = !!(a.hidden && Et(d, a.hidden, s)), c = d, f = new cs(d, c, s);
  return !l && !u ? f : ys(e, t, f, r, o, a, s, i + 1);
}
function em(e, t, n, r, o) {
  const { autoFocus: a } = e, [s, i] = un(), d = Qp(t.days, n, r || (() => !1), s), [l, u] = un(a ? d : void 0);
  return {
    isFocusTarget: (h) => !!(d != null && d.isEqualTo(h)),
    setFocused: u,
    focused: l,
    blur: () => {
      i(l), u(void 0);
    },
    moveFocus: (h, g) => {
      if (!l)
        return;
      const k = ys(h, g, l, t.navStart, t.navEnd, e, o);
      k && (t.goToDay(k), u(k));
    }
  };
}
function tm(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = Dr(n, o ? n : void 0), i = o ? n : a, { isSameDay: d } = t, l = (m) => (i == null ? void 0 : i.some((y) => d(y, m))) ?? !1, { min: u, max: c } = e;
  return {
    selected: i,
    select: (m, y, h) => {
      let g = [...i ?? []];
      if (l(m)) {
        if ((i == null ? void 0 : i.length) === u || r && (i == null ? void 0 : i.length) === 1)
          return;
        g = i == null ? void 0 : i.filter((k) => !d(k, m));
      } else
        (i == null ? void 0 : i.length) === c ? g = [m] : g = [...g, m];
      return o || s(g), o == null || o(g, m, y, h), g;
    },
    isSelected: l
  };
}
function nm(e, t, n = 0, r = 0, o = !1, a = gt) {
  const { from: s, to: i } = t || {}, { isSameDay: d, isAfter: l, isBefore: u } = a;
  let c;
  if (!s && !i)
    c = { from: e, to: n > 0 ? void 0 : e };
  else if (s && !i)
    d(s, e) ? n === 0 ? c = { from: s, to: e } : o ? c = { from: s, to: void 0 } : c = void 0 : u(e, s) ? c = { from: e, to: s } : c = { from: s, to: e };
  else if (s && i)
    if (d(s, e) && d(i, e))
      o ? c = { from: s, to: i } : c = void 0;
    else if (d(s, e))
      c = { from: s, to: n > 0 ? void 0 : e };
    else if (d(i, e))
      c = { from: e, to: n > 0 ? void 0 : e };
    else if (u(e, s))
      c = { from: e, to: i };
    else if (l(e, s))
      c = { from: s, to: e };
    else if (l(e, i))
      c = { from: s, to: e };
    else
      throw new Error("Invalid range");
  if (c != null && c.from && (c != null && c.to)) {
    const f = a.differenceInCalendarDays(c.to, c.from);
    r > 0 && f > r ? c = { from: e, to: void 0 } : n > 1 && f < n && (c = { from: e, to: void 0 });
  }
  return c;
}
function rm(e, t, n = gt) {
  const r = Array.isArray(t) ? t : [t];
  let o = e.from;
  const a = n.differenceInCalendarDays(e.to, e.from), s = Math.min(a, 6);
  for (let i = 0; i <= s; i++) {
    if (r.includes(o.getDay()))
      return !0;
    o = n.addDays(o, 1);
  }
  return !1;
}
function Ia(e, t, n = gt) {
  return kt(e, t.from, !1, n) || kt(e, t.to, !1, n) || kt(t, e.from, !1, n) || kt(t, e.to, !1, n);
}
function om(e, t, n = gt) {
  const r = Array.isArray(t) ? t : [t];
  if (r.filter((i) => typeof i != "function").some((i) => typeof i == "boolean" ? i : n.isDate(i) ? kt(e, i, !1, n) : ms(i, n) ? i.some((d) => kt(e, d, !1, n)) : Bo(i) ? i.from && i.to ? Ia(e, { from: i.from, to: i.to }, n) : !1 : ps(i) ? rm(e, i.dayOfWeek, n) : ds(i) ? n.isAfter(i.before, i.after) ? Ia(e, {
    from: n.addDays(i.after, 1),
    to: n.addDays(i.before, -1)
  }, n) : Et(e.from, i, n) || Et(e.to, i, n) : us(i) || fs(i) ? Et(e.from, i, n) || Et(e.to, i, n) : !1))
    return !0;
  const s = r.filter((i) => typeof i == "function");
  if (s.length) {
    let i = e.from;
    const d = n.differenceInCalendarDays(e.to, e.from);
    for (let l = 0; l <= d; l++) {
      if (s.some((u) => u(i)))
        return !0;
      i = n.addDays(i, 1);
    }
  }
  return !1;
}
function am(e, t) {
  const { disabled: n, excludeDisabled: r, selected: o, required: a, onSelect: s } = e, [i, d] = Dr(o, s ? o : void 0), l = s ? o : i;
  return {
    selected: l,
    select: (f, m, y) => {
      const { min: h, max: g } = e, k = f ? nm(f, l, h, g, a, t) : void 0;
      return r && n && (k != null && k.from) && k.to && om({ from: k.from, to: k.to }, n, t) && (k.from = f, k.to = void 0), s || d(k), s == null || s(k, f, m, y), k;
    },
    isSelected: (f) => l && kt(l, f, !1, t)
  };
}
function im(e, t) {
  const { selected: n, required: r, onSelect: o } = e, [a, s] = Dr(n, o ? n : void 0), i = o ? n : a, { isSameDay: d } = t;
  return {
    selected: i,
    select: (c, f, m) => {
      let y = c;
      return !r && i && i && d(c, i) && (y = void 0), o || s(y), o == null || o(y, c, f, m), y;
    },
    isSelected: (c) => i ? d(i, c) : !1
  };
}
function sm(e, t) {
  const n = im(e, t), r = tm(e, t), o = am(e, t);
  switch (e.mode) {
    case "single":
      return n;
    case "multiple":
      return r;
    case "range":
      return o;
    default:
      return;
  }
}
function cm(e) {
  var ct;
  let t = e;
  t.timeZone && (t = {
    ...e
  }, t.today && (t.today = new Ne(t.today, t.timeZone)), t.month && (t.month = new Ne(t.month, t.timeZone)), t.defaultMonth && (t.defaultMonth = new Ne(t.defaultMonth, t.timeZone)), t.startMonth && (t.startMonth = new Ne(t.startMonth, t.timeZone)), t.endMonth && (t.endMonth = new Ne(t.endMonth, t.timeZone)), t.mode === "single" && t.selected ? t.selected = new Ne(t.selected, t.timeZone) : t.mode === "multiple" && t.selected ? t.selected = (ct = t.selected) == null ? void 0 : ct.map((re) => new Ne(re, t.timeZone)) : t.mode === "range" && t.selected && (t.selected = {
    from: t.selected.from ? new Ne(t.selected.from, t.timeZone) : void 0,
    to: t.selected.to ? new Ne(t.selected.to, t.timeZone) : void 0
  }));
  const { components: n, formatters: r, labels: o, dateLib: a, locale: s, classNames: i } = wt(() => {
    const re = { ...Lo, ...t.locale };
    return {
      dateLib: new Mt({
        locale: re,
        weekStartsOn: t.broadcastCalendar ? 1 : t.weekStartsOn,
        firstWeekContainsDate: t.firstWeekContainsDate,
        useAdditionalWeekYearTokens: t.useAdditionalWeekYearTokens,
        useAdditionalDayOfYearTokens: t.useAdditionalDayOfYearTokens,
        timeZone: t.timeZone,
        numerals: t.numerals
      }, t.dateLib),
      components: up(t.components),
      formatters: kp(t.formatters),
      labels: { ...Wp, ...t.labels },
      locale: re,
      classNames: { ...pp(), ...t.classNames }
    };
  }, [
    t.locale,
    t.broadcastCalendar,
    t.weekStartsOn,
    t.firstWeekContainsDate,
    t.useAdditionalWeekYearTokens,
    t.useAdditionalDayOfYearTokens,
    t.timeZone,
    t.numerals,
    t.dateLib,
    t.components,
    t.formatters,
    t.labels,
    t.classNames
  ]), { captionLayout: d, mode: l, navLayout: u, numberOfMonths: c = 1, onDayBlur: f, onDayClick: m, onDayFocus: y, onDayKeyDown: h, onDayMouseEnter: g, onDayMouseLeave: k, onNextClick: C, onPrevClick: E, showWeekNumber: O, styles: v } = t, { formatCaption: P, formatDay: M, formatMonthDropdown: D, formatWeekNumber: L, formatWeekNumberHeader: Y, formatWeekdayName: U, formatYearDropdown: J } = r, ee = Zp(t, a), { days: q, months: G, navStart: j, navEnd: K, previousMonth: _, nextMonth: R, goToMonth: b } = ee, S = lp(q, t, j, K, a), { isSelected: A, select: T, selected: N } = sm(t, a) ?? {}, { blur: V, focused: F, isFocusTarget: W, moveFocus: z, setFocused: H } = em(t, ee, S, A ?? (() => !1), a), { labelDayButton: Q, labelGridcell: se, labelGrid: I, labelMonthDropdown: ue, labelNav: Se, labelPrevious: ze, labelNext: et, labelWeekday: _e, labelWeekNumber: Ue, labelWeekNumberHeader: ge, labelYearDropdown: Dt } = o, kn = wt(() => Op(a, t.ISOWeek), [a, t.ISOWeek]), Te = l !== void 0 || m !== void 0, Ge = be(() => {
    _ && (b(_), E == null || E(_));
  }, [_, b, E]), $ = be(() => {
    R && (b(R), C == null || C(R));
  }, [b, R, C]), ne = be((re, xe) => (oe) => {
    oe.preventDefault(), oe.stopPropagation(), H(re), T == null || T(re.date, xe, oe), m == null || m(re.date, xe, oe);
  }, [T, m, H]), me = be((re, xe) => (oe) => {
    H(re), y == null || y(re.date, xe, oe);
  }, [y, H]), Ce = be((re, xe) => (oe) => {
    V(), f == null || f(re.date, xe, oe);
  }, [V, f]), Ae = be((re, xe) => (oe) => {
    const ye = {
      ArrowLeft: [
        oe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "after" : "before"
      ],
      ArrowRight: [
        oe.shiftKey ? "month" : "day",
        t.dir === "rtl" ? "before" : "after"
      ],
      ArrowDown: [oe.shiftKey ? "year" : "week", "after"],
      ArrowUp: [oe.shiftKey ? "year" : "week", "before"],
      PageUp: [oe.shiftKey ? "year" : "month", "before"],
      PageDown: [oe.shiftKey ? "year" : "month", "after"],
      Home: ["startOfWeek", "before"],
      End: ["endOfWeek", "after"]
    };
    if (ye[oe.key]) {
      oe.preventDefault(), oe.stopPropagation();
      const [Fe, B] = ye[oe.key];
      z(Fe, B);
    }
    h == null || h(re.date, xe, oe);
  }, [z, h, t.dir]), tt = be((re, xe) => (oe) => {
    g == null || g(re.date, xe, oe);
  }, [g]), Ie = be((re, xe) => (oe) => {
    k == null || k(re.date, xe, oe);
  }, [k]), Pt = be((re) => (xe) => {
    const oe = Number(xe.target.value), ye = a.setMonth(a.startOfMonth(re), oe);
    b(ye);
  }, [a, b]), Ke = be((re) => (xe) => {
    const oe = Number(xe.target.value), ye = a.setYear(a.startOfMonth(re), oe);
    b(ye);
  }, [a, b]), { className: Yt, style: _t } = wt(() => ({
    className: [i[te.Root], t.className].filter(Boolean).join(" "),
    style: { ...v == null ? void 0 : v[te.Root], ...t.style }
  }), [i, t.className, t.style, v]), Tt = fp(t), yt = It(null);
  Bp(yt, !!t.animate, {
    classNames: i,
    months: G,
    focused: F,
    dateLib: a
  });
  const Ht = {
    dayPickerProps: t,
    selected: N,
    select: T,
    isSelected: A,
    months: G,
    nextMonth: R,
    previousMonth: _,
    goToMonth: b,
    getModifiers: S,
    components: n,
    classNames: i,
    styles: v,
    labels: o,
    formatters: r
  };
  return w.createElement(
    ls.Provider,
    { value: Ht },
    w.createElement(
      n.Root,
      { rootRef: t.animate ? yt : void 0, className: Yt, style: _t, dir: t.dir, id: t.id, lang: t.lang, nonce: t.nonce, title: t.title, role: t.role, "aria-label": t["aria-label"], ...Tt },
      w.createElement(
        n.Months,
        { className: i[te.Months], style: v == null ? void 0 : v[te.Months] },
        !t.hideNavigation && !u && w.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: i[te.Nav], style: v == null ? void 0 : v[te.Nav], "aria-label": Se(), onPreviousClick: Ge, onNextClick: $, previousMonth: _, nextMonth: R }),
        G.map((re, xe) => w.createElement(
          n.Month,
          {
            "data-animated-month": t.animate ? "true" : void 0,
            className: i[te.Month],
            style: v == null ? void 0 : v[te.Month],
            // biome-ignore lint/suspicious/noArrayIndexKey: breaks animation
            key: xe,
            displayIndex: xe,
            calendarMonth: re
          },
          u === "around" && !t.hideNavigation && xe === 0 && w.createElement(
            n.PreviousMonthButton,
            { type: "button", className: i[te.PreviousMonthButton], tabIndex: _ ? void 0 : -1, "aria-disabled": _ ? void 0 : !0, "aria-label": ze(_), onClick: Ge, "data-animated-button": t.animate ? "true" : void 0 },
            w.createElement(n.Chevron, { disabled: _ ? void 0 : !0, className: i[te.Chevron], orientation: t.dir === "rtl" ? "right" : "left" })
          ),
          w.createElement(n.MonthCaption, { "data-animated-caption": t.animate ? "true" : void 0, className: i[te.MonthCaption], style: v == null ? void 0 : v[te.MonthCaption], calendarMonth: re, displayIndex: xe }, d != null && d.startsWith("dropdown") ? w.createElement(
            n.DropdownNav,
            { className: i[te.Dropdowns], style: v == null ? void 0 : v[te.Dropdowns] },
            d === "dropdown" || d === "dropdown-months" ? w.createElement(n.MonthsDropdown, { className: i[te.MonthsDropdown], "aria-label": ue(), classNames: i, components: n, disabled: !!t.disableNavigation, onChange: Pt(re.date), options: Ep(re.date, j, K, r, a), style: v == null ? void 0 : v[te.Dropdown], value: a.getMonth(re.date) }) : w.createElement("span", null, D(re.date, a)),
            d === "dropdown" || d === "dropdown-years" ? w.createElement(n.YearsDropdown, { className: i[te.YearsDropdown], "aria-label": Dt(a.options), classNames: i, components: n, disabled: !!t.disableNavigation, onChange: Ke(re.date), options: Sp(j, K, r, a, !!t.reverseYears), style: v == null ? void 0 : v[te.Dropdown], value: a.getYear(re.date) }) : w.createElement("span", null, J(re.date, a)),
            w.createElement("span", { role: "status", "aria-live": "polite", style: {
              border: 0,
              clip: "rect(0 0 0 0)",
              height: "1px",
              margin: "-1px",
              overflow: "hidden",
              padding: 0,
              position: "absolute",
              width: "1px",
              whiteSpace: "nowrap",
              wordWrap: "normal"
            } }, P(re.date, a.options, a))
          ) : (
            // biome-ignore lint/a11y/useSemanticElements: breaking change
            w.createElement(n.CaptionLabel, { className: i[te.CaptionLabel], role: "status", "aria-live": "polite" }, P(re.date, a.options, a))
          )),
          u === "around" && !t.hideNavigation && xe === c - 1 && w.createElement(
            n.NextMonthButton,
            { type: "button", className: i[te.NextMonthButton], tabIndex: R ? void 0 : -1, "aria-disabled": R ? void 0 : !0, "aria-label": et(R), onClick: $, "data-animated-button": t.animate ? "true" : void 0 },
            w.createElement(n.Chevron, { disabled: R ? void 0 : !0, className: i[te.Chevron], orientation: t.dir === "rtl" ? "left" : "right" })
          ),
          xe === c - 1 && u === "after" && !t.hideNavigation && w.createElement(n.Nav, { "data-animated-nav": t.animate ? "true" : void 0, className: i[te.Nav], style: v == null ? void 0 : v[te.Nav], "aria-label": Se(), onPreviousClick: Ge, onNextClick: $, previousMonth: _, nextMonth: R }),
          w.createElement(
            n.MonthGrid,
            { role: "grid", "aria-multiselectable": l === "multiple" || l === "range", "aria-label": I(re.date, a.options, a) || void 0, className: i[te.MonthGrid], style: v == null ? void 0 : v[te.MonthGrid] },
            !t.hideWeekdays && w.createElement(
              n.Weekdays,
              { "data-animated-weekdays": t.animate ? "true" : void 0, className: i[te.Weekdays], style: v == null ? void 0 : v[te.Weekdays] },
              O && w.createElement(n.WeekNumberHeader, { "aria-label": ge(a.options), className: i[te.WeekNumberHeader], style: v == null ? void 0 : v[te.WeekNumberHeader], scope: "col" }, Y()),
              kn.map((oe) => w.createElement(n.Weekday, { "aria-label": _e(oe, a.options, a), className: i[te.Weekday], key: String(oe), style: v == null ? void 0 : v[te.Weekday], scope: "col" }, U(oe, a.options, a)))
            ),
            w.createElement(n.Weeks, { "data-animated-weeks": t.animate ? "true" : void 0, className: i[te.Weeks], style: v == null ? void 0 : v[te.Weeks] }, re.weeks.map((oe) => w.createElement(
              n.Week,
              { className: i[te.Week], key: oe.weekNumber, style: v == null ? void 0 : v[te.Week], week: oe },
              O && // biome-ignore lint/a11y/useSemanticElements: react component
              w.createElement(n.WeekNumber, { week: oe, style: v == null ? void 0 : v[te.WeekNumber], "aria-label": Ue(oe.weekNumber, {
                locale: s
              }), className: i[te.WeekNumber], scope: "row", role: "rowheader" }, L(oe.weekNumber, a)),
              oe.days.map((ye) => {
                const { date: Fe } = ye, B = S(ye);
                if (B[Ee.focused] = !B.hidden && !!(F != null && F.isEqualTo(ye)), B[ot.selected] = (A == null ? void 0 : A(Fe)) || B.selected, Bo(N)) {
                  const { from: At, to: Oe } = N;
                  B[ot.range_start] = !!(At && Oe && a.isSameDay(Fe, At)), B[ot.range_end] = !!(At && Oe && a.isSameDay(Fe, Oe)), B[ot.range_middle] = kt(N, Fe, !0, a);
                }
                const Me = Cp(B, v, t.modifiersStyles), Re = dp(B, i, t.modifiersClassNames), We = !Te && !B.hidden ? se(Fe, B, a.options, a) : void 0;
                return (
                  // biome-ignore lint/a11y/useSemanticElements: react component
                  w.createElement(n.Day, { key: `${a.format(Fe, "yyyy-MM-dd")}_${a.format(ye.displayMonth, "yyyy-MM")}`, day: ye, modifiers: B, className: Re.join(" "), style: Me, role: "gridcell", "aria-selected": B.selected || void 0, "aria-label": We, "data-day": a.format(Fe, "yyyy-MM-dd"), "data-month": ye.outside ? a.format(Fe, "yyyy-MM") : void 0, "data-selected": B.selected || void 0, "data-disabled": B.disabled || void 0, "data-hidden": B.hidden || void 0, "data-outside": ye.outside || void 0, "data-focused": B.focused || void 0, "data-today": B.today || void 0 }, !B.hidden && Te ? w.createElement(n.DayButton, { className: i[te.DayButton], style: v == null ? void 0 : v[te.DayButton], type: "button", day: ye, modifiers: B, disabled: B.disabled || void 0, tabIndex: W(ye) ? 0 : -1, "aria-label": Q(Fe, B, a.options, a), onClick: ne(ye, B), onBlur: Ce(ye, B), onFocus: me(ye, B), onKeyDown: Ae(ye, B), onMouseEnter: tt(ye, B), onMouseLeave: Ie(ye, B) }, M(Fe, a.options, a)) : !B.hidden && M(ye.date, a.options, a))
                );
              })
            )))
          )
        ))
      ),
      t.footer && // biome-ignore lint/a11y/useSemanticElements: react component
      w.createElement(n.Footer, { className: i[te.Footer], style: v == null ? void 0 : v[te.Footer], role: "status", "aria-live": "polite" }, t.footer)
    )
  );
}
function Fa(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Pr(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((o) => {
      const a = Fa(o, t);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let o = 0; o < r.length; o++) {
          const a = r[o];
          typeof a == "function" ? a() : Fa(e[o], null);
        }
      };
  };
}
function we(...e) {
  return p.useCallback(Pr(...e), e);
}
// @__NO_SIDE_EFFECTS__
function Xt(e) {
  const t = /* @__PURE__ */ dm(e), n = p.forwardRef((r, o) => {
    const { children: a, ...s } = r, i = p.Children.toArray(a), d = i.find(fm);
    if (d) {
      const l = d.props.children, u = i.map((c) => c === d ? p.Children.count(l) > 1 ? p.Children.only(null) : p.isValidElement(l) ? l.props.children : null : c);
      return /* @__PURE__ */ x.jsx(t, { ...s, ref: o, children: p.isValidElement(l) ? p.cloneElement(l, void 0, u) : null });
    }
    return /* @__PURE__ */ x.jsx(t, { ...s, ref: o, children: a });
  });
  return n.displayName = `${e}.Slot`, n;
}
var lm = /* @__PURE__ */ Xt("Slot");
// @__NO_SIDE_EFFECTS__
function dm(e) {
  const t = p.forwardRef((n, r) => {
    const { children: o, ...a } = n;
    if (p.isValidElement(o)) {
      const s = mm(o), i = pm(a, o.props);
      return o.type !== p.Fragment && (i.ref = r ? Pr(r, s) : s), p.cloneElement(o, i);
    }
    return p.Children.count(o) > 1 ? p.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var um = Symbol("radix.slottable");
function fm(e) {
  return p.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === um;
}
function pm(e, t) {
  const n = { ...t };
  for (const r in t) {
    const o = e[r], a = t[r];
    /^on[A-Z]/.test(r) ? o && a ? n[r] = (...i) => {
      const d = a(...i);
      return o(...i), d;
    } : o && (n[r] = o) : r === "style" ? n[r] = { ...o, ...a } : r === "className" && (n[r] = [o, a].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function mm(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function bs(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number") r += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var o = e.length;
    for (t = 0; t < o; t++) e[t] && (n = bs(e[t])) && (r && (r += " "), r += n);
  } else for (n in e) e[n] && (r && (r += " "), r += n);
  return r;
}
function ws() {
  for (var e, t, n = 0, r = "", o = arguments.length; n < o; n++) (e = arguments[n]) && (t = bs(e)) && (r && (r += " "), r += t);
  return r;
}
const Wa = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, $a = ws, hm = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null) return $a(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: o, defaultVariants: a } = t, s = Object.keys(o).map((l) => {
    const u = n == null ? void 0 : n[l], c = a == null ? void 0 : a[l];
    if (u === null) return null;
    const f = Wa(u) || Wa(c);
    return o[l][f];
  }), i = n && Object.entries(n).reduce((l, u) => {
    let [c, f] = u;
    return f === void 0 || (l[c] = f), l;
  }, {}), d = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((l, u) => {
    let { class: c, className: f, ...m } = u;
    return Object.entries(m).every((y) => {
      let [h, g] = y;
      return Array.isArray(g) ? g.includes({
        ...a,
        ...i
      }[h]) : {
        ...a,
        ...i
      }[h] === g;
    }) ? [
      ...l,
      c,
      f
    ] : l;
  }, []);
  return $a(e, s, d, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
}, Yo = "-", vm = (e) => {
  const t = xm(e), {
    conflictingClassGroups: n,
    conflictingClassGroupModifiers: r
  } = e;
  return {
    getClassGroupId: (s) => {
      const i = s.split(Yo);
      return i[0] === "" && i.length !== 1 && i.shift(), ks(i, t) || gm(s);
    },
    getConflictingClassGroupIds: (s, i) => {
      const d = n[s] || [];
      return i && r[s] ? [...d, ...r[s]] : d;
    }
  };
}, ks = (e, t) => {
  var s;
  if (e.length === 0)
    return t.classGroupId;
  const n = e[0], r = t.nextPart.get(n), o = r ? ks(e.slice(1), r) : void 0;
  if (o)
    return o;
  if (t.validators.length === 0)
    return;
  const a = e.join(Yo);
  return (s = t.validators.find(({
    validator: i
  }) => i(a))) == null ? void 0 : s.classGroupId;
}, La = /^\[(.+)\]$/, gm = (e) => {
  if (La.test(e)) {
    const t = La.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}, xm = (e) => {
  const {
    theme: t,
    classGroups: n
  } = e, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  };
  for (const o in n)
    yo(n[o], r, o, t);
  return r;
}, yo = (e, t, n, r) => {
  e.forEach((o) => {
    if (typeof o == "string") {
      const a = o === "" ? t : za(t, o);
      a.classGroupId = n;
      return;
    }
    if (typeof o == "function") {
      if (ym(o)) {
        yo(o(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: o,
        classGroupId: n
      });
      return;
    }
    Object.entries(o).forEach(([a, s]) => {
      yo(s, za(t, a), n, r);
    });
  });
}, za = (e, t) => {
  let n = e;
  return t.split(Yo).forEach((r) => {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}, ym = (e) => e.isThemeGetter, bm = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  const o = (a, s) => {
    n.set(a, s), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  };
  return {
    get(a) {
      let s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return o(a, s), s;
    },
    set(a, s) {
      n.has(a) ? n.set(a, s) : o(a, s);
    }
  };
}, bo = "!", wo = ":", wm = wo.length, km = (e) => {
  const {
    prefix: t,
    experimentalParseClassName: n
  } = e;
  let r = (o) => {
    const a = [];
    let s = 0, i = 0, d = 0, l;
    for (let y = 0; y < o.length; y++) {
      let h = o[y];
      if (s === 0 && i === 0) {
        if (h === wo) {
          a.push(o.slice(d, y)), d = y + wm;
          continue;
        }
        if (h === "/") {
          l = y;
          continue;
        }
      }
      h === "[" ? s++ : h === "]" ? s-- : h === "(" ? i++ : h === ")" && i--;
    }
    const u = a.length === 0 ? o : o.substring(d), c = Em(u), f = c !== u, m = l && l > d ? l - d : void 0;
    return {
      modifiers: a,
      hasImportantModifier: f,
      baseClassName: c,
      maybePostfixModifierPosition: m
    };
  };
  if (t) {
    const o = t + wo, a = r;
    r = (s) => s.startsWith(o) ? a(s.substring(o.length)) : {
      isExternal: !0,
      modifiers: [],
      hasImportantModifier: !1,
      baseClassName: s,
      maybePostfixModifierPosition: void 0
    };
  }
  if (n) {
    const o = r;
    r = (a) => n({
      className: a,
      parseClassName: o
    });
  }
  return r;
}, Em = (e) => e.endsWith(bo) ? e.substring(0, e.length - 1) : e.startsWith(bo) ? e.substring(1) : e, Cm = (e) => {
  const t = Object.fromEntries(e.orderSensitiveModifiers.map((r) => [r, !0]));
  return (r) => {
    if (r.length <= 1)
      return r;
    const o = [];
    let a = [];
    return r.forEach((s) => {
      s[0] === "[" || t[s] ? (o.push(...a.sort(), s), a = []) : a.push(s);
    }), o.push(...a.sort()), o;
  };
}, Om = (e) => ({
  cache: bm(e.cacheSize),
  parseClassName: km(e),
  sortModifiers: Cm(e),
  ...vm(e)
}), Sm = /\s+/, Mm = (e, t) => {
  const {
    parseClassName: n,
    getClassGroupId: r,
    getConflictingClassGroupIds: o,
    sortModifiers: a
  } = t, s = [], i = e.trim().split(Sm);
  let d = "";
  for (let l = i.length - 1; l >= 0; l -= 1) {
    const u = i[l], {
      isExternal: c,
      modifiers: f,
      hasImportantModifier: m,
      baseClassName: y,
      maybePostfixModifierPosition: h
    } = n(u);
    if (c) {
      d = u + (d.length > 0 ? " " + d : d);
      continue;
    }
    let g = !!h, k = r(g ? y.substring(0, h) : y);
    if (!k) {
      if (!g) {
        d = u + (d.length > 0 ? " " + d : d);
        continue;
      }
      if (k = r(y), !k) {
        d = u + (d.length > 0 ? " " + d : d);
        continue;
      }
      g = !1;
    }
    const C = a(f).join(":"), E = m ? C + bo : C, O = E + k;
    if (s.includes(O))
      continue;
    s.push(O);
    const v = o(k, g);
    for (let P = 0; P < v.length; ++P) {
      const M = v[P];
      s.push(E + M);
    }
    d = u + (d.length > 0 ? " " + d : d);
  }
  return d;
};
function Dm() {
  let e = 0, t, n, r = "";
  for (; e < arguments.length; )
    (t = arguments[e++]) && (n = Es(t)) && (r && (r += " "), r += n);
  return r;
}
const Es = (e) => {
  if (typeof e == "string")
    return e;
  let t, n = "";
  for (let r = 0; r < e.length; r++)
    e[r] && (t = Es(e[r])) && (n && (n += " "), n += t);
  return n;
};
function Pm(e, ...t) {
  let n, r, o, a = s;
  function s(d) {
    const l = t.reduce((u, c) => c(u), e());
    return n = Om(l), r = n.cache.get, o = n.cache.set, a = i, i(d);
  }
  function i(d) {
    const l = r(d);
    if (l)
      return l;
    const u = Mm(d, n);
    return o(d, u), u;
  }
  return function() {
    return a(Dm.apply(null, arguments));
  };
}
const De = (e) => {
  const t = (n) => n[e] || [];
  return t.isThemeGetter = !0, t;
}, Cs = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, Os = /^\((?:(\w[\w-]*):)?(.+)\)$/i, _m = /^\d+\/\d+$/, Tm = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, Am = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, Rm = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Nm = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, jm = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, on = (e) => _m.test(e), ie = (e) => !!e && !Number.isNaN(Number(e)), Nt = (e) => !!e && Number.isInteger(Number(e)), Ur = (e) => e.endsWith("%") && ie(e.slice(0, -1)), bt = (e) => Tm.test(e), Im = () => !0, Fm = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  Am.test(e) && !Rm.test(e)
), Ss = () => !1, Wm = (e) => Nm.test(e), $m = (e) => jm.test(e), Lm = (e) => !X(e) && !Z(e), zm = (e) => gn(e, Ps, Ss), X = (e) => Cs.test(e), Vt = (e) => gn(e, _s, Fm), Gr = (e) => gn(e, Vm, ie), Ba = (e) => gn(e, Ms, Ss), Bm = (e) => gn(e, Ds, $m), Jn = (e) => gn(e, Ts, Wm), Z = (e) => Os.test(e), Mn = (e) => xn(e, _s), Ym = (e) => xn(e, Um), Ya = (e) => xn(e, Ms), Hm = (e) => xn(e, Ps), qm = (e) => xn(e, Ds), er = (e) => xn(e, Ts, !0), gn = (e, t, n) => {
  const r = Cs.exec(e);
  return r ? r[1] ? t(r[1]) : n(r[2]) : !1;
}, xn = (e, t, n = !1) => {
  const r = Os.exec(e);
  return r ? r[1] ? t(r[1]) : n : !1;
}, Ms = (e) => e === "position" || e === "percentage", Ds = (e) => e === "image" || e === "url", Ps = (e) => e === "length" || e === "size" || e === "bg-size", _s = (e) => e === "length", Vm = (e) => e === "number", Um = (e) => e === "family-name", Ts = (e) => e === "shadow", Gm = () => {
  const e = De("color"), t = De("font"), n = De("text"), r = De("font-weight"), o = De("tracking"), a = De("leading"), s = De("breakpoint"), i = De("container"), d = De("spacing"), l = De("radius"), u = De("shadow"), c = De("inset-shadow"), f = De("text-shadow"), m = De("drop-shadow"), y = De("blur"), h = De("perspective"), g = De("aspect"), k = De("ease"), C = De("animate"), E = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], O = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], v = () => [...O(), Z, X], P = () => ["auto", "hidden", "clip", "visible", "scroll"], M = () => ["auto", "contain", "none"], D = () => [Z, X, d], L = () => [on, "full", "auto", ...D()], Y = () => [Nt, "none", "subgrid", Z, X], U = () => ["auto", {
    span: ["full", Nt, Z, X]
  }, Nt, Z, X], J = () => [Nt, "auto", Z, X], ee = () => ["auto", "min", "max", "fr", Z, X], q = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], G = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], j = () => ["auto", ...D()], K = () => [on, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...D()], _ = () => [e, Z, X], R = () => [...O(), Ya, Ba, {
    position: [Z, X]
  }], b = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], S = () => ["auto", "cover", "contain", Hm, zm, {
    size: [Z, X]
  }], A = () => [Ur, Mn, Vt], T = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    l,
    Z,
    X
  ], N = () => ["", ie, Mn, Vt], V = () => ["solid", "dashed", "dotted", "double"], F = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], W = () => [ie, Ur, Ya, Ba], z = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    y,
    Z,
    X
  ], H = () => ["none", ie, Z, X], Q = () => ["none", ie, Z, X], se = () => [ie, Z, X], I = () => [on, "full", ...D()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [bt],
      breakpoint: [bt],
      color: [Im],
      container: [bt],
      "drop-shadow": [bt],
      ease: ["in", "out", "in-out"],
      font: [Lm],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [bt],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [bt],
      shadow: [bt],
      spacing: ["px", ie],
      text: [bt],
      "text-shadow": [bt],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", on, X, Z, g]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [ie, X, Z, i]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": E()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": E()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: v()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: P()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": P()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": P()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: M()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": M()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": M()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: L()
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": L()
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": L()
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: L()
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: L()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: L()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: L()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: L()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: L()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [Nt, "auto", Z, X]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [on, "full", "auto", i, ...D()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [ie, on, "auto", "initial", "none", X]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", ie, Z, X]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", ie, Z, X]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [Nt, "first", "last", "none", Z, X]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": Y()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: U()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": J()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": J()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": Y()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: U()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": J()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": J()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ee()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ee()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: D()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": D()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": D()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...q(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...G(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...G()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...q()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...G(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": q()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...G(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...G()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: D()
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: D()
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: D()
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: D()
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: D()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: D()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: D()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: D()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: D()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: j()
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: j()
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: j()
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: j()
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: j()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: j()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: j()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: j()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: j()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": D()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": D()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: K()
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [i, "screen", ...K()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          i,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...K()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          i,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [s]
          },
          ...K()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...K()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...K()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...K()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", n, Mn, Vt]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [r, Z, Gr]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", Ur, X]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ym, X, t]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [o, Z, X]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [ie, "none", Z, Gr]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          a,
          ...D()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", Z, X]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", Z, X]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: _()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: _()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...V(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [ie, "from-font", "auto", Z, Vt]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: _()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [ie, "auto", Z, X]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: D()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", Z, X]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", Z, X]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: R()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: b()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: S()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, Nt, Z, X],
          radial: ["", Z, X],
          conic: [Nt, Z, X]
        }, qm, Bm]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: _()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: A()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: A()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: A()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: _()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: _()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: _()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: T()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": T()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": T()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": T()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": T()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": T()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": T()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": T()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": T()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": T()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": T()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": T()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": T()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": T()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": T()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: N()
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": N()
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": N()
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": N()
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": N()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": N()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": N()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": N()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": N()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": N()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": N()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...V(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...V(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: _()
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": _()
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": _()
      }],
      /**
       * Border Color S
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": _()
      }],
      /**
       * Border Color E
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": _()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": _()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": _()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": _()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": _()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: _()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...V(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [ie, Z, X]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", ie, Mn, Vt]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: _()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          u,
          er,
          Jn
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: _()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", c, er, Jn]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": _()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: N()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: _()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [ie, Vt]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": _()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": N()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": _()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", f, er, Jn]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": _()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [ie, Z, X]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...F(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": F()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [ie]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": W()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": W()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": _()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": _()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": W()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": W()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": _()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": _()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": W()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": W()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": _()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": _()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": W()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": W()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": _()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": _()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": W()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": W()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": _()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": _()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": W()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": W()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": _()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": _()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": W()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": W()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": _()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": _()
      }],
      "mask-image-radial": [{
        "mask-radial": [Z, X]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": W()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": W()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": _()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": _()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": O()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [ie]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": W()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": W()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": _()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": _()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: R()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: b()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: S()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", Z, X]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Z,
          X
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: z()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [ie, Z, X]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [ie, Z, X]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          m,
          er,
          Jn
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": _()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", ie, Z, X]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [ie, Z, X]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", ie, Z, X]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [ie, Z, X]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", ie, Z, X]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          Z,
          X
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": z()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [ie, Z, X]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [ie, Z, X]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", ie, Z, X]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [ie, Z, X]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", ie, Z, X]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [ie, Z, X]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [ie, Z, X]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", ie, Z, X]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": D()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": D()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": D()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", Z, X]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [ie, "initial", Z, X]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", k, Z, X]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [ie, Z, X]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", C, Z, X]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [h, Z, X]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": v()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: H()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": H()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": H()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": H()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: Q()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": Q()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": Q()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": Q()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: se()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": se()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": se()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [Z, X, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: v()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: I()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": I()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": I()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": I()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: _()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: _()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", Z, X]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": D()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": D()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": D()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": D()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": D()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": D()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": D()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": D()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": D()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": D()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": D()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": D()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": D()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": D()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": D()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": D()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": D()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": D()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", Z, X]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ..._()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [ie, Mn, Vt, Gr]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ..._()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Km = /* @__PURE__ */ Pm(Gm);
function ae(...e) {
  return Km(ws(e));
}
function Xm(e) {
  if (typeof document > "u") return;
  let t = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", t.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
}
const Zm = (e) => {
  switch (e) {
    case "success":
      return eh;
    case "info":
      return nh;
    case "warning":
      return th;
    case "error":
      return rh;
    default:
      return null;
  }
}, Qm = Array(12).fill(0), Jm = ({ visible: e, className: t }) => /* @__PURE__ */ w.createElement("div", {
  className: [
    "sonner-loading-wrapper",
    t
  ].filter(Boolean).join(" "),
  "data-visible": e
}, /* @__PURE__ */ w.createElement("div", {
  className: "sonner-spinner"
}, Qm.map((n, r) => /* @__PURE__ */ w.createElement("div", {
  className: "sonner-loading-bar",
  key: `spinner-bar-${r}`
})))), eh = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z",
  clipRule: "evenodd"
})), th = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M9.401 3.003c1.155-2 4.043-2 5.197 0l7.355 12.748c1.154 2-.29 4.5-2.599 4.5H4.645c-2.309 0-3.752-2.5-2.598-4.5L9.4 3.003zM12 8.25a.75.75 0 01.75.75v3.75a.75.75 0 01-1.5 0V9a.75.75 0 01.75-.75zm0 8.25a.75.75 0 100-1.5.75.75 0 000 1.5z",
  clipRule: "evenodd"
})), nh = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z",
  clipRule: "evenodd"
})), rh = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  height: "20",
  width: "20"
}, /* @__PURE__ */ w.createElement("path", {
  fillRule: "evenodd",
  d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-5a.75.75 0 01.75.75v4.5a.75.75 0 01-1.5 0v-4.5A.75.75 0 0110 5zm0 10a1 1 0 100-2 1 1 0 000 2z",
  clipRule: "evenodd"
})), oh = /* @__PURE__ */ w.createElement("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "12",
  height: "12",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "1.5",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /* @__PURE__ */ w.createElement("line", {
  x1: "18",
  y1: "6",
  x2: "6",
  y2: "18"
}), /* @__PURE__ */ w.createElement("line", {
  x1: "6",
  y1: "6",
  x2: "18",
  y2: "18"
})), ah = () => {
  const [e, t] = w.useState(document.hidden);
  return w.useEffect(() => {
    const n = () => {
      t(document.hidden);
    };
    return document.addEventListener("visibilitychange", n), () => window.removeEventListener("visibilitychange", n);
  }, []), e;
};
let ko = 1;
class ih {
  constructor() {
    this.subscribe = (t) => (this.subscribers.push(t), () => {
      const n = this.subscribers.indexOf(t);
      this.subscribers.splice(n, 1);
    }), this.publish = (t) => {
      this.subscribers.forEach((n) => n(t));
    }, this.addToast = (t) => {
      this.publish(t), this.toasts = [
        ...this.toasts,
        t
      ];
    }, this.create = (t) => {
      var n;
      const { message: r, ...o } = t, a = typeof (t == null ? void 0 : t.id) == "number" || ((n = t.id) == null ? void 0 : n.length) > 0 ? t.id : ko++, s = this.toasts.find((d) => d.id === a), i = t.dismissible === void 0 ? !0 : t.dismissible;
      return this.dismissedToasts.has(a) && this.dismissedToasts.delete(a), s ? this.toasts = this.toasts.map((d) => d.id === a ? (this.publish({
        ...d,
        ...t,
        id: a,
        title: r
      }), {
        ...d,
        ...t,
        id: a,
        dismissible: i,
        title: r
      }) : d) : this.addToast({
        title: r,
        ...o,
        dismissible: i,
        id: a
      }), a;
    }, this.dismiss = (t) => (t ? (this.dismissedToasts.add(t), requestAnimationFrame(() => this.subscribers.forEach((n) => n({
      id: t,
      dismiss: !0
    })))) : this.toasts.forEach((n) => {
      this.subscribers.forEach((r) => r({
        id: n.id,
        dismiss: !0
      }));
    }), t), this.message = (t, n) => this.create({
      ...n,
      message: t
    }), this.error = (t, n) => this.create({
      ...n,
      message: t,
      type: "error"
    }), this.success = (t, n) => this.create({
      ...n,
      type: "success",
      message: t
    }), this.info = (t, n) => this.create({
      ...n,
      type: "info",
      message: t
    }), this.warning = (t, n) => this.create({
      ...n,
      type: "warning",
      message: t
    }), this.loading = (t, n) => this.create({
      ...n,
      type: "loading",
      message: t
    }), this.promise = (t, n) => {
      if (!n)
        return;
      let r;
      n.loading !== void 0 && (r = this.create({
        ...n,
        promise: t,
        type: "loading",
        message: n.loading,
        description: typeof n.description != "function" ? n.description : void 0
      }));
      const o = Promise.resolve(t instanceof Function ? t() : t);
      let a = r !== void 0, s;
      const i = o.then(async (l) => {
        if (s = [
          "resolve",
          l
        ], w.isValidElement(l))
          a = !1, this.create({
            id: r,
            type: "default",
            message: l
          });
        else if (ch(l) && !l.ok) {
          a = !1;
          const c = typeof n.error == "function" ? await n.error(`HTTP error! status: ${l.status}`) : n.error, f = typeof n.description == "function" ? await n.description(`HTTP error! status: ${l.status}`) : n.description, y = typeof c == "object" && !w.isValidElement(c) ? c : {
            message: c
          };
          this.create({
            id: r,
            type: "error",
            description: f,
            ...y
          });
        } else if (l instanceof Error) {
          a = !1;
          const c = typeof n.error == "function" ? await n.error(l) : n.error, f = typeof n.description == "function" ? await n.description(l) : n.description, y = typeof c == "object" && !w.isValidElement(c) ? c : {
            message: c
          };
          this.create({
            id: r,
            type: "error",
            description: f,
            ...y
          });
        } else if (n.success !== void 0) {
          a = !1;
          const c = typeof n.success == "function" ? await n.success(l) : n.success, f = typeof n.description == "function" ? await n.description(l) : n.description, y = typeof c == "object" && !w.isValidElement(c) ? c : {
            message: c
          };
          this.create({
            id: r,
            type: "success",
            description: f,
            ...y
          });
        }
      }).catch(async (l) => {
        if (s = [
          "reject",
          l
        ], n.error !== void 0) {
          a = !1;
          const u = typeof n.error == "function" ? await n.error(l) : n.error, c = typeof n.description == "function" ? await n.description(l) : n.description, m = typeof u == "object" && !w.isValidElement(u) ? u : {
            message: u
          };
          this.create({
            id: r,
            type: "error",
            description: c,
            ...m
          });
        }
      }).finally(() => {
        a && (this.dismiss(r), r = void 0), n.finally == null || n.finally.call(n);
      }), d = () => new Promise((l, u) => i.then(() => s[0] === "reject" ? u(s[1]) : l(s[1])).catch(u));
      return typeof r != "string" && typeof r != "number" ? {
        unwrap: d
      } : Object.assign(r, {
        unwrap: d
      });
    }, this.custom = (t, n) => {
      const r = (n == null ? void 0 : n.id) || ko++;
      return this.create({
        jsx: t(r),
        id: r,
        ...n
      }), r;
    }, this.getActiveToasts = () => this.toasts.filter((t) => !this.dismissedToasts.has(t.id)), this.subscribers = [], this.toasts = [], this.dismissedToasts = /* @__PURE__ */ new Set();
  }
}
const Le = new ih(), sh = (e, t) => {
  const n = (t == null ? void 0 : t.id) || ko++;
  return Le.addToast({
    title: e,
    ...t,
    id: n
  }), n;
}, ch = (e) => e && typeof e == "object" && "ok" in e && typeof e.ok == "boolean" && "status" in e && typeof e.status == "number", lh = sh, dh = () => Le.toasts, uh = () => Le.getActiveToasts(), l0 = Object.assign(lh, {
  success: Le.success,
  info: Le.info,
  warning: Le.warning,
  error: Le.error,
  custom: Le.custom,
  message: Le.message,
  promise: Le.promise,
  dismiss: Le.dismiss,
  loading: Le.loading
}, {
  getHistory: dh,
  getToasts: uh
});
Xm("[data-sonner-toaster][dir=ltr],html[dir=ltr]{--toast-icon-margin-start:-3px;--toast-icon-margin-end:4px;--toast-svg-margin-start:-1px;--toast-svg-margin-end:0px;--toast-button-margin-start:auto;--toast-button-margin-end:0;--toast-close-button-start:0;--toast-close-button-end:unset;--toast-close-button-transform:translate(-35%, -35%)}[data-sonner-toaster][dir=rtl],html[dir=rtl]{--toast-icon-margin-start:4px;--toast-icon-margin-end:-3px;--toast-svg-margin-start:0px;--toast-svg-margin-end:-1px;--toast-button-margin-start:0;--toast-button-margin-end:auto;--toast-close-button-start:unset;--toast-close-button-end:0;--toast-close-button-transform:translate(35%, -35%)}[data-sonner-toaster]{position:fixed;width:var(--width);font-family:ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,Noto Sans,sans-serif,Apple Color Emoji,Segoe UI Emoji,Segoe UI Symbol,Noto Color Emoji;--gray1:hsl(0, 0%, 99%);--gray2:hsl(0, 0%, 97.3%);--gray3:hsl(0, 0%, 95.1%);--gray4:hsl(0, 0%, 93%);--gray5:hsl(0, 0%, 90.9%);--gray6:hsl(0, 0%, 88.7%);--gray7:hsl(0, 0%, 85.8%);--gray8:hsl(0, 0%, 78%);--gray9:hsl(0, 0%, 56.1%);--gray10:hsl(0, 0%, 52.3%);--gray11:hsl(0, 0%, 43.5%);--gray12:hsl(0, 0%, 9%);--border-radius:8px;box-sizing:border-box;padding:0;margin:0;list-style:none;outline:0;z-index:999999999;transition:transform .4s ease}@media (hover:none) and (pointer:coarse){[data-sonner-toaster][data-lifted=true]{transform:none}}[data-sonner-toaster][data-x-position=right]{right:var(--offset-right)}[data-sonner-toaster][data-x-position=left]{left:var(--offset-left)}[data-sonner-toaster][data-x-position=center]{left:50%;transform:translateX(-50%)}[data-sonner-toaster][data-y-position=top]{top:var(--offset-top)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--offset-bottom)}[data-sonner-toast]{--y:translateY(100%);--lift-amount:calc(var(--lift) * var(--gap));z-index:var(--z-index);position:absolute;opacity:0;transform:var(--y);touch-action:none;transition:transform .4s,opacity .4s,height .4s,box-shadow .2s;box-sizing:border-box;outline:0;overflow-wrap:anywhere}[data-sonner-toast][data-styled=true]{padding:16px;background:var(--normal-bg);border:1px solid var(--normal-border);color:var(--normal-text);border-radius:var(--border-radius);box-shadow:0 4px 12px rgba(0,0,0,.1);width:var(--width);font-size:13px;display:flex;align-items:center;gap:6px}[data-sonner-toast]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-y-position=top]{top:0;--y:translateY(-100%);--lift:1;--lift-amount:calc(1 * var(--gap))}[data-sonner-toast][data-y-position=bottom]{bottom:0;--y:translateY(100%);--lift:-1;--lift-amount:calc(var(--lift) * var(--gap))}[data-sonner-toast][data-styled=true] [data-description]{font-weight:400;line-height:1.4;color:#3f3f3f}[data-rich-colors=true][data-sonner-toast][data-styled=true] [data-description]{color:inherit}[data-sonner-toaster][data-sonner-theme=dark] [data-description]{color:#e8e8e8}[data-sonner-toast][data-styled=true] [data-title]{font-weight:500;line-height:1.5;color:inherit}[data-sonner-toast][data-styled=true] [data-icon]{display:flex;height:16px;width:16px;position:relative;justify-content:flex-start;align-items:center;flex-shrink:0;margin-left:var(--toast-icon-margin-start);margin-right:var(--toast-icon-margin-end)}[data-sonner-toast][data-promise=true] [data-icon]>svg{opacity:0;transform:scale(.8);transform-origin:center;animation:sonner-fade-in .3s ease forwards}[data-sonner-toast][data-styled=true] [data-icon]>*{flex-shrink:0}[data-sonner-toast][data-styled=true] [data-icon] svg{margin-left:var(--toast-svg-margin-start);margin-right:var(--toast-svg-margin-end)}[data-sonner-toast][data-styled=true] [data-content]{display:flex;flex-direction:column;gap:2px}[data-sonner-toast][data-styled=true] [data-button]{border-radius:4px;padding-left:8px;padding-right:8px;height:24px;font-size:12px;color:var(--normal-bg);background:var(--normal-text);margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end);border:none;font-weight:500;cursor:pointer;outline:0;display:flex;align-items:center;flex-shrink:0;transition:opacity .4s,box-shadow .2s}[data-sonner-toast][data-styled=true] [data-button]:focus-visible{box-shadow:0 0 0 2px rgba(0,0,0,.4)}[data-sonner-toast][data-styled=true] [data-button]:first-of-type{margin-left:var(--toast-button-margin-start);margin-right:var(--toast-button-margin-end)}[data-sonner-toast][data-styled=true] [data-cancel]{color:var(--normal-text);background:rgba(0,0,0,.08)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-styled=true] [data-cancel]{background:rgba(255,255,255,.3)}[data-sonner-toast][data-styled=true] [data-close-button]{position:absolute;left:var(--toast-close-button-start);right:var(--toast-close-button-end);top:0;height:20px;width:20px;display:flex;justify-content:center;align-items:center;padding:0;color:var(--gray12);background:var(--normal-bg);border:1px solid var(--gray4);transform:var(--toast-close-button-transform);border-radius:50%;cursor:pointer;z-index:1;transition:opacity .1s,background .2s,border-color .2s}[data-sonner-toast][data-styled=true] [data-close-button]:focus-visible{box-shadow:0 4px 12px rgba(0,0,0,.1),0 0 0 2px rgba(0,0,0,.2)}[data-sonner-toast][data-styled=true] [data-disabled=true]{cursor:not-allowed}[data-sonner-toast][data-styled=true]:hover [data-close-button]:hover{background:var(--gray2);border-color:var(--gray5)}[data-sonner-toast][data-swiping=true]::before{content:'';position:absolute;left:-100%;right:-100%;height:100%;z-index:-1}[data-sonner-toast][data-y-position=top][data-swiping=true]::before{bottom:50%;transform:scaleY(3) translateY(50%)}[data-sonner-toast][data-y-position=bottom][data-swiping=true]::before{top:50%;transform:scaleY(3) translateY(-50%)}[data-sonner-toast][data-swiping=false][data-removed=true]::before{content:'';position:absolute;inset:0;transform:scaleY(2)}[data-sonner-toast][data-expanded=true]::after{content:'';position:absolute;left:0;height:calc(var(--gap) + 1px);bottom:100%;width:100%}[data-sonner-toast][data-mounted=true]{--y:translateY(0);opacity:1}[data-sonner-toast][data-expanded=false][data-front=false]{--scale:var(--toasts-before) * 0.05 + 1;--y:translateY(calc(var(--lift-amount) * var(--toasts-before))) scale(calc(-1 * var(--scale)));height:var(--front-toast-height)}[data-sonner-toast]>*{transition:opacity .4s}[data-sonner-toast][data-x-position=right]{right:0}[data-sonner-toast][data-x-position=left]{left:0}[data-sonner-toast][data-expanded=false][data-front=false][data-styled=true]>*{opacity:0}[data-sonner-toast][data-visible=false]{opacity:0;pointer-events:none}[data-sonner-toast][data-mounted=true][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset)));height:var(--initial-height)}[data-sonner-toast][data-removed=true][data-front=true][data-swipe-out=false]{--y:translateY(calc(var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=true]{--y:translateY(calc(var(--lift) * var(--offset) + var(--lift) * -100%));opacity:0}[data-sonner-toast][data-removed=true][data-front=false][data-swipe-out=false][data-expanded=false]{--y:translateY(40%);opacity:0;transition:transform .5s,opacity .2s}[data-sonner-toast][data-removed=true][data-front=false]::before{height:calc(var(--initial-height) + 20%)}[data-sonner-toast][data-swiping=true]{transform:var(--y) translateY(var(--swipe-amount-y,0)) translateX(var(--swipe-amount-x,0));transition:none}[data-sonner-toast][data-swiped=true]{user-select:none}[data-sonner-toast][data-swipe-out=true][data-y-position=bottom],[data-sonner-toast][data-swipe-out=true][data-y-position=top]{animation-duration:.2s;animation-timing-function:ease-out;animation-fill-mode:forwards}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=left]{animation-name:swipe-out-left}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=right]{animation-name:swipe-out-right}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=up]{animation-name:swipe-out-up}[data-sonner-toast][data-swipe-out=true][data-swipe-direction=down]{animation-name:swipe-out-down}@keyframes swipe-out-left{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) - 100%));opacity:0}}@keyframes swipe-out-right{from{transform:var(--y) translateX(var(--swipe-amount-x));opacity:1}to{transform:var(--y) translateX(calc(var(--swipe-amount-x) + 100%));opacity:0}}@keyframes swipe-out-up{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) - 100%));opacity:0}}@keyframes swipe-out-down{from{transform:var(--y) translateY(var(--swipe-amount-y));opacity:1}to{transform:var(--y) translateY(calc(var(--swipe-amount-y) + 100%));opacity:0}}@media (max-width:600px){[data-sonner-toaster]{position:fixed;right:var(--mobile-offset-right);left:var(--mobile-offset-left);width:100%}[data-sonner-toaster][dir=rtl]{left:calc(var(--mobile-offset-left) * -1)}[data-sonner-toaster] [data-sonner-toast]{left:0;right:0;width:calc(100% - var(--mobile-offset-left) * 2)}[data-sonner-toaster][data-x-position=left]{left:var(--mobile-offset-left)}[data-sonner-toaster][data-y-position=bottom]{bottom:var(--mobile-offset-bottom)}[data-sonner-toaster][data-y-position=top]{top:var(--mobile-offset-top)}[data-sonner-toaster][data-x-position=center]{left:var(--mobile-offset-left);right:var(--mobile-offset-right);transform:none}}[data-sonner-toaster][data-sonner-theme=light]{--normal-bg:#fff;--normal-border:var(--gray4);--normal-text:var(--gray12);--success-bg:hsl(143, 85%, 96%);--success-border:hsl(145, 92%, 87%);--success-text:hsl(140, 100%, 27%);--info-bg:hsl(208, 100%, 97%);--info-border:hsl(221, 91%, 93%);--info-text:hsl(210, 92%, 45%);--warning-bg:hsl(49, 100%, 97%);--warning-border:hsl(49, 91%, 84%);--warning-text:hsl(31, 92%, 45%);--error-bg:hsl(359, 100%, 97%);--error-border:hsl(359, 100%, 94%);--error-text:hsl(360, 100%, 45%)}[data-sonner-toaster][data-sonner-theme=light] [data-sonner-toast][data-invert=true]{--normal-bg:#000;--normal-border:hsl(0, 0%, 20%);--normal-text:var(--gray1)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast][data-invert=true]{--normal-bg:#fff;--normal-border:var(--gray3);--normal-text:var(--gray12)}[data-sonner-toaster][data-sonner-theme=dark]{--normal-bg:#000;--normal-bg-hover:hsl(0, 0%, 12%);--normal-border:hsl(0, 0%, 20%);--normal-border-hover:hsl(0, 0%, 25%);--normal-text:var(--gray1);--success-bg:hsl(150, 100%, 6%);--success-border:hsl(147, 100%, 12%);--success-text:hsl(150, 86%, 65%);--info-bg:hsl(215, 100%, 6%);--info-border:hsl(223, 43%, 17%);--info-text:hsl(216, 87%, 65%);--warning-bg:hsl(64, 100%, 6%);--warning-border:hsl(60, 100%, 9%);--warning-text:hsl(46, 87%, 65%);--error-bg:hsl(358, 76%, 10%);--error-border:hsl(357, 89%, 16%);--error-text:hsl(358, 100%, 81%)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]{background:var(--normal-bg);border-color:var(--normal-border);color:var(--normal-text)}[data-sonner-toaster][data-sonner-theme=dark] [data-sonner-toast] [data-close-button]:hover{background:var(--normal-bg-hover);border-color:var(--normal-border-hover)}[data-rich-colors=true][data-sonner-toast][data-type=success]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=success] [data-close-button]{background:var(--success-bg);border-color:var(--success-border);color:var(--success-text)}[data-rich-colors=true][data-sonner-toast][data-type=info]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=info] [data-close-button]{background:var(--info-bg);border-color:var(--info-border);color:var(--info-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=warning] [data-close-button]{background:var(--warning-bg);border-color:var(--warning-border);color:var(--warning-text)}[data-rich-colors=true][data-sonner-toast][data-type=error]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}[data-rich-colors=true][data-sonner-toast][data-type=error] [data-close-button]{background:var(--error-bg);border-color:var(--error-border);color:var(--error-text)}.sonner-loading-wrapper{--size:16px;height:var(--size);width:var(--size);position:absolute;inset:0;z-index:10}.sonner-loading-wrapper[data-visible=false]{transform-origin:center;animation:sonner-fade-out .2s ease forwards}.sonner-spinner{position:relative;top:50%;left:50%;height:var(--size);width:var(--size)}.sonner-loading-bar{animation:sonner-spin 1.2s linear infinite;background:var(--gray11);border-radius:6px;height:8%;left:-10%;position:absolute;top:-3.9%;width:24%}.sonner-loading-bar:first-child{animation-delay:-1.2s;transform:rotate(.0001deg) translate(146%)}.sonner-loading-bar:nth-child(2){animation-delay:-1.1s;transform:rotate(30deg) translate(146%)}.sonner-loading-bar:nth-child(3){animation-delay:-1s;transform:rotate(60deg) translate(146%)}.sonner-loading-bar:nth-child(4){animation-delay:-.9s;transform:rotate(90deg) translate(146%)}.sonner-loading-bar:nth-child(5){animation-delay:-.8s;transform:rotate(120deg) translate(146%)}.sonner-loading-bar:nth-child(6){animation-delay:-.7s;transform:rotate(150deg) translate(146%)}.sonner-loading-bar:nth-child(7){animation-delay:-.6s;transform:rotate(180deg) translate(146%)}.sonner-loading-bar:nth-child(8){animation-delay:-.5s;transform:rotate(210deg) translate(146%)}.sonner-loading-bar:nth-child(9){animation-delay:-.4s;transform:rotate(240deg) translate(146%)}.sonner-loading-bar:nth-child(10){animation-delay:-.3s;transform:rotate(270deg) translate(146%)}.sonner-loading-bar:nth-child(11){animation-delay:-.2s;transform:rotate(300deg) translate(146%)}.sonner-loading-bar:nth-child(12){animation-delay:-.1s;transform:rotate(330deg) translate(146%)}@keyframes sonner-fade-in{0%{opacity:0;transform:scale(.8)}100%{opacity:1;transform:scale(1)}}@keyframes sonner-fade-out{0%{opacity:1;transform:scale(1)}100%{opacity:0;transform:scale(.8)}}@keyframes sonner-spin{0%{opacity:1}100%{opacity:.15}}@media (prefers-reduced-motion){.sonner-loading-bar,[data-sonner-toast],[data-sonner-toast]>*{transition:none!important;animation:none!important}}.sonner-loader{position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);transform-origin:center;transition:opacity .2s,transform .2s}.sonner-loader[data-visible=false]{opacity:0;transform:scale(.8) translate(-50%,-50%)}");
function tr(e) {
  return e.label !== void 0;
}
const fh = 3, ph = "24px", mh = "16px", Ha = 4e3, hh = 356, vh = 14, gh = 45, xh = 200;
function lt(...e) {
  return e.filter(Boolean).join(" ");
}
function yh(e) {
  const [t, n] = e.split("-"), r = [];
  return t && r.push(t), n && r.push(n), r;
}
const bh = (e) => {
  var t, n, r, o, a, s, i, d, l;
  const { invert: u, toast: c, unstyled: f, interacting: m, setHeights: y, visibleToasts: h, heights: g, index: k, toasts: C, expanded: E, removeToast: O, defaultRichColors: v, closeButton: P, style: M, cancelButtonStyle: D, actionButtonStyle: L, className: Y = "", descriptionClassName: U = "", duration: J, position: ee, gap: q, expandByDefault: G, classNames: j, icons: K, closeButtonAriaLabel: _ = "Close toast" } = e, [R, b] = w.useState(null), [S, A] = w.useState(null), [T, N] = w.useState(!1), [V, F] = w.useState(!1), [W, z] = w.useState(!1), [H, Q] = w.useState(!1), [se, I] = w.useState(!1), [ue, Se] = w.useState(0), [ze, et] = w.useState(0), _e = w.useRef(c.duration || J || Ha), Ue = w.useRef(null), ge = w.useRef(null), Dt = k === 0, kn = k + 1 <= h, Te = c.type, Ge = c.dismissible !== !1, $ = c.className || "", ne = c.descriptionClassName || "", me = w.useMemo(() => g.findIndex((B) => B.toastId === c.id) || 0, [
    g,
    c.id
  ]), Ce = w.useMemo(() => {
    var B;
    return (B = c.closeButton) != null ? B : P;
  }, [
    c.closeButton,
    P
  ]), Ae = w.useMemo(() => c.duration || J || Ha, [
    c.duration,
    J
  ]), tt = w.useRef(0), Ie = w.useRef(0), Pt = w.useRef(0), Ke = w.useRef(null), [Yt, _t] = ee.split("-"), Tt = w.useMemo(() => g.reduce((B, Me, Re) => Re >= me ? B : B + Me.height, 0), [
    g,
    me
  ]), yt = ah(), Ht = c.invert || u, ct = Te === "loading";
  Ie.current = w.useMemo(() => me * q + Tt, [
    me,
    Tt
  ]), w.useEffect(() => {
    _e.current = Ae;
  }, [
    Ae
  ]), w.useEffect(() => {
    N(!0);
  }, []), w.useEffect(() => {
    const B = ge.current;
    if (B) {
      const Me = B.getBoundingClientRect().height;
      return et(Me), y((Re) => [
        {
          toastId: c.id,
          height: Me,
          position: c.position
        },
        ...Re
      ]), () => y((Re) => Re.filter((We) => We.toastId !== c.id));
    }
  }, [
    y,
    c.id
  ]), w.useLayoutEffect(() => {
    if (!T) return;
    const B = ge.current, Me = B.style.height;
    B.style.height = "auto";
    const Re = B.getBoundingClientRect().height;
    B.style.height = Me, et(Re), y((We) => We.find((Oe) => Oe.toastId === c.id) ? We.map((Oe) => Oe.toastId === c.id ? {
      ...Oe,
      height: Re
    } : Oe) : [
      {
        toastId: c.id,
        height: Re,
        position: c.position
      },
      ...We
    ]);
  }, [
    T,
    c.title,
    c.description,
    y,
    c.id,
    c.jsx,
    c.action,
    c.cancel
  ]);
  const re = w.useCallback(() => {
    F(!0), Se(Ie.current), y((B) => B.filter((Me) => Me.toastId !== c.id)), setTimeout(() => {
      O(c);
    }, xh);
  }, [
    c,
    O,
    y,
    Ie
  ]);
  w.useEffect(() => {
    if (c.promise && Te === "loading" || c.duration === 1 / 0 || c.type === "loading") return;
    let B;
    return E || m || yt ? (() => {
      if (Pt.current < tt.current) {
        const We = (/* @__PURE__ */ new Date()).getTime() - tt.current;
        _e.current = _e.current - We;
      }
      Pt.current = (/* @__PURE__ */ new Date()).getTime();
    })() : (() => {
      _e.current !== 1 / 0 && (tt.current = (/* @__PURE__ */ new Date()).getTime(), B = setTimeout(() => {
        c.onAutoClose == null || c.onAutoClose.call(c, c), re();
      }, _e.current));
    })(), () => clearTimeout(B);
  }, [
    E,
    m,
    c,
    Te,
    yt,
    re
  ]), w.useEffect(() => {
    c.delete && (re(), c.onDismiss == null || c.onDismiss.call(c, c));
  }, [
    re,
    c.delete
  ]);
  function xe() {
    var B;
    if (K != null && K.loading) {
      var Me;
      return /* @__PURE__ */ w.createElement("div", {
        className: lt(j == null ? void 0 : j.loader, c == null || (Me = c.classNames) == null ? void 0 : Me.loader, "sonner-loader"),
        "data-visible": Te === "loading"
      }, K.loading);
    }
    return /* @__PURE__ */ w.createElement(Jm, {
      className: lt(j == null ? void 0 : j.loader, c == null || (B = c.classNames) == null ? void 0 : B.loader),
      visible: Te === "loading"
    });
  }
  const oe = c.icon || (K == null ? void 0 : K[Te]) || Zm(Te);
  var ye, Fe;
  return /* @__PURE__ */ w.createElement("li", {
    tabIndex: 0,
    ref: ge,
    className: lt(Y, $, j == null ? void 0 : j.toast, c == null || (t = c.classNames) == null ? void 0 : t.toast, j == null ? void 0 : j.default, j == null ? void 0 : j[Te], c == null || (n = c.classNames) == null ? void 0 : n[Te]),
    "data-sonner-toast": "",
    "data-rich-colors": (ye = c.richColors) != null ? ye : v,
    "data-styled": !(c.jsx || c.unstyled || f),
    "data-mounted": T,
    "data-promise": !!c.promise,
    "data-swiped": se,
    "data-removed": V,
    "data-visible": kn,
    "data-y-position": Yt,
    "data-x-position": _t,
    "data-index": k,
    "data-front": Dt,
    "data-swiping": W,
    "data-dismissible": Ge,
    "data-type": Te,
    "data-invert": Ht,
    "data-swipe-out": H,
    "data-swipe-direction": S,
    "data-expanded": !!(E || G && T),
    style: {
      "--index": k,
      "--toasts-before": k,
      "--z-index": C.length - k,
      "--offset": `${V ? ue : Ie.current}px`,
      "--initial-height": G ? "auto" : `${ze}px`,
      ...M,
      ...c.style
    },
    onDragEnd: () => {
      z(!1), b(null), Ke.current = null;
    },
    onPointerDown: (B) => {
      B.button !== 2 && (ct || !Ge || (Ue.current = /* @__PURE__ */ new Date(), Se(Ie.current), B.target.setPointerCapture(B.pointerId), B.target.tagName !== "BUTTON" && (z(!0), Ke.current = {
        x: B.clientX,
        y: B.clientY
      })));
    },
    onPointerUp: () => {
      var B, Me, Re;
      if (H || !Ge) return;
      Ke.current = null;
      const We = Number(((B = ge.current) == null ? void 0 : B.style.getPropertyValue("--swipe-amount-x").replace("px", "")) || 0), At = Number(((Me = ge.current) == null ? void 0 : Me.style.getPropertyValue("--swipe-amount-y").replace("px", "")) || 0), Oe = (/* @__PURE__ */ new Date()).getTime() - ((Re = Ue.current) == null ? void 0 : Re.getTime()), Xe = R === "x" ? We : At, Xn = Math.abs(Xe) / Oe;
      if (Math.abs(Xe) >= gh || Xn > 0.11) {
        Se(Ie.current), c.onDismiss == null || c.onDismiss.call(c, c), A(R === "x" ? We > 0 ? "right" : "left" : At > 0 ? "down" : "up"), re(), Q(!0);
        return;
      } else {
        var nt, rt;
        (nt = ge.current) == null || nt.style.setProperty("--swipe-amount-x", "0px"), (rt = ge.current) == null || rt.style.setProperty("--swipe-amount-y", "0px");
      }
      I(!1), z(!1), b(null);
    },
    onPointerMove: (B) => {
      var Me, Re, We;
      if (!Ke.current || !Ge || ((Me = window.getSelection()) == null ? void 0 : Me.toString().length) > 0) return;
      const Oe = B.clientY - Ke.current.y, Xe = B.clientX - Ke.current.x;
      var Xn;
      const nt = (Xn = e.swipeDirections) != null ? Xn : yh(ee);
      !R && (Math.abs(Xe) > 1 || Math.abs(Oe) > 1) && b(Math.abs(Xe) > Math.abs(Oe) ? "x" : "y");
      let rt = {
        x: 0,
        y: 0
      };
      const wa = (qt) => 1 / (1.5 + Math.abs(qt) / 20);
      if (R === "y") {
        if (nt.includes("top") || nt.includes("bottom"))
          if (nt.includes("top") && Oe < 0 || nt.includes("bottom") && Oe > 0)
            rt.y = Oe;
          else {
            const qt = Oe * wa(Oe);
            rt.y = Math.abs(qt) < Math.abs(Oe) ? qt : Oe;
          }
      } else if (R === "x" && (nt.includes("left") || nt.includes("right")))
        if (nt.includes("left") && Xe < 0 || nt.includes("right") && Xe > 0)
          rt.x = Xe;
        else {
          const qt = Xe * wa(Xe);
          rt.x = Math.abs(qt) < Math.abs(Xe) ? qt : Xe;
        }
      (Math.abs(rt.x) > 0 || Math.abs(rt.y) > 0) && I(!0), (Re = ge.current) == null || Re.style.setProperty("--swipe-amount-x", `${rt.x}px`), (We = ge.current) == null || We.style.setProperty("--swipe-amount-y", `${rt.y}px`);
    }
  }, Ce && !c.jsx && Te !== "loading" ? /* @__PURE__ */ w.createElement("button", {
    "aria-label": _,
    "data-disabled": ct,
    "data-close-button": !0,
    onClick: ct || !Ge ? () => {
    } : () => {
      re(), c.onDismiss == null || c.onDismiss.call(c, c);
    },
    className: lt(j == null ? void 0 : j.closeButton, c == null || (r = c.classNames) == null ? void 0 : r.closeButton)
  }, (Fe = K == null ? void 0 : K.close) != null ? Fe : oh) : null, (Te || c.icon || c.promise) && c.icon !== null && ((K == null ? void 0 : K[Te]) !== null || c.icon) ? /* @__PURE__ */ w.createElement("div", {
    "data-icon": "",
    className: lt(j == null ? void 0 : j.icon, c == null || (o = c.classNames) == null ? void 0 : o.icon)
  }, c.promise || c.type === "loading" && !c.icon ? c.icon || xe() : null, c.type !== "loading" ? oe : null) : null, /* @__PURE__ */ w.createElement("div", {
    "data-content": "",
    className: lt(j == null ? void 0 : j.content, c == null || (a = c.classNames) == null ? void 0 : a.content)
  }, /* @__PURE__ */ w.createElement("div", {
    "data-title": "",
    className: lt(j == null ? void 0 : j.title, c == null || (s = c.classNames) == null ? void 0 : s.title)
  }, c.jsx ? c.jsx : typeof c.title == "function" ? c.title() : c.title), c.description ? /* @__PURE__ */ w.createElement("div", {
    "data-description": "",
    className: lt(U, ne, j == null ? void 0 : j.description, c == null || (i = c.classNames) == null ? void 0 : i.description)
  }, typeof c.description == "function" ? c.description() : c.description) : null), /* @__PURE__ */ w.isValidElement(c.cancel) ? c.cancel : c.cancel && tr(c.cancel) ? /* @__PURE__ */ w.createElement("button", {
    "data-button": !0,
    "data-cancel": !0,
    style: c.cancelButtonStyle || D,
    onClick: (B) => {
      tr(c.cancel) && Ge && (c.cancel.onClick == null || c.cancel.onClick.call(c.cancel, B), re());
    },
    className: lt(j == null ? void 0 : j.cancelButton, c == null || (d = c.classNames) == null ? void 0 : d.cancelButton)
  }, c.cancel.label) : null, /* @__PURE__ */ w.isValidElement(c.action) ? c.action : c.action && tr(c.action) ? /* @__PURE__ */ w.createElement("button", {
    "data-button": !0,
    "data-action": !0,
    style: c.actionButtonStyle || L,
    onClick: (B) => {
      tr(c.action) && (c.action.onClick == null || c.action.onClick.call(c.action, B), !B.defaultPrevented && re());
    },
    className: lt(j == null ? void 0 : j.actionButton, c == null || (l = c.classNames) == null ? void 0 : l.actionButton)
  }, c.action.label) : null);
};
function qa() {
  if (typeof window > "u" || typeof document > "u") return "ltr";
  const e = document.documentElement.getAttribute("dir");
  return e === "auto" || !e ? window.getComputedStyle(document.documentElement).direction : e;
}
function wh(e, t) {
  const n = {};
  return [
    e,
    t
  ].forEach((r, o) => {
    const a = o === 1, s = a ? "--mobile-offset" : "--offset", i = a ? mh : ph;
    function d(l) {
      [
        "top",
        "right",
        "bottom",
        "left"
      ].forEach((u) => {
        n[`${s}-${u}`] = typeof l == "number" ? `${l}px` : l;
      });
    }
    typeof r == "number" || typeof r == "string" ? d(r) : typeof r == "object" ? [
      "top",
      "right",
      "bottom",
      "left"
    ].forEach((l) => {
      r[l] === void 0 ? n[`${s}-${l}`] = i : n[`${s}-${l}`] = typeof r[l] == "number" ? `${r[l]}px` : r[l];
    }) : d(i);
  }), n;
}
const kh = /* @__PURE__ */ w.forwardRef(function(t, n) {
  const { invert: r, position: o = "bottom-right", hotkey: a = [
    "altKey",
    "KeyT"
  ], expand: s, closeButton: i, className: d, offset: l, mobileOffset: u, theme: c = "light", richColors: f, duration: m, style: y, visibleToasts: h = fh, toastOptions: g, dir: k = qa(), gap: C = vh, icons: E, containerAriaLabel: O = "Notifications" } = t, [v, P] = w.useState([]), M = w.useMemo(() => Array.from(new Set([
    o
  ].concat(v.filter((S) => S.position).map((S) => S.position)))), [
    v,
    o
  ]), [D, L] = w.useState([]), [Y, U] = w.useState(!1), [J, ee] = w.useState(!1), [q, G] = w.useState(c !== "system" ? c : typeof window < "u" && window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light"), j = w.useRef(null), K = a.join("+").replace(/Key/g, "").replace(/Digit/g, ""), _ = w.useRef(null), R = w.useRef(!1), b = w.useCallback((S) => {
    P((A) => {
      var T;
      return (T = A.find((N) => N.id === S.id)) != null && T.delete || Le.dismiss(S.id), A.filter(({ id: N }) => N !== S.id);
    });
  }, []);
  return w.useEffect(() => Le.subscribe((S) => {
    if (S.dismiss) {
      requestAnimationFrame(() => {
        P((A) => A.map((T) => T.id === S.id ? {
          ...T,
          delete: !0
        } : T));
      });
      return;
    }
    setTimeout(() => {
      Vi.flushSync(() => {
        P((A) => {
          const T = A.findIndex((N) => N.id === S.id);
          return T !== -1 ? [
            ...A.slice(0, T),
            {
              ...A[T],
              ...S
            },
            ...A.slice(T + 1)
          ] : [
            S,
            ...A
          ];
        });
      });
    });
  }), [
    v
  ]), w.useEffect(() => {
    if (c !== "system") {
      G(c);
      return;
    }
    if (c === "system" && (window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches ? G("dark") : G("light")), typeof window > "u") return;
    const S = window.matchMedia("(prefers-color-scheme: dark)");
    try {
      S.addEventListener("change", ({ matches: A }) => {
        G(A ? "dark" : "light");
      });
    } catch {
      S.addListener(({ matches: T }) => {
        try {
          G(T ? "dark" : "light");
        } catch (N) {
          console.error(N);
        }
      });
    }
  }, [
    c
  ]), w.useEffect(() => {
    v.length <= 1 && U(!1);
  }, [
    v
  ]), w.useEffect(() => {
    const S = (A) => {
      var T;
      if (a.every((F) => A[F] || A.code === F)) {
        var V;
        U(!0), (V = j.current) == null || V.focus();
      }
      A.code === "Escape" && (document.activeElement === j.current || (T = j.current) != null && T.contains(document.activeElement)) && U(!1);
    };
    return document.addEventListener("keydown", S), () => document.removeEventListener("keydown", S);
  }, [
    a
  ]), w.useEffect(() => {
    if (j.current)
      return () => {
        _.current && (_.current.focus({
          preventScroll: !0
        }), _.current = null, R.current = !1);
      };
  }, [
    j.current
  ]), // Remove item from normal navigation flow, only available via hotkey
  /* @__PURE__ */ w.createElement("section", {
    ref: n,
    "aria-label": `${O} ${K}`,
    tabIndex: -1,
    "aria-live": "polite",
    "aria-relevant": "additions text",
    "aria-atomic": "false",
    suppressHydrationWarning: !0
  }, M.map((S, A) => {
    var T;
    const [N, V] = S.split("-");
    return v.length ? /* @__PURE__ */ w.createElement("ol", {
      key: S,
      dir: k === "auto" ? qa() : k,
      tabIndex: -1,
      ref: j,
      className: d,
      "data-sonner-toaster": !0,
      "data-sonner-theme": q,
      "data-y-position": N,
      "data-x-position": V,
      style: {
        "--front-toast-height": `${((T = D[0]) == null ? void 0 : T.height) || 0}px`,
        "--width": `${hh}px`,
        "--gap": `${C}px`,
        ...y,
        ...wh(l, u)
      },
      onBlur: (F) => {
        R.current && !F.currentTarget.contains(F.relatedTarget) && (R.current = !1, _.current && (_.current.focus({
          preventScroll: !0
        }), _.current = null));
      },
      onFocus: (F) => {
        F.target instanceof HTMLElement && F.target.dataset.dismissible === "false" || R.current || (R.current = !0, _.current = F.relatedTarget);
      },
      onMouseEnter: () => U(!0),
      onMouseMove: () => U(!0),
      onMouseLeave: () => {
        J || U(!1);
      },
      onDragEnd: () => U(!1),
      onPointerDown: (F) => {
        F.target instanceof HTMLElement && F.target.dataset.dismissible === "false" || ee(!0);
      },
      onPointerUp: () => ee(!1)
    }, v.filter((F) => !F.position && A === 0 || F.position === S).map((F, W) => {
      var z, H;
      return /* @__PURE__ */ w.createElement(bh, {
        key: F.id,
        icons: E,
        index: W,
        toast: F,
        defaultRichColors: f,
        duration: (z = g == null ? void 0 : g.duration) != null ? z : m,
        className: g == null ? void 0 : g.className,
        descriptionClassName: g == null ? void 0 : g.descriptionClassName,
        invert: r,
        visibleToasts: h,
        closeButton: (H = g == null ? void 0 : g.closeButton) != null ? H : i,
        interacting: J,
        position: S,
        style: g == null ? void 0 : g.style,
        unstyled: g == null ? void 0 : g.unstyled,
        classNames: g == null ? void 0 : g.classNames,
        cancelButtonStyle: g == null ? void 0 : g.cancelButtonStyle,
        actionButtonStyle: g == null ? void 0 : g.actionButtonStyle,
        closeButtonAriaLabel: g == null ? void 0 : g.closeButtonAriaLabel,
        removeToast: b,
        toasts: v.filter((Q) => Q.position == F.position),
        heights: D.filter((Q) => Q.position == F.position),
        setHeights: L,
        expandByDefault: s,
        gap: C,
        expanded: Y,
        swipeDirections: t.swipeDirections
      });
    })) : null;
  }));
}), d0 = (e, t) => !e || e.length <= t ? e ?? null : `${e.slice(0, t - 3)}...`, Eh = hm(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-all disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg:not([class*='size-'])]:size-4 shrink-0 [&_svg]:shrink-0 outline-none focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-xs hover:bg-primary/90",
        destructive: "bg-destructive text-white shadow-xs hover:bg-destructive/90 focus-visible:ring-destructive/20 dark:focus-visible:ring-destructive/40 dark:bg-destructive/60",
        outline: "border bg-background shadow-xs hover:bg-accent hover:text-accent-foreground dark:bg-input/30 dark:border-input dark:hover:bg-input/50",
        secondary: "bg-secondary text-secondary-foreground shadow-xs hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground dark:hover:bg-accent/50",
        link: "text-primary underline-offset-4 hover:underline"
      },
      size: {
        default: "h-9 px-4 py-2 has-[>svg]:px-3",
        sm: "h-8 rounded-md gap-1.5 px-3 has-[>svg]:px-2.5",
        lg: "h-10 rounded-md px-6 has-[>svg]:px-4",
        icon: "size-9"
      }
    },
    defaultVariants: {
      variant: "default",
      size: "default"
    }
  }
);
function Eo({
  className: e,
  variant: t,
  size: n,
  asChild: r = !1,
  ...o
}) {
  const a = r ? lm : "button";
  return /* @__PURE__ */ x.jsx(
    a,
    {
      className: ae(Eh({ variant: t, size: n, className: e })),
      "data-slot": "button",
      ...o
    }
  );
}
function He(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Ch(e, t) {
  const n = p.createContext(t), r = (a) => {
    const { children: s, ...i } = a, d = p.useMemo(() => i, Object.values(i));
    return /* @__PURE__ */ x.jsx(n.Provider, { value: d, children: s });
  };
  r.displayName = e + "Provider";
  function o(a) {
    const s = p.useContext(n);
    if (s) return s;
    if (t !== void 0) return t;
    throw new Error(`\`${a}\` must be used within \`${e}\``);
  }
  return [r, o];
}
function Lt(e, t = []) {
  let n = [];
  function r(a, s) {
    const i = p.createContext(s), d = n.length;
    n = [...n, s];
    const l = (c) => {
      var k;
      const { scope: f, children: m, ...y } = c, h = ((k = f == null ? void 0 : f[e]) == null ? void 0 : k[d]) || i, g = p.useMemo(() => y, Object.values(y));
      return /* @__PURE__ */ x.jsx(h.Provider, { value: g, children: m });
    };
    l.displayName = a + "Provider";
    function u(c, f) {
      var h;
      const m = ((h = f == null ? void 0 : f[e]) == null ? void 0 : h[d]) || i, y = p.useContext(m);
      if (y) return y;
      if (s !== void 0) return s;
      throw new Error(`\`${c}\` must be used within \`${a}\``);
    }
    return [l, u];
  }
  const o = () => {
    const a = n.map((s) => p.createContext(s));
    return function(i) {
      const d = (i == null ? void 0 : i[e]) || a;
      return p.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: d } }),
        [i, d]
      );
    };
  };
  return o.scopeName = e, [r, Oh(o, ...t)];
}
function Oh(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const n = () => {
    const r = e.map((o) => ({
      useScope: o(),
      scopeName: o.scopeName
    }));
    return function(a) {
      const s = r.reduce((i, { useScope: d, scopeName: l }) => {
        const c = d(a)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return p.useMemo(() => ({ [`__scope${t.scopeName}`]: s }), [s]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
var Sh = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ve = Sh.reduce((e, t) => {
  const n = /* @__PURE__ */ Xt(`Primitive.${t}`), r = p.forwardRef((o, a) => {
    const { asChild: s, ...i } = o, d = s ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ x.jsx(d, { ...i, ref: a });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Ho(e, t) {
  e && qi.flushSync(() => e.dispatchEvent(t));
}
function Ve(e) {
  const t = p.useRef(e);
  return p.useEffect(() => {
    t.current = e;
  }), p.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function As(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e);
  p.useEffect(() => {
    const r = (o) => {
      o.key === "Escape" && n(o);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Mh = "DismissableLayer", Co = "dismissableLayer.update", Dh = "dismissableLayer.pointerDownOutside", Ph = "dismissableLayer.focusOutside", Va, Rs = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), qo = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...d
    } = e, l = p.useContext(Rs), [u, c] = p.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = p.useState({}), y = we(t, (M) => c(M)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), k = h.indexOf(g), C = u ? h.indexOf(u) : -1, E = l.layersWithOutsidePointerEventsDisabled.size > 0, O = C >= k, v = Ah((M) => {
      const D = M.target, L = [...l.branches].some((Y) => Y.contains(D));
      !O || L || (o == null || o(M), s == null || s(M), M.defaultPrevented || i == null || i());
    }, f), P = Rh((M) => {
      const D = M.target;
      [...l.branches].some((Y) => Y.contains(D)) || (a == null || a(M), s == null || s(M), M.defaultPrevented || i == null || i());
    }, f);
    return As((M) => {
      C === l.layers.size - 1 && (r == null || r(M), !M.defaultPrevented && i && (M.preventDefault(), i()));
    }, f), p.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (Va = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), Ua(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = Va);
        };
    }, [u, f, n, l]), p.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), Ua());
    }, [u, l]), p.useEffect(() => {
      const M = () => m({});
      return document.addEventListener(Co, M), () => document.removeEventListener(Co, M);
    }, []), /* @__PURE__ */ x.jsx(
      ve.div,
      {
        ...d,
        ref: y,
        style: {
          pointerEvents: E ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: He(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: He(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: He(
          e.onPointerDownCapture,
          v.onPointerDownCapture
        )
      }
    );
  }
);
qo.displayName = Mh;
var _h = "DismissableLayerBranch", Th = p.forwardRef((e, t) => {
  const n = p.useContext(Rs), r = p.useRef(null), o = we(t, r);
  return p.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ x.jsx(ve.div, { ...e, ref: o });
});
Th.displayName = _h;
function Ah(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let d = function() {
          Ns(
            Dh,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Rh(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = p.useRef(!1);
  return p.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && Ns(Ph, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function Ua() {
  const e = new CustomEvent(Co);
  document.dispatchEvent(e);
}
function Ns(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ho(o, a) : o.dispatchEvent(a);
}
var Kr = 0;
function js() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Ga()), document.body.insertAdjacentElement("beforeend", e[1] ?? Ga()), Kr++, () => {
      Kr === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Kr--;
    };
  }, []);
}
function Ga() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Xr = "focusScope.autoFocusOnMount", Zr = "focusScope.autoFocusOnUnmount", Ka = { bubbles: !1, cancelable: !0 }, Nh = "FocusScope", _r = p.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: o,
    onUnmountAutoFocus: a,
    ...s
  } = e, [i, d] = p.useState(null), l = Ve(o), u = Ve(a), c = p.useRef(null), f = we(t, (h) => d(h)), m = p.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  p.useEffect(() => {
    if (r) {
      let h = function(E) {
        if (m.paused || !i) return;
        const O = E.target;
        i.contains(O) ? c.current = O : jt(c.current, { select: !0 });
      }, g = function(E) {
        if (m.paused || !i) return;
        const O = E.relatedTarget;
        O !== null && (i.contains(O) || jt(c.current, { select: !0 }));
      }, k = function(E) {
        if (document.activeElement === document.body)
          for (const v of E)
            v.removedNodes.length > 0 && jt(i);
      };
      document.addEventListener("focusin", h), document.addEventListener("focusout", g);
      const C = new MutationObserver(k);
      return i && C.observe(i, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", h), document.removeEventListener("focusout", g), C.disconnect();
      };
    }
  }, [r, i, m.paused]), p.useEffect(() => {
    if (i) {
      Za.add(m);
      const h = document.activeElement;
      if (!i.contains(h)) {
        const k = new CustomEvent(Xr, Ka);
        i.addEventListener(Xr, l), i.dispatchEvent(k), k.defaultPrevented || (jh(Lh(Is(i)), { select: !0 }), document.activeElement === h && jt(i));
      }
      return () => {
        i.removeEventListener(Xr, l), setTimeout(() => {
          const k = new CustomEvent(Zr, Ka);
          i.addEventListener(Zr, u), i.dispatchEvent(k), k.defaultPrevented || jt(h ?? document.body, { select: !0 }), i.removeEventListener(Zr, u), Za.remove(m);
        }, 0);
      };
    }
  }, [i, l, u, m]);
  const y = p.useCallback(
    (h) => {
      if (!n && !r || m.paused) return;
      const g = h.key === "Tab" && !h.altKey && !h.ctrlKey && !h.metaKey, k = document.activeElement;
      if (g && k) {
        const C = h.currentTarget, [E, O] = Ih(C);
        E && O ? !h.shiftKey && k === O ? (h.preventDefault(), n && jt(E, { select: !0 })) : h.shiftKey && k === E && (h.preventDefault(), n && jt(O, { select: !0 })) : k === C && h.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ x.jsx(ve.div, { tabIndex: -1, ...s, ref: f, onKeyDown: y });
});
_r.displayName = Nh;
function jh(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (jt(r, { select: t }), document.activeElement !== n) return;
}
function Ih(e) {
  const t = Is(e), n = Xa(t, e), r = Xa(t.reverse(), e);
  return [n, r];
}
function Is(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const o = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || o ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) t.push(n.currentNode);
  return t;
}
function Xa(e, t) {
  for (const n of e)
    if (!Fh(n, { upTo: t })) return n;
}
function Fh(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Wh(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function jt(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && Wh(e) && t && e.select();
  }
}
var Za = $h();
function $h() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = Qa(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = Qa(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function Qa(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function Lh(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Qe = globalThis != null && globalThis.document ? p.useLayoutEffect : () => {
}, zh = p[" useId ".trim().toString()] || (() => {
}), Bh = 0;
function Ct(e) {
  const [t, n] = p.useState(zh());
  return Qe(() => {
    n((r) => r ?? String(Bh++));
  }, [e]), t ? `radix-${t}` : "";
}
const Yh = ["top", "right", "bottom", "left"], Wt = Math.min, Ye = Math.max, xr = Math.round, nr = Math.floor, ht = (e) => ({
  x: e,
  y: e
}), Hh = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, qh = {
  start: "end",
  end: "start"
};
function Oo(e, t, n) {
  return Ye(e, Wt(t, n));
}
function Ot(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function St(e) {
  return e.split("-")[0];
}
function yn(e) {
  return e.split("-")[1];
}
function Vo(e) {
  return e === "x" ? "y" : "x";
}
function Uo(e) {
  return e === "y" ? "height" : "width";
}
const Vh = /* @__PURE__ */ new Set(["top", "bottom"]);
function mt(e) {
  return Vh.has(St(e)) ? "y" : "x";
}
function Go(e) {
  return Vo(mt(e));
}
function Uh(e, t, n) {
  n === void 0 && (n = !1);
  const r = yn(e), o = Go(e), a = Uo(o);
  let s = o === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (s = yr(s)), [s, yr(s)];
}
function Gh(e) {
  const t = yr(e);
  return [So(e), t, So(t)];
}
function So(e) {
  return e.replace(/start|end/g, (t) => qh[t]);
}
const Ja = ["left", "right"], ei = ["right", "left"], Kh = ["top", "bottom"], Xh = ["bottom", "top"];
function Zh(e, t, n) {
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? ei : Ja : t ? Ja : ei;
    case "left":
    case "right":
      return t ? Kh : Xh;
    default:
      return [];
  }
}
function Qh(e, t, n, r) {
  const o = yn(e);
  let a = Zh(St(e), n === "start", r);
  return o && (a = a.map((s) => s + "-" + o), t && (a = a.concat(a.map(So)))), a;
}
function yr(e) {
  return e.replace(/left|right|bottom|top/g, (t) => Hh[t]);
}
function Jh(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Fs(e) {
  return typeof e != "number" ? Jh(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function br(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: o
  } = e;
  return {
    width: r,
    height: o,
    top: n,
    left: t,
    right: t + r,
    bottom: n + o,
    x: t,
    y: n
  };
}
function ti(e, t, n) {
  let {
    reference: r,
    floating: o
  } = e;
  const a = mt(t), s = Go(t), i = Uo(s), d = St(t), l = a === "y", u = r.x + r.width / 2 - o.width / 2, c = r.y + r.height / 2 - o.height / 2, f = r[i] / 2 - o[i] / 2;
  let m;
  switch (d) {
    case "top":
      m = {
        x: u,
        y: r.y - o.height
      };
      break;
    case "bottom":
      m = {
        x: u,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: c
      };
      break;
    case "left":
      m = {
        x: r.x - o.width,
        y: c
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (yn(t)) {
    case "start":
      m[s] -= f * (n && l ? -1 : 1);
      break;
    case "end":
      m[s] += f * (n && l ? -1 : 1);
      break;
  }
  return m;
}
const ev = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: o = "absolute",
    middleware: a = [],
    platform: s
  } = n, i = a.filter(Boolean), d = await (s.isRTL == null ? void 0 : s.isRTL(t));
  let l = await s.getElementRects({
    reference: e,
    floating: t,
    strategy: o
  }), {
    x: u,
    y: c
  } = ti(l, r, d), f = r, m = {}, y = 0;
  for (let h = 0; h < i.length; h++) {
    const {
      name: g,
      fn: k
    } = i[h], {
      x: C,
      y: E,
      data: O,
      reset: v
    } = await k({
      x: u,
      y: c,
      initialPlacement: r,
      placement: f,
      strategy: o,
      middlewareData: m,
      rects: l,
      platform: s,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = C ?? u, c = E ?? c, m = {
      ...m,
      [g]: {
        ...m[g],
        ...O
      }
    }, v && y <= 50 && (y++, typeof v == "object" && (v.placement && (f = v.placement), v.rects && (l = v.rects === !0 ? await s.getElementRects({
      reference: e,
      floating: t,
      strategy: o
    }) : v.rects), {
      x: u,
      y: c
    } = ti(l, f, d)), h = -1);
  }
  return {
    x: u,
    y: c,
    placement: f,
    strategy: o,
    middlewareData: m
  };
};
async function Nn(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: o,
    platform: a,
    rects: s,
    elements: i,
    strategy: d
  } = e, {
    boundary: l = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: c = "floating",
    altBoundary: f = !1,
    padding: m = 0
  } = Ot(t, e), y = Fs(m), g = i[f ? c === "floating" ? "reference" : "floating" : c], k = br(await a.getClippingRect({
    element: (n = await (a.isElement == null ? void 0 : a.isElement(g))) == null || n ? g : g.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(i.floating)),
    boundary: l,
    rootBoundary: u,
    strategy: d
  })), C = c === "floating" ? {
    x: r,
    y: o,
    width: s.floating.width,
    height: s.floating.height
  } : s.reference, E = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(i.floating)), O = await (a.isElement == null ? void 0 : a.isElement(E)) ? await (a.getScale == null ? void 0 : a.getScale(E)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, v = br(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: C,
    offsetParent: E,
    strategy: d
  }) : C);
  return {
    top: (k.top - v.top + y.top) / O.y,
    bottom: (v.bottom - k.bottom + y.bottom) / O.y,
    left: (k.left - v.left + y.left) / O.x,
    right: (v.right - k.right + y.right) / O.x
  };
}
const tv = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: o,
      rects: a,
      platform: s,
      elements: i,
      middlewareData: d
    } = t, {
      element: l,
      padding: u = 0
    } = Ot(e, t) || {};
    if (l == null)
      return {};
    const c = Fs(u), f = {
      x: n,
      y: r
    }, m = Go(o), y = Uo(m), h = await s.getDimensions(l), g = m === "y", k = g ? "top" : "left", C = g ? "bottom" : "right", E = g ? "clientHeight" : "clientWidth", O = a.reference[y] + a.reference[m] - f[m] - a.floating[y], v = f[m] - a.reference[m], P = await (s.getOffsetParent == null ? void 0 : s.getOffsetParent(l));
    let M = P ? P[E] : 0;
    (!M || !await (s.isElement == null ? void 0 : s.isElement(P))) && (M = i.floating[E] || a.floating[y]);
    const D = O / 2 - v / 2, L = M / 2 - h[y] / 2 - 1, Y = Wt(c[k], L), U = Wt(c[C], L), J = Y, ee = M - h[y] - U, q = M / 2 - h[y] / 2 + D, G = Oo(J, q, ee), j = !d.arrow && yn(o) != null && q !== G && a.reference[y] / 2 - (q < J ? Y : U) - h[y] / 2 < 0, K = j ? q < J ? q - J : q - ee : 0;
    return {
      [m]: f[m] + K,
      data: {
        [m]: G,
        centerOffset: q - G - K,
        ...j && {
          alignmentOffset: K
        }
      },
      reset: j
    };
  }
}), nv = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        middlewareData: a,
        rects: s,
        initialPlacement: i,
        platform: d,
        elements: l
      } = t, {
        mainAxis: u = !0,
        crossAxis: c = !0,
        fallbackPlacements: f,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: y = "none",
        flipAlignment: h = !0,
        ...g
      } = Ot(e, t);
      if ((n = a.arrow) != null && n.alignmentOffset)
        return {};
      const k = St(o), C = mt(i), E = St(i) === i, O = await (d.isRTL == null ? void 0 : d.isRTL(l.floating)), v = f || (E || !h ? [yr(i)] : Gh(i)), P = y !== "none";
      !f && P && v.push(...Qh(i, h, y, O));
      const M = [i, ...v], D = await Nn(t, g), L = [];
      let Y = ((r = a.flip) == null ? void 0 : r.overflows) || [];
      if (u && L.push(D[k]), c) {
        const q = Uh(o, s, O);
        L.push(D[q[0]], D[q[1]]);
      }
      if (Y = [...Y, {
        placement: o,
        overflows: L
      }], !L.every((q) => q <= 0)) {
        var U, J;
        const q = (((U = a.flip) == null ? void 0 : U.index) || 0) + 1, G = M[q];
        if (G && (!(c === "alignment" ? C !== mt(G) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        Y.every((_) => _.overflows[0] > 0 && mt(_.placement) === C)))
          return {
            data: {
              index: q,
              overflows: Y
            },
            reset: {
              placement: G
            }
          };
        let j = (J = Y.filter((K) => K.overflows[0] <= 0).sort((K, _) => K.overflows[1] - _.overflows[1])[0]) == null ? void 0 : J.placement;
        if (!j)
          switch (m) {
            case "bestFit": {
              var ee;
              const K = (ee = Y.filter((_) => {
                if (P) {
                  const R = mt(_.placement);
                  return R === C || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  R === "y";
                }
                return !0;
              }).map((_) => [_.placement, _.overflows.filter((R) => R > 0).reduce((R, b) => R + b, 0)]).sort((_, R) => _[1] - R[1])[0]) == null ? void 0 : ee[0];
              K && (j = K);
              break;
            }
            case "initialPlacement":
              j = i;
              break;
          }
        if (o !== j)
          return {
            reset: {
              placement: j
            }
          };
      }
      return {};
    }
  };
};
function ni(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function ri(e) {
  return Yh.some((t) => e[t] >= 0);
}
const rv = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...o
      } = Ot(e, t);
      switch (r) {
        case "referenceHidden": {
          const a = await Nn(t, {
            ...o,
            elementContext: "reference"
          }), s = ni(a, n.reference);
          return {
            data: {
              referenceHiddenOffsets: s,
              referenceHidden: ri(s)
            }
          };
        }
        case "escaped": {
          const a = await Nn(t, {
            ...o,
            altBoundary: !0
          }), s = ni(a, n.floating);
          return {
            data: {
              escapedOffsets: s,
              escaped: ri(s)
            }
          };
        }
        default:
          return {};
      }
    }
  };
}, Ws = /* @__PURE__ */ new Set(["left", "top"]);
async function ov(e, t) {
  const {
    placement: n,
    platform: r,
    elements: o
  } = e, a = await (r.isRTL == null ? void 0 : r.isRTL(o.floating)), s = St(n), i = yn(n), d = mt(n) === "y", l = Ws.has(s) ? -1 : 1, u = a && d ? -1 : 1, c = Ot(t, e);
  let {
    mainAxis: f,
    crossAxis: m,
    alignmentAxis: y
  } = typeof c == "number" ? {
    mainAxis: c,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: c.mainAxis || 0,
    crossAxis: c.crossAxis || 0,
    alignmentAxis: c.alignmentAxis
  };
  return i && typeof y == "number" && (m = i === "end" ? y * -1 : y), d ? {
    x: m * u,
    y: f * l
  } : {
    x: f * l,
    y: m * u
  };
}
const av = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: o,
        y: a,
        placement: s,
        middlewareData: i
      } = t, d = await ov(t, e);
      return s === ((n = i.offset) == null ? void 0 : n.placement) && (r = i.arrow) != null && r.alignmentOffset ? {} : {
        x: o + d.x,
        y: a + d.y,
        data: {
          ...d,
          placement: s
        }
      };
    }
  };
}, iv = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: o
      } = t, {
        mainAxis: a = !0,
        crossAxis: s = !1,
        limiter: i = {
          fn: (g) => {
            let {
              x: k,
              y: C
            } = g;
            return {
              x: k,
              y: C
            };
          }
        },
        ...d
      } = Ot(e, t), l = {
        x: n,
        y: r
      }, u = await Nn(t, d), c = mt(St(o)), f = Vo(c);
      let m = l[f], y = l[c];
      if (a) {
        const g = f === "y" ? "top" : "left", k = f === "y" ? "bottom" : "right", C = m + u[g], E = m - u[k];
        m = Oo(C, m, E);
      }
      if (s) {
        const g = c === "y" ? "top" : "left", k = c === "y" ? "bottom" : "right", C = y + u[g], E = y - u[k];
        y = Oo(C, y, E);
      }
      const h = i.fn({
        ...t,
        [f]: m,
        [c]: y
      });
      return {
        ...h,
        data: {
          x: h.x - n,
          y: h.y - r,
          enabled: {
            [f]: a,
            [c]: s
          }
        }
      };
    }
  };
}, sv = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: o,
        rects: a,
        middlewareData: s
      } = t, {
        offset: i = 0,
        mainAxis: d = !0,
        crossAxis: l = !0
      } = Ot(e, t), u = {
        x: n,
        y: r
      }, c = mt(o), f = Vo(c);
      let m = u[f], y = u[c];
      const h = Ot(i, t), g = typeof h == "number" ? {
        mainAxis: h,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...h
      };
      if (d) {
        const E = f === "y" ? "height" : "width", O = a.reference[f] - a.floating[E] + g.mainAxis, v = a.reference[f] + a.reference[E] - g.mainAxis;
        m < O ? m = O : m > v && (m = v);
      }
      if (l) {
        var k, C;
        const E = f === "y" ? "width" : "height", O = Ws.has(St(o)), v = a.reference[c] - a.floating[E] + (O && ((k = s.offset) == null ? void 0 : k[c]) || 0) + (O ? 0 : g.crossAxis), P = a.reference[c] + a.reference[E] + (O ? 0 : ((C = s.offset) == null ? void 0 : C[c]) || 0) - (O ? g.crossAxis : 0);
        y < v ? y = v : y > P && (y = P);
      }
      return {
        [f]: m,
        [c]: y
      };
    }
  };
}, cv = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: o,
        rects: a,
        platform: s,
        elements: i
      } = t, {
        apply: d = () => {
        },
        ...l
      } = Ot(e, t), u = await Nn(t, l), c = St(o), f = yn(o), m = mt(o) === "y", {
        width: y,
        height: h
      } = a.floating;
      let g, k;
      c === "top" || c === "bottom" ? (g = c, k = f === (await (s.isRTL == null ? void 0 : s.isRTL(i.floating)) ? "start" : "end") ? "left" : "right") : (k = c, g = f === "end" ? "top" : "bottom");
      const C = h - u.top - u.bottom, E = y - u.left - u.right, O = Wt(h - u[g], C), v = Wt(y - u[k], E), P = !t.middlewareData.shift;
      let M = O, D = v;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (D = E), (r = t.middlewareData.shift) != null && r.enabled.y && (M = C), P && !f) {
        const Y = Ye(u.left, 0), U = Ye(u.right, 0), J = Ye(u.top, 0), ee = Ye(u.bottom, 0);
        m ? D = y - 2 * (Y !== 0 || U !== 0 ? Y + U : Ye(u.left, u.right)) : M = h - 2 * (J !== 0 || ee !== 0 ? J + ee : Ye(u.top, u.bottom));
      }
      await d({
        ...t,
        availableWidth: D,
        availableHeight: M
      });
      const L = await s.getDimensions(i.floating);
      return y !== L.width || h !== L.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Tr() {
  return typeof window < "u";
}
function bn(e) {
  return $s(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function qe(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function xt(e) {
  var t;
  return (t = ($s(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function $s(e) {
  return Tr() ? e instanceof Node || e instanceof qe(e).Node : !1;
}
function at(e) {
  return Tr() ? e instanceof Element || e instanceof qe(e).Element : !1;
}
function vt(e) {
  return Tr() ? e instanceof HTMLElement || e instanceof qe(e).HTMLElement : !1;
}
function oi(e) {
  return !Tr() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof qe(e).ShadowRoot;
}
const lv = /* @__PURE__ */ new Set(["inline", "contents"]);
function Bn(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: o
  } = it(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !lv.has(o);
}
const dv = /* @__PURE__ */ new Set(["table", "td", "th"]);
function uv(e) {
  return dv.has(bn(e));
}
const fv = [":popover-open", ":modal"];
function Ar(e) {
  return fv.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
const pv = ["transform", "translate", "scale", "rotate", "perspective"], mv = ["transform", "translate", "scale", "rotate", "perspective", "filter"], hv = ["paint", "layout", "strict", "content"];
function Ko(e) {
  const t = Xo(), n = at(e) ? it(e) : e;
  return pv.some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || mv.some((r) => (n.willChange || "").includes(r)) || hv.some((r) => (n.contain || "").includes(r));
}
function vv(e) {
  let t = $t(e);
  for (; vt(t) && !pn(t); ) {
    if (Ko(t))
      return t;
    if (Ar(t))
      return null;
    t = $t(t);
  }
  return null;
}
function Xo() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const gv = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function pn(e) {
  return gv.has(bn(e));
}
function it(e) {
  return qe(e).getComputedStyle(e);
}
function Rr(e) {
  return at(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function $t(e) {
  if (bn(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    oi(e) && e.host || // Fallback.
    xt(e)
  );
  return oi(t) ? t.host : t;
}
function Ls(e) {
  const t = $t(e);
  return pn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : vt(t) && Bn(t) ? t : Ls(t);
}
function jn(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const o = Ls(e), a = o === ((r = e.ownerDocument) == null ? void 0 : r.body), s = qe(o);
  if (a) {
    const i = Mo(s);
    return t.concat(s, s.visualViewport || [], Bn(o) ? o : [], i && n ? jn(i) : []);
  }
  return t.concat(o, jn(o, [], n));
}
function Mo(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function zs(e) {
  const t = it(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const o = vt(e), a = o ? e.offsetWidth : n, s = o ? e.offsetHeight : r, i = xr(n) !== a || xr(r) !== s;
  return i && (n = a, r = s), {
    width: n,
    height: r,
    $: i
  };
}
function Zo(e) {
  return at(e) ? e : e.contextElement;
}
function ln(e) {
  const t = Zo(e);
  if (!vt(t))
    return ht(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: o,
    $: a
  } = zs(t);
  let s = (a ? xr(n.width) : n.width) / r, i = (a ? xr(n.height) : n.height) / o;
  return (!s || !Number.isFinite(s)) && (s = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: s,
    y: i
  };
}
const xv = /* @__PURE__ */ ht(0);
function Bs(e) {
  const t = qe(e);
  return !Xo() || !t.visualViewport ? xv : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function yv(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== qe(e) ? !1 : t;
}
function Zt(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const o = e.getBoundingClientRect(), a = Zo(e);
  let s = ht(1);
  t && (r ? at(r) && (s = ln(r)) : s = ln(e));
  const i = yv(a, n, r) ? Bs(a) : ht(0);
  let d = (o.left + i.x) / s.x, l = (o.top + i.y) / s.y, u = o.width / s.x, c = o.height / s.y;
  if (a) {
    const f = qe(a), m = r && at(r) ? qe(r) : r;
    let y = f, h = Mo(y);
    for (; h && r && m !== y; ) {
      const g = ln(h), k = h.getBoundingClientRect(), C = it(h), E = k.left + (h.clientLeft + parseFloat(C.paddingLeft)) * g.x, O = k.top + (h.clientTop + parseFloat(C.paddingTop)) * g.y;
      d *= g.x, l *= g.y, u *= g.x, c *= g.y, d += E, l += O, y = qe(h), h = Mo(y);
    }
  }
  return br({
    width: u,
    height: c,
    x: d,
    y: l
  });
}
function Qo(e, t) {
  const n = Rr(e).scrollLeft;
  return t ? t.left + n : Zt(xt(e)).left + n;
}
function Ys(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), o = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Qo(e, r)
  )), a = r.top + t.scrollTop;
  return {
    x: o,
    y: a
  };
}
function bv(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: o
  } = e;
  const a = o === "fixed", s = xt(r), i = t ? Ar(t.floating) : !1;
  if (r === s || i && a)
    return n;
  let d = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = ht(1);
  const u = ht(0), c = vt(r);
  if ((c || !c && !a) && ((bn(r) !== "body" || Bn(s)) && (d = Rr(r)), vt(r))) {
    const m = Zt(r);
    l = ln(r), u.x = m.x + r.clientLeft, u.y = m.y + r.clientTop;
  }
  const f = s && !c && !a ? Ys(s, d, !0) : ht(0);
  return {
    width: n.width * l.x,
    height: n.height * l.y,
    x: n.x * l.x - d.scrollLeft * l.x + u.x + f.x,
    y: n.y * l.y - d.scrollTop * l.y + u.y + f.y
  };
}
function wv(e) {
  return Array.from(e.getClientRects());
}
function kv(e) {
  const t = xt(e), n = Rr(e), r = e.ownerDocument.body, o = Ye(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), a = Ye(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let s = -n.scrollLeft + Qo(e);
  const i = -n.scrollTop;
  return it(r).direction === "rtl" && (s += Ye(t.clientWidth, r.clientWidth) - o), {
    width: o,
    height: a,
    x: s,
    y: i
  };
}
function Ev(e, t) {
  const n = qe(e), r = xt(e), o = n.visualViewport;
  let a = r.clientWidth, s = r.clientHeight, i = 0, d = 0;
  if (o) {
    a = o.width, s = o.height;
    const l = Xo();
    (!l || l && t === "fixed") && (i = o.offsetLeft, d = o.offsetTop);
  }
  return {
    width: a,
    height: s,
    x: i,
    y: d
  };
}
const Cv = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function Ov(e, t) {
  const n = Zt(e, !0, t === "fixed"), r = n.top + e.clientTop, o = n.left + e.clientLeft, a = vt(e) ? ln(e) : ht(1), s = e.clientWidth * a.x, i = e.clientHeight * a.y, d = o * a.x, l = r * a.y;
  return {
    width: s,
    height: i,
    x: d,
    y: l
  };
}
function ai(e, t, n) {
  let r;
  if (t === "viewport")
    r = Ev(e, n);
  else if (t === "document")
    r = kv(xt(e));
  else if (at(t))
    r = Ov(t, n);
  else {
    const o = Bs(e);
    r = {
      x: t.x - o.x,
      y: t.y - o.y,
      width: t.width,
      height: t.height
    };
  }
  return br(r);
}
function Hs(e, t) {
  const n = $t(e);
  return n === t || !at(n) || pn(n) ? !1 : it(n).position === "fixed" || Hs(n, t);
}
function Sv(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = jn(e, [], !1).filter((i) => at(i) && bn(i) !== "body"), o = null;
  const a = it(e).position === "fixed";
  let s = a ? $t(e) : e;
  for (; at(s) && !pn(s); ) {
    const i = it(s), d = Ko(s);
    !d && i.position === "fixed" && (o = null), (a ? !d && !o : !d && i.position === "static" && !!o && Cv.has(o.position) || Bn(s) && !d && Hs(e, s)) ? r = r.filter((u) => u !== s) : o = i, s = $t(s);
  }
  return t.set(e, r), r;
}
function Mv(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: o
  } = e;
  const s = [...n === "clippingAncestors" ? Ar(t) ? [] : Sv(t, this._c) : [].concat(n), r], i = s[0], d = s.reduce((l, u) => {
    const c = ai(t, u, o);
    return l.top = Ye(c.top, l.top), l.right = Wt(c.right, l.right), l.bottom = Wt(c.bottom, l.bottom), l.left = Ye(c.left, l.left), l;
  }, ai(t, i, o));
  return {
    width: d.right - d.left,
    height: d.bottom - d.top,
    x: d.left,
    y: d.top
  };
}
function Dv(e) {
  const {
    width: t,
    height: n
  } = zs(e);
  return {
    width: t,
    height: n
  };
}
function Pv(e, t, n) {
  const r = vt(t), o = xt(t), a = n === "fixed", s = Zt(e, !0, a, t);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const d = ht(0);
  function l() {
    d.x = Qo(o);
  }
  if (r || !r && !a)
    if ((bn(t) !== "body" || Bn(o)) && (i = Rr(t)), r) {
      const m = Zt(t, !0, a, t);
      d.x = m.x + t.clientLeft, d.y = m.y + t.clientTop;
    } else o && l();
  a && !r && o && l();
  const u = o && !r && !a ? Ys(o, i) : ht(0), c = s.left + i.scrollLeft - d.x - u.x, f = s.top + i.scrollTop - d.y - u.y;
  return {
    x: c,
    y: f,
    width: s.width,
    height: s.height
  };
}
function Qr(e) {
  return it(e).position === "static";
}
function ii(e, t) {
  if (!vt(e) || it(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return xt(e) === n && (n = n.ownerDocument.body), n;
}
function qs(e, t) {
  const n = qe(e);
  if (Ar(e))
    return n;
  if (!vt(e)) {
    let o = $t(e);
    for (; o && !pn(o); ) {
      if (at(o) && !Qr(o))
        return o;
      o = $t(o);
    }
    return n;
  }
  let r = ii(e, t);
  for (; r && uv(r) && Qr(r); )
    r = ii(r, t);
  return r && pn(r) && Qr(r) && !Ko(r) ? n : r || vv(e) || n;
}
const _v = async function(e) {
  const t = this.getOffsetParent || qs, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: Pv(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function Tv(e) {
  return it(e).direction === "rtl";
}
const Av = {
  convertOffsetParentRelativeRectToViewportRelativeRect: bv,
  getDocumentElement: xt,
  getClippingRect: Mv,
  getOffsetParent: qs,
  getElementRects: _v,
  getClientRects: wv,
  getDimensions: Dv,
  getScale: ln,
  isElement: at,
  isRTL: Tv
};
function Vs(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function Rv(e, t) {
  let n = null, r;
  const o = xt(e);
  function a() {
    var i;
    clearTimeout(r), (i = n) == null || i.disconnect(), n = null;
  }
  function s(i, d) {
    i === void 0 && (i = !1), d === void 0 && (d = 1), a();
    const l = e.getBoundingClientRect(), {
      left: u,
      top: c,
      width: f,
      height: m
    } = l;
    if (i || t(), !f || !m)
      return;
    const y = nr(c), h = nr(o.clientWidth - (u + f)), g = nr(o.clientHeight - (c + m)), k = nr(u), E = {
      rootMargin: -y + "px " + -h + "px " + -g + "px " + -k + "px",
      threshold: Ye(0, Wt(1, d)) || 1
    };
    let O = !0;
    function v(P) {
      const M = P[0].intersectionRatio;
      if (M !== d) {
        if (!O)
          return s();
        M ? s(!1, M) : r = setTimeout(() => {
          s(!1, 1e-7);
        }, 1e3);
      }
      M === 1 && !Vs(l, e.getBoundingClientRect()) && s(), O = !1;
    }
    try {
      n = new IntersectionObserver(v, {
        ...E,
        // Handle <iframe>s
        root: o.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(v, E);
    }
    n.observe(e);
  }
  return s(!0), a;
}
function Us(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: o = !0,
    ancestorResize: a = !0,
    elementResize: s = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: d = !1
  } = r, l = Zo(e), u = o || a ? [...l ? jn(l) : [], ...jn(t)] : [];
  u.forEach((k) => {
    o && k.addEventListener("scroll", n, {
      passive: !0
    }), a && k.addEventListener("resize", n);
  });
  const c = l && i ? Rv(l, n) : null;
  let f = -1, m = null;
  s && (m = new ResizeObserver((k) => {
    let [C] = k;
    C && C.target === l && m && (m.unobserve(t), cancelAnimationFrame(f), f = requestAnimationFrame(() => {
      var E;
      (E = m) == null || E.observe(t);
    })), n();
  }), l && !d && m.observe(l), m.observe(t));
  let y, h = d ? Zt(e) : null;
  d && g();
  function g() {
    const k = Zt(e);
    h && !Vs(h, k) && n(), h = k, y = requestAnimationFrame(g);
  }
  return n(), () => {
    var k;
    u.forEach((C) => {
      o && C.removeEventListener("scroll", n), a && C.removeEventListener("resize", n);
    }), c == null || c(), (k = m) == null || k.disconnect(), m = null, d && cancelAnimationFrame(y);
  };
}
const Nv = av, jv = iv, Iv = nv, Fv = cv, Wv = rv, si = tv, $v = sv, Lv = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), o = {
    platform: Av,
    ...n
  }, a = {
    ...o.platform,
    _c: r
  };
  return ev(e, t, {
    ...o,
    platform: a
  });
};
var zv = typeof document < "u", Bv = function() {
}, hr = zv ? Hi : Bv;
function wr(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, o;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length) return !1;
      for (r = n; r-- !== 0; )
        if (!wr(e[r], t[r]))
          return !1;
      return !0;
    }
    if (o = Object.keys(e), n = o.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, o[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const a = o[r];
      if (!(a === "_owner" && e.$$typeof) && !wr(e[a], t[a]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function Gs(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function ci(e, t) {
  const n = Gs(e);
  return Math.round(t * n) / n;
}
function Jr(e) {
  const t = p.useRef(e);
  return hr(() => {
    t.current = e;
  }), t;
}
function Ks(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: o,
    elements: {
      reference: a,
      floating: s
    } = {},
    transform: i = !0,
    whileElementsMounted: d,
    open: l
  } = e, [u, c] = p.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [f, m] = p.useState(r);
  wr(f, r) || m(r);
  const [y, h] = p.useState(null), [g, k] = p.useState(null), C = p.useCallback((_) => {
    _ !== P.current && (P.current = _, h(_));
  }, []), E = p.useCallback((_) => {
    _ !== M.current && (M.current = _, k(_));
  }, []), O = a || y, v = s || g, P = p.useRef(null), M = p.useRef(null), D = p.useRef(u), L = d != null, Y = Jr(d), U = Jr(o), J = Jr(l), ee = p.useCallback(() => {
    if (!P.current || !M.current)
      return;
    const _ = {
      placement: t,
      strategy: n,
      middleware: f
    };
    U.current && (_.platform = U.current), Lv(P.current, M.current, _).then((R) => {
      const b = {
        ...R,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: J.current !== !1
      };
      q.current && !wr(D.current, b) && (D.current = b, qi.flushSync(() => {
        c(b);
      }));
    });
  }, [f, t, n, U, J]);
  hr(() => {
    l === !1 && D.current.isPositioned && (D.current.isPositioned = !1, c((_) => ({
      ..._,
      isPositioned: !1
    })));
  }, [l]);
  const q = p.useRef(!1);
  hr(() => (q.current = !0, () => {
    q.current = !1;
  }), []), hr(() => {
    if (O && (P.current = O), v && (M.current = v), O && v) {
      if (Y.current)
        return Y.current(O, v, ee);
      ee();
    }
  }, [O, v, ee, Y, L]);
  const G = p.useMemo(() => ({
    reference: P,
    floating: M,
    setReference: C,
    setFloating: E
  }), [C, E]), j = p.useMemo(() => ({
    reference: O,
    floating: v
  }), [O, v]), K = p.useMemo(() => {
    const _ = {
      position: n,
      left: 0,
      top: 0
    };
    if (!j.floating)
      return _;
    const R = ci(j.floating, u.x), b = ci(j.floating, u.y);
    return i ? {
      ..._,
      transform: "translate(" + R + "px, " + b + "px)",
      ...Gs(j.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: R,
      top: b
    };
  }, [n, i, j.floating, u.x, u.y]);
  return p.useMemo(() => ({
    ...u,
    update: ee,
    refs: G,
    elements: j,
    floatingStyles: K
  }), [u, ee, G, j, K]);
}
const Yv = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: o
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? si({
        element: r.current,
        padding: o
      }).fn(n) : {} : r ? si({
        element: r,
        padding: o
      }).fn(n) : {};
    }
  };
}, Xs = (e, t) => ({
  ...Nv(e),
  options: [e, t]
}), Zs = (e, t) => ({
  ...jv(e),
  options: [e, t]
}), Qs = (e, t) => ({
  ...$v(e),
  options: [e, t]
}), Js = (e, t) => ({
  ...Iv(e),
  options: [e, t]
}), ec = (e, t) => ({
  ...Fv(e),
  options: [e, t]
}), tc = (e, t) => ({
  ...Wv(e),
  options: [e, t]
}), nc = (e, t) => ({
  ...Yv(e),
  options: [e, t]
});
var Hv = "Arrow", rc = p.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: o = 5, ...a } = e;
  return /* @__PURE__ */ x.jsx(
    ve.svg,
    {
      ...a,
      ref: t,
      width: r,
      height: o,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ x.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
rc.displayName = Hv;
var oc = rc;
function ac(e) {
  const [t, n] = p.useState(void 0);
  return Qe(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((o) => {
        if (!Array.isArray(o) || !o.length)
          return;
        const a = o[0];
        let s, i;
        if ("borderBoxSize" in a) {
          const d = a.borderBoxSize, l = Array.isArray(d) ? d[0] : d;
          s = l.inlineSize, i = l.blockSize;
        } else
          s = e.offsetWidth, i = e.offsetHeight;
        n({ width: s, height: i });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Jo = "Popper", [ic, sc] = Lt(Jo), [qv, cc] = ic(Jo), lc = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = p.useState(null);
  return /* @__PURE__ */ x.jsx(qv, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
lc.displayName = Jo;
var dc = "PopperAnchor", uc = p.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = cc(dc, n), s = p.useRef(null), i = we(t, s), d = p.useRef(null);
    return p.useEffect(() => {
      const l = d.current;
      d.current = (r == null ? void 0 : r.current) || s.current, l !== d.current && a.onAnchorChange(d.current);
    }), r ? null : /* @__PURE__ */ x.jsx(ve.div, { ...o, ref: i });
  }
);
uc.displayName = dc;
var ea = "PopperContent", [Vv, Uv] = ic(ea), fc = p.forwardRef(
  (e, t) => {
    var W, z, H, Q, se, I;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: d = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: c = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: y,
      ...h
    } = e, g = cc(ea, n), [k, C] = p.useState(null), E = we(t, (ue) => C(ue)), [O, v] = p.useState(null), P = ac(O), M = (P == null ? void 0 : P.width) ?? 0, D = (P == null ? void 0 : P.height) ?? 0, L = r + (a !== "center" ? "-" + a : ""), Y = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, U = Array.isArray(l) ? l : [l], J = U.length > 0, ee = {
      padding: Y,
      boundary: U.filter(Kv),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: J
    }, { refs: q, floatingStyles: G, placement: j, isPositioned: K, middlewareData: _ } = Ks({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: L,
      whileElementsMounted: (...ue) => Us(...ue, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Xs({ mainAxis: o + D, alignmentAxis: s }),
        d && Zs({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? Qs() : void 0,
          ...ee
        }),
        d && Js({ ...ee }),
        ec({
          ...ee,
          apply: ({ elements: ue, rects: Se, availableWidth: ze, availableHeight: et }) => {
            const { width: _e, height: Ue } = Se.reference, ge = ue.floating.style;
            ge.setProperty("--radix-popper-available-width", `${ze}px`), ge.setProperty("--radix-popper-available-height", `${et}px`), ge.setProperty("--radix-popper-anchor-width", `${_e}px`), ge.setProperty("--radix-popper-anchor-height", `${Ue}px`);
          }
        }),
        O && nc({ element: O, padding: i }),
        Xv({ arrowWidth: M, arrowHeight: D }),
        f && tc({ strategy: "referenceHidden", ...ee })
      ]
    }), [R, b] = hc(j), S = Ve(y);
    Qe(() => {
      K && (S == null || S());
    }, [K, S]);
    const A = (W = _.arrow) == null ? void 0 : W.x, T = (z = _.arrow) == null ? void 0 : z.y, N = ((H = _.arrow) == null ? void 0 : H.centerOffset) !== 0, [V, F] = p.useState();
    return Qe(() => {
      k && F(window.getComputedStyle(k).zIndex);
    }, [k]), /* @__PURE__ */ x.jsx(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: K ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: V,
          "--radix-popper-transform-origin": [
            (Q = _.transformOrigin) == null ? void 0 : Q.x,
            (se = _.transformOrigin) == null ? void 0 : se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((I = _.hide) == null ? void 0 : I.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ x.jsx(
          Vv,
          {
            scope: n,
            placedSide: R,
            onArrowChange: v,
            arrowX: A,
            arrowY: T,
            shouldHideArrow: N,
            children: /* @__PURE__ */ x.jsx(
              ve.div,
              {
                "data-side": R,
                "data-align": b,
                ...h,
                ref: E,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
fc.displayName = ea;
var pc = "PopperArrow", Gv = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, mc = p.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = Uv(pc, r), s = Gv[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ x.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ x.jsx(
          oc,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
mc.displayName = pc;
function Kv(e) {
  return e !== null;
}
var Xv = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, k, C;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, d = s ? 0 : e.arrowHeight, [l, u] = hc(n), c = { start: "0%", center: "50%", end: "100%" }[u], f = (((k = o.arrow) == null ? void 0 : k.x) ?? 0) + i / 2, m = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + d / 2;
    let y = "", h = "";
    return l === "bottom" ? (y = s ? c : `${f}px`, h = `${-d}px`) : l === "top" ? (y = s ? c : `${f}px`, h = `${r.floating.height + d}px`) : l === "right" ? (y = `${-d}px`, h = s ? c : `${m}px`) : l === "left" && (y = `${r.floating.width + d}px`, h = s ? c : `${m}px`), { data: { x: y, y: h } };
  }
});
function hc(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Zv = lc, vc = uc, Qv = fc, Jv = mc, eg = "Portal", Nr = p.forwardRef((e, t) => {
  var i;
  const { container: n, ...r } = e, [o, a] = p.useState(!1);
  Qe(() => a(!0), []);
  const s = n || o && ((i = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : i.body);
  return s ? Vi.createPortal(/* @__PURE__ */ x.jsx(ve.div, { ...r, ref: t }), s) : null;
});
Nr.displayName = eg;
function tg(e, t) {
  return p.useReducer((n, r) => t[n][r] ?? n, e);
}
var wn = (e) => {
  const { present: t, children: n } = e, r = ng(t), o = typeof n == "function" ? n({ present: r.isPresent }) : p.Children.only(n), a = we(r.ref, rg(o));
  return typeof n == "function" || r.isPresent ? p.cloneElement(o, { ref: a }) : null;
};
wn.displayName = "Presence";
function ng(e) {
  const [t, n] = p.useState(), r = p.useRef(null), o = p.useRef(e), a = p.useRef("none"), s = e ? "mounted" : "unmounted", [i, d] = tg(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const l = rr(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), Qe(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const f = a.current, m = rr(l);
      e ? d("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? d("UNMOUNT") : d(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, d]), Qe(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, c = (m) => {
        const h = rr(r.current).includes(CSS.escape(m.animationName));
        if (m.target === t && h && (d("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, f = (m) => {
        m.target === t && (a.current = rr(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: p.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function rr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function rg(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var og = p[" useInsertionEffect ".trim().toString()] || Qe;
function Yn({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [o, a, s] = ag({
    defaultProp: t,
    onChange: n
  }), i = e !== void 0, d = i ? e : o;
  {
    const u = p.useRef(e !== void 0);
    p.useEffect(() => {
      const c = u.current;
      c !== i && console.warn(
        `${r} is changing from ${c ? "controlled" : "uncontrolled"} to ${i ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = i;
    }, [i, r]);
  }
  const l = p.useCallback(
    (u) => {
      var c;
      if (i) {
        const f = ig(u) ? u(e) : u;
        f !== e && ((c = s.current) == null || c.call(s, f));
      } else
        a(u);
    },
    [i, e, a, s]
  );
  return [d, l];
}
function ag({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = p.useState(e), o = p.useRef(n), a = p.useRef(t);
  return og(() => {
    a.current = t;
  }, [t]), p.useEffect(() => {
    var s;
    o.current !== n && ((s = a.current) == null || s.call(a, n), o.current = n);
  }, [n, o]), [n, r, a];
}
function ig(e) {
  return typeof e == "function";
}
var sg = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, an = /* @__PURE__ */ new WeakMap(), or = /* @__PURE__ */ new WeakMap(), ar = {}, eo = 0, gc = function(e) {
  return e && (e.host || gc(e.parentNode));
}, cg = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = gc(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, lg = function(e, t, n, r) {
  var o = cg(t, Array.isArray(e) ? e : [e]);
  ar[n] || (ar[n] = /* @__PURE__ */ new WeakMap());
  var a = ar[n], s = [], i = /* @__PURE__ */ new Set(), d = new Set(o), l = function(c) {
    !c || i.has(c) || (i.add(c), l(c.parentNode));
  };
  o.forEach(l);
  var u = function(c) {
    !c || d.has(c) || Array.prototype.forEach.call(c.children, function(f) {
      if (i.has(f))
        u(f);
      else
        try {
          var m = f.getAttribute(r), y = m !== null && m !== "false", h = (an.get(f) || 0) + 1, g = (a.get(f) || 0) + 1;
          an.set(f, h), a.set(f, g), s.push(f), h === 1 && y && or.set(f, !0), g === 1 && f.setAttribute(n, "true"), y || f.setAttribute(r, "true");
        } catch (k) {
          console.error("aria-hidden: cannot operate on ", f, k);
        }
    });
  };
  return u(t), i.clear(), eo++, function() {
    s.forEach(function(c) {
      var f = an.get(c) - 1, m = a.get(c) - 1;
      an.set(c, f), a.set(c, m), f || (or.has(c) || c.removeAttribute(r), or.delete(c)), m || c.removeAttribute(n);
    }), eo--, eo || (an = /* @__PURE__ */ new WeakMap(), an = /* @__PURE__ */ new WeakMap(), or = /* @__PURE__ */ new WeakMap(), ar = {});
  };
}, ta = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), o = sg(e);
  return o ? (r.push.apply(r, Array.from(o.querySelectorAll("[aria-live], script"))), lg(r, o, n, "aria-hidden")) : function() {
    return null;
  };
}, ft = function() {
  return ft = Object.assign || function(t) {
    for (var n, r = 1, o = arguments.length; r < o; r++) {
      n = arguments[r];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (t[a] = n[a]);
    }
    return t;
  }, ft.apply(this, arguments);
};
function xc(e, t) {
  var n = {};
  for (var r in e) Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var o = 0, r = Object.getOwnPropertySymbols(e); o < r.length; o++)
      t.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (n[r[o]] = e[r[o]]);
  return n;
}
function tn(e, t, n, r) {
  function o(a) {
    return a instanceof n ? a : new n(function(s) {
      s(a);
    });
  }
  return new (n || (n = Promise))(function(a, s) {
    function i(u) {
      try {
        l(r.next(u));
      } catch (c) {
        s(c);
      }
    }
    function d(u) {
      try {
        l(r.throw(u));
      } catch (c) {
        s(c);
      }
    }
    function l(u) {
      u.done ? a(u.value) : o(u.value).then(i, d);
    }
    l((r = r.apply(e, t || [])).next());
  });
}
function dg(e, t, n) {
  if (n || arguments.length === 2) for (var r = 0, o = t.length, a; r < o; r++)
    (a || !(r in t)) && (a || (a = Array.prototype.slice.call(t, 0, r)), a[r] = t[r]);
  return e.concat(a || Array.prototype.slice.call(t));
}
var vr = "right-scroll-bar-position", gr = "width-before-scroll-bar", ug = "with-scroll-bars-hidden", fg = "--removed-body-scroll-bar-size";
function to(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function pg(e, t) {
  var n = un(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var o = n.value;
          o !== r && (n.value = r, n.callback(r, o));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var mg = typeof window < "u" ? p.useLayoutEffect : p.useEffect, li = /* @__PURE__ */ new WeakMap();
function hg(e, t) {
  var n = pg(null, function(r) {
    return e.forEach(function(o) {
      return to(o, r);
    });
  });
  return mg(function() {
    var r = li.get(n);
    if (r) {
      var o = new Set(r), a = new Set(e), s = n.current;
      o.forEach(function(i) {
        a.has(i) || to(i, null);
      }), a.forEach(function(i) {
        o.has(i) || to(i, s);
      });
    }
    li.set(n, e);
  }, [e]), n;
}
function vg(e) {
  return e;
}
function gg(e, t) {
  t === void 0 && (t = vg);
  var n = [], r = !1, o = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(a) {
      var s = t(a, r);
      return n.push(s), function() {
        n = n.filter(function(i) {
          return i !== s;
        });
      };
    },
    assignSyncMedium: function(a) {
      for (r = !0; n.length; ) {
        var s = n;
        n = [], s.forEach(a);
      }
      n = {
        push: function(i) {
          return a(i);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(a) {
      r = !0;
      var s = [];
      if (n.length) {
        var i = n;
        n = [], i.forEach(a), s = n;
      }
      var d = function() {
        var u = s;
        s = [], u.forEach(a);
      }, l = function() {
        return Promise.resolve().then(d);
      };
      l(), n = {
        push: function(u) {
          s.push(u), l();
        },
        filter: function(u) {
          return s = s.filter(u), n;
        }
      };
    }
  };
  return o;
}
function xg(e) {
  e === void 0 && (e = {});
  var t = gg(null);
  return t.options = ft({ async: !0, ssr: !1 }, e), t;
}
var yc = function(e) {
  var t = e.sideCar, n = xc(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return p.createElement(r, ft({}, n));
};
yc.isSideCarExport = !0;
function yg(e, t) {
  return e.useMedium(t), yc;
}
var bc = xg(), no = function() {
}, jr = p.forwardRef(function(e, t) {
  var n = p.useRef(null), r = p.useState({
    onScrollCapture: no,
    onWheelCapture: no,
    onTouchMoveCapture: no
  }), o = r[0], a = r[1], s = e.forwardProps, i = e.children, d = e.className, l = e.removeScrollBar, u = e.enabled, c = e.shards, f = e.sideCar, m = e.noRelative, y = e.noIsolation, h = e.inert, g = e.allowPinchZoom, k = e.as, C = k === void 0 ? "div" : k, E = e.gapMode, O = xc(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), v = f, P = hg([n, t]), M = ft(ft({}, O), o);
  return p.createElement(
    p.Fragment,
    null,
    u && p.createElement(v, { sideCar: bc, removeScrollBar: l, shards: c, noRelative: m, noIsolation: y, inert: h, setCallbacks: a, allowPinchZoom: !!g, lockRef: n, gapMode: E }),
    s ? p.cloneElement(p.Children.only(i), ft(ft({}, M), { ref: P })) : p.createElement(C, ft({}, M, { className: d, ref: P }), i)
  );
});
jr.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
jr.classNames = {
  fullWidth: gr,
  zeroRight: vr
};
var bg = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function wg() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = bg();
  return t && e.setAttribute("nonce", t), e;
}
function kg(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function Eg(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var Cg = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = wg()) && (kg(t, n), Eg(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Og = function() {
  var e = Cg();
  return function(t, n) {
    p.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, wc = function() {
  var e = Og(), t = function(n) {
    var r = n.styles, o = n.dynamic;
    return e(r, o), null;
  };
  return t;
}, Sg = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ro = function(e) {
  return parseInt(e || "", 10) || 0;
}, Mg = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], o = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ro(n), ro(r), ro(o)];
}, Dg = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Sg;
  var t = Mg(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, Pg = wc(), dn = "data-scroll-locked", _g = function(e, t, n, r) {
  var o = e.left, a = e.top, s = e.right, i = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(ug, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(i, "px ").concat(r, `;
  }
  body[`).concat(dn, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(o, `px;
    padding-top: `).concat(a, `px;
    padding-right: `).concat(s, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(i, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(i, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(vr, ` {
    right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(gr, ` {
    margin-right: `).concat(i, "px ").concat(r, `;
  }
  
  .`).concat(vr, " .").concat(vr, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(gr, " .").concat(gr, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(dn, `] {
    `).concat(fg, ": ").concat(i, `px;
  }
`);
}, di = function() {
  var e = parseInt(document.body.getAttribute(dn) || "0", 10);
  return isFinite(e) ? e : 0;
}, Tg = function() {
  p.useEffect(function() {
    return document.body.setAttribute(dn, (di() + 1).toString()), function() {
      var e = di() - 1;
      e <= 0 ? document.body.removeAttribute(dn) : document.body.setAttribute(dn, e.toString());
    };
  }, []);
}, Ag = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, o = r === void 0 ? "margin" : r;
  Tg();
  var a = p.useMemo(function() {
    return Dg(o);
  }, [o]);
  return p.createElement(Pg, { styles: _g(a, !t, o, n ? "" : "!important") });
}, Do = !1;
if (typeof window < "u")
  try {
    var ir = Object.defineProperty({}, "passive", {
      get: function() {
        return Do = !0, !0;
      }
    });
    window.addEventListener("test", ir, ir), window.removeEventListener("test", ir, ir);
  } catch {
    Do = !1;
  }
var sn = Do ? { passive: !1 } : !1, Rg = function(e) {
  return e.tagName === "TEXTAREA";
}, kc = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Rg(e) && n[t] === "visible")
  );
}, Ng = function(e) {
  return kc(e, "overflowY");
}, jg = function(e) {
  return kc(e, "overflowX");
}, ui = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var o = Ec(e, r);
    if (o) {
      var a = Cc(e, r), s = a[1], i = a[2];
      if (s > i)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Ig = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Fg = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, Ec = function(e, t) {
  return e === "v" ? Ng(t) : jg(t);
}, Cc = function(e, t) {
  return e === "v" ? Ig(t) : Fg(t);
}, Wg = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, $g = function(e, t, n, r, o) {
  var a = Wg(e, window.getComputedStyle(t).direction), s = a * r, i = n.target, d = t.contains(i), l = !1, u = s > 0, c = 0, f = 0;
  do {
    if (!i)
      break;
    var m = Cc(e, i), y = m[0], h = m[1], g = m[2], k = h - g - a * y;
    (y || k) && Ec(e, i) && (c += k, f += y);
    var C = i.parentNode;
    i = C && C.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? C.host : C;
  } while (
    // portaled content
    !d && i !== document.body || // self content
    d && (t.contains(i) || t === i)
  );
  return (u && Math.abs(c) < 1 || !u && Math.abs(f) < 1) && (l = !0), l;
}, sr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, fi = function(e) {
  return [e.deltaX, e.deltaY];
}, pi = function(e) {
  return e && "current" in e ? e.current : e;
}, Lg = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, zg = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Bg = 0, cn = [];
function Yg(e) {
  var t = p.useRef([]), n = p.useRef([0, 0]), r = p.useRef(), o = p.useState(Bg++)[0], a = p.useState(wc)[0], s = p.useRef(e);
  p.useEffect(function() {
    s.current = e;
  }, [e]), p.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(o));
      var h = dg([e.lockRef.current], (e.shards || []).map(pi), !0).filter(Boolean);
      return h.forEach(function(g) {
        return g.classList.add("allow-interactivity-".concat(o));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(o)), h.forEach(function(g) {
          return g.classList.remove("allow-interactivity-".concat(o));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var i = p.useCallback(function(h, g) {
    if ("touches" in h && h.touches.length === 2 || h.type === "wheel" && h.ctrlKey)
      return !s.current.allowPinchZoom;
    var k = sr(h), C = n.current, E = "deltaX" in h ? h.deltaX : C[0] - k[0], O = "deltaY" in h ? h.deltaY : C[1] - k[1], v, P = h.target, M = Math.abs(E) > Math.abs(O) ? "h" : "v";
    if ("touches" in h && M === "h" && P.type === "range")
      return !1;
    var D = ui(M, P);
    if (!D)
      return !0;
    if (D ? v = M : (v = M === "v" ? "h" : "v", D = ui(M, P)), !D)
      return !1;
    if (!r.current && "changedTouches" in h && (E || O) && (r.current = v), !v)
      return !0;
    var L = r.current || v;
    return $g(L, g, h, L === "h" ? E : O);
  }, []), d = p.useCallback(function(h) {
    var g = h;
    if (!(!cn.length || cn[cn.length - 1] !== a)) {
      var k = "deltaY" in g ? fi(g) : sr(g), C = t.current.filter(function(v) {
        return v.name === g.type && (v.target === g.target || g.target === v.shadowParent) && Lg(v.delta, k);
      })[0];
      if (C && C.should) {
        g.cancelable && g.preventDefault();
        return;
      }
      if (!C) {
        var E = (s.current.shards || []).map(pi).filter(Boolean).filter(function(v) {
          return v.contains(g.target);
        }), O = E.length > 0 ? i(g, E[0]) : !s.current.noIsolation;
        O && g.cancelable && g.preventDefault();
      }
    }
  }, []), l = p.useCallback(function(h, g, k, C) {
    var E = { name: h, delta: g, target: k, should: C, shadowParent: Hg(k) };
    t.current.push(E), setTimeout(function() {
      t.current = t.current.filter(function(O) {
        return O !== E;
      });
    }, 1);
  }, []), u = p.useCallback(function(h) {
    n.current = sr(h), r.current = void 0;
  }, []), c = p.useCallback(function(h) {
    l(h.type, fi(h), h.target, i(h, e.lockRef.current));
  }, []), f = p.useCallback(function(h) {
    l(h.type, sr(h), h.target, i(h, e.lockRef.current));
  }, []);
  p.useEffect(function() {
    return cn.push(a), e.setCallbacks({
      onScrollCapture: c,
      onWheelCapture: c,
      onTouchMoveCapture: f
    }), document.addEventListener("wheel", d, sn), document.addEventListener("touchmove", d, sn), document.addEventListener("touchstart", u, sn), function() {
      cn = cn.filter(function(h) {
        return h !== a;
      }), document.removeEventListener("wheel", d, sn), document.removeEventListener("touchmove", d, sn), document.removeEventListener("touchstart", u, sn);
    };
  }, []);
  var m = e.removeScrollBar, y = e.inert;
  return p.createElement(
    p.Fragment,
    null,
    y ? p.createElement(a, { styles: zg(o) }) : null,
    m ? p.createElement(Ag, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Hg(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const qg = yg(bc, Yg);
var Ir = p.forwardRef(function(e, t) {
  return p.createElement(jr, ft({}, e, { ref: t, sideCar: qg }));
});
Ir.classNames = jr.classNames;
var Fr = "Popover", [Oc, u0] = Lt(Fr, [
  sc
]), Hn = sc(), [Vg, zt] = Oc(Fr), Sc = (e) => {
  const {
    __scopePopover: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !1
  } = e, i = Hn(t), d = p.useRef(null), [l, u] = p.useState(!1), [c, f] = Yn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Fr
  });
  return /* @__PURE__ */ x.jsx(Zv, { ...i, children: /* @__PURE__ */ x.jsx(
    Vg,
    {
      scope: t,
      contentId: Ct(),
      triggerRef: d,
      open: c,
      onOpenChange: f,
      onOpenToggle: p.useCallback(() => f((m) => !m), [f]),
      hasCustomAnchor: l,
      onCustomAnchorAdd: p.useCallback(() => u(!0), []),
      onCustomAnchorRemove: p.useCallback(() => u(!1), []),
      modal: s,
      children: n
    }
  ) });
};
Sc.displayName = Fr;
var Mc = "PopoverAnchor", Ug = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zt(Mc, n), a = Hn(n), { onCustomAnchorAdd: s, onCustomAnchorRemove: i } = o;
    return p.useEffect(() => (s(), () => i()), [s, i]), /* @__PURE__ */ x.jsx(vc, { ...a, ...r, ref: t });
  }
);
Ug.displayName = Mc;
var Dc = "PopoverTrigger", Pc = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zt(Dc, n), a = Hn(n), s = we(t, o.triggerRef), i = /* @__PURE__ */ x.jsx(
      ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": Nc(o.open),
        ...r,
        ref: s,
        onClick: He(e.onClick, o.onOpenToggle)
      }
    );
    return o.hasCustomAnchor ? i : /* @__PURE__ */ x.jsx(vc, { asChild: !0, ...a, children: i });
  }
);
Pc.displayName = Dc;
var na = "PopoverPortal", [Gg, Kg] = Oc(na, {
  forceMount: void 0
}), _c = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: o } = e, a = zt(na, t);
  return /* @__PURE__ */ x.jsx(Gg, { scope: t, forceMount: n, children: /* @__PURE__ */ x.jsx(wn, { present: n || a.open, children: /* @__PURE__ */ x.jsx(Nr, { asChild: !0, container: o, children: r }) }) });
};
_c.displayName = na;
var mn = "PopoverContent", Tc = p.forwardRef(
  (e, t) => {
    const n = Kg(mn, e.__scopePopover), { forceMount: r = n.forceMount, ...o } = e, a = zt(mn, e.__scopePopover);
    return /* @__PURE__ */ x.jsx(wn, { present: r || a.open, children: a.modal ? /* @__PURE__ */ x.jsx(Zg, { ...o, ref: t }) : /* @__PURE__ */ x.jsx(Qg, { ...o, ref: t }) });
  }
);
Tc.displayName = mn;
var Xg = /* @__PURE__ */ Xt("PopoverContent.RemoveScroll"), Zg = p.forwardRef(
  (e, t) => {
    const n = zt(mn, e.__scopePopover), r = p.useRef(null), o = we(t, r), a = p.useRef(!1);
    return p.useEffect(() => {
      const s = r.current;
      if (s) return ta(s);
    }, []), /* @__PURE__ */ x.jsx(Ir, { as: Xg, allowPinchZoom: !0, children: /* @__PURE__ */ x.jsx(
      Ac,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: He(e.onCloseAutoFocus, (s) => {
          var i;
          s.preventDefault(), a.current || (i = n.triggerRef.current) == null || i.focus();
        }),
        onPointerDownOutside: He(
          e.onPointerDownOutside,
          (s) => {
            const i = s.detail.originalEvent, d = i.button === 0 && i.ctrlKey === !0, l = i.button === 2 || d;
            a.current = l;
          },
          { checkForDefaultPrevented: !1 }
        ),
        onFocusOutside: He(
          e.onFocusOutside,
          (s) => s.preventDefault(),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
), Qg = p.forwardRef(
  (e, t) => {
    const n = zt(mn, e.__scopePopover), r = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ x.jsx(
      Ac,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, i;
          (s = e.onCloseAutoFocus) == null || s.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, l;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), Ac = p.forwardRef(
  (e, t) => {
    const {
      __scopePopover: n,
      trapFocus: r,
      onOpenAutoFocus: o,
      onCloseAutoFocus: a,
      disableOutsidePointerEvents: s,
      onEscapeKeyDown: i,
      onPointerDownOutside: d,
      onFocusOutside: l,
      onInteractOutside: u,
      ...c
    } = e, f = zt(mn, n), m = Hn(n);
    return js(), /* @__PURE__ */ x.jsx(
      _r,
      {
        asChild: !0,
        loop: !0,
        trapped: r,
        onMountAutoFocus: o,
        onUnmountAutoFocus: a,
        children: /* @__PURE__ */ x.jsx(
          qo,
          {
            asChild: !0,
            disableOutsidePointerEvents: s,
            onInteractOutside: u,
            onEscapeKeyDown: i,
            onPointerDownOutside: d,
            onFocusOutside: l,
            onDismiss: () => f.onOpenChange(!1),
            children: /* @__PURE__ */ x.jsx(
              Qv,
              {
                "data-state": Nc(f.open),
                role: "dialog",
                id: f.contentId,
                ...m,
                ...c,
                ref: t,
                style: {
                  ...c.style,
                  "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
                  "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
                  "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
                  "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
                  "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
                }
              }
            )
          }
        )
      }
    );
  }
), Rc = "PopoverClose", Jg = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = zt(Rc, n);
    return /* @__PURE__ */ x.jsx(
      ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: He(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Jg.displayName = Rc;
var ex = "PopoverArrow", tx = p.forwardRef(
  (e, t) => {
    const { __scopePopover: n, ...r } = e, o = Hn(n);
    return /* @__PURE__ */ x.jsx(Jv, { ...o, ...r, ref: t });
  }
);
tx.displayName = ex;
function Nc(e) {
  return e ? "open" : "closed";
}
var nx = Sc, rx = Pc, ox = _c, jc = Tc;
const ax = nx, ix = rx, Ic = Je(({ className: e, align: t = "center", sideOffset: n = 4, ...r }, o) => /* @__PURE__ */ x.jsx(ox, { children: /* @__PURE__ */ x.jsx(
  jc,
  {
    align: t,
    className: ae(
      "z-50 w-72 rounded-md border bg-popover p-4 text-popover-foreground shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ref: o,
    sideOffset: n,
    ...r
  }
) }));
Ic.displayName = jc.displayName;
const sx = [
  {
    label: "YTD",
    getValue: () => {
      const e = /* @__PURE__ */ new Date();
      return {
        from: $o(e),
        to: Qn(e)
      };
    }
  },
  {
    label: "Today",
    getValue: () => {
      const e = /* @__PURE__ */ new Date();
      return {
        from: Ft(e),
        to: Qn(e)
      };
    }
  },
  {
    label: "Yesterday",
    getValue: () => {
      const e = Pn(/* @__PURE__ */ new Date(), 1);
      return {
        from: Ft(e),
        to: Qn(e)
      };
    }
  },
  {
    label: "Last 7 Days",
    getValue: () => {
      const e = /* @__PURE__ */ new Date();
      return {
        from: Ft(Pn(e, 6)),
        to: Qn(e)
      };
    }
  },
  {
    label: "This Month",
    getValue: () => {
      const e = /* @__PURE__ */ new Date();
      return {
        from: mr(e),
        to: go(e)
      };
    }
  },
  {
    label: "Last Month",
    getValue: () => {
      const e = /* @__PURE__ */ new Date(), t = mr(e), n = Pn(t, 1), r = Pn(e, 90);
      return {
        from: n < r ? r : mr(n),
        to: go(n)
      };
    }
  }
];
function f0({
  onUpdate: e,
  initialDateFrom: t,
  initialDateTo: n,
  align: r = "start",
  className: o
}) {
  const [a, s] = un(!1), [i, d] = un(() => {
    if (t && n)
      return {
        from: new Date(t),
        to: new Date(n)
      };
  }), l = (f) => {
    d(f), e && e({
      from: f == null ? void 0 : f.from,
      to: f == null ? void 0 : f.to
    }), f != null && f.from && (f != null && f.to) && s(!1);
  }, u = (f) => {
    const m = f.getValue();
    d(m), e && e({
      from: m.from,
      to: m.to
    }), s(!1);
  }, c = (f) => f != null && f.from ? f != null && f.to ? `${Dn(f.from, "yyyy-MM-dd")} → ${Dn(f.to, "yyyy-MM-dd")}` : Dn(f.from, "yyyy-MM-dd") : "";
  return /* @__PURE__ */ x.jsx("div", { className: ae("relative", o), children: /* @__PURE__ */ x.jsxs(ax, { onOpenChange: s, open: a, children: [
    /* @__PURE__ */ x.jsx(ix, { asChild: !0, children: /* @__PURE__ */ x.jsxs(
      Eo,
      {
        className: ae(
          "w-[300px] justify-start text-left font-normal border-gray-300 hover:border-gray-400",
          !i && "text-muted-foreground"
        ),
        id: "date",
        variant: "outline",
        children: [
          /* @__PURE__ */ x.jsx(gf, { className: "mr-2 h-4 w-4 text-gray-500" }),
          i != null && i.from ? i.to ? /* @__PURE__ */ x.jsx("span", { className: "text-gray-900", children: c(i) }) : /* @__PURE__ */ x.jsx("span", { className: "text-gray-900", children: Dn(i.from, "yyyy-MM-dd") }) : /* @__PURE__ */ x.jsx("span", { className: "text-gray-500", children: "Pick a date range" })
        ]
      }
    ) }),
    /* @__PURE__ */ x.jsx(
      Ic,
      {
        align: r,
        className: "w-auto p-0 z-[9999]",
        side: "bottom",
        sideOffset: 8,
        children: /* @__PURE__ */ x.jsxs("div", { className: "flex bg-white rounded-lg overflow-hidden border border-gray-200 shadow-xl max-w-none", children: [
          /* @__PURE__ */ x.jsx("div", { className: "w-min border-r border-gray-200 p-3 bg-gray-50 min-w-[120px] flex-shrink-0", children: /* @__PURE__ */ x.jsx("div", { className: "space-y-1", children: sx.map((f) => /* @__PURE__ */ x.jsx(
            Eo,
            {
              className: "w-full justify-start text-left text-sm h-8 px-2 hover:bg-gray-100 rounded",
              onClick: () => u(f),
              size: "sm",
              variant: "ghost",
              children: f.label
            },
            f.label
          )) }) }),
          /* @__PURE__ */ x.jsx("div", { className: "p-4 bg-white min-w-[600px] flex-shrink-0", children: /* @__PURE__ */ x.jsx(
            cm,
            {
              animate: !0,
              classNames: {
                months: "flex gap-8 px-2",
                month: "space-y-4",
                caption: "flex justify-between items-center font-medium text-gray-700",
                nav: "flex gap-1",
                table: "border-collapse",
                head_row: "flex justify-between",
                head_cell: "w-9 h-9 text-xs font-medium text-gray-500 flex items-center justify-center",
                row: "flex justify-between w-full",
                cell: (
                  // 🔹 removed `rounded-md`, so no more circular borders
                  "w-9 h-9 text-sm flex items-center justify-center cursor-pointer hover:bg-gray-100"
                )
              },
              defaultMonth: i == null ? void 0 : i.from,
              disabled: (f) => {
                const m = /* @__PURE__ */ new Date(), y = Pn(m, 90);
                return f > m || f < y;
              },
              mode: "range",
              modifiersClassNames: {
                range_start: "bg-blue-500 text-white rounded-l-md",
                // start date
                range_end: "bg-blue-500 text-white rounded-l-md",
                // end date
                range_middle: "bg-blue-100"
                // in between
              },
              navLayout: "around",
              numberOfMonths: 2,
              onSelect: l,
              required: !0,
              selected: i
            }
          ) })
        ] })
      }
    )
  ] }) });
}
function p0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae(
        "bg-card text-card-foreground flex flex-col gap-6 rounded-xl border py-6 shadow-sm",
        e
      ),
      "data-slot": "card",
      ...t
    }
  );
}
function m0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae(
        "@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6",
        e
      ),
      "data-slot": "card-header",
      ...t
    }
  );
}
function h0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae("leading-none font-semibold", e),
      "data-slot": "card-title",
      ...t
    }
  );
}
function v0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae("text-muted-foreground text-sm", e),
      "data-slot": "card-description",
      ...t
    }
  );
}
function g0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae("px-6", e),
      "data-slot": "card-content",
      ...t
    }
  );
}
function x0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae("flex items-center px-6 [.border-t]:pt-6", e),
      "data-slot": "card-footer",
      ...t
    }
  );
}
var Wr = "Dialog", [Fc, y0] = Lt(Wr), [cx, st] = Fc(Wr), Wc = (e) => {
  const {
    __scopeDialog: t,
    children: n,
    open: r,
    defaultOpen: o,
    onOpenChange: a,
    modal: s = !0
  } = e, i = p.useRef(null), d = p.useRef(null), [l, u] = Yn({
    prop: r,
    defaultProp: o ?? !1,
    onChange: a,
    caller: Wr
  });
  return /* @__PURE__ */ x.jsx(
    cx,
    {
      scope: t,
      triggerRef: i,
      contentRef: d,
      contentId: Ct(),
      titleId: Ct(),
      descriptionId: Ct(),
      open: l,
      onOpenChange: u,
      onOpenToggle: p.useCallback(() => u((c) => !c), [u]),
      modal: s,
      children: n
    }
  );
};
Wc.displayName = Wr;
var $c = "DialogTrigger", Lc = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = st($c, n), a = we(t, o.triggerRef);
    return /* @__PURE__ */ x.jsx(
      ve.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": o.open,
        "aria-controls": o.contentId,
        "data-state": aa(o.open),
        ...r,
        ref: a,
        onClick: He(e.onClick, o.onOpenToggle)
      }
    );
  }
);
Lc.displayName = $c;
var ra = "DialogPortal", [lx, zc] = Fc(ra, {
  forceMount: void 0
}), Bc = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: o } = e, a = st(ra, t);
  return /* @__PURE__ */ x.jsx(lx, { scope: t, forceMount: n, children: p.Children.map(r, (s) => /* @__PURE__ */ x.jsx(wn, { present: n || a.open, children: /* @__PURE__ */ x.jsx(Nr, { asChild: !0, container: o, children: s }) })) });
};
Bc.displayName = ra;
var kr = "DialogOverlay", Yc = p.forwardRef(
  (e, t) => {
    const n = zc(kr, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = st(kr, e.__scopeDialog);
    return a.modal ? /* @__PURE__ */ x.jsx(wn, { present: r || a.open, children: /* @__PURE__ */ x.jsx(ux, { ...o, ref: t }) }) : null;
  }
);
Yc.displayName = kr;
var dx = /* @__PURE__ */ Xt("DialogOverlay.RemoveScroll"), ux = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = st(kr, n);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ x.jsx(Ir, { as: dx, allowPinchZoom: !0, shards: [o.contentRef], children: /* @__PURE__ */ x.jsx(
        ve.div,
        {
          "data-state": aa(o.open),
          ...r,
          ref: t,
          style: { pointerEvents: "auto", ...r.style }
        }
      ) })
    );
  }
), Qt = "DialogContent", Hc = p.forwardRef(
  (e, t) => {
    const n = zc(Qt, e.__scopeDialog), { forceMount: r = n.forceMount, ...o } = e, a = st(Qt, e.__scopeDialog);
    return /* @__PURE__ */ x.jsx(wn, { present: r || a.open, children: a.modal ? /* @__PURE__ */ x.jsx(fx, { ...o, ref: t }) : /* @__PURE__ */ x.jsx(px, { ...o, ref: t }) });
  }
);
Hc.displayName = Qt;
var fx = p.forwardRef(
  (e, t) => {
    const n = st(Qt, e.__scopeDialog), r = p.useRef(null), o = we(t, n.contentRef, r);
    return p.useEffect(() => {
      const a = r.current;
      if (a) return ta(a);
    }, []), /* @__PURE__ */ x.jsx(
      qc,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: He(e.onCloseAutoFocus, (a) => {
          var s;
          a.preventDefault(), (s = n.triggerRef.current) == null || s.focus();
        }),
        onPointerDownOutside: He(e.onPointerDownOutside, (a) => {
          const s = a.detail.originalEvent, i = s.button === 0 && s.ctrlKey === !0;
          (s.button === 2 || i) && a.preventDefault();
        }),
        onFocusOutside: He(
          e.onFocusOutside,
          (a) => a.preventDefault()
        )
      }
    );
  }
), px = p.forwardRef(
  (e, t) => {
    const n = st(Qt, e.__scopeDialog), r = p.useRef(!1), o = p.useRef(!1);
    return /* @__PURE__ */ x.jsx(
      qc,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (a) => {
          var s, i;
          (s = e.onCloseAutoFocus) == null || s.call(e, a), a.defaultPrevented || (r.current || (i = n.triggerRef.current) == null || i.focus(), a.preventDefault()), r.current = !1, o.current = !1;
        },
        onInteractOutside: (a) => {
          var d, l;
          (d = e.onInteractOutside) == null || d.call(e, a), a.defaultPrevented || (r.current = !0, a.detail.originalEvent.type === "pointerdown" && (o.current = !0));
          const s = a.target;
          ((l = n.triggerRef.current) == null ? void 0 : l.contains(s)) && a.preventDefault(), a.detail.originalEvent.type === "focusin" && o.current && a.preventDefault();
        }
      }
    );
  }
), qc = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: o, onCloseAutoFocus: a, ...s } = e, i = st(Qt, n), d = p.useRef(null), l = we(t, d);
    return js(), /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
      /* @__PURE__ */ x.jsx(
        _r,
        {
          asChild: !0,
          loop: !0,
          trapped: r,
          onMountAutoFocus: o,
          onUnmountAutoFocus: a,
          children: /* @__PURE__ */ x.jsx(
            qo,
            {
              role: "dialog",
              id: i.contentId,
              "aria-describedby": i.descriptionId,
              "aria-labelledby": i.titleId,
              "data-state": aa(i.open),
              ...s,
              ref: l,
              onDismiss: () => i.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
        /* @__PURE__ */ x.jsx(hx, { titleId: i.titleId }),
        /* @__PURE__ */ x.jsx(gx, { contentRef: d, descriptionId: i.descriptionId })
      ] })
    ] });
  }
), oa = "DialogTitle", Vc = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = st(oa, n);
    return /* @__PURE__ */ x.jsx(ve.h2, { id: o.titleId, ...r, ref: t });
  }
);
Vc.displayName = oa;
var Uc = "DialogDescription", mx = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = st(Uc, n);
    return /* @__PURE__ */ x.jsx(ve.p, { id: o.descriptionId, ...r, ref: t });
  }
);
mx.displayName = Uc;
var Gc = "DialogClose", Kc = p.forwardRef(
  (e, t) => {
    const { __scopeDialog: n, ...r } = e, o = st(Gc, n);
    return /* @__PURE__ */ x.jsx(
      ve.button,
      {
        type: "button",
        ...r,
        ref: t,
        onClick: He(e.onClick, () => o.onOpenChange(!1))
      }
    );
  }
);
Kc.displayName = Gc;
function aa(e) {
  return e ? "open" : "closed";
}
var Xc = "DialogTitleWarning", [b0, Zc] = Ch(Xc, {
  contentName: Qt,
  titleName: oa,
  docsSlug: "dialog"
}), hx = ({ titleId: e }) => {
  const t = Zc(Xc), n = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return p.useEffect(() => {
    e && (document.getElementById(e) || console.error(n));
  }, [n, e]), null;
}, vx = "DialogDescriptionWarning", gx = ({ contentRef: e, descriptionId: t }) => {
  const r = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Zc(vx).contentName}}.`;
  return p.useEffect(() => {
    var a;
    const o = (a = e.current) == null ? void 0 : a.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(r));
  }, [r, e, t]), null;
}, xx = Wc, yx = Lc, bx = Bc, wx = Yc, kx = Hc, Ex = Vc, Cx = Kc;
const w0 = xx, k0 = yx, E0 = Cx, Ox = ({
  children: e,
  container: t
}) => {
  const [n, r] = w.useState(null);
  return w.useEffect(() => {
    const o = t || document.getElementById("dialog-portal") || document.body;
    r(o);
  }, [t]), n ? /* @__PURE__ */ x.jsx(bx, { container: n, children: e }) : null;
}, Qc = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  wx,
  {
    className: ae(
      "fixed inset-0 z-50 bg-black/60 backdrop-blur-sm data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ref: n,
    ...t
  }
));
Qc.displayName = "DialogOverlay";
const Sx = w.forwardRef(({ className: e, children: t, container: n, ...r }, o) => /* @__PURE__ */ x.jsxs(Ox, { container: n, children: [
  /* @__PURE__ */ x.jsx(Qc, {}),
  /* @__PURE__ */ x.jsx(
    kx,
    {
      className: ae(
        "fixed inset-0 z-50 flex items-center justify-center sm:p-6",
        e
      ),
      ref: o,
      ...r,
      children: /* @__PURE__ */ x.jsx("div", { className: "grid w-[95vw] max-w-[800px] gap-4 border bg-white p-6 shadow-lg duration-200 data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] data-[state=closed]:animate-out data-[state=open]:animate-in rounded-lg max-h-[90vh] overflow-y-auto", children: t })
    }
  )
] }));
Sx.displayName = "DialogContent";
function C0(e) {
  return /* @__PURE__ */ x.jsx("div", { className: ae("mb-4 space-y-1", e.className), ...e });
}
function O0(e) {
  return /* @__PURE__ */ x.jsx(Ex, { className: ae("text-xl font-semibold", e.className), ...e, children: e.children });
}
function S0(e) {
  return /* @__PURE__ */ x.jsx("p", { className: ae("text-sm text-gray-500", e.className), ...e });
}
function M0(e) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae(
        "flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2",
        e.className
      ),
      ...e
    }
  );
}
function ce(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(o) {
    if (e == null || e(o), n === !1 || !o.defaultPrevented)
      return t == null ? void 0 : t(o);
  };
}
function Jc(e) {
  const t = e + "CollectionProvider", [n, r] = Lt(t), [o, a] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), s = (h) => {
    const { scope: g, children: k } = h, C = w.useRef(null), E = w.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ x.jsx(o, { scope: g, itemMap: E, collectionRef: C, children: k });
  };
  s.displayName = t;
  const i = e + "CollectionSlot", d = /* @__PURE__ */ Xt(i), l = w.forwardRef(
    (h, g) => {
      const { scope: k, children: C } = h, E = a(i, k), O = we(g, E.collectionRef);
      return /* @__PURE__ */ x.jsx(d, { ref: O, children: C });
    }
  );
  l.displayName = i;
  const u = e + "CollectionItemSlot", c = "data-radix-collection-item", f = /* @__PURE__ */ Xt(u), m = w.forwardRef(
    (h, g) => {
      const { scope: k, children: C, ...E } = h, O = w.useRef(null), v = we(g, O), P = a(u, k);
      return w.useEffect(() => (P.itemMap.set(O, { ref: O, ...E }), () => void P.itemMap.delete(O))), /* @__PURE__ */ x.jsx(f, { [c]: "", ref: v, children: C });
    }
  );
  m.displayName = u;
  function y(h) {
    const g = a(e + "CollectionConsumer", h);
    return w.useCallback(() => {
      const C = g.collectionRef.current;
      if (!C) return [];
      const E = Array.from(C.querySelectorAll(`[${c}]`));
      return Array.from(g.itemMap.values()).sort(
        (P, M) => E.indexOf(P.ref.current) - E.indexOf(M.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: s, Slot: l, ItemSlot: m },
    y,
    r
  ];
}
var Mx = p.createContext(void 0);
function el(e) {
  const t = p.useContext(Mx);
  return e || t || "ltr";
}
var Dx = "DismissableLayer", Po = "dismissableLayer.update", Px = "dismissableLayer.pointerDownOutside", _x = "dismissableLayer.focusOutside", mi, tl = p.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), nl = p.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: o,
      onFocusOutside: a,
      onInteractOutside: s,
      onDismiss: i,
      ...d
    } = e, l = p.useContext(tl), [u, c] = p.useState(null), f = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = p.useState({}), y = we(t, (M) => c(M)), h = Array.from(l.layers), [g] = [...l.layersWithOutsidePointerEventsDisabled].slice(-1), k = h.indexOf(g), C = u ? h.indexOf(u) : -1, E = l.layersWithOutsidePointerEventsDisabled.size > 0, O = C >= k, v = Rx((M) => {
      const D = M.target, L = [...l.branches].some((Y) => Y.contains(D));
      !O || L || (o == null || o(M), s == null || s(M), M.defaultPrevented || i == null || i());
    }, f), P = Nx((M) => {
      const D = M.target;
      [...l.branches].some((Y) => Y.contains(D)) || (a == null || a(M), s == null || s(M), M.defaultPrevented || i == null || i());
    }, f);
    return As((M) => {
      C === l.layers.size - 1 && (r == null || r(M), !M.defaultPrevented && i && (M.preventDefault(), i()));
    }, f), p.useEffect(() => {
      if (u)
        return n && (l.layersWithOutsidePointerEventsDisabled.size === 0 && (mi = f.body.style.pointerEvents, f.body.style.pointerEvents = "none"), l.layersWithOutsidePointerEventsDisabled.add(u)), l.layers.add(u), hi(), () => {
          n && l.layersWithOutsidePointerEventsDisabled.size === 1 && (f.body.style.pointerEvents = mi);
        };
    }, [u, f, n, l]), p.useEffect(() => () => {
      u && (l.layers.delete(u), l.layersWithOutsidePointerEventsDisabled.delete(u), hi());
    }, [u, l]), p.useEffect(() => {
      const M = () => m({});
      return document.addEventListener(Po, M), () => document.removeEventListener(Po, M);
    }, []), /* @__PURE__ */ x.jsx(
      ve.div,
      {
        ...d,
        ref: y,
        style: {
          pointerEvents: E ? O ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ce(e.onFocusCapture, P.onFocusCapture),
        onBlurCapture: ce(e.onBlurCapture, P.onBlurCapture),
        onPointerDownCapture: ce(
          e.onPointerDownCapture,
          v.onPointerDownCapture
        )
      }
    );
  }
);
nl.displayName = Dx;
var Tx = "DismissableLayerBranch", Ax = p.forwardRef((e, t) => {
  const n = p.useContext(tl), r = p.useRef(null), o = we(t, r);
  return p.useEffect(() => {
    const a = r.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ x.jsx(ve.div, { ...e, ref: o });
});
Ax.displayName = Tx;
function Rx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = p.useRef(!1), o = p.useRef(() => {
  });
  return p.useEffect(() => {
    const a = (i) => {
      if (i.target && !r.current) {
        let d = function() {
          rl(
            Px,
            n,
            l,
            { discrete: !0 }
          );
        };
        const l = { originalEvent: i };
        i.pointerType === "touch" ? (t.removeEventListener("click", o.current), o.current = d, t.addEventListener("click", o.current, { once: !0 })) : d();
      } else
        t.removeEventListener("click", o.current);
      r.current = !1;
    }, s = window.setTimeout(() => {
      t.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(s), t.removeEventListener("pointerdown", a), t.removeEventListener("click", o.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function Nx(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ve(e), r = p.useRef(!1);
  return p.useEffect(() => {
    const o = (a) => {
      a.target && !r.current && rl(_x, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", o), () => t.removeEventListener("focusin", o);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function hi() {
  const e = new CustomEvent(Po);
  document.dispatchEvent(e);
}
function rl(e, t, n, { discrete: r }) {
  const o = n.originalEvent.target, a = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && o.addEventListener(e, t, { once: !0 }), r ? Ho(o, a) : o.dispatchEvent(a);
}
var oo = 0;
function jx() {
  p.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? vi()), document.body.insertAdjacentElement("beforeend", e[1] ?? vi()), oo++, () => {
      oo === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), oo--;
    };
  }, []);
}
function vi() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ia = "Popper", [ol, al] = Lt(ia), [Ix, il] = ol(ia), sl = (e) => {
  const { __scopePopper: t, children: n } = e, [r, o] = p.useState(null);
  return /* @__PURE__ */ x.jsx(Ix, { scope: t, anchor: r, onAnchorChange: o, children: n });
};
sl.displayName = ia;
var cl = "PopperAnchor", ll = p.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...o } = e, a = il(cl, n), s = p.useRef(null), i = we(t, s);
    return p.useEffect(() => {
      a.onAnchorChange((r == null ? void 0 : r.current) || s.current);
    }), r ? null : /* @__PURE__ */ x.jsx(ve.div, { ...o, ref: i });
  }
);
ll.displayName = cl;
var sa = "PopperContent", [Fx, Wx] = ol(sa), dl = p.forwardRef(
  (e, t) => {
    var W, z, H, Q, se, I;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: o = 0,
      align: a = "center",
      alignOffset: s = 0,
      arrowPadding: i = 0,
      avoidCollisions: d = !0,
      collisionBoundary: l = [],
      collisionPadding: u = 0,
      sticky: c = "partial",
      hideWhenDetached: f = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: y,
      ...h
    } = e, g = il(sa, n), [k, C] = p.useState(null), E = we(t, (ue) => C(ue)), [O, v] = p.useState(null), P = ac(O), M = (P == null ? void 0 : P.width) ?? 0, D = (P == null ? void 0 : P.height) ?? 0, L = r + (a !== "center" ? "-" + a : ""), Y = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, U = Array.isArray(l) ? l : [l], J = U.length > 0, ee = {
      padding: Y,
      boundary: U.filter(Lx),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: J
    }, { refs: q, floatingStyles: G, placement: j, isPositioned: K, middlewareData: _ } = Ks({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: L,
      whileElementsMounted: (...ue) => Us(...ue, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: g.anchor
      },
      middleware: [
        Xs({ mainAxis: o + D, alignmentAxis: s }),
        d && Zs({
          mainAxis: !0,
          crossAxis: !1,
          limiter: c === "partial" ? Qs() : void 0,
          ...ee
        }),
        d && Js({ ...ee }),
        ec({
          ...ee,
          apply: ({ elements: ue, rects: Se, availableWidth: ze, availableHeight: et }) => {
            const { width: _e, height: Ue } = Se.reference, ge = ue.floating.style;
            ge.setProperty("--radix-popper-available-width", `${ze}px`), ge.setProperty("--radix-popper-available-height", `${et}px`), ge.setProperty("--radix-popper-anchor-width", `${_e}px`), ge.setProperty("--radix-popper-anchor-height", `${Ue}px`);
          }
        }),
        O && nc({ element: O, padding: i }),
        zx({ arrowWidth: M, arrowHeight: D }),
        f && tc({ strategy: "referenceHidden", ...ee })
      ]
    }), [R, b] = pl(j), S = Ve(y);
    Qe(() => {
      K && (S == null || S());
    }, [K, S]);
    const A = (W = _.arrow) == null ? void 0 : W.x, T = (z = _.arrow) == null ? void 0 : z.y, N = ((H = _.arrow) == null ? void 0 : H.centerOffset) !== 0, [V, F] = p.useState();
    return Qe(() => {
      k && F(window.getComputedStyle(k).zIndex);
    }, [k]), /* @__PURE__ */ x.jsx(
      "div",
      {
        ref: q.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: K ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: V,
          "--radix-popper-transform-origin": [
            (Q = _.transformOrigin) == null ? void 0 : Q.x,
            (se = _.transformOrigin) == null ? void 0 : se.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((I = _.hide) == null ? void 0 : I.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ x.jsx(
          Fx,
          {
            scope: n,
            placedSide: R,
            onArrowChange: v,
            arrowX: A,
            arrowY: T,
            shouldHideArrow: N,
            children: /* @__PURE__ */ x.jsx(
              ve.div,
              {
                "data-side": R,
                "data-align": b,
                ...h,
                ref: E,
                style: {
                  ...h.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
dl.displayName = sa;
var ul = "PopperArrow", $x = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, fl = p.forwardRef(function(t, n) {
  const { __scopePopper: r, ...o } = t, a = Wx(ul, r), s = $x[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ x.jsx(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [s]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ x.jsx(
          oc,
          {
            ...o,
            ref: n,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
fl.displayName = ul;
function Lx(e) {
  return e !== null;
}
var zx = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var g, k, C;
    const { placement: n, rects: r, middlewareData: o } = t, s = ((g = o.arrow) == null ? void 0 : g.centerOffset) !== 0, i = s ? 0 : e.arrowWidth, d = s ? 0 : e.arrowHeight, [l, u] = pl(n), c = { start: "0%", center: "50%", end: "100%" }[u], f = (((k = o.arrow) == null ? void 0 : k.x) ?? 0) + i / 2, m = (((C = o.arrow) == null ? void 0 : C.y) ?? 0) + d / 2;
    let y = "", h = "";
    return l === "bottom" ? (y = s ? c : `${f}px`, h = `${-d}px`) : l === "top" ? (y = s ? c : `${f}px`, h = `${r.floating.height + d}px`) : l === "right" ? (y = `${-d}px`, h = s ? c : `${m}px`) : l === "left" && (y = `${r.floating.width + d}px`, h = s ? c : `${m}px`), { data: { x: y, y: h } };
  }
});
function pl(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var ml = sl, Bx = ll, Yx = dl, Hx = fl;
function qx(e, t) {
  return p.useReducer((n, r) => t[n][r] ?? n, e);
}
var qn = (e) => {
  const { present: t, children: n } = e, r = Vx(t), o = typeof n == "function" ? n({ present: r.isPresent }) : p.Children.only(n), a = we(r.ref, Ux(o));
  return typeof n == "function" || r.isPresent ? p.cloneElement(o, { ref: a }) : null;
};
qn.displayName = "Presence";
function Vx(e) {
  const [t, n] = p.useState(), r = p.useRef(null), o = p.useRef(e), a = p.useRef("none"), s = e ? "mounted" : "unmounted", [i, d] = qx(s, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return p.useEffect(() => {
    const l = cr(r.current);
    a.current = i === "mounted" ? l : "none";
  }, [i]), Qe(() => {
    const l = r.current, u = o.current;
    if (u !== e) {
      const f = a.current, m = cr(l);
      e ? d("MOUNT") : m === "none" || (l == null ? void 0 : l.display) === "none" ? d("UNMOUNT") : d(u && f !== m ? "ANIMATION_OUT" : "UNMOUNT"), o.current = e;
    }
  }, [e, d]), Qe(() => {
    if (t) {
      let l;
      const u = t.ownerDocument.defaultView ?? window, c = (m) => {
        const h = cr(r.current).includes(m.animationName);
        if (m.target === t && h && (d("ANIMATION_END"), !o.current)) {
          const g = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", l = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = g);
          });
        }
      }, f = (m) => {
        m.target === t && (a.current = cr(r.current));
      };
      return t.addEventListener("animationstart", f), t.addEventListener("animationcancel", c), t.addEventListener("animationend", c), () => {
        u.clearTimeout(l), t.removeEventListener("animationstart", f), t.removeEventListener("animationcancel", c), t.removeEventListener("animationend", c);
      };
    } else
      d("ANIMATION_END");
  }, [t, d]), {
    isPresent: ["mounted", "unmountSuspended"].includes(i),
    ref: p.useCallback((l) => {
      r.current = l ? getComputedStyle(l) : null, n(l);
    }, [])
  };
}
function cr(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function Ux(e) {
  var r, o;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (o = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : o.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var ao = "rovingFocusGroup.onEntryFocus", Gx = { bubbles: !1, cancelable: !0 }, Vn = "RovingFocusGroup", [_o, hl, Kx] = Jc(Vn), [Xx, vl] = Lt(
  Vn,
  [Kx]
), [Zx, Qx] = Xx(Vn), gl = p.forwardRef(
  (e, t) => /* @__PURE__ */ x.jsx(_o.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ x.jsx(_o.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ x.jsx(Jx, { ...e, ref: t }) }) })
);
gl.displayName = Vn;
var Jx = p.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: r,
    loop: o = !1,
    dir: a,
    currentTabStopId: s,
    defaultCurrentTabStopId: i,
    onCurrentTabStopIdChange: d,
    onEntryFocus: l,
    preventScrollOnEntryFocus: u = !1,
    ...c
  } = e, f = p.useRef(null), m = we(t, f), y = el(a), [h, g] = Yn({
    prop: s,
    defaultProp: i ?? null,
    onChange: d,
    caller: Vn
  }), [k, C] = p.useState(!1), E = Ve(l), O = hl(n), v = p.useRef(!1), [P, M] = p.useState(0);
  return p.useEffect(() => {
    const D = f.current;
    if (D)
      return D.addEventListener(ao, E), () => D.removeEventListener(ao, E);
  }, [E]), /* @__PURE__ */ x.jsx(
    Zx,
    {
      scope: n,
      orientation: r,
      dir: y,
      loop: o,
      currentTabStopId: h,
      onItemFocus: p.useCallback(
        (D) => g(D),
        [g]
      ),
      onItemShiftTab: p.useCallback(() => C(!0), []),
      onFocusableItemAdd: p.useCallback(
        () => M((D) => D + 1),
        []
      ),
      onFocusableItemRemove: p.useCallback(
        () => M((D) => D - 1),
        []
      ),
      children: /* @__PURE__ */ x.jsx(
        ve.div,
        {
          tabIndex: k || P === 0 ? -1 : 0,
          "data-orientation": r,
          ...c,
          ref: m,
          style: { outline: "none", ...e.style },
          onMouseDown: ce(e.onMouseDown, () => {
            v.current = !0;
          }),
          onFocus: ce(e.onFocus, (D) => {
            const L = !v.current;
            if (D.target === D.currentTarget && L && !k) {
              const Y = new CustomEvent(ao, Gx);
              if (D.currentTarget.dispatchEvent(Y), !Y.defaultPrevented) {
                const U = O().filter((j) => j.focusable), J = U.find((j) => j.active), ee = U.find((j) => j.id === h), G = [J, ee, ...U].filter(
                  Boolean
                ).map((j) => j.ref.current);
                bl(G, u);
              }
            }
            v.current = !1;
          }),
          onBlur: ce(e.onBlur, () => C(!1))
        }
      )
    }
  );
}), xl = "RovingFocusGroupItem", yl = p.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: r = !0,
      active: o = !1,
      tabStopId: a,
      children: s,
      ...i
    } = e, d = Ct(), l = a || d, u = Qx(xl, n), c = u.currentTabStopId === l, f = hl(n), { onFocusableItemAdd: m, onFocusableItemRemove: y, currentTabStopId: h } = u;
    return p.useEffect(() => {
      if (r)
        return m(), () => y();
    }, [r, m, y]), /* @__PURE__ */ x.jsx(
      _o.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: r,
        active: o,
        children: /* @__PURE__ */ x.jsx(
          ve.span,
          {
            tabIndex: c ? 0 : -1,
            "data-orientation": u.orientation,
            ...i,
            ref: t,
            onMouseDown: ce(e.onMouseDown, (g) => {
              r ? u.onItemFocus(l) : g.preventDefault();
            }),
            onFocus: ce(e.onFocus, () => u.onItemFocus(l)),
            onKeyDown: ce(e.onKeyDown, (g) => {
              if (g.key === "Tab" && g.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (g.target !== g.currentTarget) return;
              const k = ny(g, u.orientation, u.dir);
              if (k !== void 0) {
                if (g.metaKey || g.ctrlKey || g.altKey || g.shiftKey) return;
                g.preventDefault();
                let E = f().filter((O) => O.focusable).map((O) => O.ref.current);
                if (k === "last") E.reverse();
                else if (k === "prev" || k === "next") {
                  k === "prev" && E.reverse();
                  const O = E.indexOf(g.currentTarget);
                  E = u.loop ? ry(E, O + 1) : E.slice(O + 1);
                }
                setTimeout(() => bl(E));
              }
            }),
            children: typeof s == "function" ? s({ isCurrentTabStop: c, hasTabStop: h != null }) : s
          }
        )
      }
    );
  }
);
yl.displayName = xl;
var ey = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function ty(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function ny(e, t, n) {
  const r = ty(e.key, n);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(r)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(r)))
    return ey[r];
}
function bl(e, t = !1) {
  const n = document.activeElement;
  for (const r of e)
    if (r === n || (r.focus({ preventScroll: t }), document.activeElement !== n)) return;
}
function ry(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var oy = gl, ay = yl, To = ["Enter", " "], iy = ["ArrowDown", "PageUp", "Home"], wl = ["ArrowUp", "PageDown", "End"], sy = [...iy, ...wl], cy = {
  ltr: [...To, "ArrowRight"],
  rtl: [...To, "ArrowLeft"]
}, ly = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, Un = "Menu", [In, dy, uy] = Jc(Un), [nn, kl] = Lt(Un, [
  uy,
  al,
  vl
]), Gn = al(), El = vl(), [Cl, Bt] = nn(Un), [fy, Kn] = nn(Un), Ol = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: o, onOpenChange: a, modal: s = !0 } = e, i = Gn(t), [d, l] = p.useState(null), u = p.useRef(!1), c = Ve(a), f = el(o);
  return p.useEffect(() => {
    const m = () => {
      u.current = !0, document.addEventListener("pointerdown", y, { capture: !0, once: !0 }), document.addEventListener("pointermove", y, { capture: !0, once: !0 });
    }, y = () => u.current = !1;
    return document.addEventListener("keydown", m, { capture: !0 }), () => {
      document.removeEventListener("keydown", m, { capture: !0 }), document.removeEventListener("pointerdown", y, { capture: !0 }), document.removeEventListener("pointermove", y, { capture: !0 });
    };
  }, []), /* @__PURE__ */ x.jsx(ml, { ...i, children: /* @__PURE__ */ x.jsx(
    Cl,
    {
      scope: t,
      open: n,
      onOpenChange: c,
      content: d,
      onContentChange: l,
      children: /* @__PURE__ */ x.jsx(
        fy,
        {
          scope: t,
          onClose: p.useCallback(() => c(!1), [c]),
          isUsingKeyboardRef: u,
          dir: f,
          modal: s,
          children: r
        }
      )
    }
  ) });
};
Ol.displayName = Un;
var py = "MenuAnchor", ca = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Gn(n);
    return /* @__PURE__ */ x.jsx(Bx, { ...o, ...r, ref: t });
  }
);
ca.displayName = py;
var la = "MenuPortal", [my, Sl] = nn(la, {
  forceMount: void 0
}), Ml = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: o } = e, a = Bt(la, t);
  return /* @__PURE__ */ x.jsx(my, { scope: t, forceMount: n, children: /* @__PURE__ */ x.jsx(qn, { present: n || a.open, children: /* @__PURE__ */ x.jsx(Nr, { asChild: !0, container: o, children: r }) }) });
};
Ml.displayName = la;
var Ze = "MenuContent", [hy, da] = nn(Ze), Dl = p.forwardRef(
  (e, t) => {
    const n = Sl(Ze, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Bt(Ze, e.__scopeMenu), s = Kn(Ze, e.__scopeMenu);
    return /* @__PURE__ */ x.jsx(In.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ x.jsx(qn, { present: r || a.open, children: /* @__PURE__ */ x.jsx(In.Slot, { scope: e.__scopeMenu, children: s.modal ? /* @__PURE__ */ x.jsx(vy, { ...o, ref: t }) : /* @__PURE__ */ x.jsx(gy, { ...o, ref: t }) }) }) });
  }
), vy = p.forwardRef(
  (e, t) => {
    const n = Bt(Ze, e.__scopeMenu), r = p.useRef(null), o = we(t, r);
    return p.useEffect(() => {
      const a = r.current;
      if (a) return ta(a);
    }, []), /* @__PURE__ */ x.jsx(
      ua,
      {
        ...e,
        ref: o,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ce(
          e.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), gy = p.forwardRef((e, t) => {
  const n = Bt(Ze, e.__scopeMenu);
  return /* @__PURE__ */ x.jsx(
    ua,
    {
      ...e,
      ref: t,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), xy = /* @__PURE__ */ Xt("MenuContent.ScrollLock"), ua = p.forwardRef(
  (e, t) => {
    const {
      __scopeMenu: n,
      loop: r = !1,
      trapFocus: o,
      onOpenAutoFocus: a,
      onCloseAutoFocus: s,
      disableOutsidePointerEvents: i,
      onEntryFocus: d,
      onEscapeKeyDown: l,
      onPointerDownOutside: u,
      onFocusOutside: c,
      onInteractOutside: f,
      onDismiss: m,
      disableOutsideScroll: y,
      ...h
    } = e, g = Bt(Ze, n), k = Kn(Ze, n), C = Gn(n), E = El(n), O = dy(n), [v, P] = p.useState(null), M = p.useRef(null), D = we(t, M, g.onContentChange), L = p.useRef(0), Y = p.useRef(""), U = p.useRef(0), J = p.useRef(null), ee = p.useRef("right"), q = p.useRef(0), G = y ? Ir : p.Fragment, j = y ? { as: xy, allowPinchZoom: !0 } : void 0, K = (R) => {
      var W, z;
      const b = Y.current + R, S = O().filter((H) => !H.disabled), A = document.activeElement, T = (W = S.find((H) => H.ref.current === A)) == null ? void 0 : W.textValue, N = S.map((H) => H.textValue), V = _y(N, b, T), F = (z = S.find((H) => H.textValue === V)) == null ? void 0 : z.ref.current;
      (function H(Q) {
        Y.current = Q, window.clearTimeout(L.current), Q !== "" && (L.current = window.setTimeout(() => H(""), 1e3));
      })(b), F && setTimeout(() => F.focus());
    };
    p.useEffect(() => () => window.clearTimeout(L.current), []), jx();
    const _ = p.useCallback((R) => {
      var S, A;
      return ee.current === ((S = J.current) == null ? void 0 : S.side) && Ay(R, (A = J.current) == null ? void 0 : A.area);
    }, []);
    return /* @__PURE__ */ x.jsx(
      hy,
      {
        scope: n,
        searchRef: Y,
        onItemEnter: p.useCallback(
          (R) => {
            _(R) && R.preventDefault();
          },
          [_]
        ),
        onItemLeave: p.useCallback(
          (R) => {
            var b;
            _(R) || ((b = M.current) == null || b.focus(), P(null));
          },
          [_]
        ),
        onTriggerLeave: p.useCallback(
          (R) => {
            _(R) && R.preventDefault();
          },
          [_]
        ),
        pointerGraceTimerRef: U,
        onPointerGraceIntentChange: p.useCallback((R) => {
          J.current = R;
        }, []),
        children: /* @__PURE__ */ x.jsx(G, { ...j, children: /* @__PURE__ */ x.jsx(
          _r,
          {
            asChild: !0,
            trapped: o,
            onMountAutoFocus: ce(a, (R) => {
              var b;
              R.preventDefault(), (b = M.current) == null || b.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: s,
            children: /* @__PURE__ */ x.jsx(
              nl,
              {
                asChild: !0,
                disableOutsidePointerEvents: i,
                onEscapeKeyDown: l,
                onPointerDownOutside: u,
                onFocusOutside: c,
                onInteractOutside: f,
                onDismiss: m,
                children: /* @__PURE__ */ x.jsx(
                  oy,
                  {
                    asChild: !0,
                    ...E,
                    dir: k.dir,
                    orientation: "vertical",
                    loop: r,
                    currentTabStopId: v,
                    onCurrentTabStopIdChange: P,
                    onEntryFocus: ce(d, (R) => {
                      k.isUsingKeyboardRef.current || R.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ x.jsx(
                      Yx,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": ql(g.open),
                        "data-radix-menu-content": "",
                        dir: k.dir,
                        ...C,
                        ...h,
                        ref: D,
                        style: { outline: "none", ...h.style },
                        onKeyDown: ce(h.onKeyDown, (R) => {
                          const S = R.target.closest("[data-radix-menu-content]") === R.currentTarget, A = R.ctrlKey || R.altKey || R.metaKey, T = R.key.length === 1;
                          S && (R.key === "Tab" && R.preventDefault(), !A && T && K(R.key));
                          const N = M.current;
                          if (R.target !== N || !sy.includes(R.key)) return;
                          R.preventDefault();
                          const F = O().filter((W) => !W.disabled).map((W) => W.ref.current);
                          wl.includes(R.key) && F.reverse(), Dy(F);
                        }),
                        onBlur: ce(e.onBlur, (R) => {
                          R.currentTarget.contains(R.target) || (window.clearTimeout(L.current), Y.current = "");
                        }),
                        onPointerMove: ce(
                          e.onPointerMove,
                          Fn((R) => {
                            const b = R.target, S = q.current !== R.clientX;
                            if (R.currentTarget.contains(b) && S) {
                              const A = R.clientX > q.current ? "right" : "left";
                              ee.current = A, q.current = R.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Dl.displayName = Ze;
var yy = "MenuGroup", fa = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ x.jsx(ve.div, { role: "group", ...r, ref: t });
  }
);
fa.displayName = yy;
var by = "MenuLabel", Pl = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ x.jsx(ve.div, { ...r, ref: t });
  }
);
Pl.displayName = by;
var Er = "MenuItem", gi = "menu.itemSelect", $r = p.forwardRef(
  (e, t) => {
    const { disabled: n = !1, onSelect: r, ...o } = e, a = p.useRef(null), s = Kn(Er, e.__scopeMenu), i = da(Er, e.__scopeMenu), d = we(t, a), l = p.useRef(!1), u = () => {
      const c = a.current;
      if (!n && c) {
        const f = new CustomEvent(gi, { bubbles: !0, cancelable: !0 });
        c.addEventListener(gi, (m) => r == null ? void 0 : r(m), { once: !0 }), Ho(c, f), f.defaultPrevented ? l.current = !1 : s.onClose();
      }
    };
    return /* @__PURE__ */ x.jsx(
      _l,
      {
        ...o,
        ref: d,
        disabled: n,
        onClick: ce(e.onClick, u),
        onPointerDown: (c) => {
          var f;
          (f = e.onPointerDown) == null || f.call(e, c), l.current = !0;
        },
        onPointerUp: ce(e.onPointerUp, (c) => {
          var f;
          l.current || (f = c.currentTarget) == null || f.click();
        }),
        onKeyDown: ce(e.onKeyDown, (c) => {
          const f = i.searchRef.current !== "";
          n || f && c.key === " " || To.includes(c.key) && (c.currentTarget.click(), c.preventDefault());
        })
      }
    );
  }
);
$r.displayName = Er;
var _l = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, disabled: r = !1, textValue: o, ...a } = e, s = da(Er, n), i = El(n), d = p.useRef(null), l = we(t, d), [u, c] = p.useState(!1), [f, m] = p.useState("");
    return p.useEffect(() => {
      const y = d.current;
      y && m((y.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ x.jsx(
      In.ItemSlot,
      {
        scope: n,
        disabled: r,
        textValue: o ?? f,
        children: /* @__PURE__ */ x.jsx(ay, { asChild: !0, ...i, focusable: !r, children: /* @__PURE__ */ x.jsx(
          ve.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": r || void 0,
            "data-disabled": r ? "" : void 0,
            ...a,
            ref: l,
            onPointerMove: ce(
              e.onPointerMove,
              Fn((y) => {
                r ? s.onItemLeave(y) : (s.onItemEnter(y), y.defaultPrevented || y.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ce(
              e.onPointerLeave,
              Fn((y) => s.onItemLeave(y))
            ),
            onFocus: ce(e.onFocus, () => c(!0)),
            onBlur: ce(e.onBlur, () => c(!1))
          }
        ) })
      }
    );
  }
), wy = "MenuCheckboxItem", Tl = p.forwardRef(
  (e, t) => {
    const { checked: n = !1, onCheckedChange: r, ...o } = e;
    return /* @__PURE__ */ x.jsx(Il, { scope: e.__scopeMenu, checked: n, children: /* @__PURE__ */ x.jsx(
      $r,
      {
        role: "menuitemcheckbox",
        "aria-checked": Cr(n) ? "mixed" : n,
        ...o,
        ref: t,
        "data-state": ha(n),
        onSelect: ce(
          o.onSelect,
          () => r == null ? void 0 : r(Cr(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
Tl.displayName = wy;
var Al = "MenuRadioGroup", [ky, Ey] = nn(
  Al,
  { value: void 0, onValueChange: () => {
  } }
), Rl = p.forwardRef(
  (e, t) => {
    const { value: n, onValueChange: r, ...o } = e, a = Ve(r);
    return /* @__PURE__ */ x.jsx(ky, { scope: e.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ x.jsx(fa, { ...o, ref: t }) });
  }
);
Rl.displayName = Al;
var Nl = "MenuRadioItem", jl = p.forwardRef(
  (e, t) => {
    const { value: n, ...r } = e, o = Ey(Nl, e.__scopeMenu), a = n === o.value;
    return /* @__PURE__ */ x.jsx(Il, { scope: e.__scopeMenu, checked: a, children: /* @__PURE__ */ x.jsx(
      $r,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...r,
        ref: t,
        "data-state": ha(a),
        onSelect: ce(
          r.onSelect,
          () => {
            var s;
            return (s = o.onValueChange) == null ? void 0 : s.call(o, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
jl.displayName = Nl;
var pa = "MenuItemIndicator", [Il, Cy] = nn(
  pa,
  { checked: !1 }
), Fl = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, forceMount: r, ...o } = e, a = Cy(pa, n);
    return /* @__PURE__ */ x.jsx(
      qn,
      {
        present: r || Cr(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ x.jsx(
          ve.span,
          {
            ...o,
            ref: t,
            "data-state": ha(a.checked)
          }
        )
      }
    );
  }
);
Fl.displayName = pa;
var Oy = "MenuSeparator", Wl = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e;
    return /* @__PURE__ */ x.jsx(
      ve.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...r,
        ref: t
      }
    );
  }
);
Wl.displayName = Oy;
var Sy = "MenuArrow", $l = p.forwardRef(
  (e, t) => {
    const { __scopeMenu: n, ...r } = e, o = Gn(n);
    return /* @__PURE__ */ x.jsx(Hx, { ...o, ...r, ref: t });
  }
);
$l.displayName = Sy;
var ma = "MenuSub", [My, Ll] = nn(ma), zl = (e) => {
  const { __scopeMenu: t, children: n, open: r = !1, onOpenChange: o } = e, a = Bt(ma, t), s = Gn(t), [i, d] = p.useState(null), [l, u] = p.useState(null), c = Ve(o);
  return p.useEffect(() => (a.open === !1 && c(!1), () => c(!1)), [a.open, c]), /* @__PURE__ */ x.jsx(ml, { ...s, children: /* @__PURE__ */ x.jsx(
    Cl,
    {
      scope: t,
      open: r,
      onOpenChange: c,
      content: l,
      onContentChange: u,
      children: /* @__PURE__ */ x.jsx(
        My,
        {
          scope: t,
          contentId: Ct(),
          triggerId: Ct(),
          trigger: i,
          onTriggerChange: d,
          children: n
        }
      )
    }
  ) });
};
zl.displayName = ma;
var Tn = "MenuSubTrigger", Bl = p.forwardRef(
  (e, t) => {
    const n = Bt(Tn, e.__scopeMenu), r = Kn(Tn, e.__scopeMenu), o = Ll(Tn, e.__scopeMenu), a = da(Tn, e.__scopeMenu), s = p.useRef(null), { pointerGraceTimerRef: i, onPointerGraceIntentChange: d } = a, l = { __scopeMenu: e.__scopeMenu }, u = p.useCallback(() => {
      s.current && window.clearTimeout(s.current), s.current = null;
    }, []);
    return p.useEffect(() => u, [u]), p.useEffect(() => {
      const c = i.current;
      return () => {
        window.clearTimeout(c), d(null);
      };
    }, [i, d]), /* @__PURE__ */ x.jsx(ca, { asChild: !0, ...l, children: /* @__PURE__ */ x.jsx(
      _l,
      {
        id: o.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": o.contentId,
        "data-state": ql(n.open),
        ...e,
        ref: Pr(t, o.onTriggerChange),
        onClick: (c) => {
          var f;
          (f = e.onClick) == null || f.call(e, c), !(e.disabled || c.defaultPrevented) && (c.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ce(
          e.onPointerMove,
          Fn((c) => {
            a.onItemEnter(c), !c.defaultPrevented && !e.disabled && !n.open && !s.current && (a.onPointerGraceIntentChange(null), s.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: ce(
          e.onPointerLeave,
          Fn((c) => {
            var m, y;
            u();
            const f = (m = n.content) == null ? void 0 : m.getBoundingClientRect();
            if (f) {
              const h = (y = n.content) == null ? void 0 : y.dataset.side, g = h === "right", k = g ? -5 : 5, C = f[g ? "left" : "right"], E = f[g ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: c.clientX + k, y: c.clientY },
                  { x: C, y: f.top },
                  { x: E, y: f.top },
                  { x: E, y: f.bottom },
                  { x: C, y: f.bottom }
                ],
                side: h
              }), window.clearTimeout(i.current), i.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(c), c.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ce(e.onKeyDown, (c) => {
          var m;
          const f = a.searchRef.current !== "";
          e.disabled || f && c.key === " " || cy[r.dir].includes(c.key) && (n.onOpenChange(!0), (m = n.content) == null || m.focus(), c.preventDefault());
        })
      }
    ) });
  }
);
Bl.displayName = Tn;
var Yl = "MenuSubContent", Hl = p.forwardRef(
  (e, t) => {
    const n = Sl(Ze, e.__scopeMenu), { forceMount: r = n.forceMount, ...o } = e, a = Bt(Ze, e.__scopeMenu), s = Kn(Ze, e.__scopeMenu), i = Ll(Yl, e.__scopeMenu), d = p.useRef(null), l = we(t, d);
    return /* @__PURE__ */ x.jsx(In.Provider, { scope: e.__scopeMenu, children: /* @__PURE__ */ x.jsx(qn, { present: r || a.open, children: /* @__PURE__ */ x.jsx(In.Slot, { scope: e.__scopeMenu, children: /* @__PURE__ */ x.jsx(
      ua,
      {
        id: i.contentId,
        "aria-labelledby": i.triggerId,
        ...o,
        ref: l,
        align: "start",
        side: s.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var c;
          s.isUsingKeyboardRef.current && ((c = d.current) == null || c.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: ce(e.onFocusOutside, (u) => {
          u.target !== i.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: ce(e.onEscapeKeyDown, (u) => {
          s.onClose(), u.preventDefault();
        }),
        onKeyDown: ce(e.onKeyDown, (u) => {
          var m;
          const c = u.currentTarget.contains(u.target), f = ly[s.dir].includes(u.key);
          c && f && (a.onOpenChange(!1), (m = i.trigger) == null || m.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
Hl.displayName = Yl;
function ql(e) {
  return e ? "open" : "closed";
}
function Cr(e) {
  return e === "indeterminate";
}
function ha(e) {
  return Cr(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function Dy(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t)) return;
}
function Py(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
function _y(e, t, n) {
  const o = t.length > 1 && Array.from(t).every((l) => l === t[0]) ? t[0] : t, a = n ? e.indexOf(n) : -1;
  let s = Py(e, Math.max(a, 0));
  o.length === 1 && (s = s.filter((l) => l !== n));
  const d = s.find(
    (l) => l.toLowerCase().startsWith(o.toLowerCase())
  );
  return d !== n ? d : void 0;
}
function Ty(e, t) {
  const { x: n, y: r } = e;
  let o = !1;
  for (let a = 0, s = t.length - 1; a < t.length; s = a++) {
    const i = t[a], d = t[s], l = i.x, u = i.y, c = d.x, f = d.y;
    u > r != f > r && n < (c - l) * (r - u) / (f - u) + l && (o = !o);
  }
  return o;
}
function Ay(e, t) {
  if (!t) return !1;
  const n = { x: e.clientX, y: e.clientY };
  return Ty(n, t);
}
function Fn(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var Ry = Ol, Ny = ca, jy = Ml, Iy = Dl, Fy = fa, Wy = Pl, $y = $r, Ly = Tl, zy = Rl, By = jl, Yy = Fl, Hy = Wl, qy = $l, Vy = zl, Uy = Bl, Gy = Hl, Lr = "DropdownMenu", [Ky, D0] = Lt(
  Lr,
  [kl]
), je = kl(), [Xy, Vl] = Ky(Lr), Ul = (e) => {
  const {
    __scopeDropdownMenu: t,
    children: n,
    dir: r,
    open: o,
    defaultOpen: a,
    onOpenChange: s,
    modal: i = !0
  } = e, d = je(t), l = p.useRef(null), [u, c] = Yn({
    prop: o,
    defaultProp: a ?? !1,
    onChange: s,
    caller: Lr
  });
  return /* @__PURE__ */ x.jsx(
    Xy,
    {
      scope: t,
      triggerId: Ct(),
      triggerRef: l,
      contentId: Ct(),
      open: u,
      onOpenChange: c,
      onOpenToggle: p.useCallback(() => c((f) => !f), [c]),
      modal: i,
      children: /* @__PURE__ */ x.jsx(Ry, { ...d, open: u, onOpenChange: c, dir: r, modal: i, children: n })
    }
  );
};
Ul.displayName = Lr;
var Gl = "DropdownMenuTrigger", Kl = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, disabled: r = !1, ...o } = e, a = Vl(Gl, n), s = je(n);
    return /* @__PURE__ */ x.jsx(Ny, { asChild: !0, ...s, children: /* @__PURE__ */ x.jsx(
      ve.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": r ? "" : void 0,
        disabled: r,
        ...o,
        ref: Pr(t, a.triggerRef),
        onPointerDown: ce(e.onPointerDown, (i) => {
          !r && i.button === 0 && i.ctrlKey === !1 && (a.onOpenToggle(), a.open || i.preventDefault());
        }),
        onKeyDown: ce(e.onKeyDown, (i) => {
          r || (["Enter", " "].includes(i.key) && a.onOpenToggle(), i.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(i.key) && i.preventDefault());
        })
      }
    ) });
  }
);
Kl.displayName = Gl;
var Zy = "DropdownMenuPortal", Xl = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = je(t);
  return /* @__PURE__ */ x.jsx(jy, { ...r, ...n });
};
Xl.displayName = Zy;
var Zl = "DropdownMenuContent", Ql = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = Vl(Zl, n), a = je(n), s = p.useRef(!1);
    return /* @__PURE__ */ x.jsx(
      Iy,
      {
        id: o.contentId,
        "aria-labelledby": o.triggerId,
        ...a,
        ...r,
        ref: t,
        onCloseAutoFocus: ce(e.onCloseAutoFocus, (i) => {
          var d;
          s.current || (d = o.triggerRef.current) == null || d.focus(), s.current = !1, i.preventDefault();
        }),
        onInteractOutside: ce(e.onInteractOutside, (i) => {
          const d = i.detail.originalEvent, l = d.button === 0 && d.ctrlKey === !0, u = d.button === 2 || l;
          (!o.modal || u) && (s.current = !0);
        }),
        style: {
          ...e.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
Ql.displayName = Zl;
var Qy = "DropdownMenuGroup", Jy = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ x.jsx(Fy, { ...o, ...r, ref: t });
  }
);
Jy.displayName = Qy;
var eb = "DropdownMenuLabel", Jl = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ x.jsx(Wy, { ...o, ...r, ref: t });
  }
);
Jl.displayName = eb;
var tb = "DropdownMenuItem", ed = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ x.jsx($y, { ...o, ...r, ref: t });
  }
);
ed.displayName = tb;
var nb = "DropdownMenuCheckboxItem", td = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(Ly, { ...o, ...r, ref: t });
});
td.displayName = nb;
var rb = "DropdownMenuRadioGroup", nd = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(zy, { ...o, ...r, ref: t });
});
nd.displayName = rb;
var ob = "DropdownMenuRadioItem", rd = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(By, { ...o, ...r, ref: t });
});
rd.displayName = ob;
var ab = "DropdownMenuItemIndicator", od = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(Yy, { ...o, ...r, ref: t });
});
od.displayName = ab;
var ib = "DropdownMenuSeparator", ad = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(Hy, { ...o, ...r, ref: t });
});
ad.displayName = ib;
var sb = "DropdownMenuArrow", cb = p.forwardRef(
  (e, t) => {
    const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
    return /* @__PURE__ */ x.jsx(qy, { ...o, ...r, ref: t });
  }
);
cb.displayName = sb;
var lb = (e) => {
  const { __scopeDropdownMenu: t, children: n, open: r, onOpenChange: o, defaultOpen: a } = e, s = je(t), [i, d] = Yn({
    prop: r,
    defaultProp: a ?? !1,
    onChange: o,
    caller: "DropdownMenuSub"
  });
  return /* @__PURE__ */ x.jsx(Vy, { ...s, open: i, onOpenChange: d, children: n });
}, db = "DropdownMenuSubTrigger", id = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(Uy, { ...o, ...r, ref: t });
});
id.displayName = db;
var ub = "DropdownMenuSubContent", sd = p.forwardRef((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, o = je(n);
  return /* @__PURE__ */ x.jsx(
    Gy,
    {
      ...o,
      ...r,
      ref: t,
      style: {
        ...e.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
sd.displayName = ub;
var fb = Ul, pb = Kl, mb = Xl, cd = Ql, ld = Jl, dd = ed, ud = td, hb = nd, fd = rd, pd = od, md = ad, vb = lb, hd = id, vd = sd;
const P0 = fb, _0 = pb, gb = w.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ x.jsx(mb, { children: /* @__PURE__ */ x.jsx(
  cd,
  {
    className: ae(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 max-h-[320px] origin-[var(--radix-dropdown-menu-content-transform-origin)] overflow-y-auto overflow-x-hidden rounded-md border p-1 text-popover-foreground shadow-md data-[state=closed]:animate-out data-[state=open]:animate-in bg-white min-w-[var(--radix-dropdown-menu-trigger-width)]",
      e
    ),
    ref: r,
    sideOffset: t,
    ...n
  }
) }));
gb.displayName = cd.displayName;
const xb = w.forwardRef(({ className: e, inset: t, variant: n = "default", ...r }, o) => /* @__PURE__ */ x.jsx(
  dd,
  {
    className: ae(
      "data-[variant=destructive]:*:[svg]:!text-destructive relative flex cursor-pointer select-none items-center gap-2 rounded-sm px-3 py-2 text-sm outline-hidden transition-colors hover:bg-accent hover:text-accent-foreground focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[inset]:pl-8 data-[variant=destructive]:text-destructive data-[disabled]:opacity-50 data-[variant=destructive]:focus:bg-destructive/10 data-[variant=destructive]:focus:text-destructive data-[variant=destructive]:hover:bg-destructive/10 data-[variant=destructive]:hover:text-destructive dark:data-[variant=destructive]:focus:bg-destructive/20 dark:data-[variant=destructive]:hover:bg-destructive/20 [&_svg:not([class*='size-'])]:size-4 [&_svg:not([class*='text-'])]:text-muted-foreground [&_svg]:pointer-events-none [&_svg]:shrink-0",
      e
    ),
    "data-inset": t,
    "data-variant": n,
    ref: o,
    ...r
  }
));
xb.displayName = dd.displayName;
const yb = w.forwardRef(({ className: e, children: t, checked: n, ...r }, o) => /* @__PURE__ */ x.jsxs(
  ud,
  {
    checked: n,
    className: ae(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
      e
    ),
    ref: o,
    ...r,
    children: [
      /* @__PURE__ */ x.jsx("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ x.jsx(pd, { children: /* @__PURE__ */ x.jsx(yf, { className: "size-4" }) }) }),
      t
    ]
  }
));
yb.displayName = ud.displayName;
const T0 = hb, bb = w.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ x.jsxs(
  fd,
  {
    className: ae(
      "relative flex cursor-default select-none items-center gap-2 rounded-sm py-1.5 pr-2 pl-8 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_svg:not([class*='size-'])]:size-4 [&_svg]:pointer-events-none [&_svg]:shrink-0",
      e
    ),
    ref: r,
    ...n,
    children: [
      /* @__PURE__ */ x.jsx("span", { className: "pointer-events-none absolute left-2 flex size-3.5 items-center justify-center", children: /* @__PURE__ */ x.jsx(pd, { children: /* @__PURE__ */ x.jsx(Ef, { className: "size-2 fill-current" }) }) }),
      t
    ]
  }
));
bb.displayName = fd.displayName;
const wb = w.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ x.jsx(
  ld,
  {
    className: ae(
      "px-2 py-1.5 font-medium text-sm data-[inset]:pl-8",
      e
    ),
    "data-inset": t,
    ref: r,
    ...n
  }
));
wb.displayName = ld.displayName;
const kb = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  md,
  {
    className: ae("-mx-1 my-1 h-px bg-border", e),
    ref: n,
    ...t
  }
));
kb.displayName = md.displayName;
const Eb = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "span",
  {
    className: ae(
      "ml-auto text-muted-foreground text-xs tracking-widest",
      e
    ),
    ref: n,
    ...t
  }
));
Eb.displayName = "DropdownMenuShortcut";
const A0 = vb, Cb = w.forwardRef(({ className: e, inset: t, children: n, ...r }, o) => /* @__PURE__ */ x.jsxs(
  hd,
  {
    className: ae(
      "flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[inset]:pl-8 data-[state=open]:text-accent-foreground",
      e
    ),
    "data-inset": t,
    ref: o,
    ...r,
    children: [
      n,
      /* @__PURE__ */ x.jsx(wf, { className: "ml-auto size-4" })
    ]
  }
));
Cb.displayName = hd.displayName;
const Ob = w.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  vd,
  {
    className: ae(
      "data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 z-50 min-w-[8rem] origin-[var(--radix-dropdown-menu-content-transform-origin)] overflow-hidden rounded-md border bg-popover p-1 text-popover-foreground shadow-lg data-[state=closed]:animate-out data-[state=open]:animate-in",
      e
    ),
    ref: n,
    ...t
  }
));
Ob.displayName = vd.displayName;
var Sb = (e) => e.type === "checkbox", An = (e) => e instanceof Date, va = (e) => e == null;
const gd = (e) => typeof e == "object";
var Jt = (e) => !va(e) && !Array.isArray(e) && gd(e) && !An(e), Mb = (e) => Jt(e) && e.target ? Sb(e.target) ? e.target.checked : e.target.value : e, Db = (e) => e.substring(0, e.search(/\.\d+(\.|$)/)) || e, Pb = (e, t) => e.has(Db(t)), _b = (e) => {
  const t = e.constructor && e.constructor.prototype;
  return Jt(t) && t.hasOwnProperty("isPrototypeOf");
}, Tb = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function xd(e) {
  let t;
  const n = Array.isArray(e), r = typeof FileList < "u" ? e instanceof FileList : !1;
  if (e instanceof Date)
    t = new Date(e);
  else if (!(Tb && (e instanceof Blob || r)) && (n || Jt(e)))
    if (t = n ? [] : Object.create(Object.getPrototypeOf(e)), !n && !_b(e))
      t = e;
    else
      for (const o in e)
        e.hasOwnProperty(o) && (t[o] = xd(e[o]));
  else
    return e;
  return t;
}
var yd = (e) => /^\w*$/.test(e), Ao = (e) => e === void 0, Ab = (e) => Array.isArray(e) ? e.filter(Boolean) : [], bd = (e) => Ab(e.replace(/["|']|\]/g, "").split(/\.|\[/)), $e = (e, t, n) => {
  if (!t || !Jt(e))
    return n;
  const r = (yd(t) ? [t] : bd(t)).reduce((o, a) => va(o) ? o : o[a], e);
  return Ao(r) || r === e ? Ao(e[t]) ? n : e[t] : r;
}, io = (e) => typeof e == "boolean", xi = (e, t, n) => {
  let r = -1;
  const o = yd(t) ? [t] : bd(t), a = o.length, s = a - 1;
  for (; ++r < a; ) {
    const i = o[r];
    let d = n;
    if (r !== s) {
      const l = e[i];
      d = Jt(l) || Array.isArray(l) ? l : isNaN(+o[r + 1]) ? {} : [];
    }
    if (i === "__proto__" || i === "constructor" || i === "prototype")
      return;
    e[i] = d, e = e[i];
  }
};
const yi = {
  BLUR: "blur",
  CHANGE: "change"
}, bi = {
  all: "all"
}, ga = w.createContext(null);
ga.displayName = "HookFormContext";
const zr = () => w.useContext(ga), Rb = (e) => {
  const { children: t, ...n } = e;
  return w.createElement(ga.Provider, { value: n }, t);
};
var Nb = (e, t, n, r = !0) => {
  const o = {
    defaultValues: t._defaultValues
  };
  for (const a in e)
    Object.defineProperty(o, a, {
      get: () => {
        const s = a;
        return t._proxyFormState[s] !== bi.all && (t._proxyFormState[s] = !r || bi.all), n && (n[s] = !0), e[s];
      }
    });
  return o;
};
const wd = typeof window < "u" ? w.useLayoutEffect : w.useEffect;
function jb(e) {
  const t = zr(), { control: n = t.control, disabled: r, name: o, exact: a } = e || {}, [s, i] = w.useState(n._formState), d = w.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  });
  return wd(() => n._subscribe({
    name: o,
    formState: d.current,
    exact: a,
    callback: (l) => {
      !r && i({
        ...n._formState,
        ...l
      });
    }
  }), [o, r, a]), w.useEffect(() => {
    d.current.isValid && n._setValid(!0);
  }, [n]), w.useMemo(() => Nb(s, n, d.current, !1), [s, n]);
}
var Ib = (e) => typeof e == "string", Fb = (e, t, n, r, o) => Ib(e) ? $e(n, e, o) : Array.isArray(e) ? e.map((a) => $e(n, a)) : n, wi = (e) => va(e) || !gd(e);
function kd(e, t, n = /* @__PURE__ */ new WeakSet()) {
  if (wi(e) || wi(t))
    return e === t;
  if (An(e) && An(t))
    return e.getTime() === t.getTime();
  const r = Object.keys(e), o = Object.keys(t);
  if (r.length !== o.length)
    return !1;
  if (n.has(e) || n.has(t))
    return !0;
  n.add(e), n.add(t);
  for (const a of r) {
    const s = e[a];
    if (!o.includes(a))
      return !1;
    if (a !== "ref") {
      const i = t[a];
      if (An(s) && An(i) || Jt(s) && Jt(i) || Array.isArray(s) && Array.isArray(i) ? !kd(s, i, n) : s !== i)
        return !1;
    }
  }
  return !0;
}
function Wb(e) {
  const t = zr(), { control: n = t.control, name: r, defaultValue: o, disabled: a, exact: s, compute: i } = e || {}, d = w.useRef(o), l = w.useRef(i), u = w.useRef(void 0);
  l.current = i;
  const c = w.useMemo(() => n._getWatch(r, d.current), [n, r]), [f, m] = w.useState(l.current ? l.current(c) : c);
  return wd(() => n._subscribe({
    name: r,
    formState: {
      values: !0
    },
    exact: s,
    callback: (y) => {
      if (!a) {
        const h = Fb(r, n._names, y.values || n._formValues, !1, d.current);
        if (l.current) {
          const g = l.current(h);
          kd(g, u.current) || (m(g), u.current = g);
        } else
          m(h);
      }
    }
  }), [n, a, r, s]), w.useEffect(() => n._removeUnmounted()), f;
}
function $b(e) {
  const t = zr(), { name: n, disabled: r, control: o = t.control, shouldUnregister: a, defaultValue: s } = e, i = Pb(o._names.array, n), d = w.useMemo(() => $e(o._formValues, n, $e(o._defaultValues, n, s)), [o, n, s]), l = Wb({
    control: o,
    name: n,
    defaultValue: d,
    exact: !0
  }), u = jb({
    control: o,
    name: n,
    exact: !0
  }), c = w.useRef(e), f = w.useRef(o.register(n, {
    ...e.rules,
    value: l,
    ...io(e.disabled) ? { disabled: e.disabled } : {}
  }));
  c.current = e;
  const m = w.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!$e(u.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!$e(u.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!$e(u.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!$e(u.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => $e(u.errors, n)
    }
  }), [u, n]), y = w.useCallback((C) => f.current.onChange({
    target: {
      value: Mb(C),
      name: n
    },
    type: yi.CHANGE
  }), [n]), h = w.useCallback(() => f.current.onBlur({
    target: {
      value: $e(o._formValues, n),
      name: n
    },
    type: yi.BLUR
  }), [n, o._formValues]), g = w.useCallback((C) => {
    const E = $e(o._fields, n);
    E && C && (E._f.ref = {
      focus: () => C.focus && C.focus(),
      select: () => C.select && C.select(),
      setCustomValidity: (O) => C.setCustomValidity(O),
      reportValidity: () => C.reportValidity()
    });
  }, [o._fields, n]), k = w.useMemo(() => ({
    name: n,
    value: l,
    ...io(r) || u.disabled ? { disabled: u.disabled || r } : {},
    onChange: y,
    onBlur: h,
    ref: g
  }), [n, r, u.disabled, y, h, g, l]);
  return w.useEffect(() => {
    const C = o._options.shouldUnregister || a;
    o.register(n, {
      ...c.current.rules,
      ...io(c.current.disabled) ? { disabled: c.current.disabled } : {}
    });
    const E = (O, v) => {
      const P = $e(o._fields, O);
      P && P._f && (P._f.mount = v);
    };
    if (E(n, !0), C) {
      const O = xd($e(o._options.defaultValues, n));
      xi(o._defaultValues, n, O), Ao($e(o._formValues, n)) && xi(o._formValues, n, O);
    }
    return !i && o.register(n), () => {
      (i ? C && !o._state.action : C) ? o.unregister(n) : E(n, !1);
    };
  }, [n, o, i, a]), w.useEffect(() => {
    o._setDisabledField({
      disabled: r,
      name: n
    });
  }, [r, n, o]), w.useMemo(() => ({
    field: k,
    formState: u,
    fieldState: m
  }), [k, u, m]);
}
const Lb = (e) => e.render($b(e));
var zb = "Label", Ed = p.forwardRef((e, t) => /* @__PURE__ */ x.jsx(
  ve.label,
  {
    ...e,
    ref: t,
    onMouseDown: (n) => {
      var o;
      n.target.closest("button, input, select, textarea") || ((o = e.onMouseDown) == null || o.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault());
    }
  }
));
Ed.displayName = zb;
var Bb = Ed;
function Yb({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ x.jsx(
    Bb,
    {
      className: ae(
        "flex select-none items-center gap-2 font-medium text-sm leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50 group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50",
        e
      ),
      "data-slot": "label",
      ...t
    }
  );
}
const R0 = Rb, Cd = w.createContext(
  {}
), N0 = ({
  ...e
}) => /* @__PURE__ */ x.jsx(Cd.Provider, { value: { name: e.name }, children: /* @__PURE__ */ x.jsx(Lb, { ...e }) }), xa = () => {
  const e = w.useContext(Cd), t = w.useContext(Od), { getFieldState: n, formState: r } = zr();
  if (!e)
    throw new Error("useFormField should be used within <FormField>");
  const o = n(e.name, r), { id: a } = t;
  return {
    id: a,
    name: e.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...o
  };
}, Od = w.createContext(
  {}
), Hb = w.forwardRef(({ className: e, ...t }, n) => {
  const r = w.useId();
  return /* @__PURE__ */ x.jsx(Od.Provider, { value: { id: r }, children: /* @__PURE__ */ x.jsx("div", { className: ae("space-y-2", e), ref: n, ...t }) });
});
Hb.displayName = "FormItem";
const qb = w.forwardRef(({ className: e, ...t }, n) => {
  const { error: r, formItemId: o } = xa();
  return /* @__PURE__ */ x.jsx(
    Yb,
    {
      className: ae(r && "text-red-500 dark:text-red-400", e),
      htmlFor: o,
      ref: n,
      ...t
    }
  );
});
qb.displayName = "FormLabel";
const Vb = w.forwardRef(({ ...e }, t) => {
  const { error: n, formItemId: r, formDescriptionId: o, formMessageId: a } = xa();
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      "aria-describedby": n ? `${o} ${a}` : `${o}`,
      "aria-invalid": !!n,
      id: r,
      ref: t,
      ...e
    }
  );
});
Vb.displayName = "FormControl";
const Ub = w.forwardRef(({ className: e, children: t, ...n }, r) => {
  var i;
  const { error: o, formMessageId: a } = xa(), s = (o == null ? void 0 : o.message) || ((i = o == null ? void 0 : o.value) == null ? void 0 : i.message) || t;
  return s ? /* @__PURE__ */ x.jsx(
    "p",
    {
      className: ae(
        "font-medium text-red-500 text-sm dark:text-red-400",
        e
      ),
      id: a,
      ref: r,
      ...n,
      children: s
    }
  ) : null;
});
Ub.displayName = "FormMessage";
function j0({ className: e, type: t, ...n }) {
  return /* @__PURE__ */ x.jsx(
    "input",
    {
      className: ae(
        "pl-4 file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        e
      ),
      "data-slot": "input",
      type: t,
      ...n
    }
  );
}
function I0({ className: e }) {
  return /* @__PURE__ */ x.jsx("div", { className: "flex items-center justify-center text-blue-500", children: /* @__PURE__ */ x.jsx(zo, { className: ae("animate-spin", e) }) });
}
function F0({ className: e, ...t }) {
  return /* @__PURE__ */ x.jsx(
    "div",
    {
      className: ae(
        "relative overflow-hidden rounded-md bg-gradient-to-r from-muted via-muted/50 to-muted",
        "before:absolute before:inset-0 before:-translate-x-full before:animate-[shimmer_2s_infinite]",
        "before:bg-gradient-to-r before:from-transparent before:via-white/20 before:to-transparent",
        "animate-pulse",
        e
      ),
      "data-slot": "skeleton",
      ...t
    }
  );
}
const W0 = ({ ...e }) => /* @__PURE__ */ x.jsx(
  kh,
  {
    className: "toaster group",
    toastOptions: {
      classNames: {
        toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
        description: "group-[.toast]:text-muted-foreground",
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground"
      }
    },
    ...e
  }
), Gb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx("div", { className: "relative w-full overflow-auto", children: /* @__PURE__ */ x.jsx(
  "table",
  {
    className: ae("w-full caption-bottom text-sm", e),
    ref: n,
    ...t
  }
) }));
Gb.displayName = "Table";
const Kb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx("thead", { className: ae("[&_tr]:border-b", e), ref: n, ...t }));
Kb.displayName = "TableHeader";
const Xb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "tbody",
  {
    className: ae("[&_tr:last-child]:border-0", e),
    ref: n,
    ...t
  }
));
Xb.displayName = "TableBody";
const Zb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "tfoot",
  {
    className: ae(
      "border-t bg-muted/50 font-medium [&>tr]:last:border-b-0",
      e
    ),
    ref: n,
    ...t
  }
));
Zb.displayName = "TableFooter";
const Qb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "tr",
  {
    className: ae(
      "border-b transition-colors hover:bg-muted/50 data-[state=selected]:bg-muted",
      e
    ),
    ref: n,
    ...t
  }
));
Qb.displayName = "TableRow";
const Jb = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "th",
  {
    className: ae(
      "h-12 px-4 text-left align-middle font-medium text-muted-foreground [&:has([role=checkbox])]:pr-0",
      e
    ),
    ref: n,
    ...t
  }
));
Jb.displayName = "TableHead";
const ew = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "td",
  {
    className: ae("p-4 align-middle [&:has([role=checkbox])]:pr-0", e),
    ref: n,
    ...t
  }
));
ew.displayName = "TableCell";
const tw = Je(({ className: e, ...t }, n) => /* @__PURE__ */ x.jsx(
  "caption",
  {
    className: ae("mt-4 text-sm text-muted-foreground", e),
    ref: n,
    ...t
  }
));
tw.displayName = "TableCaption";
function $0({
  id: e,
  accept: t = "*/*",
  metadata: n,
  buttonLabel: r,
  control: o
}) {
  const { upload: a, isPending: s } = o, i = async (d) => {
    var u;
    const l = (u = d.target.files) == null ? void 0 : u[0];
    if (!l || s) {
      d.target.value = "";
      return;
    }
    await a(l, { metadata: n }), d.target.value = "";
  };
  return /* @__PURE__ */ x.jsxs(
    Eo,
    {
      className: "relative h-10 px-4 py-2 text-indigo-700 bg-indigo-100 rounded-md hover:bg-indigo-200 whitespace-nowrap",
      disabled: s,
      type: "button",
      children: [
        /* @__PURE__ */ x.jsx("label", { className: "absolute inset-0 cursor-pointer", htmlFor: e, children: /* @__PURE__ */ x.jsx(
          "input",
          {
            accept: t,
            className: "absolute inset-0 h-full w-full opacity-0",
            id: e,
            onChange: i,
            type: "file"
          }
        ) }),
        s ? /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(zo, { className: "mr-2 h-4 w-4 animate-spin" }),
          "Uploading..."
        ] }) : /* @__PURE__ */ x.jsxs(x.Fragment, { children: [
          /* @__PURE__ */ x.jsx(as, { className: "mr-2 h-4 w-4" }),
          r || "Upload"
        ] })
      ]
    }
  );
}
var lr = { exports: {} }, dr = { exports: {} }, le = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var ki;
function nw() {
  if (ki) return le;
  ki = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
  function E(v) {
    if (typeof v == "object" && v !== null) {
      var P = v.$$typeof;
      switch (P) {
        case t:
          switch (v = v.type, v) {
            case d:
            case l:
            case r:
            case a:
            case o:
            case c:
              return v;
            default:
              switch (v = v && v.$$typeof, v) {
                case i:
                case u:
                case y:
                case m:
                case s:
                  return v;
                default:
                  return P;
              }
          }
        case n:
          return P;
      }
    }
  }
  function O(v) {
    return E(v) === l;
  }
  return le.AsyncMode = d, le.ConcurrentMode = l, le.ContextConsumer = i, le.ContextProvider = s, le.Element = t, le.ForwardRef = u, le.Fragment = r, le.Lazy = y, le.Memo = m, le.Portal = n, le.Profiler = a, le.StrictMode = o, le.Suspense = c, le.isAsyncMode = function(v) {
    return O(v) || E(v) === d;
  }, le.isConcurrentMode = O, le.isContextConsumer = function(v) {
    return E(v) === i;
  }, le.isContextProvider = function(v) {
    return E(v) === s;
  }, le.isElement = function(v) {
    return typeof v == "object" && v !== null && v.$$typeof === t;
  }, le.isForwardRef = function(v) {
    return E(v) === u;
  }, le.isFragment = function(v) {
    return E(v) === r;
  }, le.isLazy = function(v) {
    return E(v) === y;
  }, le.isMemo = function(v) {
    return E(v) === m;
  }, le.isPortal = function(v) {
    return E(v) === n;
  }, le.isProfiler = function(v) {
    return E(v) === a;
  }, le.isStrictMode = function(v) {
    return E(v) === o;
  }, le.isSuspense = function(v) {
    return E(v) === c;
  }, le.isValidElementType = function(v) {
    return typeof v == "string" || typeof v == "function" || v === r || v === l || v === a || v === o || v === c || v === f || typeof v == "object" && v !== null && (v.$$typeof === y || v.$$typeof === m || v.$$typeof === s || v.$$typeof === i || v.$$typeof === u || v.$$typeof === g || v.$$typeof === k || v.$$typeof === C || v.$$typeof === h);
  }, le.typeOf = E, le;
}
var de = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Ei;
function rw() {
  return Ei || (Ei = 1, process.env.NODE_ENV !== "production" && (function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, o = e ? Symbol.for("react.strict_mode") : 60108, a = e ? Symbol.for("react.profiler") : 60114, s = e ? Symbol.for("react.provider") : 60109, i = e ? Symbol.for("react.context") : 60110, d = e ? Symbol.for("react.async_mode") : 60111, l = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, c = e ? Symbol.for("react.suspense") : 60113, f = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, y = e ? Symbol.for("react.lazy") : 60116, h = e ? Symbol.for("react.block") : 60121, g = e ? Symbol.for("react.fundamental") : 60117, k = e ? Symbol.for("react.responder") : 60118, C = e ? Symbol.for("react.scope") : 60119;
    function E(I) {
      return typeof I == "string" || typeof I == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      I === r || I === l || I === a || I === o || I === c || I === f || typeof I == "object" && I !== null && (I.$$typeof === y || I.$$typeof === m || I.$$typeof === s || I.$$typeof === i || I.$$typeof === u || I.$$typeof === g || I.$$typeof === k || I.$$typeof === C || I.$$typeof === h);
    }
    function O(I) {
      if (typeof I == "object" && I !== null) {
        var ue = I.$$typeof;
        switch (ue) {
          case t:
            var Se = I.type;
            switch (Se) {
              case d:
              case l:
              case r:
              case a:
              case o:
              case c:
                return Se;
              default:
                var ze = Se && Se.$$typeof;
                switch (ze) {
                  case i:
                  case u:
                  case y:
                  case m:
                  case s:
                    return ze;
                  default:
                    return ue;
                }
            }
          case n:
            return ue;
        }
      }
    }
    var v = d, P = l, M = i, D = s, L = t, Y = u, U = r, J = y, ee = m, q = n, G = a, j = o, K = c, _ = !1;
    function R(I) {
      return _ || (_ = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), b(I) || O(I) === d;
    }
    function b(I) {
      return O(I) === l;
    }
    function S(I) {
      return O(I) === i;
    }
    function A(I) {
      return O(I) === s;
    }
    function T(I) {
      return typeof I == "object" && I !== null && I.$$typeof === t;
    }
    function N(I) {
      return O(I) === u;
    }
    function V(I) {
      return O(I) === r;
    }
    function F(I) {
      return O(I) === y;
    }
    function W(I) {
      return O(I) === m;
    }
    function z(I) {
      return O(I) === n;
    }
    function H(I) {
      return O(I) === a;
    }
    function Q(I) {
      return O(I) === o;
    }
    function se(I) {
      return O(I) === c;
    }
    de.AsyncMode = v, de.ConcurrentMode = P, de.ContextConsumer = M, de.ContextProvider = D, de.Element = L, de.ForwardRef = Y, de.Fragment = U, de.Lazy = J, de.Memo = ee, de.Portal = q, de.Profiler = G, de.StrictMode = j, de.Suspense = K, de.isAsyncMode = R, de.isConcurrentMode = b, de.isContextConsumer = S, de.isContextProvider = A, de.isElement = T, de.isForwardRef = N, de.isFragment = V, de.isLazy = F, de.isMemo = W, de.isPortal = z, de.isProfiler = H, de.isStrictMode = Q, de.isSuspense = se, de.isValidElementType = E, de.typeOf = O;
  })()), de;
}
var Ci;
function Sd() {
  return Ci || (Ci = 1, process.env.NODE_ENV === "production" ? dr.exports = nw() : dr.exports = rw()), dr.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var so, Oi;
function ow() {
  if (Oi) return so;
  Oi = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(a) {
    if (a == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(a);
  }
  function o() {
    try {
      if (!Object.assign)
        return !1;
      var a = new String("abc");
      if (a[5] = "de", Object.getOwnPropertyNames(a)[0] === "5")
        return !1;
      for (var s = {}, i = 0; i < 10; i++)
        s["_" + String.fromCharCode(i)] = i;
      var d = Object.getOwnPropertyNames(s).map(function(u) {
        return s[u];
      });
      if (d.join("") !== "0123456789")
        return !1;
      var l = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        l[u] = u;
      }), Object.keys(Object.assign({}, l)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return so = o() ? Object.assign : function(a, s) {
    for (var i, d = r(a), l, u = 1; u < arguments.length; u++) {
      i = Object(arguments[u]);
      for (var c in i)
        t.call(i, c) && (d[c] = i[c]);
      if (e) {
        l = e(i);
        for (var f = 0; f < l.length; f++)
          n.call(i, l[f]) && (d[l[f]] = i[l[f]]);
      }
    }
    return d;
  }, so;
}
var co, Si;
function ya() {
  if (Si) return co;
  Si = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return co = e, co;
}
var lo, Mi;
function Md() {
  return Mi || (Mi = 1, lo = Function.call.bind(Object.prototype.hasOwnProperty)), lo;
}
var uo, Di;
function aw() {
  if (Di) return uo;
  Di = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ ya(), n = {}, r = /* @__PURE__ */ Md();
    e = function(a) {
      var s = "Warning: " + a;
      typeof console < "u" && console.error(s);
      try {
        throw new Error(s);
      } catch {
      }
    };
  }
  function o(a, s, i, d, l) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in a)
        if (r(a, u)) {
          var c;
          try {
            if (typeof a[u] != "function") {
              var f = Error(
                (d || "React class") + ": " + i + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof a[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw f.name = "Invariant Violation", f;
            }
            c = a[u](s, u, d, i, null, t);
          } catch (y) {
            c = y;
          }
          if (c && !(c instanceof Error) && e(
            (d || "React class") + ": type specification of " + i + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof c + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), c instanceof Error && !(c.message in n)) {
            n[c.message] = !0;
            var m = l ? l() : "";
            e(
              "Failed " + i + " type: " + c.message + (m ?? "")
            );
          }
        }
    }
  }
  return o.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, uo = o, uo;
}
var fo, Pi;
function iw() {
  if (Pi) return fo;
  Pi = 1;
  var e = Sd(), t = ow(), n = /* @__PURE__ */ ya(), r = /* @__PURE__ */ Md(), o = /* @__PURE__ */ aw(), a = function() {
  };
  process.env.NODE_ENV !== "production" && (a = function(i) {
    var d = "Warning: " + i;
    typeof console < "u" && console.error(d);
    try {
      throw new Error(d);
    } catch {
    }
  });
  function s() {
    return null;
  }
  return fo = function(i, d) {
    var l = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function c(b) {
      var S = b && (l && b[l] || b[u]);
      if (typeof S == "function")
        return S;
    }
    var f = "<<anonymous>>", m = {
      array: k("array"),
      bigint: k("bigint"),
      bool: k("boolean"),
      func: k("function"),
      number: k("number"),
      object: k("object"),
      string: k("string"),
      symbol: k("symbol"),
      any: C(),
      arrayOf: E,
      element: O(),
      elementType: v(),
      instanceOf: P,
      node: Y(),
      objectOf: D,
      oneOf: M,
      oneOfType: L,
      shape: J,
      exact: ee
    };
    function y(b, S) {
      return b === S ? b !== 0 || 1 / b === 1 / S : b !== b && S !== S;
    }
    function h(b, S) {
      this.message = b, this.data = S && typeof S == "object" ? S : {}, this.stack = "";
    }
    h.prototype = Error.prototype;
    function g(b) {
      if (process.env.NODE_ENV !== "production")
        var S = {}, A = 0;
      function T(V, F, W, z, H, Q, se) {
        if (z = z || f, Q = Q || W, se !== n) {
          if (d) {
            var I = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw I.name = "Invariant Violation", I;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var ue = z + ":" + W;
            !S[ue] && // Avoid spamming the console because they are often not actionable except for lib authors
            A < 3 && (a(
              "You are manually calling a React.PropTypes validation function for the `" + Q + "` prop on `" + z + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), S[ue] = !0, A++);
          }
        }
        return F[W] == null ? V ? F[W] === null ? new h("The " + H + " `" + Q + "` is marked as required " + ("in `" + z + "`, but its value is `null`.")) : new h("The " + H + " `" + Q + "` is marked as required in " + ("`" + z + "`, but its value is `undefined`.")) : null : b(F, W, z, H, Q);
      }
      var N = T.bind(null, !1);
      return N.isRequired = T.bind(null, !0), N;
    }
    function k(b) {
      function S(A, T, N, V, F, W) {
        var z = A[T], H = j(z);
        if (H !== b) {
          var Q = K(z);
          return new h(
            "Invalid " + V + " `" + F + "` of type " + ("`" + Q + "` supplied to `" + N + "`, expected ") + ("`" + b + "`."),
            { expectedType: b }
          );
        }
        return null;
      }
      return g(S);
    }
    function C() {
      return g(s);
    }
    function E(b) {
      function S(A, T, N, V, F) {
        if (typeof b != "function")
          return new h("Property `" + F + "` of component `" + N + "` has invalid PropType notation inside arrayOf.");
        var W = A[T];
        if (!Array.isArray(W)) {
          var z = j(W);
          return new h("Invalid " + V + " `" + F + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected an array."));
        }
        for (var H = 0; H < W.length; H++) {
          var Q = b(W, H, N, V, F + "[" + H + "]", n);
          if (Q instanceof Error)
            return Q;
        }
        return null;
      }
      return g(S);
    }
    function O() {
      function b(S, A, T, N, V) {
        var F = S[A];
        if (!i(F)) {
          var W = j(F);
          return new h("Invalid " + N + " `" + V + "` of type " + ("`" + W + "` supplied to `" + T + "`, expected a single ReactElement."));
        }
        return null;
      }
      return g(b);
    }
    function v() {
      function b(S, A, T, N, V) {
        var F = S[A];
        if (!e.isValidElementType(F)) {
          var W = j(F);
          return new h("Invalid " + N + " `" + V + "` of type " + ("`" + W + "` supplied to `" + T + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return g(b);
    }
    function P(b) {
      function S(A, T, N, V, F) {
        if (!(A[T] instanceof b)) {
          var W = b.name || f, z = R(A[T]);
          return new h("Invalid " + V + " `" + F + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected ") + ("instance of `" + W + "`."));
        }
        return null;
      }
      return g(S);
    }
    function M(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? a(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : a("Invalid argument supplied to oneOf, expected an array.")), s;
      function S(A, T, N, V, F) {
        for (var W = A[T], z = 0; z < b.length; z++)
          if (y(W, b[z]))
            return null;
        var H = JSON.stringify(b, function(se, I) {
          var ue = K(I);
          return ue === "symbol" ? String(I) : I;
        });
        return new h("Invalid " + V + " `" + F + "` of value `" + String(W) + "` " + ("supplied to `" + N + "`, expected one of " + H + "."));
      }
      return g(S);
    }
    function D(b) {
      function S(A, T, N, V, F) {
        if (typeof b != "function")
          return new h("Property `" + F + "` of component `" + N + "` has invalid PropType notation inside objectOf.");
        var W = A[T], z = j(W);
        if (z !== "object")
          return new h("Invalid " + V + " `" + F + "` of type " + ("`" + z + "` supplied to `" + N + "`, expected an object."));
        for (var H in W)
          if (r(W, H)) {
            var Q = b(W, H, N, V, F + "." + H, n);
            if (Q instanceof Error)
              return Q;
          }
        return null;
      }
      return g(S);
    }
    function L(b) {
      if (!Array.isArray(b))
        return process.env.NODE_ENV !== "production" && a("Invalid argument supplied to oneOfType, expected an instance of array."), s;
      for (var S = 0; S < b.length; S++) {
        var A = b[S];
        if (typeof A != "function")
          return a(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + _(A) + " at index " + S + "."
          ), s;
      }
      function T(N, V, F, W, z) {
        for (var H = [], Q = 0; Q < b.length; Q++) {
          var se = b[Q], I = se(N, V, F, W, z, n);
          if (I == null)
            return null;
          I.data && r(I.data, "expectedType") && H.push(I.data.expectedType);
        }
        var ue = H.length > 0 ? ", expected one of type [" + H.join(", ") + "]" : "";
        return new h("Invalid " + W + " `" + z + "` supplied to " + ("`" + F + "`" + ue + "."));
      }
      return g(T);
    }
    function Y() {
      function b(S, A, T, N, V) {
        return q(S[A]) ? null : new h("Invalid " + N + " `" + V + "` supplied to " + ("`" + T + "`, expected a ReactNode."));
      }
      return g(b);
    }
    function U(b, S, A, T, N) {
      return new h(
        (b || "React class") + ": " + S + " type `" + A + "." + T + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + N + "`."
      );
    }
    function J(b) {
      function S(A, T, N, V, F) {
        var W = A[T], z = j(W);
        if (z !== "object")
          return new h("Invalid " + V + " `" + F + "` of type `" + z + "` " + ("supplied to `" + N + "`, expected `object`."));
        for (var H in b) {
          var Q = b[H];
          if (typeof Q != "function")
            return U(N, V, F, H, K(Q));
          var se = Q(W, H, N, V, F + "." + H, n);
          if (se)
            return se;
        }
        return null;
      }
      return g(S);
    }
    function ee(b) {
      function S(A, T, N, V, F) {
        var W = A[T], z = j(W);
        if (z !== "object")
          return new h("Invalid " + V + " `" + F + "` of type `" + z + "` " + ("supplied to `" + N + "`, expected `object`."));
        var H = t({}, A[T], b);
        for (var Q in H) {
          var se = b[Q];
          if (r(b, Q) && typeof se != "function")
            return U(N, V, F, Q, K(se));
          if (!se)
            return new h(
              "Invalid " + V + " `" + F + "` key `" + Q + "` supplied to `" + N + "`.\nBad object: " + JSON.stringify(A[T], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(b), null, "  ")
            );
          var I = se(W, Q, N, V, F + "." + Q, n);
          if (I)
            return I;
        }
        return null;
      }
      return g(S);
    }
    function q(b) {
      switch (typeof b) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !b;
        case "object":
          if (Array.isArray(b))
            return b.every(q);
          if (b === null || i(b))
            return !0;
          var S = c(b);
          if (S) {
            var A = S.call(b), T;
            if (S !== b.entries) {
              for (; !(T = A.next()).done; )
                if (!q(T.value))
                  return !1;
            } else
              for (; !(T = A.next()).done; ) {
                var N = T.value;
                if (N && !q(N[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(b, S) {
      return b === "symbol" ? !0 : S ? S["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && S instanceof Symbol : !1;
    }
    function j(b) {
      var S = typeof b;
      return Array.isArray(b) ? "array" : b instanceof RegExp ? "object" : G(S, b) ? "symbol" : S;
    }
    function K(b) {
      if (typeof b > "u" || b === null)
        return "" + b;
      var S = j(b);
      if (S === "object") {
        if (b instanceof Date)
          return "date";
        if (b instanceof RegExp)
          return "regexp";
      }
      return S;
    }
    function _(b) {
      var S = K(b);
      switch (S) {
        case "array":
        case "object":
          return "an " + S;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + S;
        default:
          return S;
      }
    }
    function R(b) {
      return !b.constructor || !b.constructor.name ? f : b.constructor.name;
    }
    return m.checkPropTypes = o, m.resetWarningCache = o.resetWarningCache, m.PropTypes = m, m;
  }, fo;
}
var po, _i;
function sw() {
  if (_i) return po;
  _i = 1;
  var e = /* @__PURE__ */ ya();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, po = function() {
    function r(s, i, d, l, u, c) {
      if (c !== e) {
        var f = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw f.name = "Invariant Violation", f;
      }
    }
    r.isRequired = r;
    function o() {
      return r;
    }
    var a = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: o,
      element: r,
      elementType: r,
      instanceOf: o,
      node: r,
      objectOf: o,
      oneOf: o,
      oneOfType: o,
      shape: o,
      exact: o,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return a.PropTypes = a, a;
  }, po;
}
var Ti;
function cw() {
  if (Ti) return lr.exports;
  if (Ti = 1, process.env.NODE_ENV !== "production") {
    var e = Sd(), t = !0;
    lr.exports = /* @__PURE__ */ iw()(e.isElement, t);
  } else
    lr.exports = /* @__PURE__ */ sw()();
  return lr.exports;
}
var lw = /* @__PURE__ */ cw();
const he = /* @__PURE__ */ Ui(lw), dw = /* @__PURE__ */ new Map([
  // https://github.com/guzzle/psr7/blob/2d9260799e713f1c475d3c5fdc3d6561ff7441b2/src/MimeType.php
  ["1km", "application/vnd.1000minds.decision-model+xml"],
  ["3dml", "text/vnd.in3d.3dml"],
  ["3ds", "image/x-3ds"],
  ["3g2", "video/3gpp2"],
  ["3gp", "video/3gp"],
  ["3gpp", "video/3gpp"],
  ["3mf", "model/3mf"],
  ["7z", "application/x-7z-compressed"],
  ["7zip", "application/x-7z-compressed"],
  ["123", "application/vnd.lotus-1-2-3"],
  ["aab", "application/x-authorware-bin"],
  ["aac", "audio/x-acc"],
  ["aam", "application/x-authorware-map"],
  ["aas", "application/x-authorware-seg"],
  ["abw", "application/x-abiword"],
  ["ac", "application/vnd.nokia.n-gage.ac+xml"],
  ["ac3", "audio/ac3"],
  ["acc", "application/vnd.americandynamics.acc"],
  ["ace", "application/x-ace-compressed"],
  ["acu", "application/vnd.acucobol"],
  ["acutc", "application/vnd.acucorp"],
  ["adp", "audio/adpcm"],
  ["aep", "application/vnd.audiograph"],
  ["afm", "application/x-font-type1"],
  ["afp", "application/vnd.ibm.modcap"],
  ["ahead", "application/vnd.ahead.space"],
  ["ai", "application/pdf"],
  ["aif", "audio/x-aiff"],
  ["aifc", "audio/x-aiff"],
  ["aiff", "audio/x-aiff"],
  ["air", "application/vnd.adobe.air-application-installer-package+zip"],
  ["ait", "application/vnd.dvb.ait"],
  ["ami", "application/vnd.amiga.ami"],
  ["amr", "audio/amr"],
  ["apk", "application/vnd.android.package-archive"],
  ["apng", "image/apng"],
  ["appcache", "text/cache-manifest"],
  ["application", "application/x-ms-application"],
  ["apr", "application/vnd.lotus-approach"],
  ["arc", "application/x-freearc"],
  ["arj", "application/x-arj"],
  ["asc", "application/pgp-signature"],
  ["asf", "video/x-ms-asf"],
  ["asm", "text/x-asm"],
  ["aso", "application/vnd.accpac.simply.aso"],
  ["asx", "video/x-ms-asf"],
  ["atc", "application/vnd.acucorp"],
  ["atom", "application/atom+xml"],
  ["atomcat", "application/atomcat+xml"],
  ["atomdeleted", "application/atomdeleted+xml"],
  ["atomsvc", "application/atomsvc+xml"],
  ["atx", "application/vnd.antix.game-component"],
  ["au", "audio/x-au"],
  ["avi", "video/x-msvideo"],
  ["avif", "image/avif"],
  ["aw", "application/applixware"],
  ["azf", "application/vnd.airzip.filesecure.azf"],
  ["azs", "application/vnd.airzip.filesecure.azs"],
  ["azv", "image/vnd.airzip.accelerator.azv"],
  ["azw", "application/vnd.amazon.ebook"],
  ["b16", "image/vnd.pco.b16"],
  ["bat", "application/x-msdownload"],
  ["bcpio", "application/x-bcpio"],
  ["bdf", "application/x-font-bdf"],
  ["bdm", "application/vnd.syncml.dm+wbxml"],
  ["bdoc", "application/x-bdoc"],
  ["bed", "application/vnd.realvnc.bed"],
  ["bh2", "application/vnd.fujitsu.oasysprs"],
  ["bin", "application/octet-stream"],
  ["blb", "application/x-blorb"],
  ["blorb", "application/x-blorb"],
  ["bmi", "application/vnd.bmi"],
  ["bmml", "application/vnd.balsamiq.bmml+xml"],
  ["bmp", "image/bmp"],
  ["book", "application/vnd.framemaker"],
  ["box", "application/vnd.previewsystems.box"],
  ["boz", "application/x-bzip2"],
  ["bpk", "application/octet-stream"],
  ["bpmn", "application/octet-stream"],
  ["bsp", "model/vnd.valve.source.compiled-map"],
  ["btif", "image/prs.btif"],
  ["buffer", "application/octet-stream"],
  ["bz", "application/x-bzip"],
  ["bz2", "application/x-bzip2"],
  ["c", "text/x-c"],
  ["c4d", "application/vnd.clonk.c4group"],
  ["c4f", "application/vnd.clonk.c4group"],
  ["c4g", "application/vnd.clonk.c4group"],
  ["c4p", "application/vnd.clonk.c4group"],
  ["c4u", "application/vnd.clonk.c4group"],
  ["c11amc", "application/vnd.cluetrust.cartomobile-config"],
  ["c11amz", "application/vnd.cluetrust.cartomobile-config-pkg"],
  ["cab", "application/vnd.ms-cab-compressed"],
  ["caf", "audio/x-caf"],
  ["cap", "application/vnd.tcpdump.pcap"],
  ["car", "application/vnd.curl.car"],
  ["cat", "application/vnd.ms-pki.seccat"],
  ["cb7", "application/x-cbr"],
  ["cba", "application/x-cbr"],
  ["cbr", "application/x-cbr"],
  ["cbt", "application/x-cbr"],
  ["cbz", "application/x-cbr"],
  ["cc", "text/x-c"],
  ["cco", "application/x-cocoa"],
  ["cct", "application/x-director"],
  ["ccxml", "application/ccxml+xml"],
  ["cdbcmsg", "application/vnd.contact.cmsg"],
  ["cda", "application/x-cdf"],
  ["cdf", "application/x-netcdf"],
  ["cdfx", "application/cdfx+xml"],
  ["cdkey", "application/vnd.mediastation.cdkey"],
  ["cdmia", "application/cdmi-capability"],
  ["cdmic", "application/cdmi-container"],
  ["cdmid", "application/cdmi-domain"],
  ["cdmio", "application/cdmi-object"],
  ["cdmiq", "application/cdmi-queue"],
  ["cdr", "application/cdr"],
  ["cdx", "chemical/x-cdx"],
  ["cdxml", "application/vnd.chemdraw+xml"],
  ["cdy", "application/vnd.cinderella"],
  ["cer", "application/pkix-cert"],
  ["cfs", "application/x-cfs-compressed"],
  ["cgm", "image/cgm"],
  ["chat", "application/x-chat"],
  ["chm", "application/vnd.ms-htmlhelp"],
  ["chrt", "application/vnd.kde.kchart"],
  ["cif", "chemical/x-cif"],
  ["cii", "application/vnd.anser-web-certificate-issue-initiation"],
  ["cil", "application/vnd.ms-artgalry"],
  ["cjs", "application/node"],
  ["cla", "application/vnd.claymore"],
  ["class", "application/octet-stream"],
  ["clkk", "application/vnd.crick.clicker.keyboard"],
  ["clkp", "application/vnd.crick.clicker.palette"],
  ["clkt", "application/vnd.crick.clicker.template"],
  ["clkw", "application/vnd.crick.clicker.wordbank"],
  ["clkx", "application/vnd.crick.clicker"],
  ["clp", "application/x-msclip"],
  ["cmc", "application/vnd.cosmocaller"],
  ["cmdf", "chemical/x-cmdf"],
  ["cml", "chemical/x-cml"],
  ["cmp", "application/vnd.yellowriver-custom-menu"],
  ["cmx", "image/x-cmx"],
  ["cod", "application/vnd.rim.cod"],
  ["coffee", "text/coffeescript"],
  ["com", "application/x-msdownload"],
  ["conf", "text/plain"],
  ["cpio", "application/x-cpio"],
  ["cpp", "text/x-c"],
  ["cpt", "application/mac-compactpro"],
  ["crd", "application/x-mscardfile"],
  ["crl", "application/pkix-crl"],
  ["crt", "application/x-x509-ca-cert"],
  ["crx", "application/x-chrome-extension"],
  ["cryptonote", "application/vnd.rig.cryptonote"],
  ["csh", "application/x-csh"],
  ["csl", "application/vnd.citationstyles.style+xml"],
  ["csml", "chemical/x-csml"],
  ["csp", "application/vnd.commonspace"],
  ["csr", "application/octet-stream"],
  ["css", "text/css"],
  ["cst", "application/x-director"],
  ["csv", "text/csv"],
  ["cu", "application/cu-seeme"],
  ["curl", "text/vnd.curl"],
  ["cww", "application/prs.cww"],
  ["cxt", "application/x-director"],
  ["cxx", "text/x-c"],
  ["dae", "model/vnd.collada+xml"],
  ["daf", "application/vnd.mobius.daf"],
  ["dart", "application/vnd.dart"],
  ["dataless", "application/vnd.fdsn.seed"],
  ["davmount", "application/davmount+xml"],
  ["dbf", "application/vnd.dbf"],
  ["dbk", "application/docbook+xml"],
  ["dcr", "application/x-director"],
  ["dcurl", "text/vnd.curl.dcurl"],
  ["dd2", "application/vnd.oma.dd2+xml"],
  ["ddd", "application/vnd.fujixerox.ddd"],
  ["ddf", "application/vnd.syncml.dmddf+xml"],
  ["dds", "image/vnd.ms-dds"],
  ["deb", "application/x-debian-package"],
  ["def", "text/plain"],
  ["deploy", "application/octet-stream"],
  ["der", "application/x-x509-ca-cert"],
  ["dfac", "application/vnd.dreamfactory"],
  ["dgc", "application/x-dgc-compressed"],
  ["dic", "text/x-c"],
  ["dir", "application/x-director"],
  ["dis", "application/vnd.mobius.dis"],
  ["disposition-notification", "message/disposition-notification"],
  ["dist", "application/octet-stream"],
  ["distz", "application/octet-stream"],
  ["djv", "image/vnd.djvu"],
  ["djvu", "image/vnd.djvu"],
  ["dll", "application/octet-stream"],
  ["dmg", "application/x-apple-diskimage"],
  ["dmn", "application/octet-stream"],
  ["dmp", "application/vnd.tcpdump.pcap"],
  ["dms", "application/octet-stream"],
  ["dna", "application/vnd.dna"],
  ["doc", "application/msword"],
  ["docm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["docx", "application/vnd.openxmlformats-officedocument.wordprocessingml.document"],
  ["dot", "application/msword"],
  ["dotm", "application/vnd.ms-word.template.macroEnabled.12"],
  ["dotx", "application/vnd.openxmlformats-officedocument.wordprocessingml.template"],
  ["dp", "application/vnd.osgi.dp"],
  ["dpg", "application/vnd.dpgraph"],
  ["dra", "audio/vnd.dra"],
  ["drle", "image/dicom-rle"],
  ["dsc", "text/prs.lines.tag"],
  ["dssc", "application/dssc+der"],
  ["dtb", "application/x-dtbook+xml"],
  ["dtd", "application/xml-dtd"],
  ["dts", "audio/vnd.dts"],
  ["dtshd", "audio/vnd.dts.hd"],
  ["dump", "application/octet-stream"],
  ["dvb", "video/vnd.dvb.file"],
  ["dvi", "application/x-dvi"],
  ["dwd", "application/atsc-dwd+xml"],
  ["dwf", "model/vnd.dwf"],
  ["dwg", "image/vnd.dwg"],
  ["dxf", "image/vnd.dxf"],
  ["dxp", "application/vnd.spotfire.dxp"],
  ["dxr", "application/x-director"],
  ["ear", "application/java-archive"],
  ["ecelp4800", "audio/vnd.nuera.ecelp4800"],
  ["ecelp7470", "audio/vnd.nuera.ecelp7470"],
  ["ecelp9600", "audio/vnd.nuera.ecelp9600"],
  ["ecma", "application/ecmascript"],
  ["edm", "application/vnd.novadigm.edm"],
  ["edx", "application/vnd.novadigm.edx"],
  ["efif", "application/vnd.picsel"],
  ["ei6", "application/vnd.pg.osasli"],
  ["elc", "application/octet-stream"],
  ["emf", "image/emf"],
  ["eml", "message/rfc822"],
  ["emma", "application/emma+xml"],
  ["emotionml", "application/emotionml+xml"],
  ["emz", "application/x-msmetafile"],
  ["eol", "audio/vnd.digital-winds"],
  ["eot", "application/vnd.ms-fontobject"],
  ["eps", "application/postscript"],
  ["epub", "application/epub+zip"],
  ["es", "application/ecmascript"],
  ["es3", "application/vnd.eszigno3+xml"],
  ["esa", "application/vnd.osgi.subsystem"],
  ["esf", "application/vnd.epson.esf"],
  ["et3", "application/vnd.eszigno3+xml"],
  ["etx", "text/x-setext"],
  ["eva", "application/x-eva"],
  ["evy", "application/x-envoy"],
  ["exe", "application/octet-stream"],
  ["exi", "application/exi"],
  ["exp", "application/express"],
  ["exr", "image/aces"],
  ["ext", "application/vnd.novadigm.ext"],
  ["ez", "application/andrew-inset"],
  ["ez2", "application/vnd.ezpix-album"],
  ["ez3", "application/vnd.ezpix-package"],
  ["f", "text/x-fortran"],
  ["f4v", "video/mp4"],
  ["f77", "text/x-fortran"],
  ["f90", "text/x-fortran"],
  ["fbs", "image/vnd.fastbidsheet"],
  ["fcdt", "application/vnd.adobe.formscentral.fcdt"],
  ["fcs", "application/vnd.isac.fcs"],
  ["fdf", "application/vnd.fdf"],
  ["fdt", "application/fdt+xml"],
  ["fe_launch", "application/vnd.denovo.fcselayout-link"],
  ["fg5", "application/vnd.fujitsu.oasysgp"],
  ["fgd", "application/x-director"],
  ["fh", "image/x-freehand"],
  ["fh4", "image/x-freehand"],
  ["fh5", "image/x-freehand"],
  ["fh7", "image/x-freehand"],
  ["fhc", "image/x-freehand"],
  ["fig", "application/x-xfig"],
  ["fits", "image/fits"],
  ["flac", "audio/x-flac"],
  ["fli", "video/x-fli"],
  ["flo", "application/vnd.micrografx.flo"],
  ["flv", "video/x-flv"],
  ["flw", "application/vnd.kde.kivio"],
  ["flx", "text/vnd.fmi.flexstor"],
  ["fly", "text/vnd.fly"],
  ["fm", "application/vnd.framemaker"],
  ["fnc", "application/vnd.frogans.fnc"],
  ["fo", "application/vnd.software602.filler.form+xml"],
  ["for", "text/x-fortran"],
  ["fpx", "image/vnd.fpx"],
  ["frame", "application/vnd.framemaker"],
  ["fsc", "application/vnd.fsc.weblaunch"],
  ["fst", "image/vnd.fst"],
  ["ftc", "application/vnd.fluxtime.clip"],
  ["fti", "application/vnd.anser-web-funds-transfer-initiation"],
  ["fvt", "video/vnd.fvt"],
  ["fxp", "application/vnd.adobe.fxp"],
  ["fxpl", "application/vnd.adobe.fxp"],
  ["fzs", "application/vnd.fuzzysheet"],
  ["g2w", "application/vnd.geoplan"],
  ["g3", "image/g3fax"],
  ["g3w", "application/vnd.geospace"],
  ["gac", "application/vnd.groove-account"],
  ["gam", "application/x-tads"],
  ["gbr", "application/rpki-ghostbusters"],
  ["gca", "application/x-gca-compressed"],
  ["gdl", "model/vnd.gdl"],
  ["gdoc", "application/vnd.google-apps.document"],
  ["geo", "application/vnd.dynageo"],
  ["geojson", "application/geo+json"],
  ["gex", "application/vnd.geometry-explorer"],
  ["ggb", "application/vnd.geogebra.file"],
  ["ggt", "application/vnd.geogebra.tool"],
  ["ghf", "application/vnd.groove-help"],
  ["gif", "image/gif"],
  ["gim", "application/vnd.groove-identity-message"],
  ["glb", "model/gltf-binary"],
  ["gltf", "model/gltf+json"],
  ["gml", "application/gml+xml"],
  ["gmx", "application/vnd.gmx"],
  ["gnumeric", "application/x-gnumeric"],
  ["gpg", "application/gpg-keys"],
  ["gph", "application/vnd.flographit"],
  ["gpx", "application/gpx+xml"],
  ["gqf", "application/vnd.grafeq"],
  ["gqs", "application/vnd.grafeq"],
  ["gram", "application/srgs"],
  ["gramps", "application/x-gramps-xml"],
  ["gre", "application/vnd.geometry-explorer"],
  ["grv", "application/vnd.groove-injector"],
  ["grxml", "application/srgs+xml"],
  ["gsf", "application/x-font-ghostscript"],
  ["gsheet", "application/vnd.google-apps.spreadsheet"],
  ["gslides", "application/vnd.google-apps.presentation"],
  ["gtar", "application/x-gtar"],
  ["gtm", "application/vnd.groove-tool-message"],
  ["gtw", "model/vnd.gtw"],
  ["gv", "text/vnd.graphviz"],
  ["gxf", "application/gxf"],
  ["gxt", "application/vnd.geonext"],
  ["gz", "application/gzip"],
  ["gzip", "application/gzip"],
  ["h", "text/x-c"],
  ["h261", "video/h261"],
  ["h263", "video/h263"],
  ["h264", "video/h264"],
  ["hal", "application/vnd.hal+xml"],
  ["hbci", "application/vnd.hbci"],
  ["hbs", "text/x-handlebars-template"],
  ["hdd", "application/x-virtualbox-hdd"],
  ["hdf", "application/x-hdf"],
  ["heic", "image/heic"],
  ["heics", "image/heic-sequence"],
  ["heif", "image/heif"],
  ["heifs", "image/heif-sequence"],
  ["hej2", "image/hej2k"],
  ["held", "application/atsc-held+xml"],
  ["hh", "text/x-c"],
  ["hjson", "application/hjson"],
  ["hlp", "application/winhlp"],
  ["hpgl", "application/vnd.hp-hpgl"],
  ["hpid", "application/vnd.hp-hpid"],
  ["hps", "application/vnd.hp-hps"],
  ["hqx", "application/mac-binhex40"],
  ["hsj2", "image/hsj2"],
  ["htc", "text/x-component"],
  ["htke", "application/vnd.kenameaapp"],
  ["htm", "text/html"],
  ["html", "text/html"],
  ["hvd", "application/vnd.yamaha.hv-dic"],
  ["hvp", "application/vnd.yamaha.hv-voice"],
  ["hvs", "application/vnd.yamaha.hv-script"],
  ["i2g", "application/vnd.intergeo"],
  ["icc", "application/vnd.iccprofile"],
  ["ice", "x-conference/x-cooltalk"],
  ["icm", "application/vnd.iccprofile"],
  ["ico", "image/x-icon"],
  ["ics", "text/calendar"],
  ["ief", "image/ief"],
  ["ifb", "text/calendar"],
  ["ifm", "application/vnd.shana.informed.formdata"],
  ["iges", "model/iges"],
  ["igl", "application/vnd.igloader"],
  ["igm", "application/vnd.insors.igm"],
  ["igs", "model/iges"],
  ["igx", "application/vnd.micrografx.igx"],
  ["iif", "application/vnd.shana.informed.interchange"],
  ["img", "application/octet-stream"],
  ["imp", "application/vnd.accpac.simply.imp"],
  ["ims", "application/vnd.ms-ims"],
  ["in", "text/plain"],
  ["ini", "text/plain"],
  ["ink", "application/inkml+xml"],
  ["inkml", "application/inkml+xml"],
  ["install", "application/x-install-instructions"],
  ["iota", "application/vnd.astraea-software.iota"],
  ["ipfix", "application/ipfix"],
  ["ipk", "application/vnd.shana.informed.package"],
  ["irm", "application/vnd.ibm.rights-management"],
  ["irp", "application/vnd.irepository.package+xml"],
  ["iso", "application/x-iso9660-image"],
  ["itp", "application/vnd.shana.informed.formtemplate"],
  ["its", "application/its+xml"],
  ["ivp", "application/vnd.immervision-ivp"],
  ["ivu", "application/vnd.immervision-ivu"],
  ["jad", "text/vnd.sun.j2me.app-descriptor"],
  ["jade", "text/jade"],
  ["jam", "application/vnd.jam"],
  ["jar", "application/java-archive"],
  ["jardiff", "application/x-java-archive-diff"],
  ["java", "text/x-java-source"],
  ["jhc", "image/jphc"],
  ["jisp", "application/vnd.jisp"],
  ["jls", "image/jls"],
  ["jlt", "application/vnd.hp-jlyt"],
  ["jng", "image/x-jng"],
  ["jnlp", "application/x-java-jnlp-file"],
  ["joda", "application/vnd.joost.joda-archive"],
  ["jp2", "image/jp2"],
  ["jpe", "image/jpeg"],
  ["jpeg", "image/jpeg"],
  ["jpf", "image/jpx"],
  ["jpg", "image/jpeg"],
  ["jpg2", "image/jp2"],
  ["jpgm", "video/jpm"],
  ["jpgv", "video/jpeg"],
  ["jph", "image/jph"],
  ["jpm", "video/jpm"],
  ["jpx", "image/jpx"],
  ["js", "application/javascript"],
  ["json", "application/json"],
  ["json5", "application/json5"],
  ["jsonld", "application/ld+json"],
  // https://jsonlines.org/
  ["jsonl", "application/jsonl"],
  ["jsonml", "application/jsonml+json"],
  ["jsx", "text/jsx"],
  ["jxr", "image/jxr"],
  ["jxra", "image/jxra"],
  ["jxrs", "image/jxrs"],
  ["jxs", "image/jxs"],
  ["jxsc", "image/jxsc"],
  ["jxsi", "image/jxsi"],
  ["jxss", "image/jxss"],
  ["kar", "audio/midi"],
  ["karbon", "application/vnd.kde.karbon"],
  ["kdb", "application/octet-stream"],
  ["kdbx", "application/x-keepass2"],
  ["key", "application/x-iwork-keynote-sffkey"],
  ["kfo", "application/vnd.kde.kformula"],
  ["kia", "application/vnd.kidspiration"],
  ["kml", "application/vnd.google-earth.kml+xml"],
  ["kmz", "application/vnd.google-earth.kmz"],
  ["kne", "application/vnd.kinar"],
  ["knp", "application/vnd.kinar"],
  ["kon", "application/vnd.kde.kontour"],
  ["kpr", "application/vnd.kde.kpresenter"],
  ["kpt", "application/vnd.kde.kpresenter"],
  ["kpxx", "application/vnd.ds-keypoint"],
  ["ksp", "application/vnd.kde.kspread"],
  ["ktr", "application/vnd.kahootz"],
  ["ktx", "image/ktx"],
  ["ktx2", "image/ktx2"],
  ["ktz", "application/vnd.kahootz"],
  ["kwd", "application/vnd.kde.kword"],
  ["kwt", "application/vnd.kde.kword"],
  ["lasxml", "application/vnd.las.las+xml"],
  ["latex", "application/x-latex"],
  ["lbd", "application/vnd.llamagraphics.life-balance.desktop"],
  ["lbe", "application/vnd.llamagraphics.life-balance.exchange+xml"],
  ["les", "application/vnd.hhe.lesson-player"],
  ["less", "text/less"],
  ["lgr", "application/lgr+xml"],
  ["lha", "application/octet-stream"],
  ["link66", "application/vnd.route66.link66+xml"],
  ["list", "text/plain"],
  ["list3820", "application/vnd.ibm.modcap"],
  ["listafp", "application/vnd.ibm.modcap"],
  ["litcoffee", "text/coffeescript"],
  ["lnk", "application/x-ms-shortcut"],
  ["log", "text/plain"],
  ["lostxml", "application/lost+xml"],
  ["lrf", "application/octet-stream"],
  ["lrm", "application/vnd.ms-lrm"],
  ["ltf", "application/vnd.frogans.ltf"],
  ["lua", "text/x-lua"],
  ["luac", "application/x-lua-bytecode"],
  ["lvp", "audio/vnd.lucent.voice"],
  ["lwp", "application/vnd.lotus-wordpro"],
  ["lzh", "application/octet-stream"],
  ["m1v", "video/mpeg"],
  ["m2a", "audio/mpeg"],
  ["m2v", "video/mpeg"],
  ["m3a", "audio/mpeg"],
  ["m3u", "text/plain"],
  ["m3u8", "application/vnd.apple.mpegurl"],
  ["m4a", "audio/x-m4a"],
  ["m4p", "application/mp4"],
  ["m4s", "video/iso.segment"],
  ["m4u", "application/vnd.mpegurl"],
  ["m4v", "video/x-m4v"],
  ["m13", "application/x-msmediaview"],
  ["m14", "application/x-msmediaview"],
  ["m21", "application/mp21"],
  ["ma", "application/mathematica"],
  ["mads", "application/mads+xml"],
  ["maei", "application/mmt-aei+xml"],
  ["mag", "application/vnd.ecowin.chart"],
  ["maker", "application/vnd.framemaker"],
  ["man", "text/troff"],
  ["manifest", "text/cache-manifest"],
  ["map", "application/json"],
  ["mar", "application/octet-stream"],
  ["markdown", "text/markdown"],
  ["mathml", "application/mathml+xml"],
  ["mb", "application/mathematica"],
  ["mbk", "application/vnd.mobius.mbk"],
  ["mbox", "application/mbox"],
  ["mc1", "application/vnd.medcalcdata"],
  ["mcd", "application/vnd.mcd"],
  ["mcurl", "text/vnd.curl.mcurl"],
  ["md", "text/markdown"],
  ["mdb", "application/x-msaccess"],
  ["mdi", "image/vnd.ms-modi"],
  ["mdx", "text/mdx"],
  ["me", "text/troff"],
  ["mesh", "model/mesh"],
  ["meta4", "application/metalink4+xml"],
  ["metalink", "application/metalink+xml"],
  ["mets", "application/mets+xml"],
  ["mfm", "application/vnd.mfmp"],
  ["mft", "application/rpki-manifest"],
  ["mgp", "application/vnd.osgeo.mapguide.package"],
  ["mgz", "application/vnd.proteus.magazine"],
  ["mid", "audio/midi"],
  ["midi", "audio/midi"],
  ["mie", "application/x-mie"],
  ["mif", "application/vnd.mif"],
  ["mime", "message/rfc822"],
  ["mj2", "video/mj2"],
  ["mjp2", "video/mj2"],
  ["mjs", "application/javascript"],
  ["mk3d", "video/x-matroska"],
  ["mka", "audio/x-matroska"],
  ["mkd", "text/x-markdown"],
  ["mks", "video/x-matroska"],
  ["mkv", "video/x-matroska"],
  ["mlp", "application/vnd.dolby.mlp"],
  ["mmd", "application/vnd.chipnuts.karaoke-mmd"],
  ["mmf", "application/vnd.smaf"],
  ["mml", "text/mathml"],
  ["mmr", "image/vnd.fujixerox.edmics-mmr"],
  ["mng", "video/x-mng"],
  ["mny", "application/x-msmoney"],
  ["mobi", "application/x-mobipocket-ebook"],
  ["mods", "application/mods+xml"],
  ["mov", "video/quicktime"],
  ["movie", "video/x-sgi-movie"],
  ["mp2", "audio/mpeg"],
  ["mp2a", "audio/mpeg"],
  ["mp3", "audio/mpeg"],
  ["mp4", "video/mp4"],
  ["mp4a", "audio/mp4"],
  ["mp4s", "application/mp4"],
  ["mp4v", "video/mp4"],
  ["mp21", "application/mp21"],
  ["mpc", "application/vnd.mophun.certificate"],
  ["mpd", "application/dash+xml"],
  ["mpe", "video/mpeg"],
  ["mpeg", "video/mpeg"],
  ["mpg", "video/mpeg"],
  ["mpg4", "video/mp4"],
  ["mpga", "audio/mpeg"],
  ["mpkg", "application/vnd.apple.installer+xml"],
  ["mpm", "application/vnd.blueice.multipass"],
  ["mpn", "application/vnd.mophun.application"],
  ["mpp", "application/vnd.ms-project"],
  ["mpt", "application/vnd.ms-project"],
  ["mpy", "application/vnd.ibm.minipay"],
  ["mqy", "application/vnd.mobius.mqy"],
  ["mrc", "application/marc"],
  ["mrcx", "application/marcxml+xml"],
  ["ms", "text/troff"],
  ["mscml", "application/mediaservercontrol+xml"],
  ["mseed", "application/vnd.fdsn.mseed"],
  ["mseq", "application/vnd.mseq"],
  ["msf", "application/vnd.epson.msf"],
  ["msg", "application/vnd.ms-outlook"],
  ["msh", "model/mesh"],
  ["msi", "application/x-msdownload"],
  ["msl", "application/vnd.mobius.msl"],
  ["msm", "application/octet-stream"],
  ["msp", "application/octet-stream"],
  ["msty", "application/vnd.muvee.style"],
  ["mtl", "model/mtl"],
  ["mts", "model/vnd.mts"],
  ["mus", "application/vnd.musician"],
  ["musd", "application/mmt-usd+xml"],
  ["musicxml", "application/vnd.recordare.musicxml+xml"],
  ["mvb", "application/x-msmediaview"],
  ["mvt", "application/vnd.mapbox-vector-tile"],
  ["mwf", "application/vnd.mfer"],
  ["mxf", "application/mxf"],
  ["mxl", "application/vnd.recordare.musicxml"],
  ["mxmf", "audio/mobile-xmf"],
  ["mxml", "application/xv+xml"],
  ["mxs", "application/vnd.triscape.mxs"],
  ["mxu", "video/vnd.mpegurl"],
  ["n-gage", "application/vnd.nokia.n-gage.symbian.install"],
  ["n3", "text/n3"],
  ["nb", "application/mathematica"],
  ["nbp", "application/vnd.wolfram.player"],
  ["nc", "application/x-netcdf"],
  ["ncx", "application/x-dtbncx+xml"],
  ["nfo", "text/x-nfo"],
  ["ngdat", "application/vnd.nokia.n-gage.data"],
  ["nitf", "application/vnd.nitf"],
  ["nlu", "application/vnd.neurolanguage.nlu"],
  ["nml", "application/vnd.enliven"],
  ["nnd", "application/vnd.noblenet-directory"],
  ["nns", "application/vnd.noblenet-sealer"],
  ["nnw", "application/vnd.noblenet-web"],
  ["npx", "image/vnd.net-fpx"],
  ["nq", "application/n-quads"],
  ["nsc", "application/x-conference"],
  ["nsf", "application/vnd.lotus-notes"],
  ["nt", "application/n-triples"],
  ["ntf", "application/vnd.nitf"],
  ["numbers", "application/x-iwork-numbers-sffnumbers"],
  ["nzb", "application/x-nzb"],
  ["oa2", "application/vnd.fujitsu.oasys2"],
  ["oa3", "application/vnd.fujitsu.oasys3"],
  ["oas", "application/vnd.fujitsu.oasys"],
  ["obd", "application/x-msbinder"],
  ["obgx", "application/vnd.openblox.game+xml"],
  ["obj", "model/obj"],
  ["oda", "application/oda"],
  ["odb", "application/vnd.oasis.opendocument.database"],
  ["odc", "application/vnd.oasis.opendocument.chart"],
  ["odf", "application/vnd.oasis.opendocument.formula"],
  ["odft", "application/vnd.oasis.opendocument.formula-template"],
  ["odg", "application/vnd.oasis.opendocument.graphics"],
  ["odi", "application/vnd.oasis.opendocument.image"],
  ["odm", "application/vnd.oasis.opendocument.text-master"],
  ["odp", "application/vnd.oasis.opendocument.presentation"],
  ["ods", "application/vnd.oasis.opendocument.spreadsheet"],
  ["odt", "application/vnd.oasis.opendocument.text"],
  ["oga", "audio/ogg"],
  ["ogex", "model/vnd.opengex"],
  ["ogg", "audio/ogg"],
  ["ogv", "video/ogg"],
  ["ogx", "application/ogg"],
  ["omdoc", "application/omdoc+xml"],
  ["onepkg", "application/onenote"],
  ["onetmp", "application/onenote"],
  ["onetoc", "application/onenote"],
  ["onetoc2", "application/onenote"],
  ["opf", "application/oebps-package+xml"],
  ["opml", "text/x-opml"],
  ["oprc", "application/vnd.palm"],
  ["opus", "audio/ogg"],
  ["org", "text/x-org"],
  ["osf", "application/vnd.yamaha.openscoreformat"],
  ["osfpvg", "application/vnd.yamaha.openscoreformat.osfpvg+xml"],
  ["osm", "application/vnd.openstreetmap.data+xml"],
  ["otc", "application/vnd.oasis.opendocument.chart-template"],
  ["otf", "font/otf"],
  ["otg", "application/vnd.oasis.opendocument.graphics-template"],
  ["oth", "application/vnd.oasis.opendocument.text-web"],
  ["oti", "application/vnd.oasis.opendocument.image-template"],
  ["otp", "application/vnd.oasis.opendocument.presentation-template"],
  ["ots", "application/vnd.oasis.opendocument.spreadsheet-template"],
  ["ott", "application/vnd.oasis.opendocument.text-template"],
  ["ova", "application/x-virtualbox-ova"],
  ["ovf", "application/x-virtualbox-ovf"],
  ["owl", "application/rdf+xml"],
  ["oxps", "application/oxps"],
  ["oxt", "application/vnd.openofficeorg.extension"],
  ["p", "text/x-pascal"],
  ["p7a", "application/x-pkcs7-signature"],
  ["p7b", "application/x-pkcs7-certificates"],
  ["p7c", "application/pkcs7-mime"],
  ["p7m", "application/pkcs7-mime"],
  ["p7r", "application/x-pkcs7-certreqresp"],
  ["p7s", "application/pkcs7-signature"],
  ["p8", "application/pkcs8"],
  ["p10", "application/x-pkcs10"],
  ["p12", "application/x-pkcs12"],
  ["pac", "application/x-ns-proxy-autoconfig"],
  ["pages", "application/x-iwork-pages-sffpages"],
  ["pas", "text/x-pascal"],
  ["paw", "application/vnd.pawaafile"],
  ["pbd", "application/vnd.powerbuilder6"],
  ["pbm", "image/x-portable-bitmap"],
  ["pcap", "application/vnd.tcpdump.pcap"],
  ["pcf", "application/x-font-pcf"],
  ["pcl", "application/vnd.hp-pcl"],
  ["pclxl", "application/vnd.hp-pclxl"],
  ["pct", "image/x-pict"],
  ["pcurl", "application/vnd.curl.pcurl"],
  ["pcx", "image/x-pcx"],
  ["pdb", "application/x-pilot"],
  ["pde", "text/x-processing"],
  ["pdf", "application/pdf"],
  ["pem", "application/x-x509-user-cert"],
  ["pfa", "application/x-font-type1"],
  ["pfb", "application/x-font-type1"],
  ["pfm", "application/x-font-type1"],
  ["pfr", "application/font-tdpfr"],
  ["pfx", "application/x-pkcs12"],
  ["pgm", "image/x-portable-graymap"],
  ["pgn", "application/x-chess-pgn"],
  ["pgp", "application/pgp"],
  ["php", "application/x-httpd-php"],
  ["php3", "application/x-httpd-php"],
  ["php4", "application/x-httpd-php"],
  ["phps", "application/x-httpd-php-source"],
  ["phtml", "application/x-httpd-php"],
  ["pic", "image/x-pict"],
  ["pkg", "application/octet-stream"],
  ["pki", "application/pkixcmp"],
  ["pkipath", "application/pkix-pkipath"],
  ["pkpass", "application/vnd.apple.pkpass"],
  ["pl", "application/x-perl"],
  ["plb", "application/vnd.3gpp.pic-bw-large"],
  ["plc", "application/vnd.mobius.plc"],
  ["plf", "application/vnd.pocketlearn"],
  ["pls", "application/pls+xml"],
  ["pm", "application/x-perl"],
  ["pml", "application/vnd.ctc-posml"],
  ["png", "image/png"],
  ["pnm", "image/x-portable-anymap"],
  ["portpkg", "application/vnd.macports.portpkg"],
  ["pot", "application/vnd.ms-powerpoint"],
  ["potm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["potx", "application/vnd.openxmlformats-officedocument.presentationml.template"],
  ["ppa", "application/vnd.ms-powerpoint"],
  ["ppam", "application/vnd.ms-powerpoint.addin.macroEnabled.12"],
  ["ppd", "application/vnd.cups-ppd"],
  ["ppm", "image/x-portable-pixmap"],
  ["pps", "application/vnd.ms-powerpoint"],
  ["ppsm", "application/vnd.ms-powerpoint.slideshow.macroEnabled.12"],
  ["ppsx", "application/vnd.openxmlformats-officedocument.presentationml.slideshow"],
  ["ppt", "application/powerpoint"],
  ["pptm", "application/vnd.ms-powerpoint.presentation.macroEnabled.12"],
  ["pptx", "application/vnd.openxmlformats-officedocument.presentationml.presentation"],
  ["pqa", "application/vnd.palm"],
  ["prc", "application/x-pilot"],
  ["pre", "application/vnd.lotus-freelance"],
  ["prf", "application/pics-rules"],
  ["provx", "application/provenance+xml"],
  ["ps", "application/postscript"],
  ["psb", "application/vnd.3gpp.pic-bw-small"],
  ["psd", "application/x-photoshop"],
  ["psf", "application/x-font-linux-psf"],
  ["pskcxml", "application/pskc+xml"],
  ["pti", "image/prs.pti"],
  ["ptid", "application/vnd.pvi.ptid1"],
  ["pub", "application/x-mspublisher"],
  ["pvb", "application/vnd.3gpp.pic-bw-var"],
  ["pwn", "application/vnd.3m.post-it-notes"],
  ["pya", "audio/vnd.ms-playready.media.pya"],
  ["pyv", "video/vnd.ms-playready.media.pyv"],
  ["qam", "application/vnd.epson.quickanime"],
  ["qbo", "application/vnd.intu.qbo"],
  ["qfx", "application/vnd.intu.qfx"],
  ["qps", "application/vnd.publishare-delta-tree"],
  ["qt", "video/quicktime"],
  ["qwd", "application/vnd.quark.quarkxpress"],
  ["qwt", "application/vnd.quark.quarkxpress"],
  ["qxb", "application/vnd.quark.quarkxpress"],
  ["qxd", "application/vnd.quark.quarkxpress"],
  ["qxl", "application/vnd.quark.quarkxpress"],
  ["qxt", "application/vnd.quark.quarkxpress"],
  ["ra", "audio/x-realaudio"],
  ["ram", "audio/x-pn-realaudio"],
  ["raml", "application/raml+yaml"],
  ["rapd", "application/route-apd+xml"],
  ["rar", "application/x-rar"],
  ["ras", "image/x-cmu-raster"],
  ["rcprofile", "application/vnd.ipunplugged.rcprofile"],
  ["rdf", "application/rdf+xml"],
  ["rdz", "application/vnd.data-vision.rdz"],
  ["relo", "application/p2p-overlay+xml"],
  ["rep", "application/vnd.businessobjects"],
  ["res", "application/x-dtbresource+xml"],
  ["rgb", "image/x-rgb"],
  ["rif", "application/reginfo+xml"],
  ["rip", "audio/vnd.rip"],
  ["ris", "application/x-research-info-systems"],
  ["rl", "application/resource-lists+xml"],
  ["rlc", "image/vnd.fujixerox.edmics-rlc"],
  ["rld", "application/resource-lists-diff+xml"],
  ["rm", "audio/x-pn-realaudio"],
  ["rmi", "audio/midi"],
  ["rmp", "audio/x-pn-realaudio-plugin"],
  ["rms", "application/vnd.jcp.javame.midlet-rms"],
  ["rmvb", "application/vnd.rn-realmedia-vbr"],
  ["rnc", "application/relax-ng-compact-syntax"],
  ["rng", "application/xml"],
  ["roa", "application/rpki-roa"],
  ["roff", "text/troff"],
  ["rp9", "application/vnd.cloanto.rp9"],
  ["rpm", "audio/x-pn-realaudio-plugin"],
  ["rpss", "application/vnd.nokia.radio-presets"],
  ["rpst", "application/vnd.nokia.radio-preset"],
  ["rq", "application/sparql-query"],
  ["rs", "application/rls-services+xml"],
  ["rsa", "application/x-pkcs7"],
  ["rsat", "application/atsc-rsat+xml"],
  ["rsd", "application/rsd+xml"],
  ["rsheet", "application/urc-ressheet+xml"],
  ["rss", "application/rss+xml"],
  ["rtf", "text/rtf"],
  ["rtx", "text/richtext"],
  ["run", "application/x-makeself"],
  ["rusd", "application/route-usd+xml"],
  ["rv", "video/vnd.rn-realvideo"],
  ["s", "text/x-asm"],
  ["s3m", "audio/s3m"],
  ["saf", "application/vnd.yamaha.smaf-audio"],
  ["sass", "text/x-sass"],
  ["sbml", "application/sbml+xml"],
  ["sc", "application/vnd.ibm.secure-container"],
  ["scd", "application/x-msschedule"],
  ["scm", "application/vnd.lotus-screencam"],
  ["scq", "application/scvp-cv-request"],
  ["scs", "application/scvp-cv-response"],
  ["scss", "text/x-scss"],
  ["scurl", "text/vnd.curl.scurl"],
  ["sda", "application/vnd.stardivision.draw"],
  ["sdc", "application/vnd.stardivision.calc"],
  ["sdd", "application/vnd.stardivision.impress"],
  ["sdkd", "application/vnd.solent.sdkm+xml"],
  ["sdkm", "application/vnd.solent.sdkm+xml"],
  ["sdp", "application/sdp"],
  ["sdw", "application/vnd.stardivision.writer"],
  ["sea", "application/octet-stream"],
  ["see", "application/vnd.seemail"],
  ["seed", "application/vnd.fdsn.seed"],
  ["sema", "application/vnd.sema"],
  ["semd", "application/vnd.semd"],
  ["semf", "application/vnd.semf"],
  ["senmlx", "application/senml+xml"],
  ["sensmlx", "application/sensml+xml"],
  ["ser", "application/java-serialized-object"],
  ["setpay", "application/set-payment-initiation"],
  ["setreg", "application/set-registration-initiation"],
  ["sfd-hdstx", "application/vnd.hydrostatix.sof-data"],
  ["sfs", "application/vnd.spotfire.sfs"],
  ["sfv", "text/x-sfv"],
  ["sgi", "image/sgi"],
  ["sgl", "application/vnd.stardivision.writer-global"],
  ["sgm", "text/sgml"],
  ["sgml", "text/sgml"],
  ["sh", "application/x-sh"],
  ["shar", "application/x-shar"],
  ["shex", "text/shex"],
  ["shf", "application/shf+xml"],
  ["shtml", "text/html"],
  ["sid", "image/x-mrsid-image"],
  ["sieve", "application/sieve"],
  ["sig", "application/pgp-signature"],
  ["sil", "audio/silk"],
  ["silo", "model/mesh"],
  ["sis", "application/vnd.symbian.install"],
  ["sisx", "application/vnd.symbian.install"],
  ["sit", "application/x-stuffit"],
  ["sitx", "application/x-stuffitx"],
  ["siv", "application/sieve"],
  ["skd", "application/vnd.koan"],
  ["skm", "application/vnd.koan"],
  ["skp", "application/vnd.koan"],
  ["skt", "application/vnd.koan"],
  ["sldm", "application/vnd.ms-powerpoint.slide.macroenabled.12"],
  ["sldx", "application/vnd.openxmlformats-officedocument.presentationml.slide"],
  ["slim", "text/slim"],
  ["slm", "text/slim"],
  ["sls", "application/route-s-tsid+xml"],
  ["slt", "application/vnd.epson.salt"],
  ["sm", "application/vnd.stepmania.stepchart"],
  ["smf", "application/vnd.stardivision.math"],
  ["smi", "application/smil"],
  ["smil", "application/smil"],
  ["smv", "video/x-smv"],
  ["smzip", "application/vnd.stepmania.package"],
  ["snd", "audio/basic"],
  ["snf", "application/x-font-snf"],
  ["so", "application/octet-stream"],
  ["spc", "application/x-pkcs7-certificates"],
  ["spdx", "text/spdx"],
  ["spf", "application/vnd.yamaha.smaf-phrase"],
  ["spl", "application/x-futuresplash"],
  ["spot", "text/vnd.in3d.spot"],
  ["spp", "application/scvp-vp-response"],
  ["spq", "application/scvp-vp-request"],
  ["spx", "audio/ogg"],
  ["sql", "application/x-sql"],
  ["src", "application/x-wais-source"],
  ["srt", "application/x-subrip"],
  ["sru", "application/sru+xml"],
  ["srx", "application/sparql-results+xml"],
  ["ssdl", "application/ssdl+xml"],
  ["sse", "application/vnd.kodak-descriptor"],
  ["ssf", "application/vnd.epson.ssf"],
  ["ssml", "application/ssml+xml"],
  ["sst", "application/octet-stream"],
  ["st", "application/vnd.sailingtracker.track"],
  ["stc", "application/vnd.sun.xml.calc.template"],
  ["std", "application/vnd.sun.xml.draw.template"],
  ["stf", "application/vnd.wt.stf"],
  ["sti", "application/vnd.sun.xml.impress.template"],
  ["stk", "application/hyperstudio"],
  ["stl", "model/stl"],
  ["stpx", "model/step+xml"],
  ["stpxz", "model/step-xml+zip"],
  ["stpz", "model/step+zip"],
  ["str", "application/vnd.pg.format"],
  ["stw", "application/vnd.sun.xml.writer.template"],
  ["styl", "text/stylus"],
  ["stylus", "text/stylus"],
  ["sub", "text/vnd.dvb.subtitle"],
  ["sus", "application/vnd.sus-calendar"],
  ["susp", "application/vnd.sus-calendar"],
  ["sv4cpio", "application/x-sv4cpio"],
  ["sv4crc", "application/x-sv4crc"],
  ["svc", "application/vnd.dvb.service"],
  ["svd", "application/vnd.svd"],
  ["svg", "image/svg+xml"],
  ["svgz", "image/svg+xml"],
  ["swa", "application/x-director"],
  ["swf", "application/x-shockwave-flash"],
  ["swi", "application/vnd.aristanetworks.swi"],
  ["swidtag", "application/swid+xml"],
  ["sxc", "application/vnd.sun.xml.calc"],
  ["sxd", "application/vnd.sun.xml.draw"],
  ["sxg", "application/vnd.sun.xml.writer.global"],
  ["sxi", "application/vnd.sun.xml.impress"],
  ["sxm", "application/vnd.sun.xml.math"],
  ["sxw", "application/vnd.sun.xml.writer"],
  ["t", "text/troff"],
  ["t3", "application/x-t3vm-image"],
  ["t38", "image/t38"],
  ["taglet", "application/vnd.mynfc"],
  ["tao", "application/vnd.tao.intent-module-archive"],
  ["tap", "image/vnd.tencent.tap"],
  ["tar", "application/x-tar"],
  ["tcap", "application/vnd.3gpp2.tcap"],
  ["tcl", "application/x-tcl"],
  ["td", "application/urc-targetdesc+xml"],
  ["teacher", "application/vnd.smart.teacher"],
  ["tei", "application/tei+xml"],
  ["teicorpus", "application/tei+xml"],
  ["tex", "application/x-tex"],
  ["texi", "application/x-texinfo"],
  ["texinfo", "application/x-texinfo"],
  ["text", "text/plain"],
  ["tfi", "application/thraud+xml"],
  ["tfm", "application/x-tex-tfm"],
  ["tfx", "image/tiff-fx"],
  ["tga", "image/x-tga"],
  ["tgz", "application/x-tar"],
  ["thmx", "application/vnd.ms-officetheme"],
  ["tif", "image/tiff"],
  ["tiff", "image/tiff"],
  ["tk", "application/x-tcl"],
  ["tmo", "application/vnd.tmobile-livetv"],
  ["toml", "application/toml"],
  ["torrent", "application/x-bittorrent"],
  ["tpl", "application/vnd.groove-tool-template"],
  ["tpt", "application/vnd.trid.tpt"],
  ["tr", "text/troff"],
  ["tra", "application/vnd.trueapp"],
  ["trig", "application/trig"],
  ["trm", "application/x-msterminal"],
  ["ts", "video/mp2t"],
  ["tsd", "application/timestamped-data"],
  ["tsv", "text/tab-separated-values"],
  ["ttc", "font/collection"],
  ["ttf", "font/ttf"],
  ["ttl", "text/turtle"],
  ["ttml", "application/ttml+xml"],
  ["twd", "application/vnd.simtech-mindmapper"],
  ["twds", "application/vnd.simtech-mindmapper"],
  ["txd", "application/vnd.genomatix.tuxedo"],
  ["txf", "application/vnd.mobius.txf"],
  ["txt", "text/plain"],
  ["u8dsn", "message/global-delivery-status"],
  ["u8hdr", "message/global-headers"],
  ["u8mdn", "message/global-disposition-notification"],
  ["u8msg", "message/global"],
  ["u32", "application/x-authorware-bin"],
  ["ubj", "application/ubjson"],
  ["udeb", "application/x-debian-package"],
  ["ufd", "application/vnd.ufdl"],
  ["ufdl", "application/vnd.ufdl"],
  ["ulx", "application/x-glulx"],
  ["umj", "application/vnd.umajin"],
  ["unityweb", "application/vnd.unity"],
  ["uoml", "application/vnd.uoml+xml"],
  ["uri", "text/uri-list"],
  ["uris", "text/uri-list"],
  ["urls", "text/uri-list"],
  ["usdz", "model/vnd.usdz+zip"],
  ["ustar", "application/x-ustar"],
  ["utz", "application/vnd.uiq.theme"],
  ["uu", "text/x-uuencode"],
  ["uva", "audio/vnd.dece.audio"],
  ["uvd", "application/vnd.dece.data"],
  ["uvf", "application/vnd.dece.data"],
  ["uvg", "image/vnd.dece.graphic"],
  ["uvh", "video/vnd.dece.hd"],
  ["uvi", "image/vnd.dece.graphic"],
  ["uvm", "video/vnd.dece.mobile"],
  ["uvp", "video/vnd.dece.pd"],
  ["uvs", "video/vnd.dece.sd"],
  ["uvt", "application/vnd.dece.ttml+xml"],
  ["uvu", "video/vnd.uvvu.mp4"],
  ["uvv", "video/vnd.dece.video"],
  ["uvva", "audio/vnd.dece.audio"],
  ["uvvd", "application/vnd.dece.data"],
  ["uvvf", "application/vnd.dece.data"],
  ["uvvg", "image/vnd.dece.graphic"],
  ["uvvh", "video/vnd.dece.hd"],
  ["uvvi", "image/vnd.dece.graphic"],
  ["uvvm", "video/vnd.dece.mobile"],
  ["uvvp", "video/vnd.dece.pd"],
  ["uvvs", "video/vnd.dece.sd"],
  ["uvvt", "application/vnd.dece.ttml+xml"],
  ["uvvu", "video/vnd.uvvu.mp4"],
  ["uvvv", "video/vnd.dece.video"],
  ["uvvx", "application/vnd.dece.unspecified"],
  ["uvvz", "application/vnd.dece.zip"],
  ["uvx", "application/vnd.dece.unspecified"],
  ["uvz", "application/vnd.dece.zip"],
  ["vbox", "application/x-virtualbox-vbox"],
  ["vbox-extpack", "application/x-virtualbox-vbox-extpack"],
  ["vcard", "text/vcard"],
  ["vcd", "application/x-cdlink"],
  ["vcf", "text/x-vcard"],
  ["vcg", "application/vnd.groove-vcard"],
  ["vcs", "text/x-vcalendar"],
  ["vcx", "application/vnd.vcx"],
  ["vdi", "application/x-virtualbox-vdi"],
  ["vds", "model/vnd.sap.vds"],
  ["vhd", "application/x-virtualbox-vhd"],
  ["vis", "application/vnd.visionary"],
  ["viv", "video/vnd.vivo"],
  ["vlc", "application/videolan"],
  ["vmdk", "application/x-virtualbox-vmdk"],
  ["vob", "video/x-ms-vob"],
  ["vor", "application/vnd.stardivision.writer"],
  ["vox", "application/x-authorware-bin"],
  ["vrml", "model/vrml"],
  ["vsd", "application/vnd.visio"],
  ["vsf", "application/vnd.vsf"],
  ["vss", "application/vnd.visio"],
  ["vst", "application/vnd.visio"],
  ["vsw", "application/vnd.visio"],
  ["vtf", "image/vnd.valve.source.texture"],
  ["vtt", "text/vtt"],
  ["vtu", "model/vnd.vtu"],
  ["vxml", "application/voicexml+xml"],
  ["w3d", "application/x-director"],
  ["wad", "application/x-doom"],
  ["wadl", "application/vnd.sun.wadl+xml"],
  ["war", "application/java-archive"],
  ["wasm", "application/wasm"],
  ["wav", "audio/x-wav"],
  ["wax", "audio/x-ms-wax"],
  ["wbmp", "image/vnd.wap.wbmp"],
  ["wbs", "application/vnd.criticaltools.wbs+xml"],
  ["wbxml", "application/wbxml"],
  ["wcm", "application/vnd.ms-works"],
  ["wdb", "application/vnd.ms-works"],
  ["wdp", "image/vnd.ms-photo"],
  ["weba", "audio/webm"],
  ["webapp", "application/x-web-app-manifest+json"],
  ["webm", "video/webm"],
  ["webmanifest", "application/manifest+json"],
  ["webp", "image/webp"],
  ["wg", "application/vnd.pmi.widget"],
  ["wgt", "application/widget"],
  ["wks", "application/vnd.ms-works"],
  ["wm", "video/x-ms-wm"],
  ["wma", "audio/x-ms-wma"],
  ["wmd", "application/x-ms-wmd"],
  ["wmf", "image/wmf"],
  ["wml", "text/vnd.wap.wml"],
  ["wmlc", "application/wmlc"],
  ["wmls", "text/vnd.wap.wmlscript"],
  ["wmlsc", "application/vnd.wap.wmlscriptc"],
  ["wmv", "video/x-ms-wmv"],
  ["wmx", "video/x-ms-wmx"],
  ["wmz", "application/x-msmetafile"],
  ["woff", "font/woff"],
  ["woff2", "font/woff2"],
  ["word", "application/msword"],
  ["wpd", "application/vnd.wordperfect"],
  ["wpl", "application/vnd.ms-wpl"],
  ["wps", "application/vnd.ms-works"],
  ["wqd", "application/vnd.wqd"],
  ["wri", "application/x-mswrite"],
  ["wrl", "model/vrml"],
  ["wsc", "message/vnd.wfa.wsc"],
  ["wsdl", "application/wsdl+xml"],
  ["wspolicy", "application/wspolicy+xml"],
  ["wtb", "application/vnd.webturbo"],
  ["wvx", "video/x-ms-wvx"],
  ["x3d", "model/x3d+xml"],
  ["x3db", "model/x3d+fastinfoset"],
  ["x3dbz", "model/x3d+binary"],
  ["x3dv", "model/x3d-vrml"],
  ["x3dvz", "model/x3d+vrml"],
  ["x3dz", "model/x3d+xml"],
  ["x32", "application/x-authorware-bin"],
  ["x_b", "model/vnd.parasolid.transmit.binary"],
  ["x_t", "model/vnd.parasolid.transmit.text"],
  ["xaml", "application/xaml+xml"],
  ["xap", "application/x-silverlight-app"],
  ["xar", "application/vnd.xara"],
  ["xav", "application/xcap-att+xml"],
  ["xbap", "application/x-ms-xbap"],
  ["xbd", "application/vnd.fujixerox.docuworks.binder"],
  ["xbm", "image/x-xbitmap"],
  ["xca", "application/xcap-caps+xml"],
  ["xcs", "application/calendar+xml"],
  ["xdf", "application/xcap-diff+xml"],
  ["xdm", "application/vnd.syncml.dm+xml"],
  ["xdp", "application/vnd.adobe.xdp+xml"],
  ["xdssc", "application/dssc+xml"],
  ["xdw", "application/vnd.fujixerox.docuworks"],
  ["xel", "application/xcap-el+xml"],
  ["xenc", "application/xenc+xml"],
  ["xer", "application/patch-ops-error+xml"],
  ["xfdf", "application/vnd.adobe.xfdf"],
  ["xfdl", "application/vnd.xfdl"],
  ["xht", "application/xhtml+xml"],
  ["xhtml", "application/xhtml+xml"],
  ["xhvml", "application/xv+xml"],
  ["xif", "image/vnd.xiff"],
  ["xl", "application/excel"],
  ["xla", "application/vnd.ms-excel"],
  ["xlam", "application/vnd.ms-excel.addin.macroEnabled.12"],
  ["xlc", "application/vnd.ms-excel"],
  ["xlf", "application/xliff+xml"],
  ["xlm", "application/vnd.ms-excel"],
  ["xls", "application/vnd.ms-excel"],
  ["xlsb", "application/vnd.ms-excel.sheet.binary.macroEnabled.12"],
  ["xlsm", "application/vnd.ms-excel.sheet.macroEnabled.12"],
  ["xlsx", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"],
  ["xlt", "application/vnd.ms-excel"],
  ["xltm", "application/vnd.ms-excel.template.macroEnabled.12"],
  ["xltx", "application/vnd.openxmlformats-officedocument.spreadsheetml.template"],
  ["xlw", "application/vnd.ms-excel"],
  ["xm", "audio/xm"],
  ["xml", "application/xml"],
  ["xns", "application/xcap-ns+xml"],
  ["xo", "application/vnd.olpc-sugar"],
  ["xop", "application/xop+xml"],
  ["xpi", "application/x-xpinstall"],
  ["xpl", "application/xproc+xml"],
  ["xpm", "image/x-xpixmap"],
  ["xpr", "application/vnd.is-xpr"],
  ["xps", "application/vnd.ms-xpsdocument"],
  ["xpw", "application/vnd.intercon.formnet"],
  ["xpx", "application/vnd.intercon.formnet"],
  ["xsd", "application/xml"],
  ["xsl", "application/xml"],
  ["xslt", "application/xslt+xml"],
  ["xsm", "application/vnd.syncml+xml"],
  ["xspf", "application/xspf+xml"],
  ["xul", "application/vnd.mozilla.xul+xml"],
  ["xvm", "application/xv+xml"],
  ["xvml", "application/xv+xml"],
  ["xwd", "image/x-xwindowdump"],
  ["xyz", "chemical/x-xyz"],
  ["xz", "application/x-xz"],
  ["yaml", "text/yaml"],
  ["yang", "application/yang"],
  ["yin", "application/yin+xml"],
  ["yml", "text/yaml"],
  ["ymp", "text/x-suse-ymp"],
  ["z", "application/x-compress"],
  ["z1", "application/x-zmachine"],
  ["z2", "application/x-zmachine"],
  ["z3", "application/x-zmachine"],
  ["z4", "application/x-zmachine"],
  ["z5", "application/x-zmachine"],
  ["z6", "application/x-zmachine"],
  ["z7", "application/x-zmachine"],
  ["z8", "application/x-zmachine"],
  ["zaz", "application/vnd.zzazz.deck+xml"],
  ["zip", "application/zip"],
  ["zir", "application/vnd.zul"],
  ["zirz", "application/vnd.zul"],
  ["zmm", "application/vnd.handheld-entertainment+xml"],
  ["zsh", "text/x-scriptzsh"]
]);
function hn(e, t, n) {
  const r = uw(e), { webkitRelativePath: o } = e, a = typeof t == "string" ? t : typeof o == "string" && o.length > 0 ? o : `./${e.name}`;
  return typeof r.path != "string" && Ai(r, "path", a), Ai(r, "relativePath", a), r;
}
function uw(e) {
  const { name: t } = e;
  if (t && t.lastIndexOf(".") !== -1 && !e.type) {
    const r = t.split(".").pop().toLowerCase(), o = dw.get(r);
    o && Object.defineProperty(e, "type", {
      value: o,
      writable: !1,
      configurable: !1,
      enumerable: !0
    });
  }
  return e;
}
function Ai(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !1,
    configurable: !1,
    enumerable: !0
  });
}
const fw = [
  // Thumbnail cache files for macOS and Windows
  ".DS_Store",
  // macOs
  "Thumbs.db"
  // Windows
];
function pw(e) {
  return tn(this, void 0, void 0, function* () {
    return Or(e) && mw(e.dataTransfer) ? xw(e.dataTransfer, e.type) : hw(e) ? vw(e) : Array.isArray(e) && e.every((t) => "getFile" in t && typeof t.getFile == "function") ? gw(e) : [];
  });
}
function mw(e) {
  return Or(e);
}
function hw(e) {
  return Or(e) && Or(e.target);
}
function Or(e) {
  return typeof e == "object" && e !== null;
}
function vw(e) {
  return Ro(e.target.files).map((t) => hn(t));
}
function gw(e) {
  return tn(this, void 0, void 0, function* () {
    return (yield Promise.all(e.map((n) => n.getFile()))).map((n) => hn(n));
  });
}
function xw(e, t) {
  return tn(this, void 0, void 0, function* () {
    if (e.items) {
      const n = Ro(e.items).filter((o) => o.kind === "file");
      if (t !== "drop")
        return n;
      const r = yield Promise.all(n.map(yw));
      return Ri(Dd(r));
    }
    return Ri(Ro(e.files).map((n) => hn(n)));
  });
}
function Ri(e) {
  return e.filter((t) => fw.indexOf(t.name) === -1);
}
function Ro(e) {
  if (e === null)
    return [];
  const t = [];
  for (let n = 0; n < e.length; n++) {
    const r = e[n];
    t.push(r);
  }
  return t;
}
function yw(e) {
  if (typeof e.webkitGetAsEntry != "function")
    return Ni(e);
  const t = e.webkitGetAsEntry();
  return t && t.isDirectory ? Pd(t) : Ni(e, t);
}
function Dd(e) {
  return e.reduce((t, n) => [
    ...t,
    ...Array.isArray(n) ? Dd(n) : [n]
  ], []);
}
function Ni(e, t) {
  return tn(this, void 0, void 0, function* () {
    var n;
    if (globalThis.isSecureContext && typeof e.getAsFileSystemHandle == "function") {
      const a = yield e.getAsFileSystemHandle();
      if (a === null)
        throw new Error(`${e} is not a File`);
      if (a !== void 0) {
        const s = yield a.getFile();
        return s.handle = a, hn(s);
      }
    }
    const r = e.getAsFile();
    if (!r)
      throw new Error(`${e} is not a File`);
    return hn(r, (n = t == null ? void 0 : t.fullPath) !== null && n !== void 0 ? n : void 0);
  });
}
function bw(e) {
  return tn(this, void 0, void 0, function* () {
    return e.isDirectory ? Pd(e) : ww(e);
  });
}
function Pd(e) {
  const t = e.createReader();
  return new Promise((n, r) => {
    const o = [];
    function a() {
      t.readEntries((s) => tn(this, void 0, void 0, function* () {
        if (s.length) {
          const i = Promise.all(s.map(bw));
          o.push(i), a();
        } else
          try {
            const i = yield Promise.all(o);
            n(i);
          } catch (i) {
            r(i);
          }
      }), (s) => {
        r(s);
      });
    }
    a();
  });
}
function ww(e) {
  return tn(this, void 0, void 0, function* () {
    return new Promise((t, n) => {
      e.file((r) => {
        const o = hn(r, e.fullPath);
        t(o);
      }, (r) => {
        n(r);
      });
    });
  });
}
var ur = {}, ji;
function kw() {
  return ji || (ji = 1, ur.__esModule = !0, ur.default = function(e, t) {
    if (e && t) {
      var n = Array.isArray(t) ? t : t.split(",");
      if (n.length === 0)
        return !0;
      var r = e.name || "", o = (e.type || "").toLowerCase(), a = o.replace(/\/.*$/, "");
      return n.some(function(s) {
        var i = s.trim().toLowerCase();
        return i.charAt(0) === "." ? r.toLowerCase().endsWith(i) : i.endsWith("/*") ? a === i.replace(/\/.*$/, "") : o === i;
      });
    }
    return !0;
  }), ur;
}
var Ew = kw();
const mo = /* @__PURE__ */ Ui(Ew);
function Ii(e) {
  return Sw(e) || Ow(e) || Td(e) || Cw();
}
function Cw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Ow(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Sw(e) {
  if (Array.isArray(e)) return No(e);
}
function Fi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function Wi(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Fi(Object(n), !0).forEach(function(r) {
      _d(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Fi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function _d(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Wn(e, t) {
  return Pw(e) || Dw(e, t) || Td(e, t) || Mw();
}
function Mw() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Td(e, t) {
  if (e) {
    if (typeof e == "string") return No(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return No(e, t);
  }
}
function No(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function Dw(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, s, i;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, i = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw i;
      }
    }
    return r;
  }
}
function Pw(e) {
  if (Array.isArray(e)) return e;
}
var _w = typeof mo == "function" ? mo : mo.default, Tw = "file-invalid-type", Aw = "file-too-large", Rw = "file-too-small", Nw = "too-many-files", jw = function() {
  var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", n = t.split(","), r = n.length > 1 ? "one of ".concat(n.join(", ")) : n[0];
  return {
    code: Tw,
    message: "File type must be ".concat(r)
  };
}, $i = function(t) {
  return {
    code: Aw,
    message: "File is larger than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Li = function(t) {
  return {
    code: Rw,
    message: "File is smaller than ".concat(t, " ").concat(t === 1 ? "byte" : "bytes")
  };
}, Iw = {
  code: Nw,
  message: "Too many files"
};
function Ad(e, t) {
  var n = e.type === "application/x-moz-file" || _w(e, t);
  return [n, n ? null : jw(t)];
}
function Rd(e, t, n) {
  if (Gt(e.size))
    if (Gt(t) && Gt(n)) {
      if (e.size > n) return [!1, $i(n)];
      if (e.size < t) return [!1, Li(t)];
    } else {
      if (Gt(t) && e.size < t) return [!1, Li(t)];
      if (Gt(n) && e.size > n) return [!1, $i(n)];
    }
  return [!0, null];
}
function Gt(e) {
  return e != null;
}
function Fw(e) {
  var t = e.files, n = e.accept, r = e.minSize, o = e.maxSize, a = e.multiple, s = e.maxFiles, i = e.validator;
  return !a && t.length > 1 || a && s >= 1 && t.length > s ? !1 : t.every(function(d) {
    var l = Ad(d, n), u = Wn(l, 1), c = u[0], f = Rd(d, r, o), m = Wn(f, 1), y = m[0], h = i ? i(d) : null;
    return c && y && !h;
  });
}
function Sr(e) {
  return typeof e.isPropagationStopped == "function" ? e.isPropagationStopped() : typeof e.cancelBubble < "u" ? e.cancelBubble : !1;
}
function fr(e) {
  return e.dataTransfer ? Array.prototype.some.call(e.dataTransfer.types, function(t) {
    return t === "Files" || t === "application/x-moz-file";
  }) : !!e.target && !!e.target.files;
}
function zi(e) {
  e.preventDefault();
}
function Ww(e) {
  return e.indexOf("MSIE") !== -1 || e.indexOf("Trident/") !== -1;
}
function $w(e) {
  return e.indexOf("Edge/") !== -1;
}
function Lw() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window.navigator.userAgent;
  return Ww(e) || $w(e);
}
function dt() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  return function(r) {
    for (var o = arguments.length, a = new Array(o > 1 ? o - 1 : 0), s = 1; s < o; s++)
      a[s - 1] = arguments[s];
    return t.some(function(i) {
      return !Sr(r) && i && i.apply(void 0, [r].concat(a)), Sr(r);
    });
  };
}
function zw() {
  return "showOpenFilePicker" in window;
}
function Bw(e) {
  if (Gt(e)) {
    var t = Object.entries(e).filter(function(n) {
      var r = Wn(n, 2), o = r[0], a = r[1], s = !0;
      return Nd(o) || (console.warn('Skipped "'.concat(o, '" because it is not a valid MIME type. Check https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types for a list of valid MIME types.')), s = !1), (!Array.isArray(a) || !a.every(jd)) && (console.warn('Skipped "'.concat(o, '" because an invalid file extension was provided.')), s = !1), s;
    }).reduce(function(n, r) {
      var o = Wn(r, 2), a = o[0], s = o[1];
      return Wi(Wi({}, n), {}, _d({}, a, s));
    }, {});
    return [{
      // description is required due to https://crbug.com/1264708
      description: "Files",
      accept: t
    }];
  }
  return e;
}
function Yw(e) {
  if (Gt(e))
    return Object.entries(e).reduce(function(t, n) {
      var r = Wn(n, 2), o = r[0], a = r[1];
      return [].concat(Ii(t), [o], Ii(a));
    }, []).filter(function(t) {
      return Nd(t) || jd(t);
    }).join(",");
}
function Hw(e) {
  return e instanceof DOMException && (e.name === "AbortError" || e.code === e.ABORT_ERR);
}
function qw(e) {
  return e instanceof DOMException && (e.name === "SecurityError" || e.code === e.SECURITY_ERR);
}
function Nd(e) {
  return e === "audio/*" || e === "video/*" || e === "image/*" || e === "text/*" || e === "application/*" || /\w+\/[-+.\w]+/g.test(e);
}
function jd(e) {
  return /^.*\.[\w]+$/.test(e);
}
var Vw = ["children"], Uw = ["open"], Gw = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"], Kw = ["refKey", "onChange", "onClick"];
function Xw(e) {
  return Jw(e) || Qw(e) || Id(e) || Zw();
}
function Zw() {
  throw new TypeError(`Invalid attempt to spread non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Qw(e) {
  if (typeof Symbol < "u" && e[Symbol.iterator] != null || e["@@iterator"] != null) return Array.from(e);
}
function Jw(e) {
  if (Array.isArray(e)) return jo(e);
}
function ho(e, t) {
  return n0(e) || t0(e, t) || Id(e, t) || e0();
}
function e0() {
  throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function Id(e, t) {
  if (e) {
    if (typeof e == "string") return jo(e, t);
    var n = Object.prototype.toString.call(e).slice(8, -1);
    if (n === "Object" && e.constructor && (n = e.constructor.name), n === "Map" || n === "Set") return Array.from(e);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return jo(e, t);
  }
}
function jo(e, t) {
  (t == null || t > e.length) && (t = e.length);
  for (var n = 0, r = new Array(t); n < t; n++)
    r[n] = e[n];
  return r;
}
function t0(e, t) {
  var n = e == null ? null : typeof Symbol < "u" && e[Symbol.iterator] || e["@@iterator"];
  if (n != null) {
    var r = [], o = !0, a = !1, s, i;
    try {
      for (n = n.call(e); !(o = (s = n.next()).done) && (r.push(s.value), !(t && r.length === t)); o = !0)
        ;
    } catch (d) {
      a = !0, i = d;
    } finally {
      try {
        !o && n.return != null && n.return();
      } finally {
        if (a) throw i;
      }
    }
    return r;
  }
}
function n0(e) {
  if (Array.isArray(e)) return e;
}
function Bi(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function ke(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? Bi(Object(n), !0).forEach(function(r) {
      Io(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : Bi(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Io(e, t, n) {
  return t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function Mr(e, t) {
  if (e == null) return {};
  var n = r0(e, t), r, o;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    for (o = 0; o < a.length; o++)
      r = a[o], !(t.indexOf(r) >= 0) && Object.prototype.propertyIsEnumerable.call(e, r) && (n[r] = e[r]);
  }
  return n;
}
function r0(e, t) {
  if (e == null) return {};
  var n = {}, r = Object.keys(e), o, a;
  for (a = 0; a < r.length; a++)
    o = r[a], !(t.indexOf(o) >= 0) && (n[o] = e[o]);
  return n;
}
var ba = /* @__PURE__ */ Je(function(e, t) {
  var n = e.children, r = Mr(e, Vw), o = Wd(r), a = o.open, s = Mr(o, Uw);
  return Bd(t, function() {
    return {
      open: a
    };
  }, [a]), /* @__PURE__ */ w.createElement(Yd, null, n(ke(ke({}, s), {}, {
    open: a
  })));
});
ba.displayName = "Dropzone";
var Fd = {
  disabled: !1,
  getFilesFromEvent: pw,
  maxSize: 1 / 0,
  minSize: 0,
  multiple: !0,
  maxFiles: 0,
  preventDropOnDocument: !0,
  noClick: !1,
  noKeyboard: !1,
  noDrag: !1,
  noDragEventsBubbling: !1,
  validator: null,
  useFsAccessApi: !1,
  autoFocus: !1
};
ba.defaultProps = Fd;
ba.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: he.func,
  /**
   * Set accepted file types.
   * Checkout https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker types option for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all (https://github.com/react-dropzone/react-dropzone/issues/276).
   */
  accept: he.objectOf(he.arrayOf(he.string)),
  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: he.bool,
  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: he.bool,
  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: he.bool,
  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: he.bool,
  /**
   * If true, disables drag 'n' drop
   */
  noDrag: he.bool,
  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: he.bool,
  /**
   * Minimum file size (in bytes)
   */
  minSize: he.number,
  /**
   * Maximum file size (in bytes)
   */
  maxSize: he.number,
  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: he.number,
  /**
   * Enable/disable the dropzone
   */
  disabled: he.bool,
  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event|Array<FileSystemFileHandle>)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: he.func,
  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: he.func,
  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: he.func,
  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: he.bool,
  /**
   * Set to true to focus the root element on render
   */
  autoFocus: he.bool,
  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: he.func,
  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: he.func,
  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: he.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: he.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: he.func,
  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: he.func,
  /**
   * Cb for when there's some error from any of the promises.
   *
   * @param {Error} error
   */
  onError: he.func,
  /**
   * Custom validation function. It must return null if there's no errors.
   * @param {File} file
   * @returns {FileError|FileError[]|null}
   */
  validator: he.func
};
var Fo = {
  isFocused: !1,
  isFileDialogActive: !1,
  isDragActive: !1,
  isDragAccept: !1,
  isDragReject: !1,
  acceptedFiles: [],
  fileRejections: []
};
function Wd() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = ke(ke({}, Fd), e), n = t.accept, r = t.disabled, o = t.getFilesFromEvent, a = t.maxSize, s = t.minSize, i = t.multiple, d = t.maxFiles, l = t.onDragEnter, u = t.onDragLeave, c = t.onDragOver, f = t.onDrop, m = t.onDropAccepted, y = t.onDropRejected, h = t.onFileDialogCancel, g = t.onFileDialogOpen, k = t.useFsAccessApi, C = t.autoFocus, E = t.preventDropOnDocument, O = t.noClick, v = t.noKeyboard, P = t.noDrag, M = t.noDragEventsBubbling, D = t.onError, L = t.validator, Y = wt(function() {
    return Yw(n);
  }, [n]), U = wt(function() {
    return Bw(n);
  }, [n]), J = wt(function() {
    return typeof g == "function" ? g : Yi;
  }, [g]), ee = wt(function() {
    return typeof h == "function" ? h : Yi;
  }, [h]), q = It(null), G = It(null), j = zd(o0, Fo), K = ho(j, 2), _ = K[0], R = K[1], b = _.isFocused, S = _.isFileDialogActive, A = It(typeof window < "u" && window.isSecureContext && k && zw()), T = function() {
    !A.current && S && setTimeout(function() {
      if (G.current) {
        var ne = G.current.files;
        ne.length || (R({
          type: "closeDialog"
        }), ee());
      }
    }, 300);
  };
  pr(function() {
    return window.addEventListener("focus", T, !1), function() {
      window.removeEventListener("focus", T, !1);
    };
  }, [G, S, ee, A]);
  var N = It([]), V = function(ne) {
    q.current && q.current.contains(ne.target) || (ne.preventDefault(), N.current = []);
  };
  pr(function() {
    return E && (document.addEventListener("dragover", zi, !1), document.addEventListener("drop", V, !1)), function() {
      E && (document.removeEventListener("dragover", zi), document.removeEventListener("drop", V));
    };
  }, [q, E]), pr(function() {
    return !r && C && q.current && q.current.focus(), function() {
    };
  }, [q, C, r]);
  var F = be(function($) {
    D ? D($) : console.error($);
  }, [D]), W = be(function($) {
    $.preventDefault(), $.persist(), Dt($), N.current = [].concat(Xw(N.current), [$.target]), fr($) && Promise.resolve(o($)).then(function(ne) {
      if (!(Sr($) && !M)) {
        var me = ne.length, Ce = me > 0 && Fw({
          files: ne,
          accept: Y,
          minSize: s,
          maxSize: a,
          multiple: i,
          maxFiles: d,
          validator: L
        }), Ae = me > 0 && !Ce;
        R({
          isDragAccept: Ce,
          isDragReject: Ae,
          isDragActive: !0,
          type: "setDraggedFiles"
        }), l && l($);
      }
    }).catch(function(ne) {
      return F(ne);
    });
  }, [o, l, F, M, Y, s, a, i, d, L]), z = be(function($) {
    $.preventDefault(), $.persist(), Dt($);
    var ne = fr($);
    if (ne && $.dataTransfer)
      try {
        $.dataTransfer.dropEffect = "copy";
      } catch {
      }
    return ne && c && c($), !1;
  }, [c, M]), H = be(function($) {
    $.preventDefault(), $.persist(), Dt($);
    var ne = N.current.filter(function(Ce) {
      return q.current && q.current.contains(Ce);
    }), me = ne.indexOf($.target);
    me !== -1 && ne.splice(me, 1), N.current = ne, !(ne.length > 0) && (R({
      type: "setDraggedFiles",
      isDragActive: !1,
      isDragAccept: !1,
      isDragReject: !1
    }), fr($) && u && u($));
  }, [q, u, M]), Q = be(function($, ne) {
    var me = [], Ce = [];
    $.forEach(function(Ae) {
      var tt = Ad(Ae, Y), Ie = ho(tt, 2), Pt = Ie[0], Ke = Ie[1], Yt = Rd(Ae, s, a), _t = ho(Yt, 2), Tt = _t[0], yt = _t[1], Ht = L ? L(Ae) : null;
      if (Pt && Tt && !Ht)
        me.push(Ae);
      else {
        var ct = [Ke, yt];
        Ht && (ct = ct.concat(Ht)), Ce.push({
          file: Ae,
          errors: ct.filter(function(re) {
            return re;
          })
        });
      }
    }), (!i && me.length > 1 || i && d >= 1 && me.length > d) && (me.forEach(function(Ae) {
      Ce.push({
        file: Ae,
        errors: [Iw]
      });
    }), me.splice(0)), R({
      acceptedFiles: me,
      fileRejections: Ce,
      isDragReject: Ce.length > 0,
      type: "setFiles"
    }), f && f(me, Ce, ne), Ce.length > 0 && y && y(Ce, ne), me.length > 0 && m && m(me, ne);
  }, [R, i, Y, s, a, d, f, m, y, L]), se = be(function($) {
    $.preventDefault(), $.persist(), Dt($), N.current = [], fr($) && Promise.resolve(o($)).then(function(ne) {
      Sr($) && !M || Q(ne, $);
    }).catch(function(ne) {
      return F(ne);
    }), R({
      type: "reset"
    });
  }, [o, Q, F, M]), I = be(function() {
    if (A.current) {
      R({
        type: "openDialog"
      }), J();
      var $ = {
        multiple: i,
        types: U
      };
      window.showOpenFilePicker($).then(function(ne) {
        return o(ne);
      }).then(function(ne) {
        Q(ne, null), R({
          type: "closeDialog"
        });
      }).catch(function(ne) {
        Hw(ne) ? (ee(ne), R({
          type: "closeDialog"
        })) : qw(ne) ? (A.current = !1, G.current ? (G.current.value = null, G.current.click()) : F(new Error("Cannot open the file picker because the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API is not supported and no <input> was provided."))) : F(ne);
      });
      return;
    }
    G.current && (R({
      type: "openDialog"
    }), J(), G.current.value = null, G.current.click());
  }, [R, J, ee, k, Q, F, U, i]), ue = be(function($) {
    !q.current || !q.current.isEqualNode($.target) || ($.key === " " || $.key === "Enter" || $.keyCode === 32 || $.keyCode === 13) && ($.preventDefault(), I());
  }, [q, I]), Se = be(function() {
    R({
      type: "focus"
    });
  }, []), ze = be(function() {
    R({
      type: "blur"
    });
  }, []), et = be(function() {
    O || (Lw() ? setTimeout(I, 0) : I());
  }, [O, I]), _e = function(ne) {
    return r ? null : ne;
  }, Ue = function(ne) {
    return v ? null : _e(ne);
  }, ge = function(ne) {
    return P ? null : _e(ne);
  }, Dt = function(ne) {
    M && ne.stopPropagation();
  }, kn = wt(function() {
    return function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ne = $.refKey, me = ne === void 0 ? "ref" : ne, Ce = $.role, Ae = $.onKeyDown, tt = $.onFocus, Ie = $.onBlur, Pt = $.onClick, Ke = $.onDragEnter, Yt = $.onDragOver, _t = $.onDragLeave, Tt = $.onDrop, yt = Mr($, Gw);
      return ke(ke(Io({
        onKeyDown: Ue(dt(Ae, ue)),
        onFocus: Ue(dt(tt, Se)),
        onBlur: Ue(dt(Ie, ze)),
        onClick: _e(dt(Pt, et)),
        onDragEnter: ge(dt(Ke, W)),
        onDragOver: ge(dt(Yt, z)),
        onDragLeave: ge(dt(_t, H)),
        onDrop: ge(dt(Tt, se)),
        role: typeof Ce == "string" && Ce !== "" ? Ce : "presentation"
      }, me, q), !r && !v ? {
        tabIndex: 0
      } : {}), yt);
    };
  }, [q, ue, Se, ze, et, W, z, H, se, v, P, r]), Te = be(function($) {
    $.stopPropagation();
  }, []), Ge = wt(function() {
    return function() {
      var $ = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, ne = $.refKey, me = ne === void 0 ? "ref" : ne, Ce = $.onChange, Ae = $.onClick, tt = Mr($, Kw), Ie = Io({
        accept: Y,
        multiple: i,
        type: "file",
        style: {
          border: 0,
          clip: "rect(0, 0, 0, 0)",
          clipPath: "inset(50%)",
          height: "1px",
          margin: "0 -1px -1px 0",
          overflow: "hidden",
          padding: 0,
          position: "absolute",
          width: "1px",
          whiteSpace: "nowrap"
        },
        onChange: _e(dt(Ce, se)),
        onClick: _e(dt(Ae, Te)),
        tabIndex: -1
      }, me, G);
      return ke(ke({}, Ie), tt);
    };
  }, [G, n, i, se, r]);
  return ke(ke({}, _), {}, {
    isFocused: b && !r,
    getRootProps: kn,
    getInputProps: Ge,
    rootRef: q,
    inputRef: G,
    open: _e(I)
  });
}
function o0(e, t) {
  switch (t.type) {
    case "focus":
      return ke(ke({}, e), {}, {
        isFocused: !0
      });
    case "blur":
      return ke(ke({}, e), {}, {
        isFocused: !1
      });
    case "openDialog":
      return ke(ke({}, Fo), {}, {
        isFileDialogActive: !0
      });
    case "closeDialog":
      return ke(ke({}, e), {}, {
        isFileDialogActive: !1
      });
    case "setDraggedFiles":
      return ke(ke({}, e), {}, {
        isDragActive: t.isDragActive,
        isDragAccept: t.isDragAccept,
        isDragReject: t.isDragReject
      });
    case "setFiles":
      return ke(ke({}, e), {}, {
        acceptedFiles: t.acceptedFiles,
        fileRejections: t.fileRejections,
        isDragReject: t.isDragReject
      });
    case "reset":
      return ke({}, Fo);
    default:
      return e;
  }
}
function Yi() {
}
function L0({
  control: { upload: e, isPending: t },
  accept: n,
  metadata: r,
  title: o = "Document",
  status: a = "Pending Upload",
  description: s,
  uploadOverride: i
}) {
  const d = Hd(), { getRootProps: l, getInputProps: u, isDragActive: c, inputRef: f } = Wd({
    onDrop: (m) => {
      console.log("INNNNNN >>> ", m), m.length > 0 && !t && (i ? i(m, { metadata: r }) : e(m, { metadata: r })), f.current.value = "";
    }
    // noClick: true,
  });
  return /* @__PURE__ */ x.jsxs("div", { className: "flex items-center justify-between rounded-lg border border-gray-200 bg-gray-50 p-4 shadow-sm", children: [
    /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-3", children: [
      /* @__PURE__ */ x.jsx("div", { className: "flex h-10 w-10 items-center justify-center rounded-lg bg-gray-100", children: /* @__PURE__ */ x.jsx(Of, { className: "h-5 w-5 text-gray-500" }) }),
      /* @__PURE__ */ x.jsxs("div", { className: "space-y-1", children: [
        /* @__PURE__ */ x.jsx("h3", { className: "font-semibold text-gray-900", children: o }),
        /* @__PURE__ */ x.jsx("p", { className: "text-sm text-gray-500", children: a })
      ] })
    ] }),
    /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2", children: [
      t && /* @__PURE__ */ x.jsxs("div", { className: "flex items-center gap-2 text-sm text-gray-500", children: [
        /* @__PURE__ */ x.jsx(zo, { className: "h-4 w-4 animate-spin" }),
        /* @__PURE__ */ x.jsx("span", { children: "Uploading..." })
      ] }),
      /* @__PURE__ */ x.jsxs(
        a0,
        {
          ...l(),
          className: "bg-purple-100 hover:bg-purple-200 text-purple-700 font-medium px-4 py-2 rounded-md shadow-sm",
          disabled: t,
          variant: "outline",
          children: [
            /* @__PURE__ */ x.jsx(as, { className: "h-4 w-4 mr-2" }),
            "Upload"
          ]
        }
      ),
      /* @__PURE__ */ x.jsx(
        "input",
        {
          ...u(),
          accept: n,
          disabled: t,
          id: d,
          multiple: !0,
          type: "file"
        }
      )
    ] })
  ] });
}
const a0 = ({
  children: e,
  className: t,
  disabled: n,
  variant: r,
  ...o
}) => /* @__PURE__ */ x.jsx(
  "button",
  {
    className: ae(
      "inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
      r === "outline" ? "border border-input bg-background hover:bg-accent hover:text-accent-foreground" : "bg-primary text-primary-foreground hover:bg-primary/90",
      t
    ),
    disabled: n,
    ...o,
    children: e
  }
);
export {
  Eo as Button,
  p0 as Card,
  g0 as CardContent,
  v0 as CardDescription,
  x0 as CardFooter,
  m0 as CardHeader,
  h0 as CardTitle,
  f0 as DateRangePicker,
  w0 as Dialog,
  E0 as DialogClose,
  Sx as DialogContent,
  S0 as DialogDescription,
  M0 as DialogFooter,
  C0 as DialogHeader,
  O0 as DialogTitle,
  k0 as DialogTrigger,
  P0 as DropdownMenu,
  yb as DropdownMenuCheckboxItem,
  gb as DropdownMenuContent,
  xb as DropdownMenuItem,
  wb as DropdownMenuLabel,
  T0 as DropdownMenuRadioGroup,
  bb as DropdownMenuRadioItem,
  kb as DropdownMenuSeparator,
  Eb as DropdownMenuShortcut,
  A0 as DropdownMenuSub,
  Ob as DropdownMenuSubContent,
  Cb as DropdownMenuSubTrigger,
  _0 as DropdownMenuTrigger,
  R0 as Form,
  Vb as FormControl,
  N0 as FormField,
  Hb as FormItem,
  qb as FormLabel,
  Ub as FormMessage,
  j0 as Input,
  I0 as Loader,
  ax as Popover,
  Ic as PopoverContent,
  ix as PopoverTrigger,
  F0 as Skeleton,
  Gb as Table,
  Xb as TableBody,
  tw as TableCaption,
  ew as TableCell,
  Zb as TableFooter,
  Jb as TableHead,
  Kb as TableHeader,
  Qb as TableRow,
  W0 as Toaster,
  $0 as UploadButton,
  L0 as UploadDropzone,
  Eh as buttonVariants,
  ae as cn,
  l0 as toast,
  d0 as truncate,
  xa as useFormField
};
